<template>
  <loading
    :active="this.releaseType"
    :can-cancel="true"
    :on-cancel="onCancel"
    :is-full-page="true"
    :color="'#fff'"
    :background-color="'#000'"
    :opacity="'0.8'"
    :loader=" dots"
    :style="this.style"
  >
    <!-- <div class="text-center text-blue-50 text-4xl" style="background-color:red;word-wrap:break-word; width:300px;">建立關鍵字...</div>
    <div class="w-2/4" style="background-color:blue;display: flex; justify-content: center; align-items: center; width:300px; ">
      <div style="margin: auto"> -->
        <!-- <circle-progress :percent="releasePercent" :show-percent="true" :class="'text-blue-50 text-4xl'"/> -->
        <div id="myItem5" class="ldBar label-center" data-type="fill" data-img="https://private.autoturn.net/autoturn_logo_v04.svg" style="width:300px;height:300px;" ></div>
      <!-- </div>
    </div> -->
  </loading>
  <loading :active="this.allPageLoading"
          :can-cancel="true"
          :on-cancel="onCancel"
          :is-full-page="true"
          :color="'#fff'"
          :background-color="'#000'"
          :opacity="'0.8'"
          :loader=" dots">
  </loading>
  <div class="flex-1 flex flex-col overflow-hidden mb-16">
    <loading :active="!this.showCampaignData"
            :can-cancel="true"
            :on-cancel="onCancel"
            :is-full-page="true"
            :color="'#fff'"
            :background-color="'#000'"
            :opacity="'0.8'"
            :loader=" dots">
    </loading>
    <Header :title="showLang[selectLang]['views']['EventAdd']['page_name']" @childLang="useLang" @toggleSidebar="$emit('toggleSidebar')">
      <div class="mx-2 lg:mx-4 text-gray-700 text-sm lg:text-base">
        {{showLang[selectLang]['views']['EventAdd']['advertising_source']}}
      </div>
      <div class="grid grid-cols-4 border-2 rounded-md w-28 -ml-2" style="border: 2px solid rgb(53, 102, 165); color: rgb(53, 102, 165);">
        <img width="28" src="https://private.autoturn.net/img/facebook_icon.png"/>
        <div class="mx-1 text-sm leading-7">
          Facebook
        </div>
      </div>
      <div class="mx-2 lg:mx-4 text-gray-700 text-sm lg:text-base">
        {{showLang[selectLang]['views']['EventAdd']['advertise_account_text']}}
      </div>
      <div class="mx-1 text-sm text-gray-400 leading-7 border-2 rounded-md px-1 -ml-2" style="border: 2px solid rgb(53, 102, 165); color: rgb(53, 102, 165);">
        {{ adaccount_name }}
      </div>
    </Header>
    <main class="flex overflow-x-hidden d2-evt-main">
      <div class="d2-evt-nav">
        <!-- 新手教學 -->
        <div class="d2-step-panel" :style="nowStep === 888 ? { zIndex: 100, position: 'relative' } : null">
          <div v-show="false" class="h-16" :class="{ 'ring-4 border-blue-400': nowStep === 888 }">
            <span v-if="!isEdit" class="break-all" @click="campaignNameEdit(true)" >{{campaign_name}}</span>
            <!-- 新手教學 -->
            <span v-if="!isEdit && campaign_name == ''" class="text-gray-400 break-all" @click="campaignNameEdit(true)">{{showLang[selectLang]['views']['EventAdd']['campaign_name_text']}}</span>
            <textarea v-if="isEdit" class="w-full border p-1" v-model="campaign_name" @blur="campaignNameEdit(false)"></textarea>
            <i class="pi pi-pencil cursor-pointer float-right" style="fontSize: 0.8rem" @click="isEdit=!isEdit"></i>
          </div>
          <div v-for="(item, index) in menu" :key="index" class="d2-step-group">
            <div
              v-if="item?.show"
              class="d2-step-header"
              :class="{ 'active': item?.target === target }">
              <div class="d2-step-num" :class="item?.open ? (item?.target === target ? 'current' : 'done') : 'locked'">
                <span>{{ index + 1 }}</span>
              </div>
              <span class="d2-step-text" :class="{ 'locked': !item?.click }">{{ item?.title }}</span>
              <i class="fas fa-lock d2-step-lock" v-if="!item?.open"></i>
            </div>
            <div v-if="item?.open">
              <div
                class="d2-step-sub"
                :class="{ 'active': item?.target === target }"
                @click="getHere(item?.target, item?.click, sub?.refName, sub?.groupType)"
                v-for="(sub, idx) in item?.submenu" :key="idx">
                <span v-if="sub.checked" class="check"><i class="fas fa-check-circle"></i></span>
                <span v-if="sub.show">{{ sub.title }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 新手教學 -->
      <div
        id="edit_content"
        class="d2-evt-editor"
        ref="scrollcontent"
        :style="{ overflowY: nowStep > -1 ? 'hidden !important' : null }"
      >
        <div v-show="target == 1">
          <div class="flex flex-wrap mb-2">
            <div class="d2-panel-main bg-white rounded-xl space-y-4">
              <div class="flex items-center justify-between">
                <span class="text-gray-700 align-middle">行銷活動版本</span>
                <div class="flex items-center space-x-3">
                  <span :class="simple_mode === 0 ? 'text-blue-700 font-medium' : 'text-gray-400'">專業版本</span>
                  <InputSwitch :model-value="simple_mode === 1" :disabled="cancelEdit" @update:model-value="changeSimpleMode" />
                  <span :class="simple_mode === 1 ? 'text-blue-700 font-medium' : 'text-gray-400'">簡易版</span>
                </div>
              </div>
            </div>
            <div class="d2-panel-tips rounded-xl space-y-2 px-4"></div>
          </div>
          <CampaignName
            ref="childCampaignName"
            :guideStep="nowStep"
            v-bind:editPage="cancelEdit"
            v-bind:teachingId="teaching_id"
            v-bind:lang="showLang[selectLang]"
            v-model:viewDatalist="campaign_name"
            v-bind:useDefaultLayout="useDefaultLayout"
            @childCampaignName="campaignData"
            @childOpenTeaching="openTeaching"
          />
          <BudgetType
            ref="childBudgetType"
            v-bind:editPage="cancelEdit"
            v-bind:lang="showLang[selectLang]"
            v-model:viewDatalist="budget_type"
            @childBudgetType="budgetTypeData"
          />
          <div v-if="simple_mode === 1" class="flex flex-wrap mb-2">
            <div class="d2-panel-main bg-white rounded-xl space-y-4">
              <div><span class="text-red-500">*</span><span class="text-gray-700 align-middle">預算金額</span></div>
              <div class="flex items-center max-w-md">
                <input v-if="budget_type === 'daily'" v-model.number="methodData.daily_budget" :disabled="cancelEdit" type="text" inputmode="numeric" class="p-inputtext p-component w-full" placeholder="請輸入單日預算" oninput="value=value.replace(/[^\d]/g,'')" @focus="$event.target.select()" @blur="ensureSimpleDailyBudgetMinimum" @input="syncSimpleBudget" />
                <input v-else v-model.number="total_budget" :disabled="cancelEdit" type="text" inputmode="numeric" class="p-inputtext p-component w-full" placeholder="請輸入總經費" oninput="value=value.replace(/[^\d]/g,'')" @focus="clearSimpleBudgetZero('lifetime')" @input="syncSimpleBudget" />
                <span class="ml-3 whitespace-nowrap text-gray-500">{{ currencyData.currency || currencyData.currency_symbol }}{{ budget_type === 'daily' ? '/day' : '' }}</span>
              </div>
            </div>
            <div class="d2-panel-tips rounded-xl space-y-2 px-4"></div>
          </div>
          <SpecialAdCategory
            ref="childSpecialAdCategory"
            v-bind:editPage="cancelEdit"
            v-bind:lang="showLang[selectLang]"
            v-model:viewDatalist="special_ad_category"
            @childSpecialAdCategory="specialAdCategoryData"
          />
          <MarketingMethod
            v-if="simple_mode === 0"
            ref="childMarketingMethod"
            :guideStep="nowStep"
            v-bind:editPage="cancelEdit"
            v-bind:budgetType="budget_type"
            v-bind:specialAdCategory="special_ad_category"
            v-bind:goalsObjective="getGoalsObjective"
            v-bind:currencyList="currencyData"
            v-bind:teachingId="teaching_id"
            v-bind:lang="showLang[selectLang]"
            v-bind:youtubeClose="youtubeClose"
            v-bind:otherCustomTitle="otherCustomTitle"
            v-bind:defaultLayout="defaultLayout"
            v-bind:useDefaultLayout="useDefaultLayout"
            v-bind:ecdAudienceList="ecdAudienceList"
            v-model:viewDatalist="methodData"
            @checkClose="changeYoutubeType"
            @childYoutube="childYoutube"
            @childTargetKW="methodTargetKW"
            @childTargetDM="methodTargetDM"
            @childTargetLA="methodTargetLA"
            @childTargetRT="methodTargetRT"
            @childTargetCF="methodTargetCF"
            @childTargetAD="methodTargetAD"
            @childTargetCR="methodTargetCR"
            @childTargetEC="methodTargetEC"
            @childTargetAC="methodTargetAC"
            :paymentPlanId="paymentPlanId"
            @childBudgetKWTotal="methodBudgetKWTotal"
            @childDefaultLayout="getDefaultLayout"
            @childOtherCustom="getOtherCustom"
            @childHideCustom="setHideCustom"
          />
          <BenefitsAndInvestment :locale="selectLang"
            ref="childBenefitAndContribution"
            v-bind:editPage="cancelEdit"
            v-bind:budgetType="budget_type"
            v-bind:viewDatalist="benefitsAndInvestmentData"
            v-bind:lang="showLang[selectLang]"
          />
          <AdBudgetAutoAdjust
            v-if="simple_mode === 0 && budget_type !== 'lifetime'"
            ref="childAdBudgetAutoAdjust"
            v-bind:editPage="cancelEdit"
            v-bind:lang="showLang[selectLang]"
            v-bind:currencySymbol="currencyData.currency"
            v-bind:originalDailyBudget="methodData.daily_budget"
            v-model:viewDatalist="autoAdjustData"
          />
          <AdvantageAbTest
            v-if="showTargetAC && !onlyTargetAC"
            v-bind:editPage="cancelEdit"
            v-model:viewDatalist="methodData"
          />
          <CustomRules
            v-if="(showTargetCR === true || showOtherTargetCR === true) && useDefaultLayout === null"
            v-bind:editPage="cancelEdit"
            v-bind:viewDatalist="keywordData"
            v-bind:defaultStage="defaultStage"
            v-bind:stageMenu="stageMenu"
            v-bind:menu="menu"
            v-model:customRulesDataList="customRulesData"
            v-bind:lang="showLang[selectLang]"
            v-bind:youtubeClose="youtubeClose"
            @checkClose="changeYoutubeType"
            @childYoutube="childYoutube"
            @childKeywordUrl="keywordUrl"
            @childHaveTest="haveTest"
            @childUseASC="useASC"
          />
          <StageDynamicBudget
            v-show="(showTargetCR === true || showOtherTargetCR === true) && useDefaultLayout === null"
            v-bind:editPage="cancelEdit"
            v-bind:viewDatalist="dynBudgetData"
            v-bind:lang="showLang[selectLang]"
          />
          <StageDoForward
            v-show="(showTargetCR === true || showOtherTargetCR === true) && useDefaultLayout === null"
            v-bind:editPage="cancelEdit"
            v-bind:viewDatalist="doForwardData"
            v-bind:lang="showLang[selectLang]"
          />
          <KeywordMix
            ref="childKeywordMix"
            :guideStep="nowStep"
            v-if="(showTargetAD || showTargetKW || showTargetLA) && !onlyTargetAC"
            v-bind:editPage="cancelEdit"
            v-bind:targetKW="showTargetKW"
            v-bind:targetAD="showTargetAD"
            v-bind:viewDatalist="keywordData"
            v-bind:lang="showLang[selectLang]"
            v-bind:youtubeClose="youtubeClose"
            v-model:viewDatalist="methodData"
            @checkClose="changeYoutubeType"
            @childYoutube="childYoutube"
            @childKeywordUrl="keywordUrl"
            @childUrlKeywordsList="urlKeywordsList"
            @childKeywordsSuggestList="keywordsSuggestList"
          />
          <AdvertisingMix
            ref="childAdvertisingMix"
            :guideStep="nowStep"
            v-if="showTargetLA && !onlyTargetAC"
            v-bind:showAdvertisingMix="showAdvertisingMix"
            v-bind:editPage="cancelEdit"
            v-bind:viewDatalist="lookData"
            v-bind:adaccountId="adaccount_id"
            v-bind:pixelId="formPixelId"
            v-bind:productUrl="productUrl"
            v-bind:lang="showLang[selectLang]"
          />
          <RemarketingMix
            ref="childRemarketingMix"
            :guideStep="nowStep"
            v-if="showTargetRT && !onlyTargetAC"
            v-bind:showRemarketingMix="showRemarketingMix"
            v-bind:editPage="cancelEdit"
            v-bind:viewDatalist="audiencesData"
            v-bind:adaccountId="adaccount_id"
            v-bind:pixelId="formPixelId"
            v-bind:productUrl="productUrl"
            v-bind:lang="showLang[selectLang]"
          />
          <EcdMix
            ref="childEcdMix"
            :guideStep="nowStep"
            v-if="showTargetEC"
            v-bind:showEcdMix="showEcdMix"
            v-bind:editPage="cancelEdit"
            v-bind:viewDatalist="methodData"
            v-bind:adaccountId="adaccount_id"
            v-bind:lang="showLang[selectLang]"
          />
          <MarketingDate
            ref="childMarketingDate"
            v-bind:showMarketingDate="showMarketingDate"
            v-bind:editPage="cancelEdit"
            v-bind:budgetType="budget_type"
            v-bind:viewDatalist="dateData"
            v-bind:lang="showLang[selectLang]"
            v-bind:youtubeClose="youtubeClose"
            v-bind:efficientAi="efficientAi"
            @checkClose="changeYoutubeType"
            @childYoutube="childYoutube"
            @childGapTime="dateGapTime"
            @childEndTime="dateEndTime"
            @childUseEndDate="dateUseEndDate"
          />
        </div>
        <!-- <div v-show="target == 2">
          <KeywordMix v-if="showTargetKW || showTargetLA" v-bind:editPage="cancelEdit" v-bind:targetKW="showTargetKW" v-bind:viewDatalist="keywordData" @childKeywordUrl="keywordUrl" />
          <AdvertisingMix v-if="showTargetLA" v-bind:showAdvertisingMix="showAdvertisingMix" v-bind:editPage="cancelEdit" v-bind:viewDatalist="lookData" v-bind:adaccountId="adaccount_id" v-bind:pageId="formPageId" v-bind:productUrl="productUrl" />
        </div> -->
        <div v-show="target == 2">
          <div v-show="showTargetCR == true || showOtherTargetCR == true || useDefaultLayout !== null">
            <StageBlock
              v-bind:editPage="cancelEdit"
              v-bind:lang="showLang[selectLang]"
              v-model:viewDatalist="campaign_name"
              v-model:customRulesDataList="customRulesData"
              @childCampaignName="campaignData"
              @childChangeEdit="changeEdit"
            />
            <StageKeywordMix
              v-bind:editPage="cancelEdit"
              v-bind:targetKW="showTargetKW"
              v-bind:targetAD="showTargetAD"
              v-bind:viewDatalist="customRulesData.subCampaignsContent[customRulesData.editIndex].keywordData"
              v-bind:stageContent="customRulesData.subCampaignsContent[customRulesData.editIndex]"
              v-bind:lang="showLang[selectLang]"
              v-bind:youtubeClose="youtubeClose"
              @checkClose="changeYoutubeType"
              @childYoutube="childYoutube"
              @childKeywordUrl="keywordUrl"
            />
            <StageAdvertisingMix
              v-bind:showAdvertisingMix="showAdvertisingMix"
              v-bind:editPage="cancelEdit"
              v-bind:viewDatalist="customRulesData.subCampaignsContent[customRulesData.editIndex].lookData"
              v-bind:stageContent="customRulesData.subCampaignsContent[customRulesData.editIndex]"
              v-bind:adaccountId="adaccount_id"
              v-bind:pixelId="formPixelId"
              v-bind:productUrl="productUrl"
              v-bind:lang="showLang[selectLang]"
            />
            <StageRemarketingMix
              v-bind:showRemarketingMix="showRemarketingMix"
              v-bind:editPage="cancelEdit"
              v-bind:viewDatalist="customRulesData.subCampaignsContent[customRulesData.editIndex].audiencesData"
              v-bind:stageContent="customRulesData.subCampaignsContent[customRulesData.editIndex]"
              v-bind:adaccountId="adaccount_id"
              v-bind:pixelId="formPixelId"
              v-bind:productUrl="productUrl"
              v-bind:lang="showLang[selectLang]"
            />
            <StageGoalsAndBudget
              v-bind:showGoalsAndBudget="showGoalsAndBudget"
              v-bind:stageContentAll="customRulesData"
              v-bind:stageContent="customRulesData.subCampaignsContent[customRulesData.editIndex]"
              v-bind:stageContentLength="customRulesData.subCampaignsContent.length"
              v-bind:stageIndex="customRulesData.editIndex"
              v-bind:editPage="cancelEdit"
              v-bind:viewDatalist="goalsData"
              v-bind:getDate="returnGapTime"
              v-bind:budgetKWTotal="budgetKW"
              v-bind:useEndDate="returnUseEndDate"
              v-bind:formMinAddition="updateMinAddition"
              v-bind:currencyList="currencyData"
              v-bind:lang="showLang[selectLang]"
              v-bind:useLang="selectLang"
              v-bind:youtubeClose="youtubeClose"
              v-bind:haveASC="haveASC"
              v-bind:useDefaultLayout="useDefaultLayout"
              @checkClose="changeYoutubeType"
              @childYoutube="childYoutube"
              @childObjective="goalsObjective"
              @childObjectiveOption="objectiveOption"
            />
            <StageRegions
              v-bind:editPage="cancelEdit"
              v-bind:viewDatalist="regionsData"
              v-bind:stageContentAll="customRulesData"
              v-bind:stageContent="customRulesData.subCampaignsContent[customRulesData.editIndex]"
              v-bind:stageIndex="customRulesData.editIndex"
              v-bind:viewRelationshipDatalist="exAudiencesData"
              v-bind:campaignId="campaign_id"
              v-bind:targetDM="showTargetDM"
              v-bind:lang="showLang[selectLang]"
              v-bind:youtubeClose="youtubeClose"
              v-model:selectCountries="selectCountries"
              v-model:selectLangs="selectLangs"
              @checkClose="changeYoutubeType"
              @childYoutube="childYoutube"
            />
            <StagePositionDeviceIdentity
              v-bind:editPage="cancelEdit"
              v-bind:viewDatalist="pdData"
              v-bind:stageContentAll="customRulesData"
              v-bind:stageContent="customRulesData.subCampaignsContent[customRulesData.editIndex]"
              v-bind:stageIndex="customRulesData.editIndex"
              v-bind:autoPublisher="auto_publisher"
              v-bind:publisherPlatforms="publisher_platforms"
              v-bind:lang="showLang[selectLang]"
              v-bind:showIdentity="showIdentity"
              v-bind:viewIdentityDatalist="idData"
              v-bind:youtubeClose="youtubeClose"
              @checkClose="changeYoutubeType"
              @childYoutube="childYoutube"
              @childPageId="eventPageId"
            />
            <StageMaterial
              v-bind:showStageMaterial="showStageMaterial"
              v-bind:showStageAdvertisingMaterial="showStageAdvertisingMaterial"
              v-bind:showStageForm="showStageForm"
              v-bind:showStageMsg="showStageMsg"
              v-bind:editPage="cancelEdit"
              v-bind:viewDatalist="customRulesData.subCampaignsContent[customRulesData.editIndex].postData"
              v-bind:viewFormDatalist="idData"
              v-bind:stageContentAll="customRulesData"
              v-bind:stageContent="customRulesData.subCampaignsContent[customRulesData.editIndex]"
              v-bind:stageIndex="customRulesData.editIndex"
              v-bind:pageId="formPageId"
              v-bind:goalsObjective="getGoalsObjective"
              v-bind:optimizationAction="currentOptimizationAction"
              v-bind:campaignId="campaign_id"
              v-bind:lang="showLang[selectLang]"
              v-bind:youtubeClose="youtubeClose"
              v-bind:changeFormId="changeFormId"
              v-bind:changeMessageId="changeMessageId"
              v-bind:firstFormId="first_form_id"
              v-bind:formStatus="form_status"
              v-bind:formId="formId"
              v-bind:firstMessageId="first_message_id"
              v-bind:messageStatus="message_status"
              v-bind:messageId="messageId"
              v-bind:useTeachDetail="use_teach_detail"
              v-bind:showTargetCR="showTargetCR"
              v-bind:showOtherTargetCR="showOtherTargetCR"
              v-bind:useDefaultLayout="useDefaultLayout"
              v-model:viewAdMaterialDatalist="customRulesData.subCampaignsContent[customRulesData.editIndex].adMaterialData"
              @checkClose="changeYoutubeType"
              @childYoutube="childYoutube"
              @childActiveScroll="activeScroll"
              @childFormId="eventFormId"
              @childMessageId="eventMessageId"
              @childContent="adMaterialContent"
              @childChangeMessageId="formChangeMessageId"
            />
          </div>

          <div v-show="showTargetCR != true && showOtherTargetCR != true && useDefaultLayout === null">
            <GoalsAndBudget
              ref="childGoalsAndBudget"
              :guideStep="nowStep"
              v-bind:showGoalsAndBudget="showGoalsAndBudget"
              v-bind:editPage="cancelEdit"
              v-bind:viewDatalist="goalsData"
              v-bind:getDate="returnGapTime"
              v-bind:budgetKWTotal="budgetKW"
              v-bind:useEndDate="returnUseEndDate"
              v-bind:formMinAddition="updateMinAddition"
              v-bind:currencyList="currencyData"
              v-bind:lang="showLang[selectLang]"
              v-bind:useLang="selectLang"
              v-bind:youtubeClose="youtubeClose"
              v-bind:efficientAi="efficientAi"
              v-bind:advantagePlusAC="simple_mode === 1 ? budget_type === 'lifetime' : showTargetAC"
              @checkClose="changeYoutubeType"
              @childYoutube="childYoutube"
              @childObjective="goalsObjective"
              @childObjectiveOption="objectiveOption"
            />
            <Regions
              ref="childRegions"
              :guideStep="nowStep"
              v-bind:editPage="cancelEdit"
              v-bind:viewDatalist="regionsData"
              v-bind:targetDM="showTargetDM"
              v-model:selectCountries="selectCountries"
              v-model:selectLangs="selectLangs"
              v-bind:lang="showLang[selectLang]"
              v-bind:youtubeClose="youtubeClose"
              v-bind:efficientAi="efficientAi"
              v-bind:onlyAdvantagePlus="onlyTargetAC"
              @checkClose="changeYoutubeType"
              @childYoutube="childYoutube"
            />
            <Relationship
              v-if="!onlyTargetAC"
              ref="childRelationship"
              :guideStep="nowStep"
              v-bind:showRelationship="showRelationship"
              v-bind:editPage="cancelEdit"
              v-bind:viewDatalist="exAudiencesData"
              v-bind:campaignId="db_campaign_id"
              v-bind:lang="showLang[selectLang]"
              v-bind:youtubeClose="youtubeClose"
              @checkClose="changeYoutubeType"
              @childYoutube="childYoutube"
            />
          </div>
        </div>
        <div v-show="target == 3">
          <div v-show="showTargetCR != true && showOtherTargetCR != true && useDefaultLayout === null">
            <PositionAndDevice
              v-if="simple_mode === 0"
              ref="childPositionDevice"
              :guideStep="nowStep"
              v-bind:editPage="cancelEdit"
              v-bind:viewDatalist="pdData"
              v-bind:autoPublisher="auto_publisher"
              v-bind:publisherPlatforms="publisher_platforms"
              v-bind:lang="showLang[selectLang]"
              v-bind:youtubeClose="youtubeClose"
              @checkClose="changeYoutubeType"
              @childYoutube="childYoutube"
            />
            <Identity
              ref="childIdentity"
              :guideStep="nowStep"
              v-bind:showIdentity="showIdentity"
              v-bind:editPage="cancelEdit"
              v-bind:viewDatalist="idData"
              v-bind:lang="showLang[selectLang]"
              v-bind:youtubeClose="youtubeClose"
              @childPageId="eventPageId"
              @checkClose="changeYoutubeType"
              @childYoutube="childYoutube"
            />
            <Material
              ref="childMaterial"
              :guideStep="nowStep"
              v-if="showMaterial"
              v-bind:editPage="cancelEdit"
              v-bind:viewDatalist="postData"
              v-bind:pageId="formPageId"
              v-bind:igId="idData.ig_id"
              v-bind:goalsObjective="getGoalsObjective"
              v-bind:optimizationAction="currentOptimizationAction"
              v-bind:campaignId="db_campaign_id"
              v-bind:lang="showLang[selectLang]"
              v-bind:youtubeClose="youtubeClose"
              v-bind:selectStatus="selectStatus"
              v-bind:efficientAi="efficientAi"
              @checkClose="changeYoutubeType"
              @childYoutube="childYoutube"
              @childActiveScroll="activeScroll"
              @nextStep="nextStep"
              @emptyStep="nextStep"
            />
            <AdvertisingMaterial
              ref="childCustomizeMaterial"
              :guideStep="nowStep"
              v-bind:editPage="cancelEdit"
              v-bind:pageId="formPageId"
              v-bind:goalsObjective="getGoalsObjective"
              v-bind:optimizationAction="currentOptimizationAction"
              v-bind:changeFormId="changeFormId"
              v-bind:changeMessageId="changeMessageId"
              v-bind:lang="showLang[selectLang]"
              v-model:viewDatalist="adMaterialDataNew"
              @childFormId="eventFormId"
              @childMessageId="eventMessageId"
              @childContent="adMaterialContent"
              @setAdvertisingMaterialType="setAdvertisingMaterialType"
              :style="[showAdvertisingMaterial ? '' : 'display:none;', (nowStep >= 58 && nowStep <= 74) || (nowStep == 5801) ? 'z-index: 100; position: relative;' : null]"
            />
            <Form
              :guideStep="nowStep"
              v-if="showForm"
              v-bind:editPage="cancelEdit"
              v-bind:viewDatalist="idData"
              v-bind:pageId="formPageId"
              v-bind:goalsObjective="getGoalsObjective"
              v-bind:firstFormId="first_form_id"
              v-bind:formId="formId"
              v-bind:teachingId="teaching_id"
              v-bind:useTeachDetail="use_teach_detail"
              v-bind:targetAllSkip="targetAllSkip"
              v-bind:formTeachingOver="formTeachingOver"
              v-bind:selectLang="selectLang"
              v-bind:campaignId="db_campaign_id"
              v-bind:lang="showLang[selectLang]"
              @childChangeFormId="formChangeFormId"
              @childFormTeachingOver="activeFormTeachingOver"
            />
            <Msg
              :guideStep="nowStep"
              v-if="showMsg"
              v-bind:editPage="cancelEdit"
              v-bind:viewDatalist="idData"
              v-bind:pageId="formPageId"
              v-bind:goalsObjective="getGoalsObjective"
              v-bind:firstMessageId="first_message_id"
              v-bind:messageId="messageId"
              v-bind:teachingId="teaching_id"
              v-bind:useTeachDetail="use_teach_detail"
              v-bind:targetAllSkip="targetAllSkip"
              v-bind:msgTeachingOver="msgTeachingOver"
              v-bind:campaignId="db_campaign_id"
              v-bind:lang="showLang[selectLang]"
              @childChangeMessageId="formChangeMessageId"
              @childMsgTeachingOver="formMsgTeachingOver"
            />
          </div>
        </div>
      </div>
    </main>
	<!-- 新手教學 -->
    <footer class="d2-bottom-bar" :style="nowStep === 999 ? { zIndex: 100 } : null">
      <div class="d2-progress-wrap">
        <div class="d2-progress-track"><div class="d2-progress-fill" :style="{width: `${process}%`}"></div></div>
        <span class="d2-progress-text">{{showLang[selectLang]['views']['EventAdd']['process_text_a']}} {{process}} % {{showLang[selectLang]['views']['EventAdd']['process_text_b']}}</span>
      </div>
      <div class="d2-progress-mobile">{{showLang[selectLang]['views']['EventAdd']['process_text_a']}} {{process}} % {{showLang[selectLang]['views']['EventAdd']['process_text_b']}}</div>
      <div class="d2-bottom-btns">
        <button class="d2-btn-evt outline" @click="form_update()"><i class="fas fa-save"></i> {{showLang[selectLang]['views']['EventAdd']['save_button']}}</button>
        <button v-if="canRelease" class="d2-btn-evt yellow" @click="release()"><i class="fas fa-paper-plane"></i> {{showLang[selectLang]['views']['EventAdd']['release_button']}}</button>
        <button v-if="this.target != 1" class="d2-btn-evt ghost" @click="prev()" :disabled="process <= 0"><i class="fas fa-chevron-left"></i> {{showLang[selectLang]['views']['EventAdd']['prev_text']}}</button>
        <button class="d2-btn-evt primary" @click="next()">{{showLang[selectLang]['views']['EventAdd']['next_text']}} <i class="fas fa-chevron-right"></i></button>
      </div>
    </footer>

    <!-- 新手教學 -->
    <Mask :isDisplay="nowStep > -1" />
    <StartTips
      v-if="nowStep === 0"
      :nowStep="nowStep"
      :selectLang="selectLang"
      @nextStep="nextStep"
      @closeTips="closeTips"
    />
    <CampaignNameTips
      v-if="nowStep == 111"
      :nowStep="nowStep"
      :selectLang="selectLang"
      @nextStep="nextStep"
      @closeTips="closeTips"
    />
    <MarketingMehodTips
      v-if="(nowStep > 0 && nowStep <= 6) || nowStep == 2001"
      :nowStep="nowStep"
      :selectLang="selectLang"
      @nextStep="nextStep"
      @closeTips="closeTips"
    />
    <KeywordTips
      v-if="nowStep >= 7 && nowStep <= 12"
      :nowStep="nowStep"
      :selectLang="selectLang"
      @nextStep="nextStep"
      @closeTips="closeTips"
    />
    <AdvertisingMixTips
      v-if="nowStep >= 13 && nowStep <= 18"
      :nowStep="nowStep"
      :selectLang="selectLang"
      @nextStep="nextStep"
      @closeTips="closeTips"
    />
    <GoalsAndBudgetTips
      v-if="(nowStep >= 19 && nowStep <= 34) || (nowStep == 271 || nowStep == 272)"
      :nowStep="nowStep"
      :selectLang="selectLang"
      :efficientAi="efficientAi"
      @nextStep="nextStep"
      @closeTips="closeTips"
    />
    <RegionsTips
      v-if="nowStep >= 35 && nowStep <= 39"
      :nowStep="nowStep"
      :selectLang="selectLang"
      :efficientAi="efficientAi"
      @nextStep="nextStep"
      @closeTips="closeTips"
    />
    <RelationshipTips
      v-if="nowStep >= 40 && nowStep <= 44"
      :nowStep="nowStep"
      :selectLang="selectLang"
      @nextStep="nextStep"
      @closeTips="closeTips"
    />
    <PositionAndDeviceTips
      v-if="nowStep >= 45 && nowStep <= 49"
      :nowStep="nowStep"
      :selectLang="selectLang"
      @nextStep="nextStep"
      @closeTips="closeTips"
    />
    <IdentityTips
      v-if="nowStep === 50"
      :nowStep="nowStep"
      :selectLang="selectLang"
      @nextStep="nextStep"
    />
    <MaterialTips
      v-if="(nowStep >= 51 && nowStep <= 57) || (nowStep >= 501 && nowStep <= 503) || (nowStep == 11001 || nowStep == 11002)"
      :nowStep="nowStep"
      :selectLang="selectLang"
      @nextStep="nextStep"
      @backStep="backStep"
      @closeTips="closeTips"
    />
    <AdvertisingMaterialTips
      v-if="(nowStep >= 58 && nowStep <= 74) || (nowStep == 5801)"
      :nowStep="nowStep"
      :selectLang="selectLang"
      @nextStep="nextStep"
      @closeTips="closeTips"
      @switchToOtherStep="switchToOtherStep"
    />
    <FormTips
      v-if="nowStep >= 75 && nowStep <= 78 && showForm"
      :nowStep="nowStep"
      :selectLang="selectLang"
      @nextStep="nextStep"
      @closeTips="closeTips"
    />
    <MsgTips
      v-if="nowStep >= 75 && nowStep <= 78 && showMsg"
      :nowStep="nowStep"
      :selectLang="selectLang"
      @nextStep="nextStep"
      @closeTips="closeTips"
    />
    <!-- <NameTips
      v-if="nowStep === 888"
      :nowStep="nowStep"
      :selectLang="selectLang"
      @nextStep="nextStep"
    /> -->
    <NextSectionTips
      v-if="nowStep === 999"
      :nowStep="nowStep"
      :selectLang="selectLang"
    />
    <!-- 新手教學 -->
  </div>
</template>

<script>
import validateRegulatedCountries from '@/utils/validateRegulatedCountries'
  // <!-- 新手教學 -->
  import Mask from '@/components/Event/Mask.vue';
  import StartTips from '@/components/Tips/StartTips.vue';
  import CampaignNameTips from '@/components/Tips/CampaignNameTips.vue';
  import MarketingMehodTips from '@/components/Tips/MarketingMehodTips.vue';
  import KeywordTips from '@/components/Tips/KeywordTips.vue';
  import AdvertisingMixTips from '@/components/Tips/AdvertisingMixTips.vue';
  import GoalsAndBudgetTips from '@/components/Tips/GoalsAndBudgetTips.vue';
  import RegionsTips from '@/components/Tips/RegionsTips.vue';
  import RelationshipTips from '@/components/Tips/RelationshipTips.vue';
  import PositionAndDeviceTips from '@/components/Tips/PositionAndDeviceTips.vue';
  import IdentityTips from '@/components/Tips/IdentityTips.vue';
  import MaterialTips from '@/components/Tips/MaterialTips.vue';
  import FormTips from '@/components/Tips/FormTips.vue';
  import MsgTips from '@/components/Tips/MsgTips.vue';
  import AdvertisingMaterialTips from '@/components/Tips/AdvertisingMaterialTips.vue';
  import NextSectionTips from '@/components/Tips/NextSectionTips.vue';
  import NameTips from '@/components/Tips/NameTips.vue';
  // <!-- 新手教學 -->
  import Header from '@/components/Header.vue'
  import CampaignName from '@/components/Event/CampaignName.vue'
  import BudgetType from '@/components/Event/BudgetType.vue'
  import SpecialAdCategory from '@/components/Event/SpecialAdCategory.vue'
  import MarketingMethod from '@/components/Event/MarketingMethod.vue'
  import BenefitsAndInvestment from '@/components/Event/BenefitsAndInvestment.vue'
  import AdBudgetAutoAdjust from '@/components/Event/AdBudgetAutoAdjust.vue'
  import AdvantageAbTest from '@/components/Event/AdvantageAbTest.vue'
  import MarketingDate from '@/components/Event/MarketingDate.vue'
  import CustomRules from '@/components/Event/CustomRules.vue'
  import KeywordMix from '@/components/Event/KeywordMix.vue'
  import AdvertisingMix from '@/components/Event/AdvertisingMix.vue'
  import RemarketingMix from '@/components/Event/RemarketingMix.vue';
  import EcdMix from '@/components/Event/EcdMix.vue';
  import StageDynamicBudget from '@/components/Event/StageDynamicBudget.vue'
  import StageDoForward from '@/components/Event/StageDoForward.vue'
  import StageKeywordMix from '@/components/Event/StageKeywordMix.vue'
  import StageAdvertisingMix from '@/components/Event/StageAdvertisingMix.vue'
  import StageRemarketingMix from '@/components/Event/StageRemarketingMix.vue'
  import StageBlock from '@/components/Event/StageBlock.vue'
  import StageGoalsAndBudget from '@/components/Event/StageGoalsAndBudget.vue'
  import StageRegions from '@/components/Event/StageRegions.vue'
  import StagePositionDeviceIdentity from '@/components/Event/StagePositionDeviceIdentity.vue'
  import StageMaterial from '@/components/Event/StageMaterial.vue'
  import GoalsAndBudget from '@/components/Event/GoalsAndBudget.vue'
  import Regions from '@/components/Event/Regions.vue'
  import Identity from '@/components/Event/Identity.vue'
  import Relationship from '@/components/Event/Relationship.vue'
  import PositionAndDevice from '@/components/Event/PositionAndDevice.vue'
  import Material from '@/components/Event/Material.vue'
  import AdvertisingMaterial from '@/components/Event/AdvertisingMaterial.vue'
  import Form from '@/views/Form.vue'
  import Msg from '@/views/Msg.vue'
  import Swal from 'sweetalert2/dist/sweetalert2.js'
  import 'sweetalert2/dist/sweetalert2.min.css'
  import Loading from 'vue3-loading-overlay';
  import InputSwitch from 'primevue/inputswitch';
  import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
  import "vue3-circle-progress/dist/circle-progress.css";
  import CircleProgress from "vue3-circle-progress";
  import axios from 'axios'
  import Qs from 'qs'
  import lang from '@/language/lang.json'
  import { reactive, toRaw } from 'vue';

  export default {
    name: 'Home',
    components: {
      InputSwitch,
      // <!-- 新手教學 -->
      Mask,
      StartTips,
      CampaignNameTips,
      MarketingMehodTips,
      KeywordTips,
      AdvertisingMixTips,
      GoalsAndBudgetTips,
      RegionsTips,
      RelationshipTips,
      PositionAndDeviceTips,
      IdentityTips,
      MaterialTips,
      FormTips,
      MsgTips,
      AdvertisingMaterialTips,
      NextSectionTips,
      NameTips,
      // <!-- 新手教學 -->
      Header,
      CampaignName,
      BudgetType,
      SpecialAdCategory,
      MarketingMethod,
      BenefitsAndInvestment,
      AdBudgetAutoAdjust,
      AdvantageAbTest,
      MarketingDate,
      CustomRules,
      KeywordMix,
      AdvertisingMix,
      RemarketingMix,
      EcdMix,
      StageDynamicBudget,
      StageDoForward,
      StageKeywordMix,
      StageAdvertisingMix,
      StageRemarketingMix,
      StageBlock,
      StageGoalsAndBudget,
      StageRegions,
      StagePositionDeviceIdentity,
      StageMaterial,
      GoalsAndBudget,
      Regions,
      Identity,
      Relationship,
      PositionAndDevice,
      Material,
      AdvertisingMaterial,
      Form,
      Msg,
      Loading,
      CircleProgress
    },
    data() {
      return {
        selectLang: 'zh-TW',
        showLang: lang,
        nowStep: -1, // <!-- 新手教學 -->
        openStep: 1, // <!-- 新手教學 -->
        teaching_id: 0, // <!-- 新手教學 -->
        isAreadlyOpenShowTargetKW: false, // <!-- 新手教學 -->
        isAreadlyOpenshowTargetLA: false, // <!-- 新手教學 -->
        isAreadlyOpenshowGoalsAndBudget: false, // <!-- 新手教學-要跟scroll搭配 -->
        isAreadlyOpenshowRegions: false, // <!-- 新手教學-要跟scroll搭配 -->
        isAreadlyOpenshowRelationship: false, // <!-- 新手教學-要跟scroll搭配 -->
        isAreadlyOpenshowPositionAndDevice: false, // <!-- 新手教學-要跟scroll搭配 -->
        isAreadlyOpenshowMaterial: false, // <!-- 新手教學-要跟scroll搭配 -->
        isAreadlyOpenshowAdvertisingMaterial: false, // <!-- 新手教學-要跟scroll搭配 -->
        isAreadlyOpenshowFormMsg: false, // <!-- 新手教學-要跟scroll搭配 -->
        isAreadlyShowRegionsTips: true, // <!-- 新手教學 -->
        isAreadlyShowRelationshipTips: true, // <!-- 新手教學 -->
        advertisingMaterialType: 1, // <!-- 新手教學 -->
        use_teach_detail: true, // <!-- 新手教學 -->
        msgTeachingOver: 0, // <!-- 新手教學 -->
        formTeachingOver: 0, // <!-- 新手教學 -->
        isAlreadyShowNameTips: false,
        targetTwoStatus: true,
        targetThreeStatus: true,
        targetAllSkip: 1,

        showCampaignData: false,
        db_campaign_id: null,
        showMarketingDate: false,
        showAdvertisingMix:'false_0',
        showRemarketingMix:'false_0',
        showGoalsAndBudget: false,
        showRelationship: false,
        showIdentity: false,
        canRelease: true,
        display: false,
        cancelEdit: false,
        process: 0,
        showTargetKW: true,
        urlKeywordsListData: [],
        keywordsSuggestListData: [],
        showTargetDM: true,
        showTargetLA: true,
        showTargetRT: true,
        showTargetCF: true,
        showTargetAD: true,
        showTargetAC: false,
        onlyTargetAC: false,
        showTargetCR: true,
        showOtherTargetCR: false,
        showTargetEC: false,
        showEcdMix: false,
        returnGapTime: null,
        returnEndTime: null,
        returnUseEndDate: null,
        budgetKW:null,
        updateMinAddition: 0,
        getGoalsObjective: null,
        showMaterial:true,
        showAdvertisingMaterial:true,
        showForm:true,
        showMsg:true,
        isEdit: false,
        campaign_id: null,
        campaign_name: null,
        simple_mode: 1,
        simpleModeMethodBackup: null,
        budget_type: 'daily',
        special_ad_category: 'NONE',
        adaccount_id: null,
        productUrl: null,
        adaccount_name: null,
        target: 1,
        click: 0,
        formPixelId: null,
        currentOptimizationAction: '',
        formPageId: null,
        selectStatus: false,
        formId: null,
        messageId: null,
        changeFormId: null,
        changeMessageId: null,
        menu: [],
        _tmpMenu: [],
        Budget_KW_result: null,
        total_budget: null,
        currencyData: {
                      currency: '',
                      currency_name: null,
                      currency_symbol: null,
                      currency_min_price: null,
                      currency_video_min_price: null,
                      currency_suggest_price: null,
                      currency_remarketing_price: null,
                      currency_offset: 1,
                    },
        methodData: {
                    Target_KW:null,
                    Budget_KW:'',
                    Target_DM:null,
                    Budget_DM:'',
                    Target_LA:null,
                    Budget_LA:'',
                    Target_RT:null,
                    Budget_RT:'',
                    use_confldential_audience_status:0,
                    Target_CF:null,
                    Budget_CF:null,
                    Target_EC:null,
                    Budget_EC:'',
                    ecd_audiences: [],
                    Target_AD:null,
                    Budget_AD_min:null,
                    Budget_AD_max:null,
                    Target_CR:null,
                    Other_Target_CR: null,
                    Target_AC: null,
                    Budget_AC: 0,
                    advantage_ab_test: false,
                    retargeting:null,
                    daily_budget:null
                  },
        benefitsAndInvestmentData: {
          useFinance: false,
          toTaiwan: false,
          regulated_countries: [],
          country_options: [],
          benefits: null,
          benefits_list: [],
          investment: null,
          investment_list: [],
          person_or_business: {label : '個人或商家驗證', value : 1},
          beneficiary_id: null,
          payer_id: null,
          beneficiary_name: null,
          payer_name: null,
          beneOrPayerPersonalList:[],
          selectedBeneficiary: null,
          selectedPayer: null,
          showKeyinBeneficiary: null,
          showKeyinPayer: null,
        },
        autoAdjustData: {
          // 功能開關
          raise_enabled: false,
          // 判斷層級
          scope_level: 'CAMPAIGN',
          // 成效條件設定
          raise_filter: {
            field: 'CPA',
            operator: 'LESS_THAN_EQUAL',
            value: null
          },
          lookback_window_days: 1,
          adjust_times_per_day: 1,
          // 加碼／減碼幅度與預算限制
          step_pct: 10,
          min_daily_budget: null,
          max_daily_budget: null,
          // 調整後預算
          adjusted_daily_budget: null
        },
        customRulesData: {
          editIndex: 0,
          haveTest: true,
          stageList: [
            { marketingValue: 'META_KW'},
            { marketingValue: 'META_LA'},
            { marketingValue: 'META_RT'}
          ],
          subCampaignsContent: [
            {
              method : 'META_TEST',
              release : {
                sr_i : 0,
                status : ''
              },
              goalsData: {
                showBlock: true,
                campaign_objective: null,
                objective_option:null,
                objective_list:null,
                product_catalog_list:null,
                product_set_list:null,
                optimization_action:null,
                optimization_goal:null,
                product_catalog_id:null,
                product_set_id:null,
                pixel_id:null,
                pixel_event:null,
                conversion_domain:null,
                domain_list:null,
              },
              budgetData: {
                showBlock: true,
                daily_budget:0,
                effect:null,
                currency_video_min_price:null,
                form_addition:null,
                use_addition:null,
                risk_automatic:null,
                risk_index:null,
                risk_level_list:null,
                risk_level:null
              },
              forwardData: {
                showBlock: true,
                ditto_forward: '0',
                frequency: '1d',
                rule_frequency: [],
              },
              stopData: {
                showBlock: true,
                ditto_stop: '0',
                rule_stop: [],
              },
              budgetExtraData: {
                showBlock: true,
                ditto_budget_extra: '0',
                amount: 0,
                frequency: 0,
                budget_extra_list: [],
              },
              localData: {
                showBlock: true,
                ditto_local: '0',
                location_types:null,
                locations:null,
                location_range:null,
                locales:null
              },
              demoData: {
                showBlock: true,
                ditto_demo: '0',
                gender:null,
                age_min:null,
                age_max:null
              },
              exAudiencesData: {
                showBlock: true,
                ditto_connect: '0',
                excluded_audiences:null,
                default_excluded_audiences:null,
                custom_excluded_audiences:null,
                custom_excluded_audiences_selected:null,
              },
              pdData: {
                showBlock: true,
                ditto_identity: '0',
                auto_publisher:null,
                publisher_platforms:null,
                publisher_platforms_list:null,
                device_platforms: null,
                user_os:null,
                user_os_list:null,
                page_id:null,
                ig_id:null,
                ig_username:null,
                adpages_list:null,
                ig_list:null,
              },
              postData: {
                showBlock: true,
                ditto_creative: '0',
                page_id:null,
                special_ad_category:null,
                disabled_creative_optimize:false,
                creative_optimize:false,
                select_article:null,
                db_select_article:null,
                select_creatives:null,
                db_select_creatives:null,
                select_creatives_message:null,
                db_select_creatives_message:null,
                select_creatives_adset_ads:null,
                db_select_creatives_adset_ads:null,
                select_creatives_adset_ads_message:null,
                db_select_creatives_adset_ads_message:null,
              },
              adMaterialData: {
                showBlock: true,
                ditto_creative: '0',
                disabled_creative_optimize:false,
                creative_optimize:false,
                creative_array:null,
              },
            },
            {
              method : 'META_KW',
              release : {
                sr_i : 0,
                status : ''
              },
              goalsData: {
                showBlock: true,
                campaign_objective: null,
                objective_option:null,
                objective_list:null,
                product_catalog_list:null,
                product_set_list:null,
                optimization_action:null,
                optimization_goal:null,
                product_catalog_id:null,
                product_set_id:null,
                pixel_id:null,
                pixel_event:null,
                conversion_domain:null,
                domain_list:null,
              },
              budgetData: {
                showBlock: true,
                daily_budget:0,
                effect:null,
                currency_video_min_price:null,
                form_addition:null,
                use_addition:null,
                risk_automatic:null,
                risk_index:null,
                risk_level_list:null,
                risk_level:null
              },
              budgetExtraData: {
                showBlock: true,
                ditto_budget_extra: '0',
                amount: 0,
                frequency: 0,
                budget_extra_list: [],
              },
              forwardData: {
                showBlock: true,
                ditto_forward: '0',
                frequency: '1d',
                rule_frequency: [],
              },
              stopData: {
                showBlock: true,
                ditto_stop: '0',
                rule_stop: [],
              },
              localData: {
                showBlock: true,
                ditto_local: '0',
                location_types:null,
                locations:null,
                location_range:null,
                locales:null
              },
              demoData: {
                showBlock: true,
                ditto_demo: '0',
                gender:null,
                age_min:null,
                age_max:null
              },
              exAudiencesData: {
                showBlock: true,
                ditto_connect: '0',
                excluded_audiences:null,
                default_excluded_audiences:null,
                custom_excluded_audiences:null,
                custom_excluded_audiences_selected:null,
              },
              pdData: {
                showBlock: true,
                ditto_identity: '0',
                auto_publisher:null,
                publisher_platforms:null,
                publisher_platforms_list:null,
                device_platforms: null,
                user_os:null,
                user_os_list:null,
                page_id:null,
                ig_id:null,
                ig_username:null,
                adpages_list:null,
                ig_list:null,
              },
              postData: {
                showBlock: true,
                ditto_creative: '0',
                page_id:null,
                special_ad_category:null,
                disabled_creative_optimize:false,
                creative_optimize:false,
                select_article:null,
                db_select_article:null,
                select_creatives:null,
                db_select_creatives:null,
                select_creatives_message:null,
                db_select_creatives_message:null,
                select_creatives_adset_ads:null,
                db_select_creatives_adset_ads:null,
                select_creatives_adset_ads_message:null,
                db_select_creatives_adset_ads_message:null,
              },
              adMaterialData: {
                showBlock: true,
                ditto_creative: '0',
                disabled_creative_optimize:false,
                creative_optimize:false,
                creative_array:null,
              },
            },
            {
              method : 'META_LA',
              release : {
                sr_i : 0,
                status : ''
              },
              goalsData: {
                showBlock: true,
                campaign_objective: null,
                objective_option:null,
                objective_list:null,
                product_catalog_list:null,
                product_set_list:null,
                optimization_action:null,
                optimization_goal:null,
                product_catalog_id:null,
                product_set_id:null,
                pixel_id:null,
                pixel_event:null,
                conversion_domain:null,
                domain_list:null,
              },
              budgetData: {
                showBlock: true,
                daily_budget:0,
                effect:null,
                currency_video_min_price:null,
                form_addition:null,
                use_addition:null,
                risk_automatic:null,
                risk_index:null,
                risk_level_list:null,
                risk_level:null
              },
              budgetExtraData: {
                showBlock: true,
                ditto_budget_extra: '0',
                amount: 0,
                frequency: 0,
                budget_extra_list: [],
              },
              forwardData: {
                showBlock: true,
                ditto_forward: '0',
                frequency: '1d',
                rule_frequency: [],
              },
              stopData: {
                showBlock: true,
                ditto_stop: '0',
                rule_stop: [],
              },
              localData: {
                showBlock: true,
                ditto_local: '0',
                location_types:null,
                locations:null,
                location_range:null,
                locales:null
              },
              demoData: {
                showBlock: true,
                ditto_demo: '0',
                gender:null,
                age_min:null,
                age_max:null
              },
              exAudiencesData: {
                showBlock: true,
                ditto_connect: '0',
                excluded_audiences:null,
                default_excluded_audiences:null,
                custom_excluded_audiences:null,
                custom_excluded_audiences_selected:null,
              },
              pdData: {
                showBlock: true,
                ditto_identity: '0',
                auto_publisher:null,
                publisher_platforms:null,
                publisher_platforms_list:null,
                device_platforms: null,
                user_os:null,
                user_os_list:null,
                page_id:null,
                ig_id:null,
                ig_username:null,
                adpages_list:null,
                ig_list:null,
              },
              postData: {
                showBlock: true,
                ditto_creative: '0',
                page_id:null,
                special_ad_category:null,
                disabled_creative_optimize:false,
                creative_optimize:false,
                select_article:null,
                db_select_article:null,
                select_creatives:null,
                db_select_creatives:null,
                select_creatives_message:null,
                db_select_creatives_message:null,
                select_creatives_adset_ads:null,
                db_select_creatives_adset_ads:null,
                select_creatives_adset_ads_message:null,
                db_select_creatives_adset_ads_message:null,
              },
              adMaterialData: {
                showBlock: true,
                ditto_creative: '0',
                disabled_creative_optimize:false,
                creative_optimize:false,
                creative_array:null,
              },
            },
            {
              method : 'META_RT',
              release : {
                sr_i : 0,
                status : ''
              },
              goalsData: {
                showBlock: true,
                campaign_objective: null,
                objective_option:null,
                objective_list:null,
                product_catalog_list:null,
                product_set_list:null,
                optimization_action:null,
                optimization_goal:null,
                product_catalog_id:null,
                product_set_id:null,
                pixel_id:null,
                pixel_event:null,
                conversion_domain:null,
                domain_list:null,
              },
              budgetData: {
                showBlock: true,
                daily_budget:0,
                effect:null,
                currency_video_min_price:null,
                form_addition:null,
                use_addition:null,
                risk_automatic:null,
                risk_index:null,
                risk_level_list:null,
                risk_level:null
              },
              budgetExtraData: {
                showBlock: true,
                ditto_budget_extra: '0',
                amount: 0,
                frequency: 0,
                budget_extra_list: [],
              },
              forwardData: {
                showBlock: true,
                ditto_forward: '0',
                frequency: '1d',
                rule_frequency: [],
              },
              stopData: {
                showBlock: true,
                ditto_stop: '0',
                rule_stop: [],
              },
              localData: {
                showBlock: true,
                ditto_local: '0',
                location_types:null,
                locations:null,
                location_range:null,
                locales:null
              },
              demoData: {
                showBlock: true,
                ditto_demo: '0',
                gender:null,
                age_min:null,
                age_max:null
              },
              exAudiencesData: {
                showBlock: true,
                ditto_connect: '0',
                excluded_audiences:null,
                default_excluded_audiences:null,
                custom_excluded_audiences:null,
                custom_excluded_audiences_selected:null,
              },
              pdData: {
                showBlock: true,
                ditto_identity: '0',
                auto_publisher:null,
                publisher_platforms:null,
                publisher_platforms_list:null,
                device_platforms: null,
                user_os:null,
                user_os_list:null,
                page_id:null,
                ig_id:null,
                ig_username:null,
                adpages_list:null,
                ig_list:null,
              },
              postData: {
                showBlock: true,
                ditto_creative: '0',
                page_id:null,
                special_ad_category:null,
                disabled_creative_optimize:false,
                creative_optimize:false,
                select_article:null,
                db_select_article:null,
                select_creatives:null,
                db_select_creatives:null,
                select_creatives_message:null,
                db_select_creatives_message:null,
                select_creatives_adset_ads:null,
                db_select_creatives_adset_ads:null,
                select_creatives_adset_ads_message:null,
                db_select_creatives_adset_ads_message:null,
              },
              adMaterialData: {
                showBlock: true,
                ditto_creative: '0',
                disabled_creative_optimize:false,
                creative_optimize:false,
                creative_array:null,
              },
            },
          ]
        },
        otherCustomTitle:[],
        defaultLayout: [],
        defaultStage: [],
        stageMenu: [],
        formCampaignHaveTest: true,
        dynBudgetData: {
          useDynamicBudget: false
        },
        doForwardData: {
          useDoForward: false
        },
        dateData: {
                    start_date:null,
                    end_date:null,
                    use_end_date:null,
                  },
        keywordData: {
                      product_url:null,
                      keywords:null,
                      keyword_list:null,
                      base_keyword_list: [],
                      select_keywords:null
                    },
        lookData: {
                    default_lookalikes:null,
                    custom_lookalikes:null,
                    custom_lookalikes_selected:null,
                    default_lookalikes_list:null,
                    custom_lookalikes_list:null
                  },
        audiencesData: {
                    default_audiences:null,
                    custom_audiences:null,
                    custom_audiences_selected:null,
                    default_audiences_list:null,
                    custom_audiences_list:null
                  },
        ecdAudienceList: [],
        goalsData: {
                    campaign_objective:null,
                    objective_option:null,
                    objective_list:null,
                    product_catalog_list:null,
                    product_set_list:null,
                    optimization_action:null,
                    optimization_goal:null,
                    product_catalog_id:null,
                    product_set_id:null,
                    pixel_id:null,
                    pixel_event:null,
                    conversion_domain:null,
                    domain_list:null,
                    useAppEvent: false,
                    appItemsSelected: null,
                    appItemsList: [],
                    effect:null,
                    currency_video_min_price:null,
                    form_addition:null,
                    use_addition:null,
                    risk_automatic:null,
                    risk_index:null,
                    risk_level_list:null,
                    risk_level:null
                  },
        regionsData: {
                      location_types:null,
                      locations:null,
                      location_range:null,
                      locales:null,
                      gender:null,
                      age_min:null,
                      age_max:null
                    },
        selectCountries: null,
        selectLangs: null,
        exAudiencesData: {
                      excluded_audiences:null,
                      default_excluded_audiences:null,
                      custom_excluded_audiences:null,
                      custom_excluded_audiences_selected:null,
                    },
        pdData: {
                  auto_publisher:null,
                  publisher_platforms:null,
                  publisher_platforms_list:null,
                  device_platforms: null,
                  user_os:null,
                  user_os_list:null,
                },
        auto_publisher: null,
        publisher_platforms: null,
        idData: {
                  page_id:null,
                  ig_id:null,
                  ig_username:null,
                  adpages_list:null,
                  ig_list:null,
                },
        postData: {
                  page_id:null,
                  special_ad_category:null,
                  disabled_creative_optimize:false,
                  creative_optimize:false,
                  select_article:[],
                  db_select_article:null,
                  select_creatives:null,
                  db_select_creatives:null,
                  select_creatives_message:null,
                  db_select_creatives_message:null,
                  select_creatives_adset_ads:null,
                  db_select_creatives_adset_ads:null,
                  select_adset_ads_message:null,
                  db_select_adset_ads_message:null,
                  select_creatives_adset_ads_message:null,
                  db_select_creatives_adset_ads_message:null,
                },
        adMaterialData: {
                          disabled_creative_optimize:false,
                          creative_optimize:false,
                          creative_array:null,
                        },
        tmpAdMaterialDataNew:{
                            disabled_creative_optimize:false,
                            creative_optimize:false,
                            creative_array:null,
                          },
        adMaterialDataNew:{
                            disabled_creative_optimize:false,
                            creative_optimize:false,
                            creative_array:null,
                          },
        formData: {
                    pageId: null,
                    formId: null
                  },
        msgData: {
                    pageId: null,
                    msgId: null
                  },
        first_form_id: null,
        first_message_id: null,
        AdvertisingMaterialStatus: undefined,
        releaseType: true,
        efficientAi: null,
        style: 'z-index: -1;',
        releaseText: '發佈中...',
        releasePercent: 5,
        allPageLoading: false,
        youtubeClose: false,
        isEmptySelect: '',
        isClass: 'n',
        haveASC: 'false_',
        otherCustomCampaignId: null,
        subCampaignList: [],
        nextLoading: false,
        useDefaultLayout: null,
        getHereTarget: null,
        getHereRefName: null,
        getHereGroupType: null,
      }
    },
    created() {
      // console.log('id:'+this.$route.params.id);
      // console.log('adaccount_id:'+this.$route.params.adaccount_id);
      // console.log('campaign_id:'+this.$route.params.campaign_id);

      let hash = this.$route.params.id;

      if(hash != '' && hash != null && typeof hash != 'undefined'){
        axios
          .post('https://www.autoturn.net/api/member_info.php', Qs.stringify({
            s_code: this.$route.params.id,
          }), {withCredentials: true})
          .then((adResponse) => {
            // console.log('adResponse:'+adResponse.data.selecded_data);
            // console.log('sidebar member_info.php');
            if(adResponse.data.status == 'success'){

              this.paymentPlanId = adResponse.data.return_data.payment_plan_id;

              if(adResponse.data.return_data.source == 6 && adResponse.data.return_data.payment_plan_id == 1){
                this.isClass = 'y';
              }

            } else {
              Swal.fire({
                icon: 'error',
                title: this.showLang[this.selectLang]['views']['EventAdd']['created']['no_hash_swal_title'],
                text: adResponse.data.info,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['created']['no_hash_swal_confirm_button']
                // denyButtonText: `Don't save`,
              }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                  // Swal.fire('Saved!', '', 'success')
                  // this.allPageLoading = true
                  window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
                } else if (result.isDenied) {
                  // Swal.fire('Changes are not saved', '', 'info')
                  // this.allPageLoading = true
                  window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
                }
              })
            }
          });

        axios
          .post('https://www.autoturn.net/api/lib/default_stage.php', Qs.stringify({
            s_code: this.$route.params.id,
            adaccount_id: this.$route.params.adaccount_id,
          }))
          .then((dsResponse) => {
            // console.log('dsResponse:'+dsResponse.data.selecded_data);
        //  console.log('lib default_stage.php');
        //  console.log(dsResponse.data);
            if(dsResponse.data.status == 'success'){
              this.defaultStage = dsResponse.data.return_data;
              this.stageMenu = dsResponse.data.menu;

          //  console.log('this.defaultStage');
          //  console.log(this.defaultStage);
          //  console.log('this.stageMenu');
          //  console.log(this.stageMenu);

              axios
                .post('https://www.autoturn.net/api/campaign_create_default.php', Qs.stringify({
                  s_code: this.$route.params.id,
                  adaccount_id: this.$route.params.adaccount_id,
                  campaign_id: this.$route.params.campaign_id
                }))
                .then((response) => {
                  if(response.data.status == 'success'){
                    this.campaign_id = this.$route.params.campaign_id
                    this.campaign_name = response.data.return_data.campaign_name
                    this.originName = response.data.return_data.campaign_name;
                    this.adaccount_id = response.data.return_data.adaccount_id
                    this.adaccount_name = response.data.return_data.adaccount_name
                    this.productUrl = response.data.return_data.product_url

                    this.showTargetKW = response.data.return_data.Target_KW
                    this.showTargetLA = response.data.return_data.Target_LA
                    this.showTargetRT = response.data.return_data.Target_RT;
                    this.showTargetAD = response.data.return_data.Target_AD
                    this.showTargetAC = response.data.return_data.Target_AC
                    this.showTargetCR = response.data.return_data.Target_CR

                    this.defaultLayout = response.data.return_data.default_layout;

                    this.otherCustomTitle = response.data.return_data.other_subset_data;

                    this.benefitsAndInvestmentData = {
                      toTaiwan: response.data.return_data.toTaiwan,
                      regulated_countries: response.data.return_data.regulated_countries,
                      country_options: response.data.return_data.country_options,
                      useFinance: response.data.return_data.useFinance,
                      benefits: response.data.return_data.benefits,
                      benefits_list: response.data.return_data.benefits_list,
                      investment: response.data.return_data.investment,
                      investment_list: response.data.return_data.investment_list,
                      person_or_business: response.data.return_data.person_or_business,
                      beneficiary_id: response.data.return_data.beneficiary_id,
                      payer_id: response.data.return_data.payer_id,
                      beneficiary_name: response.data.return_data.beneficiary_name,
                      payer_name: response.data.return_data.payer_name,
                      beneOrPayerPersonalList: response.data.return_data.beneficiary_or_payer_personal_list,
                      selectedBeneficiary: response.data.return_data.selected_beneficiary,
                      selectedPayer: response.data.return_data.selected_payer,
                      showKeyinBeneficiary: response.data.return_data.show_keyin_beneficiary,
                      showKeyinPayer: response.data.return_data.show_keyin_payer,
                    };
                    this.normalizeBenefitsAndInvestmentData();

                    let startTime = response.data.return_data.start_date;
                    let endTime = response.data.return_data.end_date;
                    let diffType = 'day';

                    let gapTime = 0;

                    if(startTime != '' && startTime != '0000-00-00' && startTime != null && endTime != '' && endTime != '0000-00-00' && endTime != null){
                      diffType = diffType.toLowerCase();
                      var sTime = new Date(startTime); //開始時間
                      var eTime = new Date(endTime); //結束時間
                      //作為除數的數字
                      var timeType = 1;
                      switch (diffType) {
                          case"second":
                              timeType =1000;
                          break;
                          case"minute":
                              timeType =1000*60;
                          break;
                          case"hour":
                              timeType =1000*3600;
                          break;
                          case"day":
                              timeType =1000*3600*24;
                          break;
                          default:
                          break;
                      }
                      gapTime = parseInt((eTime.getTime() - sTime.getTime()) / parseInt(timeType));
                    }

                    this.budgetKW = response.data.return_data.Budget_KW;
                    this.returnGapTime = gapTime;
                    this.returnEndTime = response.data.return_data.end_date;
                    this.returnUseEndDate = response.data.return_data.use_end_date;
                    this.Budget_KW_result = response.data.return_data.Budget_KW_result;
                    this.total_budget = response.data.return_data.total_budget;

                    this.currencyData = {
                                          currency: response.data.return_data.currency,
                                          currency_name: response.data.return_data.currency_name,
                                          currency_symbol: response.data.return_data.currency_symbol,
                                          currency_min_price: response.data.return_data.currency_min_price,
                                          currency_video_min_price: response.data.return_data.currency_video_min_price,
                                          currency_suggest_price: response.data.return_data.currency_suggest_price,
                                          currency_remarketing_price: response.data.return_data.currency_remarketing_price,
                                          KW_min_price: response.data.return_data.KW_min_price,
                                          DM_min_price: response.data.return_data.DM_min_price,
                                          LA_min_price: response.data.return_data.LA_min_price,
                                          RT_min_price: response.data.return_data.RT_min_price,
                                          currency_offset: response.data.return_data.offset,
                                          EC_min_price: response.data.return_data.EC_min_price,
                                          AC_min_price: response.data.return_data.AC_min_price,
                                        }

                    this.methodData = {
                                        Target_KW : response.data.return_data.Target_KW,
                                        Budget_KW : response.data.return_data.Budget_KW,
                                        Target_DM : response.data.return_data.Target_DM,
                                        Budget_DM : response.data.return_data.Budget_DM,
                                        Target_LA : response.data.return_data.Target_LA,
                                        Budget_LA : response.data.return_data.Budget_LA,
                                        Target_RT : response.data.return_data.Target_RT,
                                        Budget_RT : response.data.return_data.Budget_RT,
                                        Target_CF : response.data.return_data.Target_CF,
                                        Budget_CF : response.data.return_data.Budget_CF,
                                        Target_EC : response.data.return_data.Target_EC,
                                        Budget_EC : response.data.return_data.Budget_EC,
                                        ecd_audiences : response.data.return_data.ecd_audiences ? response.data.return_data.ecd_audiences.split(',') : [],
                                        Target_AD : response.data.return_data.Target_AD,
                                        Budget_AD_min : response.data.return_data.Budget_AD_min,
                                        Budget_AD_max : response.data.return_data.Budget_AD_max,
                                        Target_CR : response.data.return_data.Target_CR,
                                        Other_Target_CR : false,
                                        Target_AC : response.data.return_data.Target_AC,
                                        Budget_AC : response.data.return_data.Budget_AC,
                                        advantage_ab_test : response.data.return_data.advantage_ab_test,
                                        use_similar_audience_status : response.data.return_data.use_similar_audience_status,
                                        use_confldential_audience_status : response.data.return_data.use_confldential_audience_status,
                                        retargeting : response.data.return_data.retargeting,
                                        daily_budget : response.data.return_data.daily_budget
                                      }

                    this.updateOnlyTargetAC();

                    this.dynBudgetData = {
                      useDynamicBudget: response.data.return_data.use_dynamic_budget,
                    }

                    this.doForwardData = {
                      useDoForward: response.data.return_data.use_do_forward,
                    }

                    this.dateData = {
                                      start_date : response.data.return_data.start_date,
                                      end_date : response.data.return_data.end_date,
                                      use_end_date : response.data.return_data.use_end_date
                                    }

                    this.showMarketingDate = true;

                    this.keywordData = {
                                          product_url : response.data.return_data.product_url,
                                          keywords : response.data.return_data.keywords,
                                          keyword_list : response.data.return_data.keyword_list,
                                          base_keyword_list: response.data.return_data.base_keyword_list,
                                          select_keywords : response.data.return_data.keywords
                                        }

                    this.lookData = {
                                      default_lookalikes : response.data.return_data.default_lookalikes,
                                      custom_lookalikes : response.data.return_data.custom_lookalikes,
                                      custom_lookalikes_selected : response.data.return_data.custom_lookalikes_selected,
                                      default_lookalikes_list : response.data.return_data.default_lookalikes_list,
                                      custom_lookalikes_list : response.data.return_data.custom_lookalikes_list
                                    }

                    var todayForm = new Date();
                    var yearForm = todayForm.getFullYear();
                    var dateForm = String(todayForm.getDate()).padStart(2, '0');
                    var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                    var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                    let get_value_la = 'true_'+yearForm + monthForm + dateForm + timeForm;

                    this.showAdvertisingMix = get_value_la;

                    this.audiencesData = {
                                      default_audiences : response.data.return_data.default_audiences,
                                      custom_audiences : response.data.return_data.custom_audiences,
                                      custom_audiences_selected : response.data.return_data.custom_audiences_selected,
                                      default_audiences_list : response.data.return_data.default_audiences_list,
                                      custom_audiences_list : response.data.return_data.custom_audiences_list
                                    }

                    var todayForm = new Date();
                    var yearForm = todayForm.getFullYear();
                    var dateForm = String(todayForm.getDate()).padStart(2, '0');
                    var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                    var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                    let get_value_rt = 'true_'+yearForm + monthForm + dateForm + timeForm;

                    this.showRemarketingMix = get_value_rt;

                    this.goalsData = {
                                        campaign_objective : response.data.return_data.campaign_objective,
                                        objective_option : response.data.return_data.objective_option,
                                        objective_list : response.data.return_data.objective_list,
                                        product_catalog_list : response.data.return_data.product_catalog_list,
                                        product_set_list : response.data.return_data.product_set_list,
                                        optimization_action : response.data.return_data.optimization_action,
                                        optimization_goal : response.data.return_data.optimization_goal,
                                        product_catalog_id : response.data.return_data.product_catalog_id,
                                        product_set_id : response.data.return_data.product_set_id,
                                        useAppEvent: response.data.return_data.useAppEvent,
                                        appItemsSelected: response.data.return_data.appItemsSelected,
                                        appItemsList: response.data.return_data.appItemsList,
                                        pixel_id : response.data.return_data.pixel_id,
                                        pixel_event : response.data.return_data.pixel_event,
                                        conversion_domain : response.data.return_data.conversion_domain,
                                        domain_list: response.data.return_data.domain_list,
                                        effect : response.data.return_data.effect,
                                        currency_video_min_price: response.data.return_data.currency_video_min_price,
                                        form_addition : response.data.return_data.form_addition,
                                        use_addition : response.data.return_data.use_addition,
                                        risk_automatic : response.data.return_data.risk_automatic,
                                        risk_index : response.data.return_data.risk_index,
                                        risk_level_list: response.data.return_data.risk_level_list,
                                        risk_level: response.data.return_data.risk_level
                                      }

                //  console.log('this.goalsData');
                //  console.log(this.goalsData);

                    this.showGoalsAndBudget = true;

                    this.regionsData = {
                                          location_types : response.data.return_data.location_types,
                                          location_item : response.data.return_data.location_item,
                                          locations : response.data.return_data.locations,
                                          location_range : response.data.return_data.location_range,
                                          locales : response.data.return_data.locales,
                                          gender : response.data.return_data.gender,
                                          age_min : response.data.return_data.age_min,
                                          age_max : response.data.return_data.age_max
                                        }

                    if(response.data.return_data.Target_DM == true){
                      this.regionsData.age_min = 18;
                      this.regionsData.age_max = 65;
                    }

                    this.selectCountries = response.data.return_data.locations

                    this.selectLangs = response.data.return_data.locales

                    this.exAudiencesData = {
                                              excluded_audiences : response.data.return_data.excluded_audiences,
                                              default_excluded_audiences : response.data.return_data.default_excluded_audiences,
                                              custom_excluded_audiences : response.data.return_data.custom_excluded_audiences,
                                              custom_excluded_audiences_selected : response.data.return_data.custom_excluded_audiences_selected,
                                            }

                    this.showRelationship = true;

                    this.pdData = {
                                    auto_publisher : response.data.return_data.auto_publisher,
                                    publisher_platforms : response.data.return_data.publisher_platforms,
                                    publisher_platforms_list : response.data.return_data.publisher_platforms_list,
                                    device_platforms: response.data.return_data.device_platforms,
                                    user_os : response.data.return_data.user_os,
                                    user_os_list : response.data.return_data.user_os_list
                                  }

                    this.auto_publisher = response.data.return_data.auto_publisher
                    this.publisher_platforms = response.data.return_data.publisher_platforms

                    this.idData = {
                                    page_id : response.data.return_data.page_id,
                                    ig_id : response.data.return_data.ig_id,
                                    ig_username : response.data.return_data.ig_username,
                                    adpages_list : response.data.return_data.adpages_list,
                                    ig_list : response.data.return_data.ig_list,
                                  }

                    this.showIdentity = true;

                    this.simpleModeMethodBackup = JSON.parse(JSON.stringify(this.methodData))
                    this.simple_mode = 1
                    this.methodData.simple_mode = this.simple_mode
                    this.budget_type = response.data.return_data.budget_type || 'daily'
                    this.special_ad_category = response.data.return_data.special_ad_category || 'NONE'
                    this.applySimpleModeRules()

                    this.postData = {
                                      page_id : response.data.return_data.page_id,
                                      special_ad_category : this.special_ad_category,
                                      disabled_creative_optimize : response.data.return_data.disabled_creative_optimize,
                                      creative_optimize: response.data.return_data.creative_optimize,
                                      db_select_article : response.data.return_data.post_ids,
                                    }

                    this.adMaterialData = {
                                            disabled_creative_optimize : response.data.return_data.disabled_creative_optimize,
                                            creative_optimize: response.data.return_data.creative_optimize,
                                            creative_array : response.data.return_data.creative_array,
                                          }

                    this.tmpAdMaterialDataNew = {
                                                  disabled_creative_optimize : response.data.return_data.disabled_creative_optimize,
                                                  creative_optimize: response.data.return_data.creative_optimize,
                                                  creative_array : response.data.return_data.creative_array
                                                }

                    this.formPixelId = response.data.return_data.pixel_id

                    this.formPageId = response.data.return_data.page_id

                    this.first_form_id = response.data.return_data.first_form_id

                    this.first_message_id = response.data.return_data.first_message_id

                    // console.log('load this.adMaterialData');
                    // console.log(this.adMaterialData);

                    // console.log('response.data.return_data.form_addition:'+response.data.return_data.form_addition);
                    // console.log('b this.goalsData:'+this.goalsData.form_addition);
                    this.minAddition(response.data.return_data.form_addition, gapTime, response.data.return_data.Budget_KW, this.returnUseEndDate);
                    // console.log('a this.goalsData:'+this.goalsData.form_addition);

                    this.showCampaignData = true;

                //  console.log('response.data.return_data.openStep');
                //  console.log(response.data.return_data.openStep);
                //  console.log('b this.nowStep');
                //  console.log(this.nowStep);
                //  console.log('b this.teaching_id');
                //  console.log(this.teaching_id);

                    this.nowStep = -1;
                    if(response.data.return_data.openStep == 0){
                      this.nowStep = 0;
                      this.targetTwoStatus = false
                      this.targetThreeStatus = false
                      this.targetAllSkip = 0
                      this.isAreadlyShowRegionsTips = false
                      this.isAreadlyShowRelationshipTips = false
                      this.teaching_id = response.data.return_data.teaching_id;
                    }

                //  console.log('a this.nowStep');
                //  console.log(this.nowStep);
                //  console.log('a this.teaching_id');
                //  console.log(this.teaching_id);

                    this.$router.push({ query: { step: this.nowStep }});
                  }

                  if(response.data.status == 'login'){
                    Swal.fire({
                      icon: 'error',
                      title: this.showLang[this.selectLang]['views']['EventAdd']['created']['login_error_swal_title'],
                      text: this.showLang[this.selectLang]['views']['EventAdd']['created']['login_error_swal_text'],
                      showDenyButton: false,
                      showCancelButton: false,
                      confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['created']['login_error_swal_confirm_button']
                      // denyButtonText: `Don't save`,
                    }).then((result) => {
                      /* Read more about isConfirmed, isDenied below */
                      if (result.isConfirmed) {
                        // Swal.fire('Saved!', '', 'success')
                        // this.allPageLoading = true
                        window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
                      } else if (result.isDenied) {
                        // Swal.fire('Changes are not saved', '', 'info')
                        // this.allPageLoading = true
                        window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
                      }
                    })
                  }
                });
            }
          });
      } else {
        Swal.fire({
          icon: 'error',
          title: this.showLang[this.selectLang]['views']['EventAdd']['created']['no_hash_swal_title'],
          text: this.showLang[this.selectLang]['views']['EventAdd']['created']['no_hash_swal_text'],
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['created']['no_hash_swal_confirm_button']
          // denyButtonText: `Don't save`,
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            // Swal.fire('Saved!', '', 'success')
            // this.allPageLoading = true
            window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
          } else if (result.isDenied) {
            // Swal.fire('Changes are not saved', '', 'info')
            // this.allPageLoading = true
            window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
          }
        })
      }
    },
    // <!-- 新手教學 -->
    watch:{
      // showTargetKW(val) {
      //   if (val) {
      //     if (!this.isAreadlyOpenShowTargetKW) {
      //       this.nowStep = 7;
      //       this.$router.push({ query: { step: this.nowStep }});
      //     }
      //   }
      // },
      // showTargetLA(val) {
      //   if (val) {
      //     if (!this.isAreadlyOpenshowTargetLA) {

      //       this.nowStep = 13;
      //       this.$router.push({ query: { step: this.nowStep }});
      //       setTimeout(()=> {
      //         this.$refs.scrollcontent.scrollTo({
      //           top: 300,
      //           behavior: 'smooth'
      //         });

      //       }, 1000);
      //     }
      //   }
      // },
      target(val) {
        //console.log('target');
        //console.log(val);
        if (val === 2) {
          if(this.targetTwoStatus == false){
            this.nowStep = 19;
            this.$router.push({ query: { step: this.nowStep }});

            //console.log('this.nowStep');
            //console.log(this.nowStep);

            this.$refs.scrollcontent.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
          }
        } else if (val === 3) {
          if(this.targetThreeStatus == false){
            this.nowStep = 45;
            this.$router.push({ query: { step: this.nowStep }});

            //console.log('this.nowStep');
            //console.log(this.nowStep);

            this.$refs.scrollcontent.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
          }
        }
      },
      AdvertisingMaterialStatus(status) {
        // console.log('watch AdvertisingMaterialStatus');
        // console.log(status);
        if (status) {
          // console.log(status);
          this.$nextTick().then(() =>
            this.$refs.scrollcontent.scrollTo({
              top: 1505,
              behavior: 'smooth'
            })
          );
        }
      },
      sub_campaigns(v){
    //  console.log('sub_campaigns');
    //  console.log(v);
      },
      'customRulesData': function(v){
    //  console.log('customRulesData');
    //  console.log(this.customRulesData)
      },
      'menu':function(v){
    //  console.log('menu content');
    //  console.log(v);
      },
      'doForwardData.useDoForward':function(v){
    //  console.log('doForwardData.useDoForward');
    //  console.log(v);

        let subCampaignsContentLength = this.customRulesData.subCampaignsContent.length;

        if(v == true){
          if(this.customRulesData.haveTest == true){
            for (var i = 0; i < subCampaignsContentLength; i++) {
              if(i >= 2){
                this.customRulesData.subCampaignsContent[i].forwardData.showBlock = false;
              }
            }
          } else {
            for (var i = 0; i < subCampaignsContentLength; i++) {
              if(i >= 1){
                this.customRulesData.subCampaignsContent[i].forwardData.showBlock = false;
              }
            }
          }
        } else {
          for (var i = 0; i < subCampaignsContentLength; i++) {
            this.customRulesData.subCampaignsContent[i].forwardData.showBlock = true;
          }
        }

    //  console.log(this.customRulesData);
      }
      // 'formPageId': function(v){
      //   console.log('event formPageId');
      //   console.log(v);
      // },
      // 'idData.page_id': function(v){
      //   console.log('event idData.page_id');
      //   console.log(v);
      // }
    },
    // <!-- 新手教學 -->
    mounted() {
      // document.title = '行銷活動建立頁 - AutoTurn';

      //console.log('this.$route.query');
      //console.log(this.$route.query);
      //console.log('this.nowStep');
      //console.log(this.nowStep);
      if (this.$route.query.step) {
        this.nowStep = Number(this.$route.query.step);
      } else {
        this.$router.push({ query: { step: this.nowStep }});
      }
      // scroll
      const _self = this;
      const scrollRegions = this.isAreadlyOpenshowRegions
      const scrollRelationship = this.isAreadlyOpenshowRelationship
      this.$refs.scrollcontent.addEventListener('scroll', function () {
        //console.log('_self.isAreadlyOpenshowRegions');
        //console.log(_self.isAreadlyOpenshowRegions);
        //console.log('_self.isAreadlyOpenshowRelationship');
        //console.log(_self.isAreadlyOpenshowRelationship);
        if (_self.target === 2 && _self.nowStep === -1) {
          let deRegionsTop = 780
          let regionsTop = 780
          let deRelationshipTop = 1000
          let relationshipTop = 1450
          if(_self.efficientAi == true){
            deRegionsTop = 300
            regionsTop = 300
            deRelationshipTop = 800
            // relationshipTop = 655
          }

          if (_self.$refs.scrollcontent.scrollTop >= deRegionsTop && !_self.isAreadlyShowRegionsTips && (_self.isAreadlyOpenshowRegions == false || typeof _self.isAreadlyOpenshowRegions == undefined)) {
            _self.nowStep = 35;
            _self.$router.push({ query: { step: _self.nowStep }});
            _self.$refs.scrollcontent.scrollTo({
              top: regionsTop,
              behavior: 'smooth'
            });
          }

          if (_self.$refs.scrollcontent.scrollTop >= deRelationshipTop && !_self.isAreadlyShowRelationshipTips && (_self.isAreadlyOpenshowRelationship == false || typeof _self.isAreadlyOpenshowRelationship == undefined)) {
            _self.nowStep = 40;
            _self.$router.push({ query: { step: _self.nowStep }});
            _self.$refs.scrollcontent.scrollTo({
              top: relationshipTop,
              behavior: 'smooth'
            });
          }

        }
      });
      // scroll
    },
    methods: {
      strategyFetchData(subCampaigns, response) {
        if (!response || !response.data || !response.data.return_data) {
          // console.error('Invalid response data');
          return;
        }

        const haveTest = response.data.return_data.haveTest;

        this.customRulesData = {
          editIndex: 0,
          haveTest: false,
          stageList: [
            {
              marketingValue: 'META_KW',
              source_platform: 'facebook',
              marketingMethodList: [
                { name: '精準興趣（Facebook）', code: 'META_KW'},
                { name: '類似受眾（Facebook）', code: 'META_LA'},
                { name: '再行銷（Facebook）', code: 'META_RT'},
                { name: 'ASC（Facebook）', code: 'META_ASC'},
              ]
            },
          ],
          subCampaignsContent: [
            {
              method : 'META_KW',
              release : {
                sr_i : 0,
                status : ''
              },
              goalsData: {
                showBlock: true,
                campaign_objective: null,
                objective_option:null,
                objective_list:null,
                product_catalog_list:null,
                product_set_list:null,
                optimization_action:null,
                optimization_goal:null,
                product_catalog_id:null,
                product_set_id:null,
                pixel_id:null,
                pixel_event:null,
                conversion_domain:null,
                domain_list:null,
              },
              budgetData: {
                showBlock: true,
                daily_budget:0,
                effect:null,
                currency_video_min_price:null,
                form_addition:null,
                use_addition:null,
                risk_automatic:null,
                risk_index:null,
                risk_level_list:null,
                risk_level:null
              },
              forwardData: {
                showBlock: true,
                ditto_forward: '0',
                frequency: '1d',
                rule_frequency: [],
              },
              budgetExtraData: {
                showBlock: true,
                ditto_budget_extra: '0',
                amount: 0,
                frequency: 0,
                budget_extra_list: [],
              },
              stopData: {
                showBlock: true,
                ditto_stop: '0',
                rule_stop: [],
              },
              localData: {
                showBlock: true,
                ditto_local: '0',
                location_types:null,
                locations:null,
                location_range:null,
                locales:null
              },
              demoData: {
                showBlock: true,
                ditto_demo: '0',
                gender:null,
                age_min:null,
                age_max:null
              },
              exAudiencesData: {
                showBlock: true,
                ditto_connect: '0',
                excluded_audiences:null,
                default_excluded_audiences:null,
                custom_excluded_audiences:null,
                custom_excluded_audiences_selected:null,
              },
              pdData: {
                showBlock: true,
                ditto_identity: '0',
                auto_publisher:null,
                publisher_platforms:null,
                publisher_platforms_list:null,
                device_platforms: null,
                user_os:null,
                user_os_list:null,
                page_id:null,
                ig_id:null,
                ig_username:null,
                adpages_list:null,
                ig_list:null,
              },
              postData: {
                showBlock: true,
                ditto_creative: '0',
                page_id:null,
                special_ad_category:null,
                disabled_creative_optimize:false,
                creative_optimize:false,
                select_article:null,
                db_select_article:null,
                select_creatives:null,
                db_select_creatives:null,
                select_creatives_message:null,
                db_select_creatives_message:null,
                select_creatives_adset_ads:null,
                db_select_creatives_adset_ads:null,
                select_creatives_adset_ads_message:null,
                db_select_creatives_adset_ads_message:null,
              },
              adMaterialData: {
                showBlock: true,
                ditto_creative: '0',
                disabled_creative_optimize:false,
                creative_optimize:false,
                creative_array:null,
              },
            },
          ]
        };

    //  console.log('strategyFetchData this.customRulesData');
    //  console.log(this.customRulesData);

        // 使用 reduce 按顺序执行请求
        subCampaigns.reduce((promiseChain, value, index) => {
          let _toMenuIndex = index + parseInt(1);

          return promiseChain
            .then(() => {
          //  console.log(`Making request for item: ${value} at index: ${index}`);
              return axios.post('https://www.autoturn.net/api/customize/campaign/campaign_strategy.php', Qs.stringify({
                s_code: this.$route.params.id,
                adaccount_id: this.$route.params.adaccount_id,
                haveTest: haveTest,
                useDoForward: this.doForwardData.useDoForward,
                itemIndex: index,
                campaign_id: value,
                useOtherCustom: 'use',
                useFixedTemp: true
              }));
            })
            .then(subResponse => {
          //  console.log(`Fetched data for item: ${value}`);
          //  console.log('response.data:', subResponse.data);

              if(subResponse.data.status == 'success'){
                let _tmpReturnMenu = JSON.stringify(subResponse.data.return_menu);
                this.menu[_toMenuIndex] = JSON.parse(_tmpReturnMenu);
                this.customRulesData.haveTest = response.data.return_data.haveTest;

                if(subResponse.data.subset_method != 'META_TEST'){
                  let _toStageListIndex = index;
                  if(this.customRulesData.haveTest == true){
                    _toStageListIndex = index - parseInt(1);
                  }

              //  console.log(typeof subResponse.data.return_stage_list);
              //  console.log(subResponse.data.return_stage_list);
                  let _tmpReturnStageList = JSON.stringify(subResponse.data.return_stage_list);
                  this.customRulesData.stageList[_toStageListIndex] = JSON.parse(_tmpReturnStageList)
                }

                if(subResponse.data.subset_method == 'META_ASC'){
                  var todayForm = new Date();
                  var yearForm = todayForm.getFullYear();
                  var dateForm = String(todayForm.getDate()).padStart(2, '0');
                  var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                  var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                  todayForm = yearForm + monthForm + dateForm + timeForm;

                  this.haveASC = 'true_'+todayForm;
                }

            //  console.log(typeof subResponse.data.return_data);
            //  console.log(subResponse.data.return_data);
                // console.log('this.customRulesData.subCampaignsContent['+index+'] = JSON.parse(JSON.stringify('+subResponse.data.return_data+')');
                let _tmpReturnData = JSON.stringify(subResponse.data.return_data);
                // console.log(_tmpReturnData);
                // this.customRulesData.subCampaignsContent[index] = JSON.parse(_tmpReturnData);

                try {
                  JSON.parse(_tmpReturnData);
              //  console.log("JSON 格式正确");
                } catch (error) {
                  // console.error("JSON 格式错误:", error.message);
                }

                // this.customRulesData.subCampaignsContent.splice(index, 1, JSON.parse(_tmpReturnData));

                // if (!this.customRulesData.subCampaignsContent[index]) {
                //   this.customRulesData.subCampaignsContent.splice(index, 1, this.ensureReactive({}));
                // } else {
                //   // 确保对象是响应式的
                //   this.customRulesData.subCampaignsContent[index] = this.ensureReactive(this.customRulesData.subCampaignsContent[index]);
                // }

                if (!this.customRulesData.subCampaignsContent[index]) {
                  this.customRulesData.subCampaignsContent[index] = reactive({});
                }

            //  console.log('before db+ this.customRulesData');
            //  console.log(this.customRulesData);

                if (this.customRulesData.subCampaignsContent && index != null) {
                  const parsedData = JSON.parse(_tmpReturnData);

              //  console.log('Index:', index);
              //  console.log('Original Object:', this.customRulesData.subCampaignsContent[index]);
              //  console.log('Data to Assign:', parsedData);

                  if(this.customRulesData.subCampaignsContent[index] != null && parsedData != null){
                    Object.assign(this.customRulesData.subCampaignsContent[index], parsedData);
                  }

                  // this.customRulesData.subCampaignsContent[index] = {
                  //     ...this.customRulesData.subCampaignsContent[index],
                  //     ...parsedData
                  // };

                  if(!this.customRulesData.subCampaignsContent[index]){
                //  console.log('資料沒更新成功');
                  } else {
                //  console.log("有資料");
                  }

              //  console.log('this.customRulesData.subCampaignsContent['+index+']');
              //  console.log(this.customRulesData.subCampaignsContent[index]);
              //  console.log(this.customRulesData.subCampaignsContent);
              //  console.log(this.customRulesData);
                } else {
                  // console.error('subCampaignsContent 或 index 無效');
                }

                // console.log('check subCampaignsContent');
                // this.customRulesData.subCampaignsContent.forEach((checkValue, checkIndex) => {
                //   console.log(checkIndex);
                //   console.log(checkValue);
                // });

            //  console.log(index+ ' strategyFetchData db+ this.customRulesData');
            //  console.log(this.customRulesData);

            //  console.log(index+ ' campaign_subset this.menu');
            //  console.log(this.menu);
              }

              if(_toMenuIndex == subCampaigns.length){
            //  console.log('fin strategyFetchData this.customRulesData');
            //  console.log(this.customRulesData);
            //  console.log('db end this.showTargetCR');
            //  console.log(this.showTargetCR);
            //  console.log('campaign_subset done');
                this._tmpMenu = this.menu;
            //  console.log('fetchData this._tmpMenu');
            //  console.log(this._tmpMenu);

                if(this.doForwardData.useDoForward == true){
                  if(this.customRulesData.haveTest == true){
                //  console.log('#1');
                    for (var i = 0; i < subCampaigns.length; i++) {
                      if(i >= 2){
                        this.customRulesData.subCampaignsContent[i].forwardData.showBlock = false;
                      }
                    }
                  } else {
                //  console.log('#2');
                    for (var i = 0; i < subCampaigns.length; i++) {
                      if(i >= 1){
                        this.customRulesData.subCampaignsContent[i].forwardData.showBlock = false;
                      }
                    }
                  }
                } else {
              //  console.log('#3');
                  for (var i = 0; i < subCampaigns.length; i++) {
                    this.customRulesData.subCampaignsContent[i].forwardData.showBlock = true;
                  }
                }

                this.showCampaignData = true;
              }
            })
            .catch(error => {
              // console.error(`Error fetching data for item: ${value}`, error.subResponse ? error.subResponse.data : error.message);
            });
        }, Promise.resolve());
      },
      fetchData(subCampaigns, response) {
        if (!response || !response.data || !response.data.return_data) {
          // console.error('Invalid response data');
          return;
        }

        const haveTest = response.data.return_data.haveTest;

        // 使用 reduce 按顺序执行请求
        subCampaigns.reduce((promiseChain, value, index) => {
          let _toMenuIndex = index + parseInt(1);

          return promiseChain
            .then(() => {
          //  console.log(`Making request for item: ${value} at index: ${index}`);
              return axios.post('https://www.autoturn.net/api/campaign_subset.php', Qs.stringify({
                s_code: this.$route.params.id,
                adaccount_id: this.$route.params.adaccount_id,
                haveTest: haveTest,
                useDoForward: this.doForwardData.useDoForward,
                itemIndex: index,
                campaign_id: value,
                useOtherCustom: 'use',
                useFixedTemp: true
              }));
            })
            .then(subResponse => {
          //  console.log(`Fetched data for item: ${value}`);
          //  console.log('response.data:', subResponse.data);

              if(subResponse.data.status == 'success'){
                let _tmpReturnMenu = JSON.stringify(subResponse.data.return_menu);
                this.menu[_toMenuIndex] = JSON.parse(_tmpReturnMenu);
                this.customRulesData.haveTest = response.data.return_data.haveTest;

                if(subResponse.data.subset_method != 'META_TEST'){
                  let _toStageListIndex = index;
                  if(this.customRulesData.haveTest == true){
                    _toStageListIndex = index - parseInt(1);
                  }

              //  console.log(typeof subResponse.data.return_stage_list);
              //  console.log(subResponse.data.return_stage_list);
                  let _tmpReturnStageList = JSON.stringify(subResponse.data.return_stage_list);
                  this.customRulesData.stageList[_toStageListIndex] = JSON.parse(_tmpReturnStageList)
                }

                if(subResponse.data.subset_method == 'META_ASC'){
                  var todayForm = new Date();
                  var yearForm = todayForm.getFullYear();
                  var dateForm = String(todayForm.getDate()).padStart(2, '0');
                  var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                  var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                  todayForm = yearForm + monthForm + dateForm + timeForm;

                  this.haveASC = 'true_'+todayForm;
                }

            //  console.log(typeof subResponse.data.return_data);
            //  console.log(subResponse.data.return_data);
                // console.log('this.customRulesData.subCampaignsContent['+index+'] = JSON.parse(JSON.stringify('+subResponse.data.return_data+')');
                let _tmpReturnData = JSON.stringify(subResponse.data.return_data);
                // console.log(_tmpReturnData);
                // this.customRulesData.subCampaignsContent[index] = JSON.parse(_tmpReturnData);

                try {
                  JSON.parse(_tmpReturnData);
              //  console.log("JSON 格式正确");
                } catch (error) {
                  // console.error("JSON 格式错误:", error.message);
                }

                // this.customRulesData.subCampaignsContent.splice(index, 1, JSON.parse(_tmpReturnData));

                // if (!this.customRulesData.subCampaignsContent[index]) {
                //   this.customRulesData.subCampaignsContent.splice(index, 1, this.ensureReactive({}));
                // } else {
                //   // 确保对象是响应式的
                //   this.customRulesData.subCampaignsContent[index] = this.ensureReactive(this.customRulesData.subCampaignsContent[index]);
                // }

                if (!this.customRulesData.subCampaignsContent[index]) {
                  this.customRulesData.subCampaignsContent[index] = reactive({});
                }

            //  console.log('before db+ this.customRulesData');
            //  console.log(this.customRulesData);

                if (this.customRulesData.subCampaignsContent && index != null) {
                  const parsedData = JSON.parse(_tmpReturnData);

              //  console.log('Index:', index);
              //  console.log('Original Object:', this.customRulesData.subCampaignsContent[index]);
              //  console.log('Data to Assign:', parsedData);

                  if(this.customRulesData.subCampaignsContent[index] != null && parsedData != null){
                    Object.assign(this.customRulesData.subCampaignsContent[index], parsedData);
                  }

                  // this.customRulesData.subCampaignsContent[index] = {
                  //     ...this.customRulesData.subCampaignsContent[index],
                  //     ...parsedData
                  // };

                  if(!this.customRulesData.subCampaignsContent[index]){
                //  console.log('資料沒更新成功');
                  } else {
                //  console.log("有資料");
                  }

              //  console.log('this.customRulesData.subCampaignsContent['+index+']');
              //  console.log(this.customRulesData.subCampaignsContent[index]);
              //  console.log(this.customRulesData.subCampaignsContent);
              //  console.log(this.customRulesData);
                } else {
                  // console.error('subCampaignsContent 或 index 無效');
                }

                // console.log('check subCampaignsContent');
                // this.customRulesData.subCampaignsContent.forEach((checkValue, checkIndex) => {
                //   console.log(checkIndex);
                //   console.log(checkValue);
                // });

            //  console.log(index+ ' db+ this.customRulesData');
            //  console.log(this.customRulesData);

            //  console.log(index+ ' campaign_subset this.menu');
            //  console.log(this.menu);
              }

              if(_toMenuIndex == subCampaigns.length){
            //  console.log('db end this.showTargetCR');
            //  console.log(this.showTargetCR);
            //  console.log('campaign_subset done');
                this._tmpMenu = this.menu;
            //  console.log('fetchData this._tmpMenu');
            //  console.log(this._tmpMenu);
                this.showCampaignData = true;
              }
            })
            .catch(error => {
              // console.error(`Error fetching data for item: ${value}`, error.subResponse ? error.subResponse.data : error.message);
            });
        }, Promise.resolve());
      },
      changeYoutubeType(){
        var todayForm = new Date();
        var yearForm = todayForm.getFullYear();
        var dateForm = String(todayForm.getDate()).padStart(2, '0');
        var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
        var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

        todayForm = yearForm + monthForm + dateForm + timeForm;

        this.youtubeClose = 'false_'+todayForm;

        // console.log('eventadd changeYoutubeType');
        // console.log(this.youtubeClose);
      },
      childYoutube(v){
        this.youtubeClose = v;
      },
      useLang(v){
        if(v == '' || v == null || typeof v == 'undefined'){
          v = 'zh-TW';
        }

        this.selectLang = v

        this.$emit('childLang', v);

        // console.log('this.selectLang');
        // console.log(this.selectLang);
        // console.log('showLang['+v+'][msg]');
        // console.log(this.showLang[v]['msg']);

        document.title = this.showLang[this.selectLang]['views']['EventAdd']['mounted']['page_title'] + ' - AutoTurn';

        if(this.showTargetCR != true && this.showOtherTargetCR != true){
          this.menu = [
            {
              title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_1_title'],
              submenu: [
                {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_1_submenu_0_title'], groupType: 'childCampaignName', refName: 'campaignName', show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_1_submenu_budget_type'], groupType: 'childBudgetType', refName: 'budgetType', show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_1_submenu_1_title'], groupType: 'childMarketingMethod', refName: 'marketingMethod', show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_1_submenu_8_title'], groupType: 'childBenefitAndContribution', refName: 'benefitAndContribution', show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_1_submenu_2_title'], groupType: 'childAdStrategy', refName: 'adStrategy', show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_1_submenu_3_title'], groupType: 'childKeywordMix', refName: 'keywordMix', show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_1_submenu_4_title'], groupType: 'childAdvertisingMix', refName: 'advertisingMix', show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_1_submenu_7_title'], groupType: 'childRemarketingMix', refName: 'remarketingMix', show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_1_submenu_6_title'], groupType: 'childMarketingDate', refName: 'marketingDate', show: true, checked: false},
              ],
              open: true,
              show: true,
              target: 1,
              click: 1
            },
            // {
            //   title: '關鍵字與受眾',
            //   submenu: [
            //     {title: '精準興趣關鍵字', show: true, checked: false},
            //     {title: '類似受眾廣告組合', show: true, checked: false},
            //   ],
            //   open: true,
            //   show: true,
            //   target: 2
            // },
            {
              title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_2_title'],
              submenu: [
                {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_2_submenu_1_title'], groupType: 'childGoalsAndBudget', refName: 'goalsAndBudget', show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_2_submenu_2_title'], groupType: 'childRegions', refName: 'regions', show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_2_submenu_3_title'], groupType: 'childRelationship', refName: 'relationship', show: true, checked: false},
              ],
              open: true,
              show: true,
              target: 2,
              click: 0
            },
            {
              title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_3_title'],
              submenu: [
                {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_3_submenu_1_title'], groupType: 'childPositionDevice', refName: 'positionDevice', show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_3_submenu_2_title'], groupType: 'childIdentity', refName: 'identity', show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_3_submenu_3_title'], groupType: 'childMaterial', refName: 'material', show: true, checked: false},
              ],
              open: true,
              show: true,
              target: 3,
              click: 0
            },
          ];
        } else {
          this.menu = [
            {
              title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_1_title'],
              submenu: [
                {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_1_submenu_0_title'], groupType: 'childCampaignName', refName: 'campaignName', show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_1_submenu_budget_type'], groupType: 'childBudgetType', refName: 'budgetType', show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_1_submenu_1_title'], groupType: 'childMarketingMethod', refName: 'marketingMethod', show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_1_submenu_8_title'], groupType: 'childBenefitAndContribution', refName: 'benefitAndContribution', show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_1_submenu_2_title'], groupType: 'childAdStrategy', refName: 'adStrategy', show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_1_submenu_3_title'], groupType: 'childKeywordMix', refName: 'keywordMix', show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_1_submenu_4_title'], groupType: 'childAdvertisingMix', refName: 'advertisingMix', show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_1_submenu_7_title'], groupType: 'childRemarketingMix', refName: 'remarketingMix', show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_1_submenu_6_title'], groupType: 'childMarketingDate', refName: 'marketingDate', show: true, checked: false},
              ],
              open: true,
              show: true,
              target: 1
            },
            // {
            //   title: '關鍵字與受眾',
            //   submenu: [
            //     {title: '精準興趣關鍵字', show: true, checked: false},
            //     {title: '類似受眾廣告組合', show: true, checked: false},
            //   ],
            //   open: true,
            //   show: true,
            //   target: 2
            // },
            {
              title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_2_title'],
              submenu: [
                {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_2_submenu_1_title'], groupType: 'childGoalsAndBudget', refName: 'goalsAndBudget', show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_2_submenu_2_title'], groupType: 'childRegions', refName: 'regions', show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_2_submenu_3_title'], groupType: 'childRelationship', refName: 'relationship', show: true, checked: false},
              ],
              open: true,
              show: true,
              target: 2
            },
            {
              title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_3_title'],
              submenu: [
                {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_3_submenu_1_title'], groupType: 'childPositionDevice', refName: 'positionDevice', show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_3_submenu_2_title'], groupType: 'childIdentity', refName: 'identity', show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_3_submenu_3_title'], groupType: 'childMaterial', refName: 'material', show: true, checked: false},
              ],
              open: true,
              show: true,
              target: 3
            },
          ];
        }
      },
      // <!-- 新手教學 -->
      campaignData(value){
        // console.log('campaignData'+value);
        this.campaign_name = value
      },
      changeSimpleMode(value){
        const enabled = value === true
        if (enabled && this.simple_mode !== 1) {
          this.simpleModeMethodBackup = JSON.parse(JSON.stringify(this.methodData))
        }
        this.simple_mode = enabled ? 1 : 0
        this.methodData.simple_mode = this.simple_mode
        this.syncSimpleModeMenu()
        if (enabled) {
          this.applySimpleModeRules()
          return
        }
        if (this.simpleModeMethodBackup) {
          this.methodData = JSON.parse(JSON.stringify(this.simpleModeMethodBackup))
          this.methodData.simple_mode = 0
          this.simpleModeMethodBackup = null
        }
        this.showTargetKW = this.methodData.Target_KW === true
        this.showTargetDM = this.methodData.Target_DM === true
        this.showTargetLA = this.methodData.Target_LA === true
        this.showTargetRT = this.methodData.Target_RT === true
        this.showTargetCF = this.methodData.Target_CF === true
        this.showTargetAD = this.methodData.Target_AD === true
        this.showTargetEC = this.methodData.Target_EC === true
        this.showTargetAC = this.methodData.Target_AC === true
        this.updateOnlyTargetAC()
      },
      syncSimpleModeMenu(){
        this.menu.forEach((step) => {
          if (!Array.isArray(step.submenu)) {
            return
          }
          step.submenu.forEach((sub) => {
            if (sub.refName === 'marketingMethod' || sub.refName === 'positionDevice') {
              sub.show = this.simple_mode === 0
            }
          })
        })
      },
      applySimpleModeRules(){
        if (this.simple_mode !== 1) {
          return
        }
        this.efficientAi = this.budget_type === 'lifetime'
        this.methodData.Target_KW = false
        this.methodData.Budget_KW = 0
        this.methodData.Target_DM = false
        this.methodData.Budget_DM = 0
        this.methodData.Target_LA = false
        this.methodData.Budget_LA = 0
        this.methodData.Target_RT = false
        this.methodData.Budget_RT = 0
        this.methodData.Target_CF = false
        this.methodData.Budget_CF = 0
        this.methodData.Target_AD = false
        this.methodData.Budget_AD_min = 0
        this.methodData.Budget_AD_max = 0
        this.methodData.Target_EC = false
        this.methodData.Budget_EC = 0
        this.methodData.Target_CR = false
        this.methodData.Other_Target_CR = false
        this.methodData.Target_AC = true
        this.methodData.simple_mode = 1
        this.showTargetKW = false
        this.showTargetDM = false
        this.showTargetLA = false
        this.showTargetRT = false
        this.showTargetCF = false
        this.showTargetAD = false
        this.showTargetEC = false
        this.showTargetCR = false
        this.showOtherTargetCR = false
        this.showTargetAC = true
        this.onlyTargetAC = true
        if (this.autoAdjustData) {
          this.autoAdjustData.raise_enabled = false
        }
        this.ensureSimpleDailyBudgetMinimum()
        this.syncSimpleModeMenu()
        this.syncSimpleBudget()
      },
      getSimpleDailyBudgetMinimum(){
        return Number(this.currencyData && this.currencyData.AC_min_price) || 10
      },
      ensureSimpleDailyBudgetMinimum(){
        if (this.simple_mode !== 1 || this.budget_type !== 'daily') return
        const minimum = this.getSimpleDailyBudgetMinimum()
        if (!this.methodData.daily_budget || Number(this.methodData.daily_budget) < minimum) {
          this.methodData.daily_budget = minimum
        }
        this.syncSimpleBudget()
      },
      syncSimpleBudget(){
        if (this.simple_mode !== 1) {
          return
        }
        const rawBudget = this.budget_type === 'lifetime' ? this.total_budget : this.methodData.daily_budget
        const isEmpty = rawBudget === null || typeof rawBudget === 'undefined' || rawBudget === ''
        const budget = isEmpty ? 0 : (parseInt(rawBudget) || 0)
        this.methodData.Budget_AC = budget
        if (this.budget_type === 'lifetime') {
          this.methodData.daily_budget = isEmpty ? null : budget
        } else {
          if (!isEmpty) this.methodData.daily_budget = budget
          this.total_budget = 0
        }
      },
      clearSimpleBudgetZero(type){
        if (type === 'daily' && Number(this.methodData.daily_budget) === 0) this.methodData.daily_budget = ''
        if (type === 'lifetime' && Number(this.total_budget) === 0) this.total_budget = ''
      },

      budgetTypeData(value){
        const wasLifetime = this.budget_type === 'lifetime'
        this.budget_type = value

        if (wasLifetime && value !== 'lifetime') {
          this.efficientAi = false
          if (this.simple_mode === 0) {
            this.methodData.Target_AC = false
            this.showTargetAC = false
            this.onlyTargetAC = false
          }
        }

        // 如�??��? lifetime（總經費）�?實施?�制
        if (value === 'lifetime') {
          this.efficientAi = true
          // 1. ?�能使用高�??��? (Target_AC)，�??�其他�??�方�?
          this.methodData.Target_KW = false
          this.methodData.Budget_KW = 0
          this.methodData.Target_DM = false
          this.methodData.Budget_DM = 0
          this.methodData.Target_LA = false
          this.methodData.Budget_LA = 0
          this.methodData.Target_RT = false
          this.methodData.Budget_RT = 0
          this.methodData.Target_CF = false
          this.methodData.Budget_CF = 0
          this.methodData.Target_AD = false
          this.methodData.Budget_AD_min = 0
          this.methodData.Budget_AD_max = 0
          this.methodData.Target_EC = false
          this.methodData.Budget_EC = 0
          this.methodData.Target_CR = false
          this.methodData.Other_Target_CR = false

          // ?��??�用高�??��?
          this.methodData.Target_AC = true
          this.showTargetAC = true
          this.onlyTargetAC = true

          // 2. 禁用?��??��?�?
          if (this.autoAdjustData) {
            this.autoAdjustData.raise_enabled = false
          }

          // 3. 必�?設�?結�??��?（移?�無結�??��??��?�?
          this.use_end_date = true
        } else {
          // ?��? daily（單?��?算�??��??�復�?��?�??
          // 不�?要特?��??��?保�??�戶?��??��?
        }
        this.applySimpleModeRules()
      },
      isRestrictedSpecialAdCategory(){
        return this.special_ad_category !== null && this.special_ad_category !== '' && String(this.special_ad_category).toUpperCase() !== 'NONE'
      },
      isLifetimeEndDateMissing(){
        return this.budget_type === 'lifetime' && (!this.dateData || this.dateData.end_date === '' || this.dateData.end_date === null || typeof this.dateData.end_date === 'undefined' || this.dateData.end_date === '0000-00-00')
      },
      validateBudgetTypeAndSpecialAdCategory(){
        if (this.isLifetimeEndDateMissing()) {
          Swal.fire('總經費設定', '選擇總經費時，行銷日期必須設定結束日期。', 'error')
          return false
        }

        if (this.isRestrictedSpecialAdCategory() && this.methodData.Target_LA === 'prevented_by_ui') {
          Swal.fire('特殊廣告類別設定', '已選擇特殊廣告類別時，不能使用類似受眾。', 'error')
          return false
        }

        return true
      },
      clearLookalikeForSpecialAdCategory(){
        const lookalikeMenu = this.menu[0] && this.menu[0].submenu ? this.menu[0].submenu[5] : null

        if (!this.isRestrictedSpecialAdCategory()) {
          if (lookalikeMenu && this.budget_type !== 'lifetime') {
            lookalikeMenu.show = this.showTargetLA
          }
          return
        }

        this.methodData.Target_LA = false
        this.methodData.Budget_LA = 0
        this.showTargetLA = false
        if (lookalikeMenu) {
          lookalikeMenu.show = false
        }
      },
      normalizeBenefitsAndInvestmentData(){
        const data = this.benefitsAndInvestmentData
        if (!data) {
          return
        }

        const personalList = Array.isArray(data.beneOrPayerPersonalList) ? data.beneOrPayerPersonalList : []
        const hasBeneficiaryOption = personalList.some(item => item.code == data.beneficiary_id)
        const hasPayerOption = personalList.some(item => item.code == data.payer_id)
        const hasValue = (value, ignoreZero = false) => {
          if (value === null || value === undefined || value === "") {
            return false
          }

          if (ignoreZero && value === 0) {
            return false
          }

          return true
        }
        const hasPersonalBeneficiary = hasValue(data.beneficiary_id, true) || hasValue(data.beneficiary_name, true)
        const hasPersonalPayer = hasValue(data.payer_id, true) || hasValue(data.payer_name, true)

        if (hasPersonalBeneficiary || hasPersonalPayer) {
          data.toTaiwan = true
          data.useFinance = true
          if (!data.person_or_business || !data.person_or_business.value) {
            data.person_or_business = { label: '個人或商家驗證', value: 1 }
          }
        }

        const isBusinessVerification = data.person_or_business && String(data.person_or_business.value) === '2'
        if (isBusinessVerification) {
          data.benefits_list = Array.isArray(data.benefits_list) ? data.benefits_list : []
          data.investment_list = Array.isArray(data.investment_list) ? data.investment_list : []

          if (hasValue(data.beneficiary_id, true)) {
            if (!data.benefits_list.some(item => item.code == data.beneficiary_id)) {
              data.benefits_list.push({
                name: hasValue(data.beneficiary_name, true) ? data.beneficiary_name : data.beneficiary_id,
                code: data.beneficiary_id
              })
            }
            if (!hasValue(data.benefits, true)) {
              data.benefits = data.beneficiary_id
            }
          }

          if (hasValue(data.payer_id, true)) {
            if (!data.investment_list.some(item => item.code == data.payer_id)) {
              data.investment_list.push({
                name: hasValue(data.payer_name, true) ? data.payer_name : data.payer_id,
                code: data.payer_id
              })
            }
            if (!hasValue(data.investment, true)) {
              data.investment = data.payer_id
            }
          }
        }

        if (!hasValue(data.selectedBeneficiary, true) && hasValue(data.beneficiary_id, true)) {
          if (hasBeneficiaryOption) {
            data.selectedBeneficiary = data.beneficiary_id
          } else {
            data.showKeyinBeneficiary = true
          }
        }
        if (hasPersonalBeneficiary && !hasBeneficiaryOption) {
          data.showKeyinBeneficiary = true
        }
        if (!hasValue(data.selectedPayer, true) && hasValue(data.payer_id, true)) {
          if (hasPayerOption) {
            data.selectedPayer = data.payer_id
          } else {
            data.showKeyinPayer = true
          }
        }
        if (hasPersonalPayer && !hasPayerOption) {
          data.showKeyinPayer = true
        }
      },
      validateTransparencyAdvertisers(){
        const data = this.benefitsAndInvestmentData
        if (!data || data.toTaiwan !== true || !data.person_or_business || String(data.person_or_business.value) !== '1') return true
        const isMissing = value => value === null || typeof value === 'undefined' || String(value).trim() === ''
        if (isMissing(data.beneficiary_id) || isMissing(data.beneficiary_name)) {
          Swal.fire('受益者資料未完成', '請確認受益者 ID 與名稱皆已填寫。', 'warning')
          return false
        }
        if (isMissing(data.payer_id) || isMissing(data.payer_name)) {
          Swal.fire('出資者資料未完成', '請確認出資者 ID 與名稱皆已填寫。', 'warning')
          return false
        }
        return true
      },
      syncLifetimeTotalBudget(){
        if (this.budget_type !== 'lifetime') {
          return
        }

        const acBudget = parseInt(this.methodData.Budget_AC) || parseInt(this.methodData.daily_budget) || 0
        this.methodData.Budget_AC = acBudget
        this.methodData.daily_budget = acBudget
        this.total_budget = acBudget
      },
      specialAdCategoryData(value){
        this.special_ad_category = value
        this.clearLookalikeForSpecialAdCategory()
      },
      tryTest() {
        /* this.$refs.scrollcontent.scrollTo({
          top: 181,
          behavior: 'smooth'
        });
    //  console.log(this.$refs.scrollcontent.scrollTop); */
        //console.log('tryTest');
        //console.log(this.showAdvertisingMaterial);
      },
      // <!-- 新手教學 -->
      backStep() {
        this.nowStep = this.nowStep - 1;
        this.$router.push({ query: { step: this.nowStep }});
      },
      emptyStep(val){
    //  console.log('eventadd emptyStep: '+val);

        var _tmp_emptyStep = val.split('_');
    //  console.log(_tmp_emptyStep);

        // this.nowStep = _tmp_emptyStep[0];
        // this.$router.push({ query: { step: this.nowStep }});
      },
      nextStep(value) {
        //console.log('b event add nextStep');
        //console.log(this.nowStep);
        //console.log('this.getGoalsObjective');
        //console.log(this.getGoalsObjective);

        //console.log('value');
        //console.log(value);

        if(value != '' && value != null && typeof value != undefined){
          this.isEmptySelect = value
        }

        let overStepArray = [6, 12, 18, 44, 57, 78];
        let overStep = 0;
        let skip = 0;
        for(let i = 0; i < overStepArray.length; i++){
          if(this.nowStep == overStepArray[i]){
            overStep = 1;
          }
        }

        if(this.nowStep == 66){
          skip = 1;
        }

        if(overStep == 1){
          axios
            .post('https://www.autoturn.net/api/data/teaching_update.php', Qs.stringify({
              s_code: this.$route.params.id,
              id: this.teaching_id,
              campaign_id: this.db_campaign_id,
              campaign_objective: this.getGoalsObjective,
              skip: skip,
              step: this.nowStep,
              active: ''
            }))
            .then((response) => {
              if(response.data.teaching_status == 'Y'){
                this.teaching_id = 0;

                //console.log('isEmptySelect');
                //console.log(this.isEmptySelect);

                if(this.isEmptySelect != '' && this.isEmptySelect != null && typeof this.isEmptySelect != undefined){
                  this.postData.select_article = [];
                  this.isEmptySelect = '';
                }
              }

              if(response.data.id != null && response.data.id != '' && typeof response.data.id != 'undefined'){
                this.teaching_id = response.data.id
              }
              // console.log(response);
              // if(response.data.status == 'success'){
                // this.urlKeywords = response.data.return_data

                // console.log(this.urlKeywords);
              // }
            });
        }

        if(this.nowStep == 44 || this.nowStep == 45){
          this.targetTwoStatus = true;
        }

        if(this.nowStep == 57 || this.nowStep == 78){
          this.targetThreeStatus = true;
        }

        if(this.nowStep == 0){
          this.nowStep = 111;
          this.$router.push({ query: { step: this.nowStep }});
        } else if(this.nowStep == 111){
          this.nowStep = 1;
          this.$router.push({ query: { step: this.nowStep }});
        } else if (this.nowStep === 5) {
          this.nowStep = 2001;
          this.$router.push({ query: { step: this.nowStep }});
        } else if (this.nowStep === 2001) {
          this.nowStep = 6;
          this.$router.push({ query: { step: this.nowStep }});
        } else if (this.nowStep === 6) {
          this.nowStep = -1;
          this.$router.push({ query: { step: this.nowStep }});
        } else if (this.nowStep === 7) {
          //console.log('stop');
          if(this.urlKeywordsListData.length > 0){
            this.nowStep = this.nowStep + 1;
            this.$router.push({ query: { step: this.nowStep }});
          } else {
            Swal.fire(
                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['nextStep']['nowStep_7_swal_title'],
                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['nextStep']['nowStep_7_swal_text'],
                      'warning'
                    )
          }
        } else if (this.nowStep === 12) {
          this.nowStep = -1;
          this.$router.push({ query: { step: this.nowStep }});
          this.isAreadlyOpenShowTargetKW = true;
        } else if (this.nowStep === 18) {
          this.nowStep = -1;
          this.$router.push({ query: { step: this.nowStep }});
          this.isAreadlyOpenshowTargetLA = true;
          // scroll
        } else if (this.nowStep === 34) {
          this.nowStep = -1;
          this.$router.push({ query: { step: this.nowStep }});
        } else if (this.nowStep === 22 && this.efficientAi == true) {
          this.nowStep = 28;
          this.$router.push({ query: { step: this.nowStep }});
        } else if (this.nowStep === 24) {
          this.nowStep = 271;
          this.$router.push({ query: { step: this.nowStep }});
        } else if (this.nowStep === 28 && this.efficientAi == true) {
          this.nowStep = -1;
          this.$router.push({ query: { step: this.nowStep }});
          this.isAreadlyOpenshowGoalsAndBudget = true;
        } else if (this.nowStep === 271) {
          this.nowStep = 25;
          this.$router.push({ query: { step: this.nowStep }});
        } else if (this.nowStep === 27) {
          this.nowStep = 272;
          this.$router.push({ query: { step: this.nowStep }});
        } else if (this.nowStep === 272) {
          this.nowStep = 28;
          this.$router.push({ query: { step: this.nowStep }});
        } else if (this.nowStep === 31) {
          this.nowStep = 34;
          this.$router.push({ query: { step: this.nowStep }});
        } else if (this.nowStep === 39) {
          this.nowStep = -1;
          this.$router.push({ query: { step: this.nowStep }});
          this.isAreadlyShowRegionsTips = true;
        } else if (this.nowStep === 44) {
          this.nowStep = -1;
          this.$router.push({ query: { step: this.nowStep }});
          this.isAreadlyShowRelationshipTips = true;
          // scroll
        } else if (this.nowStep === 50) {
          if(this.getGoalsObjective == 'MESSAGES'){
            this.nowStep = this.nowStep + 1;
            this.$router.push({ query: { step: this.nowStep }});
            if (this.nowStep === 51) {
              this.$refs.scrollcontent.scrollTo({
                top: 700,
                behavior: 'smooth'
              });
            }
          } else if (this.showAdvertisingMaterial) {
            //console.log('scrollToTop50 showAdvertisingMaterial');
            this.nowStep = 58;
            this.$router.push({ query: { step: this.nowStep }});

            let scrollToTop = 750;
            if(this.getGoalsObjective == 'MESSAGES'){
              scrollToTop = 1500;
            }

            this.$refs.scrollcontent.scrollTo({
              top: scrollToTop,
              behavior: 'smooth'
            });
          } else {
            this.nowStep = this.nowStep + 1;
            this.$router.push({ query: { step: this.nowStep }});
            if (this.nowStep === 51) {
              this.$refs.scrollcontent.scrollTo({
                top: 1250,
                behavior: 'smooth'
              });
            }
          }
          // this.nowStep = -1;
          // this.$router.push({ query: { step: this.nowStep }});
        } else if (this.nowStep === 51) {
          this.nowStep = 11001;
          this.$router.push({ query: { step: this.nowStep }});
        } else if (this.nowStep === 11001 && this.getGoalsObjective == 'PRODUCT_CATALOG_SALES') {
          this.nowStep = 501;
          this.$router.push({ query: { step: this.nowStep }});
        } else if (this.nowStep === 11001 && this.getGoalsObjective == 'MESSAGES') {
          this.showAdvertisingMaterial = true;
          this.showMsg = true;

          this.nowStep = 11002;
          this.$router.push({ query: { step: this.nowStep }});
        } else if (this.nowStep === 11002) {
          //console.log('scrollToTop1500');
          this.nowStep = 58;
          this.$router.push({ query: { step: this.nowStep }});
          this.$refs.scrollcontent.scrollTo({
            top: 1500,
            behavior: 'smooth'
          });
        } else if (this.nowStep === 11001) {
          this.nowStep = 52;
          this.$router.push({ query: { step: this.nowStep }});
        } else if (this.nowStep === 503) {
          this.nowStep = 57;
          this.$router.push({ query: { step: this.nowStep }});
        } else if (this.nowStep === 57) {
          this.nowStep = -1;
          this.$router.push({ query: { step: this.nowStep }});
        } else if (this.nowStep === 58 && this.getGoalsObjective == 'LEAD_GENERATION') {
          this.nowStep = 5801;
          this.$router.push({ query: { step: this.nowStep }});
        } else if (this.nowStep === 5801 && this.getGoalsObjective == 'LEAD_GENERATION') {
          this.nowStep = 59;
          this.$router.push({ query: { step: this.nowStep }});
        } else if (this.nowStep === 63) {
          if (this.advertisingMaterialType === 1) {
            this.nowStep = this.nowStep + 1;
            this.$router.push({ query: { step: this.nowStep }});
          } else {
            this.nowStep = 67;
            this.$router.push({ query: { step: this.nowStep }});
          }

        } else if (this.nowStep === 78) {
          this.nowStep = -1;
          this.$router.push({ query: { step: this.nowStep }});
        }
        // else if (this.nowStep === 888) {
        //   this.nowStep = -1;
        //   this.$router.push({ query: { step: this.nowStep }});
        // }
        else {
          if(this.nowStep != -1){
            this.nowStep = this.nowStep + 1;
            this.$router.push({ query: { step: this.nowStep }});

            if(this.targetTwoStatus == false){
              if (this.nowStep === 29) {
                this.$refs.scrollcontent.scrollTo({
                  top: 400,
                  behavior: 'smooth'
                });
              }

              if (this.nowStep === 34) {
                this.$refs.scrollcontent.scrollTo({
                  top: 400,
                  behavior: 'smooth'
                });
              }

              if (this.nowStep === 35) {
                this.$refs.scrollcontent.scrollTo({
                  top: 780,
                  behavior: 'smooth'
                });
              }

              if (this.nowStep === 40) {
                this.$refs.scrollcontent.scrollTo({
                  top: 1250,
                  behavior: 'smooth'
                });
              }

              if (this.nowStep === 40) {
                this.$refs.scrollcontent.scrollTo({
                  top: 1450,
                  behavior: 'smooth'
                });
              }
            }

            if(this.targetThreeStatus == false){
              if (this.nowStep === 50) {
                this.$refs.scrollcontent.scrollTo({
                  top: 350,
                  behavior: 'smooth'
                });
              }

              if (this.nowStep === 57) {
                this.selectStatus = true;
              }

              if (this.nowStep === 58) {
                this.showAdvertisingMaterial = true;
                this.showMsg = true;

                let scrollToTop = 650;
                if(this.getGoalsObjective == 'MESSAGES'){
                  scrollToTop = 1150;
                }

                this.$refs.scrollcontent.scrollTo({
                  top: scrollToTop,
                  behavior: 'smooth'
                });
              }

              if (this.nowStep === 65) {
                // console.log('nowStep 65');
                let scrollToTop = 1150;
                if(this.getGoalsObjective == 'MESSAGES'){
                  scrollToTop = 2050;
                }

                this.$refs.scrollcontent.scrollTo({
                  top: scrollToTop,
                  behavior: 'smooth'
                });
              }

              if (this.nowStep === 68) {
                let scrollToTop = 800;
                if(this.getGoalsObjective == 'MESSAGES'){
                  scrollToTop = 1300;
                }

                this.$refs.scrollcontent.scrollTo({
                  top: scrollToTop,
                  behavior: 'smooth'
                });
              }

              if (this.nowStep === 69) {
                let scrollToTop = 650;
                if(this.getGoalsObjective == 'MESSAGES'){
                  scrollToTop = 1150;
                }

                this.$refs.scrollcontent.scrollTo({
                  top: scrollToTop,
                  behavior: 'smooth'
                });
              }

              if (this.nowStep === 71) {
                let scrollToTop = 950;
                if(this.getGoalsObjective == 'MESSAGES'){
                  scrollToTop = 1450;
                }

                this.$refs.scrollcontent.scrollTo({
                  top: scrollToTop,
                  behavior: 'smooth'
                });
              }

              if (this.nowStep === 73) {
                let scrollToTop = 1450;
                if(this.getGoalsObjective == 'MESSAGES'){
                  scrollToTop = 2050;
                }

                this.$refs.scrollcontent.scrollTo({
                  top:scrollToTop,
                  behavior: 'smooth'
                });
              }

              if (this.nowStep === 75) {
                // console.log('nowStep 75');
                let scrollToTop = 1950;
                if(this.getGoalsObjective == 'MESSAGES'){
                  scrollToTop = 2550;
                }

                this.$refs.scrollcontent.scrollTo({
                  top:scrollToTop,
                  behavior: 'smooth'
                });
              }
            }
          }
        }

        //console.log('a event add nextStep');
        //console.log(this.nowStep);

        if(overStep == 0 && this.nowStep != -1){
          // if(this.nowStep == 57 && selectArticleLength <= 0){
          //   this.nowStep = 56;
          //   this.$router.push({ query: { step: this.nowStep }});
          // } else {
            axios
              .post('https://www.autoturn.net/api/data/teaching_update.php', Qs.stringify({
                s_code: this.$route.params.id,
                id: this.teaching_id,
                campaign_id: this.db_campaign_id,
                campaign_objective: this.getGoalsObjective,
                skip: skip,
                step: this.nowStep,
                active: ''
              }))
              .then((response) => {
                if(response.data.id != null && response.data.id != '' && typeof response.data.id != 'undefined'){
                  this.teaching_id = response.data.id
                }
                // console.log(response);
                // if(response.data.status == 'success'){
                  // this.urlKeywords = response.data.return_data

                  // console.log(this.urlKeywords);
                // }
              });
          // }
        }
      },
      switchToOtherStep() {
        if (this.nowStep === 66) {
          this.nowStep = 67;
          this.$router.push({ query: { step: this.nowStep }});
          this.$refs.scrollcontent.scrollTo({
            top: 1250,
            behavior: 'smooth'
          });
          // this.$refs.scrollcontent.scrollTo({
          //   top: 650,
          //   behavior: 'smooth'
          // });
        } else {
          this.nowStep = 64;
          this.$router.push({ query: { step: this.nowStep }});
          this.$refs.scrollcontent.scrollTo({
            top: 950,
            behavior: 'smooth'
          });
        }
      },
      closeTips() {
        //console.log('closeTips');
        //console.log(this.nowStep);

        let skip = 0;
        let skip_target = [0, 7, 13, 19, 28, 35, 40, 45, 51, 58, 75, 111];
        for(let i = 0; i < skip_target.length; i++){
          if(this.nowStep == skip_target[i]){
            skip = 1;
          } else if(this.nowStep == skip_target[i] && this.efficientAi == true){
            skip = 1;
          }
        }

        if(this.nowStep == 0 && skip == 1){
          this.targetAllSkip = 1;
        }

        // if(this.nowStep == 70){
        //   skip = 1;
        // }

        axios
          .post('https://www.autoturn.net/api/data/teaching_update.php', Qs.stringify({
            s_code: this.$route.params.id,
            id: this.teaching_id,
            campaign_id: this.db_campaign_id,
            campaign_objective: this.getGoalsObjective,
            skip: skip,
            step: this.nowStep,
            active: ''
          }))
          .then((response) => {
            if(response.data.teaching_status == 'Y'){
              this.targetTwoStatus = true
              this.targetThreeStatus = true
              this.teaching_id = 0;
            }

            if(response.data.id != null && response.data.id != '' && typeof response.data.id != 'undefined'){
                this.teaching_id = response.data.id
              }

            if(this.nowStep == 7){
              this.isAreadlyOpenShowTargetKW = true;
            }

            if(this.nowStep == 13){
              this.isAreadlyOpenshowTargetLA = true;
            }

            if(this.nowStep == 19 || (this.nowStep == 28 && this.efficientAi == true)){
              this.isAreadlyOpenshowGoalsAndBudget = true;
            }

            if(this.nowStep == 35){
              this.isAreadlyOpenshowRegions = true;
            }

            if(this.nowStep == 40){
              this.isAreadlyOpenshowRelationship = true;
            }

            if(this.nowStep == 45){
              this.isAreadlyOpenshowPositionAndDevice = true;
            }

            if(this.nowStep == 51){
              this.isAreadlyOpenshowMaterial = true;
            }

            if(this.nowStep == 58){
              this.isAreadlyOpenshowAdvertisingMaterial = true;
            }

            if(this.nowStep == 75){
              this.isAreadlyOpenshowFormMsg = true;
            }

            if(this.target == 3){
              this.targetThreeStatus = true;
            }

            if(this.nowStep === 66){
              this.nowStep = 75;
              this.$router.push({ query: { step: this.nowStep }});

              let scrollToTop = 1950;
              if(this.getGoalsObjective == 'MESSAGES'){
                scrollToTop = 2550;
              }

              this.$refs.scrollcontent.scrollTo({
                top:scrollToTop,
                behavior: 'smooth'
              });
            } else {
              this.nowStep = -1;
              this.openStep = 0;
              this.$router.push({ query: { step: this.nowStep }});
            }
          });
      },
      campaignNameEdit(type){
        //console.log('campaignNameEdit');

        this.isEdit = type;
      },
      haveTest(value){
        let get_value = value.split('_');

        if(get_value[0] == 'false'){
          let subCampaignsContentLength = this.customRulesData.subCampaignsContent.length;
          let _tmpSubCampaignsContent = [];

          for(let i = 0; i < subCampaignsContentLength; i++){
            if(this.customRulesData.subCampaignsContent[i].method != 'META_TEST'){
              this.customRulesData.subCampaignsContent[i].goalsData.showBlock = true;
              this.customRulesData.subCampaignsContent[i].pdData.showBlock = true;
              this.customRulesData.subCampaignsContent[i].postData.showBlock = true;
              _tmpSubCampaignsContent.push(this.customRulesData.subCampaignsContent[i]);
            }
          }

      //  console.log('_tmpSubCampaignsContent');
      //  console.log(_tmpSubCampaignsContent);

          this.customRulesData.subCampaignsContent = _tmpSubCampaignsContent;
          this.customRulesData.editIndex = 0;

          let _tmpMenu = [];
          for(let i = 0; i < this.menu.length; i++){
            if(this.menu[i].title != '測試素材'){
              _tmpMenu.push(this.menu[i]);
            }
          }

          this.menu = _tmpMenu;
        } else {
          if(this.customRulesData.subCampaignsContent[0].method != 'META_TEST'){
            this.customRulesData.subCampaignsContent.unshift(this.defaultStage['USE_TEST']['META_TEST']);

            this.menu.splice(1, 0, this.stageMenu['USE_TEST']['META_TEST']);

            let subCampaignsContentLength = this.customRulesData.subCampaignsContent.length;
            let _tmpSubCampaignsContent = [];

            for(let i = 0; i < subCampaignsContentLength; i++){
              if(this.customRulesData.subCampaignsContent[i].method != 'META_TEST'){
                this.customRulesData.subCampaignsContent[i].goalsData.showBlock = false;
                this.customRulesData.subCampaignsContent[i].pdData.showBlock = false;
                this.customRulesData.subCampaignsContent[i].postData.showBlock = false;
              }

              _tmpSubCampaignsContent.push(this.customRulesData.subCampaignsContent[i]);
            }

            this.customRulesData.subCampaignsContent = _tmpSubCampaignsContent;
            this.customRulesData.editIndex = 0;
          }
        }

    //  console.log('haveTest');
    //  console.log(this.customRulesData);
    //  console.log(this.menu);
      },
      changeEdit(value){
        let get_value = value.split('_');

        this.customRulesData.editIndex = parseInt(get_value[0]);
      },
      setAdvertisingMaterialType(type) {
        this.advertisingMaterialType = type;
      },
      openTeaching(value){
        //console.log('openTeaching');

        axios
          .post('https://www.autoturn.net/api/data/teaching_create.php', Qs.stringify({
            s_code: this.$route.params.id
          }))
          .then((response) => {
            // console.log(response);
            // if(response.data.status == 'success'){
              // this.urlKeywords = response.data.return_data

              // console.log(this.urlKeywords);
            // }
            // console.log('openTeaching response.data');
            // console.log(response.data.id);
            // console.log('openTeaching b this.nowStep');
            // console.log(this.nowStep);
            // console.log('openTeaching b this.teaching_id');
            // console.log(this.teaching_id);
            this.nowStep = value;
            this.targetTwoStatus = false
            this.targetThreeStatus = false
            this.targetAllSkip = 0;

            var todayForm = new Date();
            var yearForm = todayForm.getFullYear();
            var dateForm = String(todayForm.getDate()).padStart(2, '0');
            var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
            var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

            let get_value = '0_'+yearForm + monthForm + dateForm + timeForm;
            this.msgTeachingOver = get_value
            this.formTeachingOver = get_value

            this.teaching_id = response.data.id;
            // console.log('openTeaching a this.msgTeachingOver');
            // console.log(this.msgTeachingOver);
            // console.log('openTeaching a this.nowStep');
            // console.log(this.nowStep);
            // console.log('openTeaching a this.teaching_id');
            // console.log(this.teaching_id);
            this.$router.push({ query: { step: this.nowStep }});
            this.$refs.scrollcontent.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
          });
      },
      // <!-- 新手教學 -->
      campaignNameEdit(type){
        // console.log('campaignNameEdit');

        this.isEdit = type;
      },
      minAddition(budgetAddition, day, budgetKW, useEndDate){
        // console.log('value budgetAddition:'+budgetAddition);

        // console.log('getDate budgetAddition:'+day);
        // console.log('budgetKWTotal budgetAddition:'+budgetKW);
        // console.log('useEndDate budgetAddition:'+useEndDate);

        // if(useEndDate == false){
        //   //有結束日期
        //   // console.log('有結束日期');
        //   //先算精準興趣總預算

        //   if(!isNaN(day) && day > 0){
        //     // console.log('有日期間距');
        //     var _tmp_days = day;
        //     var _tmp_total = budgetKW;
        //     // var _tmp_budget_addition = (budget_addition == '' || budget_addition == 0)?0:budget_addition/100
        //     var _tmp_interval_week = 0;
        //     var interval_week = 0;
        //     var n = 0;
        //     var html = 0;
        //     var video_min_price = this.currencyData.currency_video_min_price;
        //     var _tmp_budget_addition = video_min_price;

        //     let _test_total = 0;

        //     if(_tmp_days > 0){
        //         if(_tmp_days > 3){
        //             n = Math.round(_tmp_days/7);
        //         }
        //     }

        //     //console.log(_tmp_total+'*7');
        //     var first_week = _tmp_total*7;

        //     for(var i = 1; i < n; i++){
        //         var days_pow = i + 1;
        //         // console.log('days_pow:'+days_pow);
        //         // console.log(_tmp_total+' * Math.pow((1 + '+_tmp_budget_addition+'), '+days_pow+') * 7');

        //         //console.log('('+_tmp_total +'+ ('+days_pow+' - 1) * '+_tmp_budget_addition+') * 7');
        //         _tmp_interval_week = (parseInt(_tmp_total) + (parseInt(days_pow) - 1) * parseInt(_tmp_budget_addition)) * 7;

        //         // console.log(interval_week +'='+ interval_week +'+'+ _tmp_interval_week);
        //         interval_week = interval_week + _tmp_interval_week;
        //     }

        //     // console.log(_tmp_total + ' * Math.pow((1 + '+_tmp_budget_addition+'), '+n+') * ('+_tmp_days+' - 7 * '+n+')');

        //     //console.log('('+_tmp_total +'+'+ n +'*'+ _tmp_budget_addition+') * ('+_tmp_days +' - 7 * '+ n+')');
        //     var finish_week = (parseInt(_tmp_total) + parseInt(n) * parseInt(_tmp_budget_addition)) * (parseInt(_tmp_days) - 7 * parseInt(n));

        //     if(_tmp_days > 0 && _tmp_total > 0){
        //         // console.log('Math.round('+first_week +'+'+ interval_week +'+'+ finish_week+')');
        //         html = Math.round(parseInt(first_week) + parseInt(interval_week) + parseInt(finish_week));
        //     }

        //     _test_total = html;

        //     this.Budget_KW_result = html;

        //     //計算最低預算比率
        //     let _ratio = ((Math.ceil(((parseInt(_test_total) / (parseInt(_tmp_total) * parseInt(_tmp_days))))*100)/100 - 1)*100).toFixed(0);

        //     this.updateMinAddition = _ratio;

        //     if(parseInt(budgetAddition) < parseInt(_ratio)){
        //       // console.log('有結束日期之下，不允許小於:'+_ratio);
        //       this.goalsData.form_addition = _ratio;
        //     } else {
        //       // console.log(budgetAddition +" > "+ _ratio);
        //     }
        //   } else {
        //     // console.log('沒結束日期也沒日期間距');
        //     var _tmp_keyword_split_budget = budgetKW;
        //     var video_min_price = this.currencyData.currency_video_min_price;
        //     var single_ratio = Math.ceil((video_min_price/(parseInt(_tmp_keyword_split_budget)))*100);
        //     if(_tmp_keyword_split_budget == 0){
        //         single_ratio = 0;
        //     }

        //     this.updateMinAddition = single_ratio;

        //     if(parseInt(budgetAddition) < parseInt(single_ratio)){
        //       // console.log('沒結束日期之下，不允許小於:'+single_ratio);
        //       this.goalsData.form_addition = single_ratio;
        //     } else {
        //       // console.log(budgetAddition +" > "+ single_ratio);
        //     }
        //   }

        // } else {
        //   //沒結束日期
        //   // console.log('沒結束日期');
        //   var _tmp_keyword_split_budget = budgetKW;
        //   var video_min_price = this.currencyData.currency_video_min_price;
        //   var single_ratio = Math.ceil((video_min_price/(parseInt(_tmp_keyword_split_budget)))*100);
        //   if(_tmp_keyword_split_budget == 0){
        //       single_ratio = 0;
        //   }

        //   this.updateMinAddition = single_ratio;

        //   if(budgetAddition < single_ratio){
        //     // console.log('沒結束日期之下，不允許小於:'+single_ratio);
        //     this.goalsData.form_addition = single_ratio;
        //   } else {
        //     // console.log(budgetAddition +" > "+ single_ratio);
        //   }
        // }

        // console.log('update this.updateMinAddition:'+this.updateMinAddition);

        // return 'string form test_call';
      },
      methodTargetAC(value){
        console.log('methodTargetAC');
        console.log(value);
        this.showTargetAC = value;
        this.updateOnlyTargetAC();
      },
      updateOnlyTargetAC(){
        this.onlyTargetAC = this.methodData.Target_AC &&
          !this.methodData.Target_KW && !this.methodData.Target_DM &&
          !this.methodData.Target_LA && !this.methodData.Target_RT &&
          !this.methodData.Target_CF && !this.methodData.Target_AD &&
          !this.methodData.Target_CR;
      },
      methodTargetKW(value){
        // console.log('methods childTargetKW')
        // console.log(value);
        this.showTargetKW = value
        this.updateOnlyTargetAC();
        if(this.menu[0].submenu[4] != '' && this.menu[0].submenu[4] != null && typeof this.menu[0].submenu[4] != 'undefined'){
          this.menu[0].submenu[4].show = value
        }

        if(value == true){
          this.menu = [this.menu[0]];

          this.minAddition(this.goalsData.form_addition, this.returnGapTime, this.budgetKW, this.returnUseEndDate);
          this.useDefaultLayout = null;
          this.showTargetCR = false;
          this.showOtherTargetCR = false;
          this.methodData.Other_Target_CR = false;

          const newItems = [{
            title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_2_title'],
            submenu: [
              {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_2_submenu_1_title'], groupType: 'childGoalsAndBudget', refName: 'goalsAndBudget', show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_2_submenu_2_title'], groupType: 'childRegions', refName: 'regions', show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_2_submenu_3_title'], groupType: 'childRelationship', refName: 'relationship', show: true, checked: false},
            ],
            open: true,
            show: true,
            target: 2
          },
          {
            title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_3_title'],
            submenu: [
              {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_3_submenu_1_title'], groupType: 'childPositionDevice', refName: 'positionDevice', show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_3_submenu_2_title'], groupType: 'childIdentity', refName: 'identity', show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_3_submenu_3_title'], groupType: 'childMaterial', refName: 'material', show: true, checked: false},
            ],
            open: true,
            show: true,
            target: 3
          }];

          this.menu.push(...newItems);

          //新手教學
          if(this.teaching_id != 0){
            if (!this.isAreadlyOpenShowTargetKW) {
              this.nowStep = 7;
              this.$router.push({ query: { step: this.nowStep }});

              setTimeout(()=> {
                this.$refs.scrollcontent.scrollTo({
                  top: 850,
                  behavior: 'smooth'
                });

              }, 1000);
            }
          }
          //新手教學
        } else {
          this.updateMinAddition = 0;
          this.urlKeywordsListData = [];
          this.keywordsSuggestListData = [];
        }

        // if(!this.menu[1].submenu[0].show && !this.menu[1].submenu[1].show){
        //   this.menu[1].show = false
        // } else {
        //   this.menu[1].show = true
        // }
      },
      methodTargetDM(value){
        // console.log('methods childTargetDM')
        // console.log(value);
        this.showTargetDM = value
        this.updateOnlyTargetAC();

        if(value == true){
          //if(this.getGoalsObjective == 'CONVERSIONS'){
          //  this.regionsData.age_min = 18;
          //  this.regionsData.age_max = 65;
          //}
          //if(this.getGoalsObjective == 'LINK_CLICKS'){
          //  this.regionsData.age_min = 18;
          //  this.regionsData.age_max = 64;
          //}
          //if(this.getGoalsObjective == 'POST_ENGAGEMENT'){
          //  this.regionsData.age_min = 18;
          //  this.regionsData.age_max = 64;
          //}
          //if(this.getGoalsObjective == 'VIDEO_VIEWS'){
          //  this.regionsData.age_min = 18;
          //  this.regionsData.age_max = 64;
          //}
          //if(this.getGoalsObjective == 'LEAD_GENERATION'){
          //  this.regionsData.age_min = 18;
          //  this.regionsData.age_max = 65;
          //}
          //if(this.getGoalsObjective == 'MESSAGES'){
          //  this.regionsData.age_min = 18;
          //  this.regionsData.age_max = 64;
          //}

          this.menu = [this.menu[0]];

          this.useDefaultLayout = null;
          this.showTargetCR = false;
          this.showOtherTargetCR = false;
          this.methodData.Other_Target_CR = false;

          const newItems = [{
            title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_2_title'],
            submenu: [
              {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_2_submenu_1_title'], groupType: 'childGoalsAndBudget', refName: 'goalsAndBudget', show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_2_submenu_2_title'], groupType: 'childRegions', refName: 'regions', show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_2_submenu_3_title'], groupType: 'childRelationship', refName: 'relationship', show: true, checked: false},
            ],
            open: true,
            show: true,
            target: 2
          },
          {
            title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_3_title'],
            submenu: [
              {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_3_submenu_1_title'], groupType: 'childPositionDevice', refName: 'positionDevice', show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_3_submenu_2_title'], groupType: 'childIdentity', refName: 'identity', show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_3_submenu_3_title'], groupType: 'childMaterial', refName: 'material', show: true, checked: false},
            ],
            open: true,
            show: true,
            target: 3
          }];

          this.menu.push(...newItems);

          this.regionsData.age_min = 18;
          this.regionsData.age_max = 65;
        }

        // console.log(this.regionsData);
      },
      methodTargetLA(value){
        // console.log('methods childTargetLA')
        // console.log(value);
        this.showTargetLA = value
        this.updateOnlyTargetAC();
        if(this.menu[0].submenu[5] != '' && this.menu[0].submenu[5] != null && typeof this.menu[0].submenu[5] != 'undefined'){
          this.menu[0].submenu[5].show = value
        }

        let customLookalikesListLength = 0;
        if(this.lookData.custom_lookalikes_list != null && this.lookData.custom_lookalikes_list != null != '' && typeof this.lookData.custom_lookalikes_list != 'undefined'){
          customLookalikesListLength = this.lookData.custom_lookalikes_list.length;
        }

        if(value == true && customLookalikesListLength <= 0){
          var todayForm = new Date();
          var yearForm = todayForm.getFullYear();
          var dateForm = String(todayForm.getDate()).padStart(2, '0');
          var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
          var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

          let get_value = 'true_'+yearForm + monthForm + dateForm + timeForm;

          this.showAdvertisingMix = get_value;

          axios
            .post('https://www.autoturn.net/api/campaign_lookalikes.php', Qs.stringify({
              s_code: this.$route.params.id,
              adaccount_id: this.$route.params.adaccount_id,
              pixel_id: this.goalsData.pixel_id,
              product_url: this.productUrl,
            }))
            .then((response) => {
              if(response.data.status == 'success'){

                this.lookData = {
                                  default_lookalikes : response.data.return_data.default_lookalikes,
                                  custom_lookalikes : response.data.return_data.custom_lookalikes,
                                  custom_lookalikes_selected : response.data.return_data.custom_lookalikes_selected,
                                  default_lookalikes_list : response.data.return_data.default_lookalikes_list,
                                  custom_lookalikes_list : response.data.return_data.custom_lookalikes_list
                                }

                var todayForm = new Date();
                var yearForm = todayForm.getFullYear();
                var dateForm = String(todayForm.getDate()).padStart(2, '0');
                var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                let get_value = 'false_'+yearForm + monthForm + dateForm + timeForm;

                this.showAdvertisingMix = get_value;

                //新手教學
                if(this.teaching_id != 0){
                  if (!this.isAreadlyOpenshowTargetLA) {
                    this.nowStep = 13;
                    this.$router.push({ query: { step: this.nowStep }});

                    let srollLA = 1000;
                    if(this.urlKeywordsListData.length > 0){
                      srollLA = 1150;
                    }

                    if(this.keywordsSuggestListData.length > 0){
                      srollLA = 1350;
                    }

                    setTimeout(()=> {
                      this.$refs.scrollcontent.scrollTo({
                        top: srollLA,
                        behavior: 'smooth'
                      });

                    }, 1000);
                  }
                }
                //新手教學
              }
            });
        }

        if(value != true && this.lookData.custom_lookalikes != null) {
          this.lookData = {
                            default_lookalikes : null,
                            custom_lookalikes : null,
                            custom_lookalikes_selected : null,
                            default_lookalikes_list : null,
                            custom_lookalikes_list : null
                          }
        }

        if(value == true){
          this.menu = [this.menu[0]];

          this.useDefaultLayout = null;
          this.showTargetCR = false;
          this.showOtherTargetCR = false;
          this.methodData.Other_Target_CR = false;

          const newItems = [{
            title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_2_title'],
            submenu: [
              {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_2_submenu_1_title'], groupType: 'childGoalsAndBudget', refName: 'goalsAndBudget', show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_2_submenu_2_title'], groupType: 'childRegions', refName: 'regions', show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_2_submenu_3_title'], groupType: 'childRelationship', refName: 'relationship', show: true, checked: false},
            ],
            open: true,
            show: true,
            target: 2
          },
          {
            title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_3_title'],
            submenu: [
              {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_3_submenu_1_title'], groupType: 'childPositionDevice', refName: 'positionDevice', show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_3_submenu_2_title'], groupType: 'childIdentity', refName: 'identity', show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_3_submenu_3_title'], groupType: 'childMaterial', refName: 'material', show: true, checked: false},
            ],
            open: true,
            show: true,
            target: 3
          }];

          this.menu.push(...newItems);
        }

        // if(!this.menu[1].submenu[0].show && !this.menu[1].submenu[1].show){
        //   this.menu[1].show = false
        // } else {
        //   this.menu[1].show = true
        // }
      },
      methodTargetRT(value){
    //  console.log('methods childTargetRT')
    //  console.log(value);
    //  console.log('this.audiencesData');
    //  console.log(this.audiencesData);
        this.showTargetRT = value
        this.updateOnlyTargetAC();

        if(this.menu[0].submenu[6] != '' && this.menu[0].submenu[6] != null && typeof this.menu[0].submenu[6] != 'undefined'){
          this.menu[0].submenu[6].show = value
        }

        if(value == true && this.audiencesData.custom_audiences_list == null){
      //  console.log('in');

          var todayForm = new Date();
          var yearForm = todayForm.getFullYear();
          var dateForm = String(todayForm.getDate()).padStart(2, '0');
          var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
          var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

          let get_value = 'ture_'+yearForm + monthForm + dateForm + timeForm;

          this.showRemarketingMix = get_value;

          axios
            .post('https://www.autoturn.net/api/campaign_audiences.php', Qs.stringify({
              s_code: this.$route.params.id,
              adaccount_id: this.$route.params.adaccount_id,
            }))
            .then((response) => {
              if(response.data.status == 'success'){

                this.audiencesData = {
                                  default_audiences : response.data.return_data.default_audiences,
                                  custom_audiences : response.data.return_data.custom_audiences,
                                  custom_audiences_selected : response.data.return_data.custom_audiences_selected,
                                  default_audiences_list : response.data.return_data.default_audiences_list,
                                  custom_audiences_list : response.data.return_data.custom_audiences_list
                                }

                var todayForm = new Date();
                var yearForm = todayForm.getFullYear();
                var dateForm = String(todayForm.getDate()).padStart(2, '0');
                var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                let get_value = 'false_'+yearForm + monthForm + dateForm + timeForm;

                this.showRemarketingMix = get_value;
              }
            });
        }

        if(value != true && this.audiencesData.custom_audiences != null) {
          this.audiencesData = {
                            default_audiences : null,
                            custom_audiences : null,
                            custom_audiences_selected : null,
                            default_audiences_list : null,
                            custom_audiences_list : null
                          }
        }

        if(value == true){
          this.menu = [this.menu[0]];

          this.useDefaultLayout = null;
          this.showTargetCR = false;
          this.showOtherTargetCR = false;
          this.methodData.Other_Target_CR = false;

          const newItems = [{
            title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_2_title'],
            submenu: [
              {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_2_submenu_1_title'], groupType: 'childGoalsAndBudget', refName: 'goalsAndBudget', show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_2_submenu_2_title'], groupType: 'childRegions', refName: 'regions', show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_2_submenu_3_title'], groupType: 'childRelationship', refName: 'relationship', show: true, checked: false},
            ],
            open: true,
            show: true,
            target: 2
          },
          {
            title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_3_title'],
            submenu: [
              {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_3_submenu_1_title'], groupType: 'childPositionDevice', refName: 'positionDevice', show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_3_submenu_2_title'], groupType: 'childIdentity', refName: 'identity', show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_3_submenu_3_title'], groupType: 'childMaterial', refName: 'material', show: true, checked: false},
            ],
            open: true,
            show: true,
            target: 3
          }];

          this.menu.push(...newItems);
        }

    //  console.log(this.audiencesData);
    //  console.log('end showRemarketingMix');
    //  console.log(this.showRemarketingMix);
      },
      methodTargetCF(value){
        this.showTargetCF = value
        this.updateOnlyTargetAC();
        if(this.menu[0].submenu[4] != '' && this.menu[0].submenu[4] != null && typeof this.menu[0].submenu[4] != 'undefined'){
          this.menu[0].submenu[4].show = value
        }

        if(value == true){
          this.menu = [this.menu[0]];

          this.useDefaultLayout = null;
          this.showTargetCR = false;
          this.showOtherTargetCR = false;
          this.methodData.Other_Target_CR = false;

          const newItems = [{
            title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_2_title'],
            submenu: [
              {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_2_submenu_1_title'], groupType: 'childGoalsAndBudget', refName: 'goalsAndBudget', show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_2_submenu_2_title'], groupType: 'childRegions', refName: 'regions', show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_2_submenu_3_title'], groupType: 'childRelationship', refName: 'relationship', show: true, checked: false},
            ],
            open: true,
            show: true,
            target: 2
          },
          {
            title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_3_title'],
            submenu: [
              {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_3_submenu_1_title'], groupType: 'childPositionDevice', refName: 'positionDevice', show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_3_submenu_2_title'], groupType: 'childIdentity', refName: 'identity', show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_3_submenu_3_title'], groupType: 'childMaterial', refName: 'material', show: true, checked: false},
            ],
            open: true,
            show: true,
            target: 3
          }];

          this.menu.push(...newItems);
        }
      },
      methodTargetAD(value){
        this.showTargetAD = value;
        this.updateOnlyTargetAC();
        this.efficientAi = value;

        if(value == true){
          this.useDefaultLayout = null;
          this.showTargetCR = false;
          this.showOtherTargetCR = false;
          this.methodData.Other_Target_CR = false;

          const newItems = [{
            title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_2_title'],
            submenu: [
              {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_2_submenu_1_title'], groupType: 'childGoalsAndBudget', refName: 'goalsAndBudget', show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_2_submenu_2_title'], groupType: 'childRegions', refName: 'regions', show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_2_submenu_3_title'], groupType: 'childRelationship', refName: 'relationship', show: true, checked: false},
            ],
            open: true,
            show: true,
            target: 2
          },
          {
            title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_3_title'],
            submenu: [
              {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_3_submenu_1_title'], groupType: 'childPositionDevice', refName: 'positionDevice', show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_3_submenu_2_title'], groupType: 'childIdentity', refName: 'identity', show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_3_submenu_3_title'], groupType: 'childMaterial', refName: 'material', show: true, checked: false},
            ],
            open: true,
            show: true,
            target: 3
          }];

          this.menu.push(...newItems);
        }

        this.dateData.end_date = '0000-00-00';
    //  console.log('this.dateData.end_date');
    //  console.log(this.dateData.end_date);
      },
      methodTargetCR(value){
    //  console.log('methodTargetCR');
    //  console.log(value)
        this.showTargetCR = value
        this.updateOnlyTargetAC();

        // if(value == true && this.lookData.custom_lookalikes_list == null){
        //   console.log('in');
        //   var todayForm = new Date();
        //   var yearForm = todayForm.getFullYear();
        //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
        //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
        //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

        //   let get_value = 'true_'+yearForm + monthForm + dateForm + timeForm;

        //   this.showAdvertisingMix = get_value;
        //   console.log('axios showAdvertisingMix');
        //   console.log(this.showAdvertisingMix);

        //   axios
        //     .post('https://www.autoturn.net/api/campaign_lookalikes.php', Qs.stringify({
        //       s_code: this.$route.params.id,
        //       adaccount_id: this.$route.params.adaccount_id,
        //       pixel_id: this.goalsData.pixel_id,
        //       product_url: this.productUrl,
        //     }))
        //     .then((response) => {
        //       if(response.data.status == 'success'){

        //         this.lookData = {
        //                           default_lookalikes : response.data.return_data.default_lookalikes,
        //                           custom_lookalikes : response.data.return_data.custom_lookalikes,
        //                           custom_lookalikes_selected : response.data.return_data.custom_lookalikes_selected,
        //                           default_lookalikes_list : response.data.return_data.default_lookalikes_list,
        //                           custom_lookalikes_list : response.data.return_data.custom_lookalikes_list
        //                         }

        //         var todayForm = new Date();
        //         var yearForm = todayForm.getFullYear();
        //         var dateForm = String(todayForm.getDate()).padStart(2, '0');
        //         var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
        //         var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

        //         let get_value = 'false_'+yearForm + monthForm + dateForm + timeForm;

        //         this.showAdvertisingMix = get_value;
        //       }
        //     });
        // }

        // if(value != true && this.lookData.custom_lookalikes != null) {
        //   this.lookData = {
        //                     default_lookalikes : null,
        //                     custom_lookalikes : null,
        //                     custom_lookalikes_selected : null,
        //                     default_lookalikes_list : null,
        //                     custom_lookalikes_list : null
        //                   }
        // }

        // if(value == true && this.audiencesData.custom_audiences_list == null){
        //   console.log('in');

        //   var todayForm = new Date();
        //   var yearForm = todayForm.getFullYear();
        //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
        //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
        //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

        //   let get_value = 'ture_'+yearForm + monthForm + dateForm + timeForm;

        //   this.showRemarketingMix = get_value;

        //   axios
        //     .post('https://www.autoturn.net/api/campaign_audiences.php', Qs.stringify({
        //       s_code: this.$route.params.id,
        //       adaccount_id: this.$route.params.adaccount_id,
        //     }))
        //     .then((response) => {
        //       if(response.data.status == 'success'){

        //         this.audiencesData = {
        //                           default_audiences : response.data.return_data.default_audiences,
        //                           custom_audiences : response.data.return_data.custom_audiences,
        //                           custom_audiences_selected : response.data.return_data.custom_audiences_selected,
        //                           default_audiences_list : response.data.return_data.default_audiences_list,
        //                           custom_audiences_list : response.data.return_data.custom_audiences_list
        //                         }

        //         var todayForm = new Date();
        //         var yearForm = todayForm.getFullYear();
        //         var dateForm = String(todayForm.getDate()).padStart(2, '0');
        //         var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
        //         var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

        //         let get_value = 'false_'+yearForm + monthForm + dateForm + timeForm;

        //         this.showRemarketingMix = get_value;
        //       }
        //     });
        // }

        // if(value != true && this.audiencesData.custom_audiences != null) {
        //   this.audiencesData = {
        //                     default_audiences : null,
        //                     custom_audiences : null,
        //                     custom_audiences_selected : null,
        //                     default_audiences_list : null,
        //                     custom_audiences_list : null
        //                   }
        // }

        if(value == true){
          this.useDefaultLayout = null;

          this.menu = [
            {
              title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_title'],
              submenu: [
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_0_title'], show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_1_title'], show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_2_title'], show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_3_title'], show: false, checked: false},
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_4_title'], show: false, checked: false},
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_7_title'], show: false, checked: false},
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_6_title'], show: true, checked: false},
              ],
              open: true,
              show: true,
              target: 1,
              click: 1
            },
          ];

      //  console.log('0 this.stageMenu');
      //  console.log(this.stageMenu);

          let _tmpMenu = JSON.parse(JSON.stringify(this.menu));
          let _tmpMetaTest = JSON.parse(JSON.stringify(this.stageMenu['USE_TEST']['META_TEST']));
          let _tmpMetaKw = JSON.parse(JSON.stringify(this.stageMenu['USE_TEST']['META_KW']));
          let _tmpMetaLa = JSON.parse(JSON.stringify(this.stageMenu['USE_TEST']['META_LA']));
          let _tmpMetaAsc = JSON.parse(JSON.stringify(this.stageMenu['USE_TEST']['META_RT']));

          _tmpMenu.push(_tmpMetaTest);
          _tmpMenu.push(_tmpMetaKw);
          _tmpMenu.push(_tmpMetaLa);
          _tmpMenu.push(_tmpMetaAsc);

      //  console.log('1 this.stageMenu');
      //  console.log(this.stageMenu);

      //  console.log('b this.menu');
      //  console.log(this.menu);

      //  console.log('2 this.stageMenu');
      //  console.log(this.stageMenu);

          let stageIndex = 1;

      //  console.log('b _tmpMenu');
      //  console.log(_tmpMenu);
      //  console.log('b this.menu');
      //  console.log(this.menu);

          for(let i = 0; i < _tmpMenu.length; i++){
        //  console.log('_tmpMenu[1].title');
        //  console.log(_tmpMenu[1].title);
            if(_tmpMenu[1].title == '測試素材' && i > 1){
          //  console.log('#1');
              _tmpMenu[i].title = '第'+stageIndex+'階段：'+_tmpMenu[i].title;
              stageIndex++;
            } else if(_tmpMenu[1].title != '測試素材' && i > 0){
          //  console.log('#2');
              _tmpMenu[i].title = '第'+stageIndex+'階段：'+_tmpMenu[i].title;
              stageIndex++;
            }
        //  console.log('stageIndex');
        //  console.log(stageIndex);
          }

          this.menu = _tmpMenu;

      //  console.log('a _tmpMenu');
      //  console.log(_tmpMenu);

      //  console.log('3 this.stageMenu');
      //  console.log(this.stageMenu);

      //  console.log('a this.menu');
      //  console.log(this.menu);

          this.customRulesData = {
            editIndex: 0,
            haveTest: true,
            stageList: [
              { marketingValue: 'META_KW'},
              { marketingValue: 'META_LA'},
              { marketingValue: 'META_RT'}
            ],
            subCampaignsContent: []
          };

      //  console.log('b this.customRulesData');
      //  console.log(this.customRulesData);

          let _tmpSubCampaignsContent = [];

          _tmpSubCampaignsContent.push(this.defaultStage['USE_TEST']['META_TEST']);
          _tmpSubCampaignsContent.push(this.defaultStage['USE_TEST']['META_KW']);
          _tmpSubCampaignsContent.push(this.defaultStage['USE_TEST']['META_LA']);
          _tmpSubCampaignsContent.push(this.defaultStage['USE_TEST']['META_RT']);

          for(let i = 0; i < _tmpSubCampaignsContent.length; i++){
            if(_tmpSubCampaignsContent[i].method == 'META_LA'){
              axios
                .post('https://www.autoturn.net/api/campaign_lookalikes.php', Qs.stringify({
                  s_code: this.$route.params.id,
                  adaccount_id: this.$route.params.adaccount_id,
                  pixel_id: this.goalsData.pixel_id,
                  product_url: this.productUrl,
                }))
                .then((response) => {
                  if(response.data.status == 'success'){

                    _tmpSubCampaignsContent[i].lookData.default_lookalikes = response.data.return_data.default_lookalikes;
                    _tmpSubCampaignsContent[i].lookData.custom_lookalikes = response.data.return_data.custom_lookalikes;
                    _tmpSubCampaignsContent[i].lookData.custom_lookalikes_selected = response.data.return_data.custom_lookalikes_selected;
                    _tmpSubCampaignsContent[i].lookData.default_lookalikes_list = response.data.return_data.default_lookalikes_list;
                    _tmpSubCampaignsContent[i].lookData.custom_lookalikes_list = response.data.return_data.custom_lookalikes_list;

                    // this.lookData = {
                    //                   default_lookalikes : response.data.return_data.default_lookalikes,
                    //                   custom_lookalikes : response.data.return_data.custom_lookalikes,
                    //                   custom_lookalikes_selected : response.data.return_data.custom_lookalikes_selected,
                    //                   default_lookalikes_list : response.data.return_data.default_lookalikes_list,
                    //                   custom_lookalikes_list : response.data.return_data.custom_lookalikes_list
                    //                 }

                    var todayForm = new Date();
                    var yearForm = todayForm.getFullYear();
                    var dateForm = String(todayForm.getDate()).padStart(2, '0');
                    var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                    var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                    let get_value_la = 'false_'+yearForm + monthForm + dateForm + timeForm;

                    this.showAdvertisingMix = get_value_la;
                  }
                });
            }

            if(_tmpSubCampaignsContent[i].method == 'META_RT'){
              axios
                .post('https://www.autoturn.net/api/campaign_audiences.php', Qs.stringify({
                  s_code: this.$route.params.id,
                  adaccount_id: this.$route.params.adaccount_id,
                }))
                .then((response) => {
                  if(response.data.status == 'success'){

                    _tmpSubCampaignsContent[i].audiencesData.default_audiences = response.data.return_data.default_audiences;
                    _tmpSubCampaignsContent[i].audiencesData.custom_audiences = response.data.return_data.custom_audiences;
                    _tmpSubCampaignsContent[i].audiencesData.custom_audiences_selected = response.data.return_data.custom_audiences_selected;
                    _tmpSubCampaignsContent[i].audiencesData.default_audiences_list = response.data.return_data.default_audiences_list;
                    _tmpSubCampaignsContent[i].audiencesData.custom_audiences_list = response.data.return_data.custom_audiences_list;

                    var todayForm = new Date();
                    var yearForm = todayForm.getFullYear();
                    var dateForm = String(todayForm.getDate()).padStart(2, '0');
                    var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                    var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                    let get_value_rt = 'false_'+yearForm + monthForm + dateForm + timeForm;

                    this.showRemarketingMix = get_value_rt;
                  }
                });
            }
          }

          this.customRulesData.subCampaignsContent = _tmpSubCampaignsContent;

      //  console.log('a this.customRulesData');
      //  console.log(this.customRulesData);
        } else {
          this.menu = [
            {
              title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_1_title'],
              submenu: [
                {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_1_submenu_0_title'], groupType: 'childCampaignName', refName: 'campaignName', show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_1_submenu_budget_type'], groupType: 'childBudgetType', refName: 'budgetType', show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_1_submenu_1_title'], groupType: 'childMarketingMethod', refName: 'marketingMethod', show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_1_submenu_8_title'], groupType: 'childBenefitAndContribution', refName: 'benefitAndContribution', show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_1_submenu_2_title'], groupType: 'childAdStrategy', refName: 'adStrategy', show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_1_submenu_3_title'], groupType: 'childKeywordMix', refName: 'keywordMix', show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_1_submenu_4_title'], groupType: 'childAdvertisingMix', refName: 'advertisingMix', show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_1_submenu_7_title'], groupType: 'childRemarketingMix', refName: 'remarketingMix', show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_1_submenu_6_title'], groupType: 'childMarketingDate', refName: 'marketingDate', show: true, checked: false},
              ],
              open: true,
              show: true,
              target: 1,
              click: 1
            },
            // {
            //   title: '關鍵字與受眾',
            //   submenu: [
            //     {title: '精準興趣關鍵字', show: true, checked: false},
            //     {title: '類似受眾廣告組合', show: true, checked: false},
            //   ],
            //   open: true,
            //   show: true,
            //   target: 2
            // },
            {
              title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_2_title'],
              submenu: [
                {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_2_submenu_1_title'], groupType: 'childGoalsAndBudget', refName: 'goalsAndBudget', show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_2_submenu_2_title'], groupType: 'childRegions', refName: 'regions', show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_2_submenu_3_title'], groupType: 'childRelationship', refName: 'relationship', show: true, checked: false},
              ],
              open: true,
              show: true,
              target: 2,
              click: 0
            },
            {
              title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_3_title'],
              submenu: [
                {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_3_submenu_1_title'], groupType: 'childPositionDevice', refName: 'positionDevice', show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_3_submenu_2_title'], groupType: 'childIdentity', refName: 'identity', show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_3_submenu_3_title'], groupType: 'childMaterial', refName: 'material', show: true, checked: false},
              ],
              open: true,
              show: true,
              target: 3,
              click: 0
            },
          ];

          this.menu[0].submenu[4].show = this.showTargetKW
          this.menu[0].submenu[5].show = this.showTargetLA
          this.menu[0].submenu[6].show = this.showTargetRT

          this.showTargetCR = false;
          this.showOtherTargetCR = false;
        }

    //  console.log('this.customRulesData');
    //  console.log(this.customRulesData);

        this.menu[0].submenu[3].show = value
      },
      methodBudgetKWTotal(value){
        // console.log('methodBudgetKWTotal:'+value);
        // console.log('b this.budgetKW:'+this.budgetKW);
        this.budgetKW = value;

        if(value > 0){
          this.minAddition(this.goalsData.form_addition, this.returnGapTime, value, this.returnUseEndDate);
        }

        // console.log('a this.budgetKW:'+this.budgetKW);
      },
      dateGapTime(value){
        // console.log('dateGapTime:'+value);
        // console.log('b this.returnGapTime:'+this.returnGapTime);
        this.returnGapTime = value;

        if(value > 0){
          this.minAddition(this.goalsData.form_addition, value, this.budgetKW, this.returnUseEndDate);
        }

        // console.log('a this.returnGapTime:'+this.returnGapTime);
      },
      dateEndTime(value){
        // console.log('dateEndTime:'+value);
        // console.log('b this.returnEndTime:'+this.returnEndTime);
        this.returnEndTime = value;

        let startTime = this.dateData.start_date;
        let diffType = 'day';
        let gapTime = 0;

        if(startTime != '' && startTime != '0000-00-00' && startTime != null && value != '' && value != '0000-00-00' && value != null){
          diffType = diffType.toLowerCase();
          var sTime =new Date(startTime); //開始時間
          var eTime =new Date(value); //結束時間
          //作為除數的數字
          var timeType = 1;
          switch (diffType) {
              case"second":
                  timeType =1000;
              break;
              case"minute":
                  timeType =1000*60;
              break;
              case"hour":
                  timeType =1000*3600;
              break;
              case"day":
                  timeType =1000*3600*24;
              break;
              default:
              break;
          }
          gapTime = parseInt((eTime.getTime() - sTime.getTime()) / parseInt(timeType));
        }

        this.returnGapTime = gapTime;

        this.minAddition(this.goalsData.form_addition, gapTime, this.budgetKW, this.returnUseEndDate);

        // console.log('a this.returnEndTime:'+this.returnEndTime);
      },
      dateUseEndDate(value){
        // console.log('dateUseEndDate:'+value);
        // console.log('b this.returnUseEndDate:'+this.returnUseEndDate);
        this.returnUseEndDate = value

        this.minAddition(this.goalsData.form_addition, this.returnGapTime, this.budgetKW, value);

        // console.log('a this.returnUseEndDate:'+this.returnUseEndDate);
      },
      resetMaterialContentOnObjectiveChange(){
        this.postData.select_article = [];
        this.postData.db_select_article = [];
        this.postData.select_creatives = [];
        this.postData.db_select_creatives = [];
        this.postData.select_creatives_message = [];
        this.postData.db_select_creatives_message = [];
        this.postData.select_creatives_adset_ads = [];
        this.postData.db_select_creatives_adset_ads = [];
        this.postData.select_adset_ads_message = [];
        this.postData.db_select_adset_ads_message = [];
        this.postData.select_creatives_adset_ads_message = [];
        this.postData.db_select_creatives_adset_ads_message = [];

        this.adMaterialData.creative_array = [];
        this.tmpAdMaterialDataNew = {
          ...this.tmpAdMaterialDataNew,
          creative_array: []
        };
        this.adMaterialDataNew = {
          ...this.adMaterialDataNew,
          creative_array: []
        };

        if(this.customRulesData && this.customRulesData.subCampaignsContent && this.customRulesData.subCampaignsContent[this.customRulesData.editIndex]){
          let stageContent = this.customRulesData.subCampaignsContent[this.customRulesData.editIndex];
          if(stageContent.postData){
            stageContent.postData.select_article = [];
            stageContent.postData.db_select_article = [];
            stageContent.postData.select_creatives = [];
            stageContent.postData.db_select_creatives = [];
            stageContent.postData.select_creatives_message = [];
            stageContent.postData.db_select_creatives_message = [];
            stageContent.postData.select_creatives_adset_ads = [];
            stageContent.postData.db_select_creatives_adset_ads = [];
            stageContent.postData.select_adset_ads_message = [];
            stageContent.postData.db_select_adset_ads_message = [];
            stageContent.postData.select_creatives_adset_ads_message = [];
            stageContent.postData.db_select_creatives_adset_ads_message = [];
          }
          if(stageContent.adMaterialData){
            stageContent.adMaterialData.creative_array = [];
          }
        }

        this.changeFormId = null;
        this.changeMessageId = null;
      },
      goalsObjective(value){
    //  console.log('goalsObjective');
    //  console.log(value);

        var todayForm = new Date();
        var yearForm = todayForm.getFullYear();
        var dateForm = String(todayForm.getDate()).padStart(2, '0');
        var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
        var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

        let get_value = yearForm + monthForm + dateForm + timeForm;

        const previousObjective = this.getGoalsObjective;
        this.getGoalsObjective = value
        if(previousObjective && previousObjective != value){
          this.resetMaterialContentOnObjectiveChange();
        }

        if(this.showTargetDM == true){
          // if(value == 'CONVERSIONS'){
          //   this.regionsData.age_min = 13;
          //   this.regionsData.age_max = 65;
          // }
          // if(value == 'LINK_CLICKS'){
          //   this.regionsData.age_min = 13;
          //   this.regionsData.age_max = 64;
          // }
          // if(value == 'POST_ENGAGEMENT'){
          //   this.regionsData.age_min = 13;
          //   this.regionsData.age_max = 64;
          // }
          // if(value == 'VIDEO_VIEWS'){
          //   this.regionsData.age_min = 13;
          //   this.regionsData.age_max = 64;
          // }
          // if(value == 'LEAD_GENERATION'){
          //   this.regionsData.age_min = 18;
          //   this.regionsData.age_max = 65;
          // }
          // if(value == 'MESSAGES'){
          //   this.regionsData.age_min = 13;
          //   this.regionsData.age_max = 64;
          // }

          this.regionsData.age_min = 18;
          this.regionsData.age_max = 65;
        }

        if(value == 'CONVERSIONS'){
          this.showMaterial = true;
          this.showAdvertisingMaterial = false;
          this.showForm = false;
          this.showMsg = false;

          this.showStageMaterial = 'true_'+get_value;
          this.showStageAdvertisingMaterial = 'false_'+get_value;
          this.showStageForm = 'false_'+get_value;
          this.showStageMsg = 'false_'+get_value;

          this.adMaterialDataNew.creative_array = []
        }
        if(value == 'LINK_CLICKS'){
          this.showMaterial = true;
          this.showAdvertisingMaterial = false;
          this.showForm = false;
          this.showMsg = false;

          this.showStageMaterial = 'true_'+get_value;
          this.showStageAdvertisingMaterial = 'false_'+get_value;
          this.showStageForm = 'false_'+get_value;
          this.showStageMsg = 'false_'+get_value;

          this.adMaterialDataNew.creative_array = []
        }
        if(value == 'POST_ENGAGEMENT'){
          this.showMaterial = true;
          this.showAdvertisingMaterial = false;
          this.showForm = false;
          this.showMsg = false;

          this.showStageMaterial = 'true_'+get_value;
          this.showStageAdvertisingMaterial = 'false_'+get_value;
          this.showStageForm = 'false_'+get_value;
          this.showStageMsg = 'false_'+get_value;

          this.adMaterialDataNew.creative_array = []
        }
        if(value == 'VIDEO_VIEWS'){
          this.showMaterial = true;
          this.showAdvertisingMaterial = false;
          this.showForm = false;
          this.showMsg = false;

          this.showStageMaterial = 'true_'+get_value;
          this.showStageAdvertisingMaterial = 'false_'+get_value;
          this.showStageForm = 'false_'+get_value;
          this.showStageMsg = 'false_'+get_value;

          this.adMaterialDataNew.creative_array = []
        }
        if(value == 'LEAD_GENERATION'){
          this.showMaterial = true;
          this.showAdvertisingMaterial = false;
          this.showForm = false;
          this.showMsg = false;

          this.showStageMaterial = 'true_'+get_value;
          this.showStageAdvertisingMaterial = 'false_'+get_value;
          this.showStageForm = 'false_'+get_value;
          this.showStageMsg = 'false_'+get_value;

          this.adMaterialDataNew.creative_array = []
        }
        if(value == 'MESSAGES'){
          this.showMaterial = true;
          this.showAdvertisingMaterial = false;
          this.showForm = false;
          this.showMsg = false;

          this.showStageMaterial = 'true_'+get_value;
          this.showStageAdvertisingMaterial = 'true_'+get_value;
          this.showStageForm = 'false_'+get_value;
          this.showStageMsg = 'true_'+get_value;

          // if(this.adMaterialData.creative_array == null){
          //   this.adMaterialData.creative_array = [
          //     {
          //       title: "xxxx",
          //       isEdit: false,
          //       type: 1,
          //       materials:[],
          //       materialSingle: [
          //         {
          //           src: null,
          //           title: null,
          //           size: null
          //         }
          //       ],
          //       callActive: 'SIGN_UP'
          //     }
          //   ]
          // }
        }

        if(value == 'PRODUCT_CATALOG_SALES'){
          this.showMaterial = true;
          this.showAdvertisingMaterial = false;
          this.showForm = false;
          this.showMsg = false;

          this.showStageMaterial = 'true_'+get_value;
          this.showStageAdvertisingMaterial = 'false_'+get_value;
          this.showStageForm = 'false_'+get_value;
          this.showStageMsg = 'false_'+get_value;

          this.postData.select_article = [];
          this.postData.select_creatives = [];
        } else {
          this.postData.select_creatives_adset_ads = [];
        }

        this.adMaterialDataNew = this.tmpAdMaterialDataNew

        // console.log('this.showMaterial:'+this.showMaterial);
        // console.log('this.showAdvertisingMaterial:'+this.showAdvertisingMaterial);
        // console.log('this.showForm:'+this.showForm);
        // console.log('this.showMsg:'+this.showMsg);

        // console.log('this.adMaterialData');
        // console.log(this.adMaterialData);
      },
      objectiveOption(value){
        if(value != '' && value != null && typeof value != 'undefined'){
          let objectiveOptionValue = value.split("|");

          // console.log('objectiveOption');
          // console.log(objectiveOptionValue);
          // console.log(this.formPixelId);

          this.formPixelId = objectiveOptionValue[0]
          this.currentOptimizationAction = objectiveOptionValue[2] || ''

          // console.log(this.formPixelId);
        }
      },
      keywordUrl(value){
        // console.log('keywordUrl')
        // console.log(value);

        this.productUrl = value
      },
      urlKeywordsList(value){
        // console.log('urlKeywordsList');
        // console.log(value);
        // console.log(value.length);

        this.urlKeywordsListData = value
      },
      keywordsSuggestList(value){
        this.keywordsSuggestListData = value
      },
      getHere(target, click, refName, groupType){
        //console.log('getHere', target, click, refName, groupType, this.menu);

        this.changeYoutubeType();
        // console.log('getHere');
        // console.log('this.target');
        // console.log(this.target);

        // console.log('target');
        // console.log(target);

        if(click == 1){

          if(this.target < target){
            this.next(true);
          }

          if(this.target > target) {
            this.prev(true);
          }

          this.getHereTarget = target;
          this.getHereRefName = refName;
          this.getHereGroupType = groupType;

          if(this.target == target){
            this.getAutoTarget(true);
          }

          // if(this.target != target){
          //   console.log('不同target');
          //   this.target = target
          // }

          //console.log('getHere a this.target', this.target);

          // if(this.menu[1].show == false){
          //   if (target > 1) {
          //     target -= 1
          //   }
          //   this.process = parseInt(33) * (parseInt(target) - parseInt(1))
          // } else {
          //   this.process = parseInt(25) * (parseInt(target) - parseInt(1))
          // }
          if(this.showTargetCR == true){
            this.process = parseInt(50)
          } else {
            this.process = parseInt(33) * (parseInt(target) - parseInt(1));
          }

          document.getElementById('edit_content').scrollTop = 0;
        }
      },
      getAutoTarget(isMenu = false){
        //console.log('getAutoTarget', isMenu, this.getHereTarget, this.getHereRefName, this.getHereGroupType);

        //console.log('getAutoTarget b this.target', this.target, this.getHereTarget, this.process);

        if(isMenu === true){
          this.target = this.getHereTarget;
        }

        switch(this.target){
          case 1:
            this.process = 0;
            break;
          case 2:
            if(this.showTargetCR == true){
              this.process = 50;
            } else {
              this.process = 33;
            } 
            break;
          case 3:
            this.process = 66;
            break;
        }

        //console.log('getAutoTarget a this.target', this.target, this.getHereTarget, this.process);

        if(isMenu === true){
          this.$nextTick(() => {
            if(typeof this.getHereGroupType !== 'undefined'){
              let childComponent = this.$refs.childCampaignName;
              if(this.getHereGroupType === 'childMarketingMethod'){
                childComponent = this.$refs.childMarketingMethod;
              }
              if(this.getHereGroupType === 'childBenefitAndContribution'){
                childComponent = this.$refs.childBenefitAndContribution;
              }
              if(this.getHereGroupType === 'childAdStrategy'){
                childComponent = this.$refs.childAdStrategy;
              }
              if(this.getHereGroupType === 'childKeywordMix'){
                childComponent = this.$refs.childKeywordMix;
              }
              if(this.getHereGroupType === 'childAdvertisingMix'){
                childComponent = this.$refs.childAdvertisingMix;
              }
              if(this.getHereGroupType === 'childRemarketingMix'){
                childComponent = this.$refs.childRemarketingMix;
              }
              if(this.getHereGroupType === 'childMarketingDate'){
                childComponent = this.$refs.childMarketingDate;
              }
              if(this.getHereGroupType === 'childGoalsAndBudget'){
                childComponent = this.$refs.childGoalsAndBudget;
              }
              if(this.getHereGroupType === 'childRegions'){
                childComponent = this.$refs.childRegions;
              }
              if(this.getHereGroupType === 'childRelationship'){
                childComponent = this.$refs.childRelationship;
              }
              if(this.getHereGroupType === 'childPositionDevice'){
                childComponent = this.$refs.childPositionDevice;
              }
              if(this.getHereGroupType === 'childIdentity'){
                childComponent = this.$refs.childIdentity;
              }
              if(this.getHereGroupType === 'childMaterial'){
                childComponent = this.$refs.childMaterial;
              }
              if(this.getHereGroupType === 'childCustomizeMaterial'){
                childComponent = this.$refs.childCustomizeMaterial;
              }
              //console.log('childComponent', childComponent);
              if (childComponent && childComponent.$refs[this.getHereRefName]) {
                //console.log('移動');
                childComponent.$refs[this.getHereRefName].scrollIntoView({ behavior: "smooth", block: "start" });
              }
            }

            //console.log('getAutoTarget nextTick b this.target', this.target);
          });
        }
      },
      eventPageId(value) {
        // console.log('methods eventPageId')
        // console.log(value);
        this.formPageId = value
      },
      methodTargetEC(value) {
        this.showTargetEC = value;
      },
      eventFormId(value) {
        // console.log('methods eventFormId')
        // console.log(value);

        var todayForm = new Date();
        var yearForm = todayForm.getFullYear();
        var dateForm = String(todayForm.getDate()).padStart(2, '0');
        var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
        var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

        let get_value = value+'_'+yearForm + monthForm + dateForm + timeForm;
        if(value != '' && value != null && typeof value != 'undefined'){
          this.formId = get_value
        } else {
          this.formId = []
        }
      },
      eventMessageId(value) {
        // console.log('methods eventMessageId')
        // console.log(value);

        var todayForm = new Date();
        var yearForm = todayForm.getFullYear();
        var dateForm = String(todayForm.getDate()).padStart(2, '0');
        var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
        var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

        let get_value = value+'_'+yearForm + monthForm + dateForm + timeForm;
        if(value != '' && value != null && typeof value != 'undefined'){
          this.messageId = get_value
        } else {
          this.messageId = []
        }
      },
      adMaterialContent(value){
        // console.log('adMaterialContent')
        // console.log(value);

        if(typeof value.creative_array != 'undefined'){
          this.adMaterialDataNew = value
        } else {
          this.adMaterialDataNew.creative_array = value
        }
      },
      formChangeFormId(value){
        //console.log('b this.changeFormId')
        //console.log(this.changeFormId);

        this.changeFormId = null

        //console.log('c this.changeFormId')
        //console.log(this.changeFormId);

        this.changeFormId = value
      },
      formChangeMessageId(value){
        // console.log('formChangeMessageId')
        // console.log(value);

        this.changeMessageId = value
      },
      activeScroll(value){

        let tmpDataType = value.split('_');

        if(tmpDataType[0] == 1){
          this.showAdvertisingMaterial = true;
          this.showMsg = true;

          this.AdvertisingMaterialStatus = this.showMsg;

          // console.log('activeScroll');
          // console.log('this.showAdvertisingMaterial');
          // console.log(this.showAdvertisingMaterial);
          // console.log('this.showMsg');
          // console.log(this.showMsg);

          // this.$refs.scrollcontent.scrollTo({
          //   top: 1505,
          //   behavior: 'smooth'
          // });
        }
      },
      formMsgTeachingOver(value){
        //console.log('formMsgTeachingOver');
        //console.log(value);

        var todayForm = new Date();
        var yearForm = todayForm.getFullYear();
        var dateForm = String(todayForm.getDate()).padStart(2, '0');
        var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
        var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

        let get_value = '1_'+yearForm + monthForm + dateForm + timeForm;

        this.msgTeachingOver = get_value
        //console.log('this.msgTeachingOver');
        //console.log(this.msgTeachingOver);
      },
      activeFormTeachingOver(value){
        //console.log('activeFormTeachingOver');
        //console.log(value);

        var todayForm = new Date();
        var yearForm = todayForm.getFullYear();
        var dateForm = String(todayForm.getDate()).padStart(2, '0');
        var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
        var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

        let get_value = '1_'+yearForm + monthForm + dateForm + timeForm;

        this.formTeachingOver = get_value
    //  console.log('this.formTeachingOver');
    //  console.log(this.formTeachingOver);
      },
      useASC(value){
    //  console.log('useASC');
    //  console.log(value);

        var todayForm = new Date();
        var yearForm = todayForm.getFullYear();
        var dateForm = String(todayForm.getDate()).padStart(2, '0');
        var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
        var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

        todayForm = yearForm + monthForm + dateForm + timeForm;

        if(value == true){
          this.haveASC = 'true_'+todayForm;
        } else {
          this.haveASC = 'false_'+todayForm;
        }
      },
      processData(data) {
        let return_type = data.some(Array.isArray) ? 1 : 2;

        const flattenArray = (arr) => {
          return arr.reduce((acc, val) =>
            Array.isArray(val) ? acc.concat(flattenArray(val)) : acc.concat(val)
          , []);
        };

        let flattened_data = flattenArray(data);

        return {
          return_type: return_type,
          data: flattened_data
        };
      },
      getDefaultLayout(data){
    //  console.log('getDefaultLayout');
    //  console.log(data);

        let value = data.split('_');
    //  console.log('value');
    //  console.log(value);
        let processSubData = this.processData(this.defaultLayout[value[1]].sub);
        let otherCustomSub = processSubData.data;
        let otherCustomContentLength = this.defaultLayout[value[1]].content.length;
        this.otherCustomCampaignId = this.defaultLayout[value[1]].main_campaign_id;

        if(processSubData.return_type == 1){
          this.doForwardData.useDoForward = true;
        } else {
          this.doForwardData.useDoForward = false;
        }

    //  console.log('otherCustomSub');
    //  console.log(otherCustomSub);
    //  console.log('otherCustomContentLength');
    //  console.log(otherCustomContentLength);
    //  console.log('this.defaultLayout[value[1]]');
    //  console.log(this.defaultLayout[value[1]]);
    //  console.log('this.defaultLayout[value[1]].content');
    //  console.log(this.defaultLayout[value[1]].content);

        this.useDefaultLayout = this.otherCustomCampaignId;
        this.showOtherTargetCR = true;
        this.methodData.Other_Target_CR = true;

        // console.log('b showOtherTargetCR');
        // console.log(this.showOtherTargetCR);

        // this.showOtherTargetCR = (value[0] === "true");
        // this.methodData.Other_Target_CR = (value[0] === "true");
        this.showCampaignData = false;

        // console.log('a showOtherTargetCR');
        // console.log(typeof this.showTargetCR);
        // console.log(this.showTargetCR);
        // console.log(typeof this.showOtherTargetCR);
        // console.log(this.showOtherTargetCR);
    //  console.log(typeof this.useDefaultLayout);
    //  console.log(this.useDefaultLayout);

        axios
          .post('https://www.autoturn.net/api/customize/campaign/strategy.php', Qs.stringify({
            s_code: this.$route.params.id,
            adaccount_id: this.$route.params.adaccount_id,
            campaign_id: this.otherCustomCampaignId
          }))
          .then((response) => {
            var todayForm = new Date();
            var yearForm = todayForm.getFullYear();
            var dateForm = String(todayForm.getDate()).padStart(2, '0');
            var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
            var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

            todayForm = yearForm + monthForm + dateForm + timeForm;

            let _tmpCampaignName = response.data.return_data.campaign_name+'_'+todayForm;
            this.campaign_name = _tmpCampaignName;

            if(otherCustomContentLength <= 0){
              // if(otherCustomSub != '' && otherCustomSub != null && typeof otherCustomSub != 'undefined'){
                if(otherCustomSub.length > 0){
              //  console.log('#01');

                  // this.customRulesData.stageList = [];
                  // this.customRulesData.subCampaignsContent = [];

              //  console.log('before db this.customRulesData');
              //  console.log(this.customRulesData);

                  this.customRulesData.haveTest = false;

                  // this.fetchData(otherCustomSub, response, 'use');
                  this.strategyFetchData(otherCustomSub, response);
                }
              // }
            }
            else {
          //  console.log('有資料');
          //  console.log(this.menu);
          //  console.log(this.customRulesData);

              this.menu = this.defaultLayout[value[1]].menu;
              this.customRulesData.haveTest = this.defaultLayout[value[1]].statusTest;
              this.customRulesData.stageList = this.defaultLayout[value[1]].stageList;
              this.customRulesData.subCampaignsContent = this.defaultLayout[value[1]].content;

          //  console.log(this.menu);
          //  console.log(this.customRulesData);
              this.showCampaignData = true;
            }
          });

        // console.log('getOtherCustom this.customRulesData');
        // console.log(this.customRulesData);
      },
      getOtherCustom(data){
    //  console.log('getOtherCustom');
    //  console.log(data);

        let value = data.split('_');
    //  console.log('value');
    //  console.log(value);
        let processSubData = this.processData(this.otherCustomTitle[value[1]].sub);
        let otherCustomSub = processSubData.data;
        let otherCustomContentLength = this.otherCustomTitle[value[1]].content.length;
        this.otherCustomCampaignId = this.otherCustomTitle[value[1]].main_campaign_id;

        if(processSubData.return_type == 1){
          this.doForwardData.useDoForward = true;
        } else {
          this.doForwardData.useDoForward = false;
        }

    //  console.log('otherCustomSub');
    //  console.log(otherCustomSub);
    //  console.log('otherCustomContentLength');
    //  console.log(otherCustomContentLength);
    //  console.log('this.otherCustomTitle[value[1]]');
    //  console.log(this.otherCustomTitle[value[1]]);
    //  console.log('this.otherCustomTitle[value[1]].content');
    //  console.log(this.otherCustomTitle[value[1]].content);

    //  console.log('b showOtherTargetCR');
    //  console.log(this.showOtherTargetCR);

        this.useDefaultLayout = null;
        this.showOtherTargetCR = (value[0] === "true");
        this.methodData.Other_Target_CR = (value[0] === "true");
        this.showCampaignData = false;

    //  console.log('a showOtherTargetCR');
    //  console.log(this.showOtherTargetCR);

        axios
          .post('https://www.autoturn.net/api/campaign.php', Qs.stringify({
            s_code: this.$route.params.id,
            adaccount_id: this.$route.params.adaccount_id,
            campaign_id: this.otherCustomCampaignId
          }))
          .then((response) => {
            var todayForm = new Date();
            var yearForm = todayForm.getFullYear();
            var dateForm = String(todayForm.getDate()).padStart(2, '0');
            var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
            var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

            todayForm = yearForm + monthForm + dateForm + timeForm;

            let _tmpCampaignName = response.data.return_data.campaign_name+'_'+todayForm;
            this.campaign_name = _tmpCampaignName;

            if(otherCustomContentLength <= 0){
              // if(otherCustomSub != '' && otherCustomSub != null && typeof otherCustomSub != 'undefined'){
                if(otherCustomSub.length > 0){
              //  console.log('#01');

                  // this.customRulesData.stageList = [];
                  // this.customRulesData.subCampaignsContent = [];

              //  console.log('before db this.customRulesData');
              //  console.log(this.customRulesData);

                  this.customRulesData.haveTest = false;

                  // otherCustomSub.forEach((sub_value, sub_index) => {
                  //   console.log(sub_index+':'+sub_value);
                  //   console.log(sub_index+ ' before this.customRulesData');
                  //   console.log(this.customRulesData);

                  //   let _toMenuIndex = sub_index + parseInt(1);
                  //   console.log(_toMenuIndex);

                  //   axios
                  //     .post('https://www.autoturn.net/api/campaign_subset.php', Qs.stringify({
                  //       s_code: this.$route.params.id,
                  //       adaccount_id: this.$route.params.adaccount_id,
                  //       haveTest: response.data.return_data.haveTest,
                  //       itemIndex: sub_index,
                  //       campaign_id: sub_value,
                  //       useOtherCustom: 'use',
                  //       useFixedTemp: true
                  //     }))
                  //     .then((subResponse) => {
                  //   //  console.log('getOtherCustom campaign_subset subResponse');
                  //   //  console.log(subResponse);
                  //       if(subResponse.data.status == 'success'){
                  //         this.menu[_toMenuIndex] = JSON.parse(JSON.stringify(subResponse.data.return_menu));
                  //         this.customRulesData.haveTest = response.data.return_data.haveTest;
                  //         this.otherCustomTitle[value[1]].statusTest = response.data.return_data.haveTest;

                  //         if(subResponse.data.subset_method != 'META_TEST'){
                  //           let _toStageListIndex = sub_index;
                  //           if(this.customRulesData.haveTest == true){
                  //             _toStageListIndex = sub_index - parseInt(1);
                  //           }
                  //       //  console.log(typeof subResponse.data.return_stage_list);
                  //       //  console.log(subResponse.data.return_stage_list);
                  //           this.customRulesData.stageList[_toStageListIndex] = JSON.parse(JSON.stringify(subResponse.data.return_stage_list));
                  //           this.otherCustomTitle[value[1]].stageList[_toStageListIndex] = JSON.parse(JSON.stringify(subResponse.data.return_stage_list));
                  //         }

                  //         if(subResponse.data.subset_method == 'META_ASC'){
                  //           var todayForm = new Date();
                  //           var yearForm = todayForm.getFullYear();
                  //           var dateForm = String(todayForm.getDate()).padStart(2, '0');
                  //           var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                  //           var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                  //           todayForm = yearForm + monthForm + dateForm + timeForm;

                  //           this.haveASC = 'true_'+todayForm;
                  //         }

                  //     //  console.log(typeof subResponse.data.return_data);
                  //     //  console.log(subResponse.data.return_data);
                  //         this.customRulesData.subCampaignsContent[sub_index] = JSON.parse(JSON.stringify(subResponse.data.return_data));
                  //         this.otherCustomTitle[value[1]].content[sub_index] = JSON.parse(JSON.stringify(subResponse.data.return_data));

                  //     //  console.log(sub_index+ ' db+ this.menu');
                  //     //  console.log(this.menu);
                  //     //  console.log(sub_index+ ' db+ this.customRulesData');
                  //     //  console.log(this.customRulesData);
                  //       }

                  //       if(_toMenuIndex == otherCustomSub.length){
                  //         this.otherCustomTitle[value[1]].menu = this.menu;
                  //         this.menu[0].submenu[2].show = true
                  //     //  console.log('change menu show');
                  //     //  console.log(this.menu);
                  //     //  console.log('db end this.showOtherTargetCR');
                  //     //  console.log(this.showOtherTargetCR);
                  //     //  console.log('db end this.otherCustomTitle');
                  //     //  console.log(this.otherCustomTitle);
                  //     //  console.log('campaign_subset done');
                  //         this.showCampaignData = true;
                  //       }
                  //     });

                  //   // console.log('all db this.customRulesData');
                  //   // console.log(this.customRulesData);
                  //   // console.log('all this.menu');
                  //   // console.log(this.menu);
                  // });

                  this.fetchData(otherCustomSub, response);
                }
              // }
            }
            else {
          //  console.log('有資料');
          //  console.log(this.menu);
          //  console.log(this.customRulesData);

              this.menu = this.otherCustomTitle[value[1]].menu;
              this.customRulesData.haveTest = this.otherCustomTitle[value[1]].statusTest;
              this.customRulesData.stageList = this.otherCustomTitle[value[1]].stageList;
              this.customRulesData.subCampaignsContent = this.otherCustomTitle[value[1]].content;

          //  console.log(this.menu);
          //  console.log(this.customRulesData);
              this.showCampaignData = true;
            }
          });

        // console.log('getOtherCustom this.customRulesData');
        // console.log(this.customRulesData);
      },
      setHideCustom(data){
        let value = data.split('|||');
    //  console.log('setHideCustom');
    //  console.log(this.otherCustomCampaignId);

        Swal.fire({
          title: '刪除其他自定義',
          html: '您要刪除「'+value[0]+'」其他自定義規則嗎？',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          width: 'auto', // 可選：根據內容自動調整寬度
          padding: '1em',
          confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['yes_button'],
          cancelButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['no_button'],
        }).then((result) => {
          if (result.isConfirmed) {
        //  console.log(value);

            this.showCampaignData = false;

            axios
              .post('https://www.autoturn.net/api/data/campaign_subset_status_update.php', Qs.stringify({
                s_code: this.$route.params.id,
                campaign_id: value[1],
              }))
              .then((response) => {
                // console.log(response.data);
                this.showCampaignData = true;

                if(response.data.status == 'success'){
                  Swal.fire({
                    icon: response.data.status,
                    title: '刪除其他自定義',
                    text: response.data.info,
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['success']['info_state_success']['confirm_button'],
                    // denyButtonText: `Don't save`,
                  }).then((result) => {
                    this.showCampaignData = false;
                    /* Read more about isConfirmed, isDenied below */
                    // if (result.isConfirmed) {
                    //   // Swal.fire('Saved!', '', 'success')
                    //   this.allPageLoading = true
                    //   window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                    // } else if (result.isDenied) {
                    //   // Swal.fire('Changes are not saved', '', 'info')
                    //   this.allPageLoading = true
                    //   window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                    // }

                    // if (result.dismiss === Swal.DismissReason.timer) {
                    //   this.allPageLoading = true
                    //   window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                    // }

                    axios
                      .post('https://www.autoturn.net/api/campaign_create_default.php', Qs.stringify({
                        s_code: this.$route.params.id,
                        adaccount_id: this.$route.params.adaccount_id,
                        campaign_id: this.$route.params.campaign_id
                      }))
                      .then((response) => {
                        if(response.data.status == 'success'){
                          let otherSubsetDataLength = response.data.return_data.other_subset_data.length;
                          for(let i = 0; i < otherSubsetDataLength; i++){
                            if(response.data.return_data.other_subset_data[i].main_campaign_id == this.otherCustomCampaignId){
                              response.data.return_data.other_subset_data[i].selected = true;
                            }
                          }
                          this.otherCustomTitle = response.data.return_data.other_subset_data;

                          if(otherSubsetDataLength == 0){
                            this.showOtherTargetCR = false;
                            this.methodData.Other_Target_CR = false;
                          }
                        }

                        this.showCampaignData = true;
                      });
                  })
                }
              });
          }
        });
      },
      hasValue(value, ignoreZero = false) {
        if (value === null || value === undefined || value === "") {
          return false;
        }

        if (ignoreZero && value === 0) {
          return false;
        }

        return true;
      },
      validateBeneficiary() {
        if (this.hasValue(this.benefitsAndInvestmentData.selectedBeneficiary, true)) {
          return true;
        }

        return (
          this.hasValue(this.benefitsAndInvestmentData.beneficiary_id, true) &&
          this.hasValue(this.benefitsAndInvestmentData.beneficiary_name, true)
        );
      },
      validatePayer() {
        if (this.hasValue(this.benefitsAndInvestmentData.selectedPayer, true)) {
          return true;
        }

        return (
          this.hasValue(this.benefitsAndInvestmentData.payer_id, true) &&
          this.hasValue(this.benefitsAndInvestmentData.payer_name, true)
        );
      },
      prev(isMenu = false) {
        this.changeYoutubeType();
        // console.log('now target:'+this.target);
        // let isTrue = 1;

        // if(this.campaign_name == null || this.campaign_name == '' || typeof this.campaign_name == 'undefined'){
        //   Swal.fire(
        //                 "行銷活動名稱",
        //                 "請填寫行銷活動名稱",
        //                 "error"
        //               )
        //   isTrue = 0;
        // }

        // if(this.target == 2){
        //   if(this.keywordData.select_keywords != '' && this.keywordData.select_keywords != null && typeof this.keywordData.select_keywords != 'undefined'){
        //     if(this.keywordData.select_keywords.length > 0 && this.methodData.Target_KW == true){
        //       let select_keywords_num = 0;
        //       for (var i = 0; i >= this.keywordData.select_keywords.length; i++) {
        //         if(this.keywordData.select_keywords.checked == true){
        //           select_keywords_num = parseInt(select_keywords_num) + parseInt(1);
        //         }
        //       }

        //       if(select_keywords_num > 5){
        //         Swal.fire(
        //                 "精準興趣",
        //                 "關鍵字最多選擇5個",
        //                 "error"
        //               )
        //         isTrue = 0;
        //       }
        //     }
        //   } else {
        //     Swal.fire(
        //               "精準興趣",
        //               "關鍵字最多選擇5個",
        //               "error"
        //             )
        //     isTrue = 0;
        //   }

        //   if(this.methodData.Target_LA == true){
        //     if((this.lookData.default_lookalikes_list != '' && this.lookData.default_lookalikes_list != null && typeof this.lookData.default_lookalikes_list != 'undefined') || (this.lookData.custom_lookalikes_selected != '' && this.lookData.custom_lookalikes_selected != null && typeof this.lookData.custom_lookalikes_selected != 'undefined')){
        //       let lookalikes_num = 0;
        //       for (var i = 0; i >= this.lookData.default_lookalikes_list.length; i++) {
        //     //  console.log('checked type:'+typeof this.lookData.default_lookalikes_list.checked);
        //         if(this.lookData.default_lookalikes_list.checked == true){
        //           lookalikes_num = parseInt(lookalikes_num) + parseInt(1);
        //         }
        //       }

        //   //  console.log(this.lookData.default_lookalikes_list);
        //   //  console.log('default_lookalikes_list');
        //   //  console.log(lookalikes_num);

        //       for (var i = 0; i >= this.lookData.custom_lookalikes_selected.length; i++) {
        //         lookalikes_num = parseInt(lookalikes_num) + parseInt(1);
        //       }

        //   //  console.log(this.lookData.custom_lookalikes_selected);
        //   //  console.log('custom_lookalikes_selected');
        //   //  console.log(lookalikes_num);

        //       if(lookalikes_num != 5){
        //         Swal.fire(
        //                 "類似受眾廣告組合",
        //                 "自訂類似受眾與預設類似受眾，總共需選擇5個",
        //                 "error"
        //               )
        //         isTrue = 0;
        //       }
        //     } else {
        //       Swal.fire(
        //               "類似受眾廣告組合",
        //               "自訂類似受眾與預設類似受眾，總共需選擇5個",
        //               "error"
        //             )
        //       isTrue = 0;
        //     }
        //   }
        // }

        // if(this.target == 3){
        //   console.log('objective_option:'+this.goalsData.objective_option);
        //   console.log('conversion_domain:'+this.goalsData.conversion_domain);
        //   console.log('risk_level:'+this.goalsData.risk_level.code);
        //   console.log('excluded_audiences:'+this.exAudiencesData.excluded_audiences);
        //   if(this.goalsData.objective_option == '' || this.goalsData.objective_option == null || typeof this.goalsData.objective_option == 'undefined'){
        //     Swal.fire(
        //             "行銷活動目標",
        //             "請選擇一個行銷活動目標與條件",
        //             "error"
        //           )
        //     isTrue = 0;
        //   }

        //   if(this.goalsData.campaign_objective == 'CONVERSIONS' && (this.goalsData.conversion_domain == '' || this.goalsData.conversion_domain == null || typeof this.goalsData.conversion_domain == 'undefined')){
        //     Swal.fire(
        //               "行銷活動目標",
        //               "若選擇「轉換次數」，就必須設定「轉換網域」",
        //               "error"
        //             )
        //     isTrue = 0;
        //   }

        //   if((this.goalsData.risk_level.code == 'auto' || this.goalsData.risk_level.code == 'low') && (this.goalsData.effect == '' || this.goalsData.effect == 0 || this.goalsData.effect == null)){
        //     Swal.fire(
        //               "目標成本與預算使用",
        //               "如預算使用設定為「自動」或「保守」，則必須設定目標成本",
        //               "error"
        //             )

        //     isTrue = 0;
        //   }

        //   if(this.exAudiencesData.excluded_audiences != '' && this.exAudiencesData.excluded_audiences != null && typeof this.exAudiencesData.excluded_audiences != 'undefined' ){
        //     let excluded_audiences = this.exAudiencesData.excluded_audiences.length;
        //     let custom_excluded_audiences_selected_num = 0;
        //     for (var i = 0; i >= this.exAudiencesData.custom_excluded_audiences_selected.length; i++) {
        //       if(this.exAudiencesData.custom_excluded_audiences_selected.checked == true){
        //         custom_excluded_audiences_selected_num = parseInt(custom_excluded_audiences_selected_num) + parseInt(1);
        //       }
        //     }

        //     let excluded_audiences_num = parseInt(excluded_audiences) + parseInt(custom_excluded_audiences_selected_num);

        //     if(excluded_audiences_num > 5){
        //       Swal.fire(
        //                 "排除受眾",
        //                 "最多設定5個",
        //                 "error"
        //               )

        //       isTrue = 0;
        //     }
        //   }
        // }

        // if(this.target == 4){
        //   if(this.pdData.auto_publisher == false && (this.pdData.publisher_platforms.length <= 0 || this.pdData.publisher_platforms == '' || this.pdData.publisher_platforms == null || typeof this.pdData.publisher_platforms == 'undefined')){
        //     Swal.fire(
        //               "版位與裝置",
        //               "請至少設定一種版位。",
        //               "error"
        //             )

        //     isTrue = 0;
        //   }

        //   if(this.idData.page_id == '' || this.idData.page_id == null || typeof this.idData.page_id == 'undefined'){
        //     Swal.fire(
        //               "Facebook",
        //               "請選擇一個Facebook粉絲專頁。",
        //               "error"
        //             )

        //     isTrue = 0;
        //   }

        //   if(this.goalsData.campaign_objective == 'CONVERSIONS' || this.goalsData.campaign_objective == 'LINK_CLICKS' || this.goalsData.campaign_objective == 'POST_ENGAGEMENT' || this.goalsData.campaign_objective == 'VIDEO_VIEWS'){
        //     if(this.postData.select_article.length <= 0){
        //       isTrue = 1;

        //       Swal.fire(
        //         '確認修改',
        //         '請選擇一篇貼文。',
        //         'error'
        //       )
        //     }
        //   }

        //   if(this.goalsData.campaign_objective == 'LEAD_GENERATION' || this.goalsData.campaign_objective == 'MESSAGES'){
        //     if(this.adMaterialData.creative_array.length <= 0){
        //       isTrue = 1;

        //       Swal.fire(
        //         '確認修改',
        //         '請設定一組廣告素材。',
        //         'error'
        //       )
        //     }
        //   }
        // }

        // if(isTrue == 1){
          let member_hash = this.$route.params.id
          let adaccount_id = this.$route.params.adaccount_id

          axios
            .post('https://www.autoturn.net/api/campaign_member_status.php', Qs.stringify({
              s_code: member_hash,
              route_type: this.$route.params.type,
              active: 'add',
            }))
            .then((caResponse) => {

              if(caResponse.data.status == 'error'){
                if(caResponse.data.type == 2){
                  Swal.fire({
                    icon: caResponse.data.status,
                    title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['prev']['campaign_member_status']['error']['swal_title'],
                    text: caResponse.data.info,
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['prev']['campaign_member_status']['error']['confirm_button']
                    // denyButtonText: `Don't save`,
                  }).then((result) => {
                    if (result.isConfirmed) {
                      // Swal.fire('Saved!', '', 'success')
                      this.allPageLoading = true
                      window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                    } else if (result.isDenied) {
                      // Swal.fire('Changes are not saved', '', 'info')
                      this.allPageLoading = true
                      window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                    }

                    if (result.dismiss === Swal.DismissReason.timer) {
                      this.allPageLoading = true
                      window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                    }
                  })
                } else if(caResponse.data.type == 3){
                  Swal.fire({
                    icon: caResponse.data.status,
                    title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['prev']['campaign_member_status']['error']['swal_title'],
                    text: caResponse.data.info,
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['prev']['campaign_member_status']['error']['confirm_button']
                    // denyButtonText: `Don't save`,
                  }).then((result) => {
                    if (result.isConfirmed) {
                      // Swal.fire('Saved!', '', 'success')
                      this.allPageLoading = true
                      window.location.href = "https://private.autoturn.net/f/"+member_hash;
                    } else if (result.isDenied) {
                      // Swal.fire('Changes are not saved', '', 'info')
                      this.allPageLoading = true
                      window.location.href = "https://private.autoturn.net/f/"+member_hash;
                    }

                    if (result.dismiss === Swal.DismissReason.timer) {
                      this.allPageLoading = true
                      window.location.href = "https://private.autoturn.net/f/"+member_hash;
                    }
                  })
                } else {
                  Swal.fire(
                            this.showLang[this.selectLang]['views']['EventAdd']['methods']['prev']['campaign_member_status']['error']['swal_title'],
                            caResponse.data.info,
                            caResponse.data.status
                          )
                }
              }

              if(caResponse.data.status == 'warning'){
                Swal.fire({
                  icon: 'warning',
                  title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['prev']['campaign_member_status']['warning']['swal_title'],
                  text: caResponse.data.info,
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['prev']['campaign_member_status']['warning']['confirm_button']
                  // denyButtonText: `Don't save`,
                }).then((result) => {
                  // if(this.menu[1].show == false){
                    this.process -= 33
                    if (this.target > 1) {
                      this.target -= 1

                      // if(this.target == 2){
                      //   this.target -= 1
                      // }
                    }
                  // } else {
                  //   this.process -= 25
                  //   if (this.target > 1) {
                  //     this.target -= 1
                  //   }
                  // }
                  // console.log('prev target:'+this.target);
                  document.getElementById('edit_content').scrollTop = 0;

                  this.getAutoTarget(isMenu);

                  if(this.db_campaign_id == null || this.db_campaign_id == '' || typeof this.db_campaign_id == 'undefined'){
                    var daily_keyword_split_budget = this.methodData.Budget_KW;
                    var daily_demo_budget = this.methodData.Budget_DM;
                    var budget_addition = this.goalsData.form_addition;

                    if(this.dateData.start_date != "" && this.dateData.end_date != ""){
                        var d1 = new Date(this.dateData.start_date);
                        var d2 = new Date(this.dateData.end_date);
                        var days = parseInt((d2-d1)/86400000) + parseInt(1);
                    } else {
                        var days = 0;
                    }

                    var keyword_split_budget = 0;
                    if(this.methodData.Budget_KW != ''){
                        keyword_split_budget = Math.round(this.methodData.Budget_KW * days * (1+(budget_addition/100)));
                    }

                    var demo_budget = 0;
                    if(this.methodData.Budget_DM != ''){
                        demo_budget = this.methodData.Budget_DM * days;
                    }

                    var _tmp_audience_budget = 0;
                    var audience_budget = 0;
                    // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.5)');
                    _tmp_audience_budget = this.methodData.Budget_LA;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.5);
                    // console.log('Math.round('+_tmp_audience_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                    audience_budget = Math.round(_tmp_audience_budget * days * (1+(budget_addition/100)));

                    var _tmp_marketing_again_budget = 0;
                    var marketing_again_budget = 0;
                    // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.25)');
                    _tmp_marketing_again_budget = this.methodData.Budget_RT;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.25);
                    // console.log('Math.round('+_tmp_marketing_again_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                    marketing_again_budget = Math.round(_tmp_marketing_again_budget * days * (1+(budget_addition/100)));

                    // console.log(parseInt(keyword_split_budget)+' + '+parseInt(demo_budget)+' + '+parseInt(audience_budget)+' + '+parseInt(marketing_again_budget));
                    var ac_budget = 0;
                    if(this.methodData.Budget_AC != '' && this.methodData.Budget_AC != 0){
                        ac_budget = Math.round(this.methodData.Budget_AC * days);
                    }
                    var html = parseInt(keyword_split_budget) + parseInt(demo_budget) + parseInt(audience_budget) + parseInt(marketing_again_budget) + parseInt(ac_budget);

                    if(isNaN(html)){
                        html = '0';
                    }

                    this.total_budget = html;

                    let _tmp_goalsData = this.goalsData;
                    const _view_goalsData = JSON.parse(JSON.stringify(_tmp_goalsData));
                    let _tmp_exAudiencesData = this.exAudiencesData;
                    const _view_exAudiencesData = JSON.parse(JSON.stringify(_tmp_exAudiencesData));

                    delete _view_goalsData['objective_list'];
                    delete _view_exAudiencesData['custom_excluded_audiences'];

                    let formData = {
                      campaign_name: this.campaign_name,
                      budget_type: this.budget_type,
                      special_ad_category: this.special_ad_category,
                      adaccount_id: this.adaccount_id,
                      Budget_KW_result: this.Budget_KW_result,
                      total_budget: this.total_budget,
                      useDefaultLayout: this.useDefaultLayout,
                      dynBudgetData: this.dynBudgetData,
                      methodData: this.methodData,
                      benefitsAndInvestmentData: this.benefitsAndInvestmentData,
                      dateData: this.dateData,
                      keywordData: this.keywordData,
                      lookData: this.lookData,
                      audiencesData: this.audiencesData,
                      goalsData: _view_goalsData,
                      regionsData: this.regionsData,
                      selectCountries: this.selectCountries,
                      selectLangs: this.selectLangs,
                      exAudiencesData: _view_exAudiencesData,
                      pdData: this.pdData,
                      idData: this.idData,
                      postData: this.postData,
                      adMaterialData: this.adMaterialDataNew,
                      autoAdjustData: this.autoAdjustData
                    }

                    axios
                      .post('https://www.autoturn.net/api/data/campaign_add_update.php', Qs.stringify({
                        s_code: this.$route.params.id,
                        form_data: formData,
                      }))
                      .then((response) => {
                        // console.log(response.data);

                        if(response.data.status == 'success'){
                          this.db_campaign_id = response.data.campaign_id
                          axios
                            .post('https://www.autoturn.net/api/data/teaching_update.php', Qs.stringify({
                              s_code: this.$route.params.id,
                              id: this.teaching_id,
                              campaign_id: this.db_campaign_id,
                              campaign_objective: '',
                              skip: '',
                              step: '',
                              active: 'campaign_id'
                            }));
                        } else if(response.data.status == 'login'){
                          Swal.fire({
                            icon: 'error',
                            title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['prev']['campaign_member_status']['login']['swal_title'],
                            text: response.data.info,
                            showDenyButton: false,
                            showCancelButton: false,
                            confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['prev']['campaign_member_status']['login']['confirm_button']
                            // denyButtonText: `Don't save`,
                          }).then((result) => {
                            /* Read more about isConfirmed, isDenied below */
                            if (result.isConfirmed) {
                              // Swal.fire('Saved!', '', 'success')
                              // this.allPageLoading = true
                              window.location.href = "https://www.autoturn.net/index.php/index/logout/"+this.$route.params.id+"?o=1";
                            } else if (result.isDenied) {
                              // Swal.fire('Changes are not saved', '', 'info')
                              // this.allPageLoading = true
                              window.location.href = "https://www.autoturn.net/index.php/index/logout/"+this.$route.params.id+"?o=1";
                            }
                          })
                        } else {
                          let text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['prev']['campaign_member_status']['warning']['campaign_add_update']['default_swal_text'];
                          if(response.data.info != '' && response.data.info != null){
                            text = response.data.info
                          }
                          Swal.fire(
                            this.showLang[this.selectLang]['views']['EventAdd']['methods']['prev']['campaign_member_status']['warning']['campaign_add_update']['swal_title'],
                            text,
                            'error'
                          )
                        }
                      });
                  } else {
                    var daily_keyword_split_budget = this.methodData.Budget_KW;
                    var daily_demo_budget = this.methodData.Budget_DM;
                    var budget_addition = this.goalsData.form_addition;

                    if(this.dateData.start_date != "" && this.dateData.end_date != ""){
                        var d1 = new Date(this.dateData.start_date);
                        var d2 = new Date(this.dateData.end_date);
                        var days = parseInt((d2-d1)/86400000) + parseInt(1);
                    } else {
                        var days = 0;
                    }

                    var keyword_split_budget = 0;
                    if(this.methodData.Budget_KW != ''){
                        keyword_split_budget = Math.round(this.methodData.Budget_KW * days * (1+(budget_addition/100)));
                    }

                    var demo_budget = 0;
                    if(this.methodData.Budget_DM != ''){
                        demo_budget = this.methodData.Budget_DM * days;
                    }

                    var _tmp_audience_budget = 0;
                    var audience_budget = 0;
                    // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.5)');
                    _tmp_audience_budget = this.methodData.Budget_LA;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.5);
                    // console.log('Math.round('+_tmp_audience_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                    audience_budget = Math.round(_tmp_audience_budget * days * (1+(budget_addition/100)));

                    var _tmp_marketing_again_budget = 0;
                    var marketing_again_budget = 0;
                    // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.25)');
                    _tmp_marketing_again_budget = this.methodData.Budget_RT;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.25);
                    // console.log('Math.round('+_tmp_marketing_again_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                    marketing_again_budget = Math.round(_tmp_marketing_again_budget * days * (1+(budget_addition/100)));

                    // console.log(parseInt(keyword_split_budget)+' + '+parseInt(demo_budget)+' + '+parseInt(audience_budget)+' + '+parseInt(marketing_again_budget));
                    var ac_budget = 0;
                    if(this.methodData.Budget_AC != '' && this.methodData.Budget_AC != 0){
                        ac_budget = Math.round(this.methodData.Budget_AC * days);
                    }
                    var html = parseInt(keyword_split_budget) + parseInt(demo_budget) + parseInt(audience_budget) + parseInt(marketing_again_budget) + parseInt(ac_budget);

                    if(isNaN(html)){
                        html = '0';
                    }

                    this.total_budget = html;

                    let _tmp_goalsData = this.goalsData;
                    const _view_goalsData = JSON.parse(JSON.stringify(_tmp_goalsData));
                    let _tmp_exAudiencesData = this.exAudiencesData;
                    const _view_exAudiencesData = JSON.parse(JSON.stringify(_tmp_exAudiencesData));

                    delete _view_goalsData['objective_list'];
                    delete _view_exAudiencesData['custom_excluded_audiences'];

                    let formData = {
                      campaign_id: this.db_campaign_id,
                      campaign_name: this.campaign_name,
                      budget_type: this.budget_type,
                      special_ad_category: this.special_ad_category,
                      adaccount_id: this.adaccount_id,
                      Budget_KW_result: this.Budget_KW_result,
                      total_budget: this.total_budget,
                      useDefaultLayout: this.useDefaultLayout,
                      dynBudgetData: this.dynBudgetData,
                      methodData: this.methodData,
                      benefitsAndInvestmentData: this.benefitsAndInvestmentData,
                      dateData: this.dateData,
                      keywordData: this.keywordData,
                      lookData: this.lookData,
                      audiencesData: this.audiencesData,
                      goalsData: _view_goalsData,
                      regionsData: this.regionsData,
                      selectCountries: this.selectCountries,
                      selectLangs: this.selectLangs,
                      exAudiencesData: _view_exAudiencesData,
                      pdData: this.pdData,
                      idData: this.idData,
                      postData: this.postData,
                      adMaterialData: this.adMaterialDataNew,
                      autoAdjustData: this.autoAdjustData
                    }

                    axios
                      .post('https://www.autoturn.net/api/data/campaign_update.php', Qs.stringify({
                        s_code: this.$route.params.id,
                        form_data: formData,
                        target: 'add_prev_'+this.target,
                      }))
                      .then((response) => {
                        // console.log(response.data);
                        if(response.data.status == 'success'){
                          // this.immediateList = response.data.return_data
                          // this.formData = response.data.return_data.form

                          // Swal.fire({
                          //   icon: 'success',
                          //   title: '儲存',
                          //   text: response.data.info,
                          //   showDenyButton: false,
                          //   showCancelButton: false,
                          //   confirmButtonText: '確定',
                          //   // denyButtonText: `Don't save`,
                          // }).then((result) => {
                          //   if (result.isConfirmed) {
                          //     // Swal.fire('Saved!', '', 'success')

                          //     // window.location.href = "https://private.autoturn.net/events-list/"+this.$route.params.id+"/"+this.$route.params.adaccount_id;
                          //   } else if (result.isDenied) {
                          //     // Swal.fire('Changes are not saved', '', 'info')
                          //   }
                          // })

                          // if(type == 1){
                          //   var todayForm = new Date();
                          //   var yearForm = todayForm.getFullYear();
                          //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                          //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                          //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                          //   todayForm = yearForm + monthForm + dateForm + timeForm;

                          //   this.formTitle = 'title_'+todayForm;
                          // } else {
                          //   this.formTitle = response.data.return_data.name;
                          // }

                          // this.showModal = true
                        } else if(response.data.status == 'login'){
                          Swal.fire({
                            icon: 'error',
                            title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['prev']['campaign_member_status']['login']['swal_title'],
                            text: response.data.info,
                            showDenyButton: false,
                            showCancelButton: false,
                            confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['prev']['campaign_member_status']['login']['confirm_button']
                            // denyButtonText: `Don't save`,
                          }).then((result) => {
                            /* Read more about isConfirmed, isDenied below */
                            if (result.isConfirmed) {
                              // Swal.fire('Saved!', '', 'success')
                              // this.allPageLoading = true
                              window.location.href = "https://www.autoturn.net/index.php/index/logout/"+this.$route.params.id+"?o=1";
                            } else if (result.isDenied) {
                              // Swal.fire('Changes are not saved', '', 'info')
                              // this.allPageLoading = true
                              window.location.href = "https://www.autoturn.net/index.php/index/logout/"+this.$route.params.id+"?o=1";
                            }
                          })
                        } else {
                          let text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['prev']['campaign_member_status']['warning']['campaign_update']['default_swal_text'];
                          if(response.data.info != '' && response.data.info != null){
                            text = response.data.info
                          }
                          Swal.fire(
                            this.showLang[this.selectLang]['views']['EventAdd']['methods']['prev']['campaign_member_status']['warning']['campaign_update']['swal_title'],
                            text,
                            'error'
                          )
                        }
                      });
                  }
                });
              }

              if(caResponse.data.status == 'success'){
                // if(this.menu[1].show == false){
                  this.process -= 33
                  if (this.target > 1) {
                    this.target -= 1

                    // if(this.target == 2){
                    //   this.target -= 1
                    // }
                  }
                // } else {
                //   this.process -= 25
                //   if (this.target > 1) {
                //     this.target -= 1
                //   }
                // }
                // console.log('prev target:'+this.target);
                document.getElementById('edit_content').scrollTop = 0;

                this.getAutoTarget(isMenu);

                if(this.db_campaign_id == null || this.db_campaign_id == '' || typeof this.db_campaign_id == 'undefined'){
                  var daily_keyword_split_budget = this.methodData.Budget_KW;
                  var daily_demo_budget = this.methodData.Budget_DM;
                  var budget_addition = this.goalsData.form_addition;

                  if(this.dateData.start_date != "" && this.dateData.end_date != ""){
                      var d1 = new Date(this.dateData.start_date);
                      var d2 = new Date(this.dateData.end_date);
                      var days = parseInt((d2-d1)/86400000) + parseInt(1);
                  } else {
                      var days = 0;
                  }

                  var keyword_split_budget = 0;
                  if(this.methodData.Budget_KW != ''){
                      keyword_split_budget = Math.round(this.methodData.Budget_KW * days * (1+(budget_addition/100)));
                  }

                  var demo_budget = 0;
                  if(this.methodData.Budget_DM != ''){
                      demo_budget = this.methodData.Budget_DM * days;
                  }

                  var _tmp_audience_budget = 0;
                  var audience_budget = 0;
                  // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.5)');
                  _tmp_audience_budget = this.methodData.Budget_LA;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.5);
                  // console.log('Math.round('+_tmp_audience_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                  audience_budget = Math.round(_tmp_audience_budget * days * (1+(budget_addition/100)));

                  var _tmp_marketing_again_budget = 0;
                  var marketing_again_budget = 0;
                  // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.25)');
                  _tmp_marketing_again_budget = this.methodData.Budget_RT;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.25);
                  // console.log('Math.round('+_tmp_marketing_again_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                  marketing_again_budget = Math.round(_tmp_marketing_again_budget * days * (1+(budget_addition/100)));

                  // console.log(parseInt(keyword_split_budget)+' + '+parseInt(demo_budget)+' + '+parseInt(audience_budget)+' + '+parseInt(marketing_again_budget));
                  var ac_budget = 0;
                  if(this.methodData.Budget_AC != '' && this.methodData.Budget_AC != 0){
                      ac_budget = Math.round(this.methodData.Budget_AC * days);
                  }
                  var html = parseInt(keyword_split_budget) + parseInt(demo_budget) + parseInt(audience_budget) + parseInt(marketing_again_budget) + parseInt(ac_budget);

                  if(isNaN(html)){
                      html = '0';
                  }

                  this.total_budget = html;

                  let _tmp_goalsData = this.goalsData;
                  const _view_goalsData = JSON.parse(JSON.stringify(_tmp_goalsData));
                  let _tmp_exAudiencesData = this.exAudiencesData;
                  const _view_exAudiencesData = JSON.parse(JSON.stringify(_tmp_exAudiencesData));

                  delete _view_goalsData['objective_list'];
                  delete _view_exAudiencesData['custom_excluded_audiences'];

                  let formData = {
                    campaign_name: this.campaign_name,
                    adaccount_id: this.adaccount_id,
                    Budget_KW_result: this.Budget_KW_result,
                    total_budget: this.total_budget,
                    useDefaultLayout: this.useDefaultLayout,
                    dynBudgetData: this.dynBudgetData,
                    methodData: this.methodData,
                    benefitsAndInvestmentData: this.benefitsAndInvestmentData,
                    dateData: this.dateData,
                    keywordData: this.keywordData,
                    lookData: this.lookData,
                    audiencesData: this.audiencesData,
                    goalsData: _view_goalsData,
                    regionsData: this.regionsData,
                    selectCountries: this.selectCountries,
                    selectLangs: this.selectLangs,
                    exAudiencesData: _view_exAudiencesData,
                    pdData: this.pdData,
                    idData: this.idData,
                    postData: this.postData,
                    adMaterialData: this.adMaterialDataNew,
                    autoAdjustData: this.autoAdjustData
                  }

                  axios
                    .post('https://www.autoturn.net/api/data/campaign_add_update.php', Qs.stringify({
                      s_code: this.$route.params.id,
                      form_data: formData,
                    }))
                    .then((response) => {
                      // console.log(response.data);

                      if(response.data.status == 'success'){
                        this.db_campaign_id = response.data.campaign_id
                        axios
                          .post('https://www.autoturn.net/api/data/teaching_update.php', Qs.stringify({
                            s_code: this.$route.params.id,
                            id: this.teaching_id,
                            campaign_id: this.db_campaign_id,
                            campaign_objective: '',
                            skip: '',
                            step: '',
                            active: 'campaign_id'
                          }));
                      } else if(response.data.status == 'login'){
                        Swal.fire({
                          icon: 'error',
                          title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['prev']['campaign_member_status']['login']['swal_title'],
                          text: response.data.info,
                          showDenyButton: false,
                          showCancelButton: false,
                          confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['prev']['campaign_member_status']['login']['confirm_button']
                          // denyButtonText: `Don't save`,
                        }).then((result) => {
                          /* Read more about isConfirmed, isDenied below */
                          if (result.isConfirmed) {
                            // Swal.fire('Saved!', '', 'success')
                            // this.allPageLoading = true
                            window.location.href = "https://www.autoturn.net/index.php/index/logout/"+this.$route.params.id+"?o=1";
                          } else if (result.isDenied) {
                            // Swal.fire('Changes are not saved', '', 'info')
                            // this.allPageLoading = true
                            window.location.href = "https://www.autoturn.net/index.php/index/logout/"+this.$route.params.id+"?o=1";
                          }
                        })
                      } else {
                        let text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['prev']['campaign_add_update']['success']['campaign_add_update']['default_swal_text'];
                        if(response.data.info != '' && response.data.info != null){
                          text = response.data.info
                        }
                        Swal.fire(
                          this.showLang[this.selectLang]['views']['EventAdd']['methods']['prev']['campaign_add_update']['success']['campaign_add_update']['swal_title'],
                          text,
                          'error'
                        )
                      }
                    });
                } else {
                  var daily_keyword_split_budget = this.methodData.Budget_KW;
                  var daily_demo_budget = this.methodData.Budget_DM;
                  var budget_addition = this.goalsData.form_addition;

                  if(this.dateData.start_date != "" && this.dateData.end_date != ""){
                      var d1 = new Date(this.dateData.start_date);
                      var d2 = new Date(this.dateData.end_date);
                      var days = parseInt((d2-d1)/86400000) + parseInt(1);
                  } else {
                      var days = 0;
                  }

                  var keyword_split_budget = 0;
                  if(this.methodData.Budget_KW != ''){
                      keyword_split_budget = Math.round(this.methodData.Budget_KW * days * (1+(budget_addition/100)));
                  }

                  var demo_budget = 0;
                  if(this.methodData.Budget_DM != ''){
                      demo_budget = this.methodData.Budget_DM * days;
                  }

                  var _tmp_audience_budget = 0;
                  var audience_budget = 0;
                  // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.5)');
                  _tmp_audience_budget = this.methodData.Budget_LA;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.5);
                  // console.log('Math.round('+_tmp_audience_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                  audience_budget = Math.round(_tmp_audience_budget * days * (1+(budget_addition/100)));

                  var _tmp_marketing_again_budget = 0;
                  var marketing_again_budget = 0;
                  // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.25)');
                  _tmp_marketing_again_budget = this.methodData.Budget_RT;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.25);
                  // console.log('Math.round('+_tmp_marketing_again_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                  marketing_again_budget = Math.round(_tmp_marketing_again_budget * days * (1+(budget_addition/100)));

                  // console.log(parseInt(keyword_split_budget)+' + '+parseInt(demo_budget)+' + '+parseInt(audience_budget)+' + '+parseInt(marketing_again_budget));
                  var ac_budget = 0;
                  if(this.methodData.Budget_AC != '' && this.methodData.Budget_AC != 0){
                      ac_budget = Math.round(this.methodData.Budget_AC * days);
                  }
                  var html = parseInt(keyword_split_budget) + parseInt(demo_budget) + parseInt(audience_budget) + parseInt(marketing_again_budget) + parseInt(ac_budget);

                  if(isNaN(html)){
                      html = '0';
                  }

                  this.total_budget = html;

                  let _tmp_goalsData = this.goalsData;
                  const _view_goalsData = JSON.parse(JSON.stringify(_tmp_goalsData));
                  let _tmp_exAudiencesData = this.exAudiencesData;
                  const _view_exAudiencesData = JSON.parse(JSON.stringify(_tmp_exAudiencesData));

                  delete _view_goalsData['objective_list'];
                  delete _view_exAudiencesData['custom_excluded_audiences'];

                  let formData = {
                    campaign_id: this.db_campaign_id,
                    campaign_name: this.campaign_name,
                      budget_type: this.budget_type,
                      special_ad_category: this.special_ad_category,
                    adaccount_id: this.adaccount_id,
                    Budget_KW_result: this.Budget_KW_result,
                    total_budget: this.total_budget,
                    useDefaultLayout: this.useDefaultLayout,
                    dynBudgetData: this.dynBudgetData,
                    methodData: this.methodData,
                    benefitsAndInvestmentData: this.benefitsAndInvestmentData,
                    dateData: this.dateData,
                    keywordData: this.keywordData,
                    lookData: this.lookData,
                    audiencesData: this.audiencesData,
                    goalsData: _view_goalsData,
                    regionsData: this.regionsData,
                    selectCountries: this.selectCountries,
                    selectLangs: this.selectLangs,
                    exAudiencesData: _view_exAudiencesData,
                    pdData: this.pdData,
                    idData: this.idData,
                    postData: this.postData,
                    adMaterialData: this.adMaterialDataNew,
                    autoAdjustData: this.autoAdjustData
                  }

                  axios
                    .post('https://www.autoturn.net/api/data/campaign_update.php', Qs.stringify({
                      s_code: this.$route.params.id,
                      form_data: formData,
                      target: 'add_prev_'+this.target,
                    }))
                    .then((response) => {
                      // console.log(response.data);
                      if(response.data.status == 'success'){
                        // this.immediateList = response.data.return_data
                        // this.formData = response.data.return_data.form

                        // Swal.fire({
                        //   icon: 'success',
                        //   title: '儲存',
                        //   text: response.data.info,
                        //   showDenyButton: false,
                        //   showCancelButton: false,
                        //   confirmButtonText: '確定',
                        //   // denyButtonText: `Don't save`,
                        // }).then((result) => {
                        //   if (result.isConfirmed) {
                        //     // Swal.fire('Saved!', '', 'success')

                        //     // window.location.href = "https://private.autoturn.net/events-list/"+this.$route.params.id+"/"+this.$route.params.adaccount_id;
                        //   } else if (result.isDenied) {
                        //     // Swal.fire('Changes are not saved', '', 'info')
                        //   }
                        // })

                        // if(type == 1){
                        //   var todayForm = new Date();
                        //   var yearForm = todayForm.getFullYear();
                        //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                        //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                        //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                        //   todayForm = yearForm + monthForm + dateForm + timeForm;

                        //   this.formTitle = 'title_'+todayForm;
                        // } else {
                        //   this.formTitle = response.data.return_data.name;
                        // }

                        // this.showModal = true
                      } else if(response.data.status == 'login'){
                        Swal.fire({
                          icon: 'error',
                          title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['prev']['campaign_member_status']['login']['swal_title'],
                          text: response.data.info,
                          showDenyButton: false,
                          showCancelButton: false,
                          confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['prev']['campaign_member_status']['login']['confirm_button']
                          // denyButtonText: `Don't save`,
                        }).then((result) => {
                          /* Read more about isConfirmed, isDenied below */
                          if (result.isConfirmed) {
                            // Swal.fire('Saved!', '', 'success')
                            // this.allPageLoading = true
                            window.location.href = "https://www.autoturn.net/index.php/index/logout/"+this.$route.params.id+"?o=1";
                          } else if (result.isDenied) {
                            // Swal.fire('Changes are not saved', '', 'info')
                            // this.allPageLoading = true
                            window.location.href = "https://www.autoturn.net/index.php/index/logout/"+this.$route.params.id+"?o=1";
                          }
                        })
                      } else {
                        let text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['prev']['campaign_add_update']['success']['campaign_update']['default_swal_text'];
                        if(response.data.info != '' && response.data.info != null){
                          text = response.data.info
                        }
                        Swal.fire(
                          this.showLang[this.selectLang]['views']['EventAdd']['methods']['prev']['campaign_add_update']['success']['campaign_update']['swal_title'],
                          text,
                          'error'
                        )
                      }
                    });
                }
              }

              if(caResponse.data.status == 'login'){
                Swal.fire({
                  icon: 'error',
                  title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['prev']['campaign_member_status']['login']['swal_title'],
                  text: caResponse.data.info,
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['prev']['campaign_member_status']['login']['confirm_button']
                  // denyButtonText: `Don't save`,
                }).then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    // Swal.fire('Saved!', '', 'success')
                    // this.allPageLoading = true
                    window.location.href = "https://www.autoturn.net/index.php/index/logout/"+member_hash+"?o=1";
                  } else if (result.isDenied) {
                    // Swal.fire('Changes are not saved', '', 'info')
                    // this.allPageLoading = true
                    window.location.href = "https://www.autoturn.net/index.php/index/logout/"+member_hash+"?o=1";
                  }
                })
              }
            });
        // }
      },
      next(isMenu = false) {
        if (this.target === 1 && !validateRegulatedCountries(this.benefitsAndInvestmentData, this.selectLang)) return
        if (this.target === 1) this.ensureSimpleDailyBudgetMinimum()
        if (this.target === 1 && !this.validateTransparencyAdvertisers()) return
        //console.log('this.methodData');
        //console.log(this.methodData);

        this.changeYoutubeType();

        // if (this.target === 3 && this.campaign_name === this.originName && !this.isAlreadyShowNameTips) {
        //   this.nowStep = 888;
        //   this.$router.push({ query: { step: this.nowStep }});
        //   this.isAlreadyShowNameTips = true;
        //   return;
        // }
        // console.log('now target:'+this.target);
        let isTrue = 1;
        this.clearLookalikeForSpecialAdCategory();
        if (!this.validateBudgetTypeAndSpecialAdCategory()) {
          isTrue = 0;
        }

        // console.log('this.campaign_name');
        // console.log(this.campaign_name);

        // 驗證自動加碼/減碼設定（在第一步和第三步）
        if(this.target == 1 || this.target == 3){
          const adBudgetAutoAdjust = this.$refs.childAdBudgetAutoAdjust;
          if (adBudgetAutoAdjust && typeof adBudgetAutoAdjust.checkData === 'function') {
            const validation = adBudgetAutoAdjust.checkData();
            if (!validation.isValid) {
              Swal.fire(
                '自動加碼／減碼設定未完成',
                validation.errors.join('<br>'),
                'warning'
              );
              isTrue = 0;
            }
          }
        }

        if(this.adaccount_id == null || this.adaccount_id == '' || typeof this.adaccount_id == 'undefined'){
          Swal.fire({
            icon: 'error',
            title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_adaccount_id_swal_title'],
            text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_adaccount_id_swal_text'],
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_adaccount_id_confirm_button']
            // denyButtonText: `Don't save`,
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              // Swal.fire('Saved!', '', 'success')
              this.allPageLoading = true
              window.location.href = "https://private.autoturn.net/events-list/f/"+this.$route.params.id;
            } else if (result.isDenied) {
              // Swal.fire('Changes are not saved', '', 'info')
              this.allPageLoading = true
              window.location.href = "https://private.autoturn.net/events-list/f/"+this.$route.params.id;
            }
          })

          isTrue = 0;
        }

        // if(this.campaign_name == null || this.campaign_name == '' || typeof this.campaign_name == 'undefined'){
        //   Swal.fire(
        //                 this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_campaign_name_swal_title'],
        //                 this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_campaign_name_swal_text'],
        //                 "error"
        //               )
        //   isTrue = 0;
        // }

        if(this.target == 1 || this.target == 3){
          if(this.methodData.Target_KW == false && this.methodData.Target_DM == false && this.methodData.Target_LA == false && this.methodData.Target_RT == false && this.methodData.Target_CF == false && this.methodData.Target_AD == false && this.methodData.Target_CR == false && this.methodData.Other_Target_CR == false && this.methodData.Target_EC == false && this.methodData.Target_AC == false){
            Swal.fire(
                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_target_kw_swal_title'],
                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_target_kw_swal_text'],
                      "error"
                    )
            isTrue = 0;
          }

          if((this.methodData.Target_KW == true && this.methodData.Budget_KW == '') || (this.methodData.Target_DM == true && this.methodData.Budget_DM == '') || (this.methodData.Target_LA == true && this.methodData.Budget_LA == '') || (this.methodData.Target_RT == true && this.methodData.Budget_RT == '') || (this.methodData.Target_CF == true && this.methodData.Budget_CF == '') || (this.methodData.Target_EC == true && this.methodData.Budget_EC == '') || (this.methodData.Target_AC == true && this.methodData.Budget_AC == '')){
            Swal.fire(
                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_budget_kw_swal_title'],
                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_budget_kw_swal_text'],
                      "error"
                    )
            isTrue = 0;
          }

          if(this.methodData.Target_RT == true){
            let audiences_num = 0;
            if(this.audiencesData.default_audiences_list.length > 0){
              for (var i = 0; i < this.audiencesData.default_audiences_list.length; i++) {
                // console.log('i1:'+i);
                if(this.audiencesData.default_audiences_list[i].checked == true){
                  audiences_num = parseInt(audiences_num) + parseInt(1);
                }
              }
            }

            if(this.audiencesData.custom_audiences_selected.length > 0){
              for (var i = 0; i < this.audiencesData.custom_audiences_selected.length; i++) {
                // console.log('i2:'+i);
                audiences_num = parseInt(audiences_num) + parseInt(1);
              }
            }

            if(audiences_num < 1){
              Swal.fire(
                        this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_target_rt_swal_title'],
                        '請至少選擇一個再行銷受眾. ',
                        "error"
                      )
              isTrue = 0;
            }
          }

          if(this.methodData.Target_AD == true){
            if(this.methodData.Budget_AD_min != '' && this.methodData.Budget_AD_min != null && typeof this.methodData.Budget_AD_min != 'undefined' && this.methodData.Budget_AD_max != '' && this.methodData.Budget_AD_max != null && typeof this.methodData.Budget_AD_max != 'undefined' && parseInt(this.methodData.Budget_AD_min) >= parseInt(this.methodData.Budget_AD_max)){

              Swal.fire(
                        this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['efficient_ai_swal_title'],
                        this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['efficient_ai_swal_text_1'],
                        "error"
                      )

              isTrue = 0;
            }

            if(parseInt(this.methodData.Budget_AD_min) == 0 || this.methodData.Budget_AD_min == '' || this.methodData.Budget_AD_min == null || typeof this.methodData.Budget_AD_min == 'undefined'){
              Swal.fire(
                        this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['efficient_ai_swal_title'],
                        this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['efficient_ai_swal_text_2'],
                        "error"
                      )

              isTrue = 0;
            }

            if(parseInt(this.methodData.Budget_AD_max) == 0 || this.methodData.Budget_AD_max == '' || this.methodData.Budget_AD_max == null || typeof this.methodData.Budget_AD_max == 'undefined'){
              Swal.fire(
                        this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['efficient_ai_swal_title'],
                        this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['efficient_ai_swal_text_3'],
                        "error"
                      )

              isTrue = 0;
            }
          }

          // if(this.benefitsAndInvestmentData.toTaiwan === true){
          //   if(this.benefitsAndInvestmentData.person_or_business.value == 2){
          //     if(this.benefitsAndInvestmentData.benefits == '' || this.benefitsAndInvestmentData.benefits == null || typeof this.benefitsAndInvestmentData.benefits == 'undefined'){
          //       Swal.fire(
          //                 this.showLang[this.selectLang]['components']['Event']['BenefitsAndInvestment']['title'],
          //                 '受益者不能為空。',
          //                 "error"
          //               )
          //       isTrue = 0;
          //     }

          //     if(this.benefitsAndInvestmentData.investment == '' || this.benefitsAndInvestmentData.investment == null || typeof this.benefitsAndInvestmentData.investment == 'undefined'){
          //       Swal.fire(
          //                 this.showLang[this.selectLang]['components']['Event']['BenefitsAndInvestment']['title'],
          //                 '出資者不能為空。',
          //                 "error"
          //               )
          //       isTrue = 0;
          //     }
          //   } else {
          //     if(this.benefitsAndInvestmentData.beneficiary_id == '' || this.benefitsAndInvestmentData.beneficiary_id == null || typeof this.benefitsAndInvestmentData.beneficiary_id == 'undefined'){
          //       Swal.fire(
          //                 this.showLang[this.selectLang]['components']['Event']['BenefitsAndInvestment']['title'],
          //                 '請填寫受益者 ID',
          //                 "error"
          //               )
          //       isTrue = 0;
          //     }

          //     if(this.benefitsAndInvestmentData.beneficiary_name == '' || this.benefitsAndInvestmentData.beneficiary_name == null || typeof this.benefitsAndInvestmentData.beneficiary_name == 'undefined'){
          //       Swal.fire(
          //                 this.showLang[this.selectLang]['components']['Event']['BenefitsAndInvestment']['title'],
          //                 '請填寫受益者 名稱',
          //                 "error"
          //               )
          //       isTrue = 0;
          //     }

          //     if(this.benefitsAndInvestmentData.payer_id == '' || this.benefitsAndInvestmentData.payer_id == null || typeof this.benefitsAndInvestmentData.payer_id == 'undefined'){
          //       Swal.fire(
          //                 this.showLang[this.selectLang]['components']['Event']['BenefitsAndInvestment']['title'],
          //                 '請填寫出資者 ID',
          //                 "error"
          //               )
          //       isTrue = 0;
          //     }

          //     if(this.benefitsAndInvestmentData.payer_name == '' || this.benefitsAndInvestmentData.payer_name == null || typeof this.benefitsAndInvestmentData.payer_name == 'undefined'){
          //       Swal.fire(
          //                 this.showLang[this.selectLang]['components']['Event']['BenefitsAndInvestment']['title'],
          //                 '請填寫出資者 名稱',
          //                 "error"
          //               )
          //       isTrue = 0;
          //     }
          //   }
          // }

          if (this.benefitsAndInvestmentData.toTaiwan === true) {
            const isBusiness = this.benefitsAndInvestmentData.person_or_business.value === 2;

            if (isBusiness === true) {
              if (!this.hasValue(this.benefitsAndInvestmentData.benefits, true) && 
                !this.hasValue(this.benefitsAndInvestmentData.investment, true)) {
                Swal.fire(
                      this.showLang[this.selectLang]['components']['Event']['BenefitsAndInvestment']['title'],
                      '請設定出資者、受益者。',
                      "error"
                    )
                isTrue = 0;
              }
            } else {
              if (!this.validateBeneficiary()) {
                Swal.fire(
                      this.showLang[this.selectLang]['components']['Event']['BenefitsAndInvestment']['title'],
                      '您的受益者資料並未設定完成（選擇已驗證，或手動輸入名稱、ID）。',
                      "error"
                    )
                isTrue = 0;
              }
              if (!this.validatePayer()) {
                Swal.fire(
                      this.showLang[this.selectLang]['components']['Event']['BenefitsAndInvestment']['title'],
                      '您的出資者資料並未設定完成（選擇已驗證，或手動輸入名稱、ID）。',
                      "error"
                    )
                isTrue = 0;
              }
            }
          }

          if(this.dateData.start_date != '' && this.dateData.start_date != '0000-00-00' && this.dateData.end_date != '' && this.dateData.end_date != '0000-00-00'){
            let startTime = this.dateData.start_date;
            let endTime = this.dateData.end_date;

            var sTime = new Date(startTime); //開始時間
            var eTime = new Date(endTime); //結束時間

            if(sTime > eTime){
              Swal.fire(
                        this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_start_date_swal_title'],
                        this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_start_date_swal_text'],
                        "error"
                      )
              isTrue = 0;
            }
          }

          // console.log(this.dateData.end_date+':'+this.dateData.use_end_date);

          if(this.dateData.end_date == '0000-00-00' && (this.dateData.use_end_date == false || typeof this.dateData.use_end_date == 'undefined')){
            Swal.fire(
                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_end_date_swal_title'],
                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_end_date_swal_text'],
                      "error"
                    )
            isTrue = 0;
          }
        }

        if(this.target == 1 || this.target == 3){
          if(this.methodData.Target_KW == true || this.methodData.Target_AD == true){
            let select_keywords_length = 0;
            if(this.keywordData.select_keywords != '' && this.keywordData.select_keywords != null && typeof this.keywordData.select_keywords != 'undefined'){
              select_keywords_length = this.keywordData.select_keywords.length;
            }

            if(select_keywords_length > 0 && (this.methodData.Target_KW == true || this.methodData.Target_AD == true)){
              let select_keywords_num = 0;

              for (var i = 0; i < select_keywords_length; i++) {
                if(this.keywordData.select_keywords[i].checked == true){
                  select_keywords_num = parseInt(select_keywords_num) + parseInt(1);
                }
              }

              if(this.methodData.Target_AD == true){
                if(select_keywords_num != 4 && select_keywords_num > 0){
                  Swal.fire(
                          this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_select_keywords_swal_title'],
                          this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_ad_select_keywords_swal_text'],
                          "error"
                        )
                  isTrue = 0;
                }
              }

              if(this.methodData.Target_KW == true){
                if(select_keywords_num > 5){
                  Swal.fire(
                          this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_select_keywords_swal_title'],
                          this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_select_keywords_swal_text'],
                          "error"
                        )
                  isTrue = 0;
                }
              }
            }

            if(select_keywords_length == 0 && this.methodData.Target_KW == true){
              Swal.fire(
                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_select_keywords_swal_title'],
                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_select_keywords_swal_text'],
                      "error"
                    )
              isTrue = 0;
            }
          }

          if(this.methodData.Target_LA == true){
            // console.log('this.lookData.default_lookalikes_list');
            // console.log(this.lookData.default_lookalikes_list);
            // console.log('this.lookData.custom_lookalikes_selected');
            // console.log(this.lookData.custom_lookalikes_selected);
            // console.log('this.lookData.custom_lookalikes_selected.length');
            // console.log(this.lookData.custom_lookalikes_selected.length);
            if((this.lookData.default_lookalikes_list != '' && this.lookData.default_lookalikes_list != null && typeof this.lookData.default_lookalikes_list != 'undefined') || (this.lookData.custom_lookalikes_selected != '' && this.lookData.custom_lookalikes_selected != null && typeof this.lookData.custom_lookalikes_selected != 'undefined')){
              let lookalikes_num = 0;
              if(this.lookData.default_lookalikes_list.length > 0){
                for (var i = 0; i < this.lookData.default_lookalikes_list.length; i++) {
                  // console.log('i1:'+i);
                  if(this.lookData.default_lookalikes_list[i].checked == true){
                    lookalikes_num = parseInt(lookalikes_num) + parseInt(1);
                  }
                }
              }

              if(this.lookData.custom_lookalikes_selected.length > 0){
                for (var i = 0; i < this.lookData.custom_lookalikes_selected.length; i++) {
                  // console.log('i2:'+i);
                  lookalikes_num = parseInt(lookalikes_num) + parseInt(1);
                }
              }

              if(lookalikes_num != 5){
                // console.log('33');
                Swal.fire(
                        this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_lookalikes_list_swal_title'],
                        this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_lookalikes_list_swal_text'],
                        "error"
                      )
                isTrue = 0;
              }
            } else {
              // console.log('44');
              Swal.fire(
                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_lookalikes_list_swal_title'],
                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_lookalikes_list_swal_text'],
                      "error"
                    )
              isTrue = 0;
            }
          }
        }

        if(this.target == 2){
          // console.log('this.goalsData');
          // console.log(this.goalsData);
          // console.log('objective_option:'+this.goalsData.objective_option);
          // console.log('conversion_domain:'+this.goalsData.conversion_domain);
          // console.log('risk_level:'+this.goalsData.risk_level.code);
          // console.log('excluded_audiences:'+this.exAudiencesData.excluded_audiences);

          if(this.methodData.Target_CR != true && this.methodData.Other_Target_CR != true){
            if(this.goalsData.objective_option == '' || this.goalsData.objective_option == null || typeof this.goalsData.objective_option == 'undefined'){
              Swal.fire(
                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_objective_option_swal_title'],
                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_objective_option_swal_text'],
                      "error"
                    )
              isTrue = 0;
            }

            if(this.goalsData.campaign_objective == 'CONVERSIONS' && (this.goalsData.conversion_domain == '' || this.goalsData.conversion_domain == null || typeof this.goalsData.conversion_domain == 'undefined')){
              Swal.fire(
                        this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_conversion_domain_swal_title'],
                        this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_conversion_domain_swal_text'],
                        "error"
                      )
              isTrue = 0;
            }

            let event_text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['product_datalog_sales_default_event_text'];
            if(this.goalsData.campaign_objective == 'PRODUCT_CATALOG_SALES'){
              event_text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['is_product_datalog_sales_default_event_text'];
            }

            if(this.goalsData.objective_option == '' || this.goalsData.objective_option == null || typeof this.goalsData.objective_option == 'undefined'){
              Swal.fire(
                        this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_product_catalog_sales_swal_title'],
                        event_text,
                        "warning"
                      )

              isTrue = 0;
            }

            if(this.goalsData.campaign_objective == 'PRODUCT_CATALOG_SALES'){
              if(this.goalsData.product_set_id == '' || this.goalsData.product_set_id == null || typeof this.goalsData.product_set_id == 'undefined'){
                Swal.fire(
                          this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_product_catalog_sales_swal_title'],
                          this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['is_product_datalog_sales_set_id_event_text'],
                          "warning"
                        )

                isTrue = 0;
              }

              if(this.goalsData.product_catalog_id == '' || this.goalsData.product_catalog_id == null || typeof this.goalsData.product_catalog_id == 'undefined'){
                Swal.fire(
                          this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_product_catalog_sales_swal_title'],
                          this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['is_product_datalog_sales_catalog_id_event_text'],
                          "warning"
                        )

                isTrue = 0;
              }
            }

            // if(this.methodData.Target_AD == true){
              if(this.goalsData.effect == '' || this.goalsData.effect == null || typeof this.goalsData.effect == 'undefined'){
                Swal.fire(
                          this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['efficient_ai_not_effect_swal_title'],
                          this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['efficient_ai_not_effect_swal_text'],
                          "error"
                        )

                isTrue = 0;
              }
            // }

            // if((this.goalsData.risk_level.code == 'auto' || this.goalsData.risk_level.code == 'low') && (this.goalsData.effect == '' || this.goalsData.effect == 0 || this.goalsData.effect == null)){
            if(this.goalsData.effect == '' || this.goalsData.effect == 0 || this.goalsData.effect == null){
              Swal.fire(
                        this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_effect_swal_title'],
                        this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_effect_swal_text'],
                        "error"
                      )

              isTrue = 0;
            }

            if(this.exAudiencesData.excluded_audiences != '' && this.exAudiencesData.excluded_audiences != null && typeof this.exAudiencesData.excluded_audiences != 'undefined' ){
              let excluded_audiences = this.exAudiencesData.excluded_audiences.length;
              let custom_excluded_audiences_selected_num = 0;
              if(this.exAudiencesData.custom_excluded_audiences_selected.length > 0){
                for (var i = 0; i >= this.exAudiencesData.custom_excluded_audiences_selected.length; i++) {
                  if(this.exAudiencesData.custom_excluded_audiences_selected.checked == true){
                    custom_excluded_audiences_selected_num = parseInt(custom_excluded_audiences_selected_num) + parseInt(1);
                  }
                }
              }

              let excluded_audiences_num = parseInt(excluded_audiences) + parseInt(custom_excluded_audiences_selected_num);

              if(excluded_audiences_num > 10){
                Swal.fire(
                          this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_excluded_audiences_swal_title'],
                          this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_excluded_audiences_swal_text'],
                          "error"
                        )

                isTrue = 0;
              }
            }

            if(this.methodData.Target_AD == true){
              let _default_Budget_AD_max = Math.trunc(parseInt(this.goalsData.effect) * parseInt(10));
              if(_default_Budget_AD_max > this.methodData.Budget_AD_max){
                Swal.fire(
                          '目標成本',
                          '預算上限要大於目標成本 10 倍。',
                          "error"
                        )

                isTrue = 0;
              }
            }
          } else {
        //  console.log('confirm Target_CR');
          }
        }

        if(isTrue == 1){
          if(this.target == 2 && (this.methodData.Target_CR == true || this.methodData.Other_Target_CR == true || this.useDefaultLayout !== null)){
        //  console.log('CR 儲存並發佈');
        //  console.log(this.methodData.Target_CR);
        //  console.log(this.methodData.Other_Target_CR);
        //  console.log(this.useDefaultLayout);
            this.customize();
          } else {
            let member_hash = this.$route.params.id
            let adaccount_id = this.$route.params.adaccount_id

            axios
              .post('https://www.autoturn.net/api/campaign_member_status.php', Qs.stringify({
                s_code: member_hash,
                route_type: this.$route.params.type,
                active: 'add',
              }))
              .then((caResponse) => {

                if(caResponse.data.status == 'error'){
                  if(caResponse.data.type == 2){
                    Swal.fire({
                      icon: caResponse.data.status,
                      title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['error']['swal_title'],
                      text: caResponse.data.info,
                      showDenyButton: false,
                      showCancelButton: false,
                      confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['error']['confirm_button']
                      // denyButtonText: `Don't save`,
                    }).then((result) => {
                      if (result.isConfirmed) {
                        // Swal.fire('Saved!', '', 'success')
                        this.allPageLoading = true
                        window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                      } else if (result.isDenied) {
                        // Swal.fire('Changes are not saved', '', 'info')
                        this.allPageLoading = true
                        window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                      }
                    })
                  } else if(caResponse.data.type == 3){
                    Swal.fire({
                      icon: caResponse.data.status,
                      title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['error']['swal_title'],
                      text: caResponse.data.info,
                      showDenyButton: false,
                      showCancelButton: false,
                      confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['error']['confirm_button']
                      // denyButtonText: `Don't save`,
                    }).then((result) => {
                      if (result.isConfirmed) {
                        // Swal.fire('Saved!', '', 'success')
                        this.allPageLoading = true
                        window.location.href = "https://private.autoturn.net/f/"+member_hash;
                      } else if (result.isDenied) {
                        // Swal.fire('Changes are not saved', '', 'info')
                        this.allPageLoading = true
                        window.location.href = "https://private.autoturn.net/f/"+member_hash;
                      }
                    })
                  } else {
                    Swal.fire(
                              this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['error']['swal_title'],
                              caResponse.data.info,
                              caResponse.data.status
                            )
                  }
                }

                if(caResponse.data.status == 'warning'){
                  Swal.fire({
                    icon: 'warning',
                    title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['swal_title'],
                    text: caResponse.data.info,
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['confirm_button']
                    // denyButtonText: `Don't save`,
                  }).then((result) => {
                    if(this.db_campaign_id == null || this.db_campaign_id == '' || typeof this.db_campaign_id == 'undefined'){
                      var daily_keyword_split_budget = this.methodData.Budget_KW;
                      var daily_demo_budget = this.methodData.Budget_DM;
                      var budget_addition = this.goalsData.form_addition;

                      if(this.dateData.start_date != "" && this.dateData.end_date != ""){
                          var d1 = new Date(this.dateData.start_date);
                          var d2 = new Date(this.dateData.end_date);
                          var days = parseInt((d2-d1)/86400000) + parseInt(1);
                      } else {
                          var days = 0;
                      }

                      var keyword_split_budget = 0;
                      if(this.methodData.Budget_KW != ''){
                          keyword_split_budget = Math.round(this.methodData.Budget_KW * days * (1+(budget_addition/100)));
                      }

                      var demo_budget = 0;
                      if(this.methodData.Budget_DM != ''){
                          demo_budget = this.methodData.Budget_DM * days;
                      }

                      var _tmp_audience_budget = 0;
                      var audience_budget = 0;
                      // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.5)');
                      _tmp_audience_budget = this.methodData.Budget_LA;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.5);
                      // console.log('Math.round('+_tmp_audience_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                      audience_budget = Math.round(_tmp_audience_budget * days * (1+(budget_addition/100)));

                      var _tmp_marketing_again_budget = 0;
                      var marketing_again_budget = 0;
                      // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.25)');
                      _tmp_marketing_again_budget = this.methodData.Budget_RT;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.25);
                      // console.log('Math.round('+_tmp_marketing_again_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                      marketing_again_budget = Math.round(_tmp_marketing_again_budget * days * (1+(budget_addition/100)));

                      // console.log(parseInt(keyword_split_budget)+' + '+parseInt(demo_budget)+' + '+parseInt(audience_budget)+' + '+parseInt(marketing_again_budget));
                      var ac_budget = 0;
                      if(this.methodData.Budget_AC != '' && this.methodData.Budget_AC != 0){
                          ac_budget = Math.round(this.methodData.Budget_AC * days);
                      }
                      var html = parseInt(keyword_split_budget) + parseInt(demo_budget) + parseInt(audience_budget) + parseInt(marketing_again_budget) + parseInt(ac_budget);

                      if(isNaN(html)){
                          html = '0';
                      }

                      this.total_budget = html;

                      let _tmp_goalsData = this.goalsData;
                      const _view_goalsData = JSON.parse(JSON.stringify(_tmp_goalsData));
                      let _tmp_exAudiencesData = this.exAudiencesData;
                      const _view_exAudiencesData = JSON.parse(JSON.stringify(_tmp_exAudiencesData));

                  //  console.log(this.goalsData);
                  //  console.log(this.exAudiencesData);
                  //  console.log(_tmp_goalsData);
                  //  console.log(_tmp_exAudiencesData);

                  //  console.log('======b');

                      delete _view_goalsData['objective_list'];
                      delete _view_exAudiencesData['custom_excluded_audiences'];

                  //  console.log('======a');

                  //  console.log(this.goalsData);
                  //  console.log(this.exAudiencesData);
                  //  console.log(_tmp_goalsData);
                  //  console.log(_tmp_exAudiencesData);

                      let formData = {
                        campaign_name: this.campaign_name,
                        adaccount_id: this.adaccount_id,
                        Budget_KW_result: this.Budget_KW_result,
                        total_budget: this.total_budget,
                        useDefaultLayout: this.useDefaultLayout,
                        dynBudgetData: this.dynBudgetData,
                        methodData: this.methodData,
                        benefitsAndInvestmentData: this.benefitsAndInvestmentData,
                        dateData: this.dateData,
                        keywordData: this.keywordData,
                        lookData: this.lookData,
                        audiencesData: this.audiencesData,
                        goalsData: _view_goalsData,
                        regionsData: this.regionsData,
                        selectCountries: this.selectCountries,
                        selectLangs: this.selectLangs,
                        exAudiencesData: _view_exAudiencesData,
                        pdData: this.pdData,
                        idData: this.idData,
                        postData: this.postData,
                        adMaterialData: this.adMaterialDataNew,
                        autoAdjustData: this.autoAdjustData
                      }

                      axios
                        .post('https://www.autoturn.net/api/data/campaign_add_update.php', Qs.stringify({
                          s_code: this.$route.params.id,
                          form_data: formData,
                        }))
                        .then((response) => {
                          // console.log(response.data);

                          if(response.data.status == 'success'){
                            this.db_campaign_id = response.data.campaign_id
                            axios
                              .post('https://www.autoturn.net/api/data/teaching_update.php', Qs.stringify({
                                s_code: this.$route.params.id,
                                id: this.teaching_id,
                                campaign_id: this.db_campaign_id,
                                campaign_objective: '',
                                skip: '',
                                step: '',
                                active: 'campaign_id'
                              }));

                            // console.log('333111發佈 this.target');
                            // console.log(this.target);

                            // if(this.menu[1].show == false){
                              if(this.methodData.Target_CR == true){
                                // console.log('now target:'+this.target);
                                if (this.target <= 1) {
                                  this.process += 50
                                  this.target += 1
                                  this.menu[this.target-1].open = true
                                  this.menu[this.target-1].click = 1
                                }
                              } else {
                                if(this.process < 66){
                                  this.process += 33
                                  // console.log('now target:'+this.target);
                                  if (this.target <= 3) {
                                    this.target += 1
                                    this.menu[this.target-1].open = true
                                    this.menu[this.target-1].click = 1
                                  }
                                  // if(this.target == 2){
                                  //   this.target += 1
                                  // }
                                }
                              }

                              //console.log('#3 this.process', this.process);
                              this.getAutoTarget(isMenu);
                            // } else {
                            //   if(this.process < 75){
                            //     this.process += 25
                            //     // console.log('now target:'+this.target);
                            //     if (this.target <= 4) {
                            //       this.target += 1
                            //       this.menu[this.target-1].open = true
                            //       this.menu[this.target-1].click = 1
                            //     }
                            //     // console.log('next target:'+this.target);
                            //   }
                            // }
                            // console.log('next target:'+this.target);
                            document.getElementById('edit_content').scrollTop = 0;
                          } else {
                            let text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['default_swal_text'];
                            if(response.data.info != '' && response.data.info != null){
                              text = response.data.info
                            }
                            Swal.fire(
                              this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['swal_title'],
                              text,
                              'error'
                            )
                          }
                        });
                    } else {
                      var daily_keyword_split_budget = this.methodData.Budget_KW;
                      var daily_demo_budget = this.methodData.Budget_DM;
                      var budget_addition = this.goalsData.form_addition;

                      if(this.dateData.start_date != "" && this.dateData.end_date != ""){
                          var d1 = new Date(this.dateData.start_date);
                          var d2 = new Date(this.dateData.end_date);
                          var days = parseInt((d2-d1)/86400000) + parseInt(1);
                      } else {
                          var days = 0;
                      }

                      var keyword_split_budget = 0;
                      if(this.methodData.Budget_KW != ''){
                          keyword_split_budget = Math.round(this.methodData.Budget_KW * days * (1+(budget_addition/100)));
                      }

                      var demo_budget = 0;
                      if(this.methodData.Budget_DM != ''){
                          demo_budget = this.methodData.Budget_DM * days;
                      }

                      var _tmp_audience_budget = 0;
                      var audience_budget = 0;
                      // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.5)');
                      _tmp_audience_budget = this.methodData.Budget_LA;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.5);
                      // console.log('Math.round('+_tmp_audience_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                      audience_budget = Math.round(_tmp_audience_budget * days * (1+(budget_addition/100)));

                      var _tmp_marketing_again_budget = 0;
                      var marketing_again_budget = 0;
                      // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.25)');
                      _tmp_marketing_again_budget = this.methodData.Budget_RT;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.25);
                      // console.log('Math.round('+_tmp_marketing_again_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                      marketing_again_budget = Math.round(_tmp_marketing_again_budget * days * (1+(budget_addition/100)));

                      // console.log(parseInt(keyword_split_budget)+' + '+parseInt(demo_budget)+' + '+parseInt(audience_budget)+' + '+parseInt(marketing_again_budget));
                      var ac_budget = 0;
                      if(this.methodData.Budget_AC != '' && this.methodData.Budget_AC != 0){
                          ac_budget = Math.round(this.methodData.Budget_AC * days);
                      }
                      var html = parseInt(keyword_split_budget) + parseInt(demo_budget) + parseInt(audience_budget) + parseInt(marketing_again_budget) + parseInt(ac_budget);

                      if(isNaN(html)){
                          html = '0';
                      }

                      this.total_budget = html;

                      let _tmp_goalsData = this.goalsData;
                      const _view_goalsData = JSON.parse(JSON.stringify(_tmp_goalsData));
                      let _tmp_exAudiencesData = this.exAudiencesData;
                      const _view_exAudiencesData = JSON.parse(JSON.stringify(_tmp_exAudiencesData));

                      // console.log(_tmp_exAudiencesData);

                      delete _view_goalsData['objective_list'];
                      delete _view_exAudiencesData['custom_excluded_audiences'];

                      let formData = {
                        campaign_id: this.db_campaign_id,
                        campaign_name: this.campaign_name,
                      budget_type: this.budget_type,
                      special_ad_category: this.special_ad_category,
                        adaccount_id: this.adaccount_id,
                        Budget_KW_result: this.Budget_KW_result,
                        total_budget: this.total_budget,
                        useDefaultLayout: this.useDefaultLayout,
                        dynBudgetData: this.dynBudgetData,
                        methodData: this.methodData,
                        benefitsAndInvestmentData: this.benefitsAndInvestmentData,
                        dateData: this.dateData,
                        keywordData: this.keywordData,
                        lookData: this.lookData,
                        audiencesData: this.audiencesData,
                        goalsData: _view_goalsData,
                        regionsData: this.regionsData,
                        selectCountries: this.selectCountries,
                        selectLangs: this.selectLangs,
                        exAudiencesData: _view_exAudiencesData,
                        pdData: this.pdData,
                        idData: this.idData,
                        postData: this.postData,
                        adMaterialData: this.adMaterialDataNew,
                        autoAdjustData: this.autoAdjustData
                      }

                      let type = '';
                      if(this.target == 3){
                        type = 'release';
                      }

                      if(this.goalsData.campaign_objective == 'LEAD_GENERATION' || this.goalsData.campaign_objective == 'MESSAGES'){
                        // console.log('#1');
                        if(this.target == 3){
                          let materialType = 0;
                          let selectArticleLength = 0;
                          if(this.postData.select_article != '' && this.postData.select_article != null && typeof this.postData.select_article != 'undefined'){
                            selectArticleLength = this.postData.select_article.length;
                          }

                          let selectCreativesMessageLength = 0;
                          if(this.postData.select_creatives_message != '' && this.postData.select_creatives_message != null && typeof this.postData.select_creatives_message != 'undefined'){
                            selectCreativesMessageLength = this.postData.select_creatives_message.length;
                          }

                          let selectCreativesAdsetAdsMessageLength = 0;
                          if(this.postData.select_creatives_adset_ads_message != '' && this.postData.select_creatives_adset_ads_message != null && typeof this.postData.select_creatives_adset_ads_message != 'undefined'){
                            selectCreativesAdsetAdsMessageLength = this.postData.select_creatives_adset_ads_message.length;
                          }

                          let creativeArrayLength = 0;
                          if(this.adMaterialDataNew.creative_array != '' && this.adMaterialDataNew.creative_array != null && typeof this.adMaterialDataNew.creative_array != 'undefined'){
                            creativeArrayLength = this.adMaterialDataNew.creative_array.length;
                          }

                          if(creativeArrayLength == 0 && (!this.postData.select_creatives || this.postData.select_creatives.length == 0) && selectArticleLength == 0 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
                            materialType = 1;
                          } else if(selectArticleLength == 0 && selectCreativesMessageLength == 0 && selectCreativesAdsetAdsMessageLength == 0 && creativeArrayLength == 0 && this.goalsData.campaign_objective == 'MESSAGES'){
                            materialType = 2;
                          }

                      //  console.log('#1 materialType:'+materialType);

                          if(materialType == 0){
                            // console.log('#2');
                            let message_sr_i = 0;
                            let form_sr_i = 0;
                            let message = 0;
                            let single_object_spec = 0;
                            let single_title = 0;
                            let materials_item = 0;
                            let materials_object_spec = 0;
                            let materials_title = 0;
                            let ad_name = 0;

                            for(let i = 0; i < creativeArrayLength; i++){
                              if(this.adMaterialDataNew.creative_array[i].title == '' || this.adMaterialDataNew.creative_array[i].title == null || typeof this.adMaterialDataNew.creative_array[i].title == 'undefined'){
                                ad_name = 1;
                              }

                              if(this.adMaterialDataNew.creative_array[i].type == 2){
                                let materials_length = this.adMaterialDataNew.creative_array[i].materials.length

                                if(materials_length < 2){
                                  materials_item = 1;
                                } else {
                                  for(let j = 0; j < materials_length; j++){
                                    if(this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == '' || this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == null || typeof this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == 'undefined'){
                                      materials_object_spec = 1;
                                    }

                                    if(this.adMaterialDataNew.creative_array[i].materials[j].title == '' || this.adMaterialDataNew.creative_array[i].materials[j].title == null || typeof this.adMaterialDataNew.creative_array[i].materials[j].title == 'undefined'){
                                      materials_title = 1;
                                    }
                                  }
                                }
                              }

                              if(this.adMaterialDataNew.creative_array[i].type == 1){
                                if(this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == '' || this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == null || typeof this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == 'undefined'){
                                  single_object_spec = 1;
                                }

                                if(this.adMaterialDataNew.creative_array[i].materialSingle[0].title == '' || this.adMaterialDataNew.creative_array[i].materialSingle[0].title == null || typeof this.adMaterialDataNew.creative_array[i].materialSingle[0].title == 'undefined'){
                                  single_title = 1;
                                }
                              }

                              if(this.adMaterialDataNew.creative_array[i].message == '' || this.adMaterialDataNew.creative_array[i].message == null || typeof this.adMaterialDataNew.creative_array[i].message == 'undefined'){
                                message = 1;
                              }

                              if(this.adMaterialDataNew.creative_array[i].form_sr_i == '' || this.adMaterialDataNew.creative_array[i].form_sr_i == null || typeof this.adMaterialDataNew.creative_array[i].form_sr_i == 'undefined'){
                                form_sr_i = 1;
                              }

                              if(this.adMaterialDataNew.creative_array[i].message_sr_i == '' || this.adMaterialDataNew.creative_array[i].message_sr_i == null || typeof this.adMaterialDataNew.creative_array[i].message_sr_i == 'undefined'){
                                message_sr_i = 1;
                              }
                            }

                            if(ad_name == 1){
                              Swal.fire(
                                          this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['swal_title'],
                                          this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_ad_name_swal_text'],
                                          "error"
                                        )
                            } else if(single_object_spec == 1){
                              Swal.fire(
                                          this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['swal_title'],
                                          this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_single_object_spec_swal_text'],
                                          "error"
                                        )
                            } else if(single_title == 1){
                              Swal.fire(
                                          this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['swal_title'],
                                          this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_single_title_swal_text'],
                                          "error"
                                        )
                            } else if(materials_item == 1){
                              Swal.fire(
                                          this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['swal_title'],
                                          this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_materials_item_swal_text'],
                                          "error"
                                        )
                            } else if(materials_object_spec == 1){
                              Swal.fire(
                                          this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['swal_title'],
                                          this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_materials_object_spec_swal_text'],
                                          "error"
                                        )
                            } else if(materials_title == 1){
                              Swal.fire(
                                          this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['swal_title'],
                                          this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_materials_title_swal_text'],
                                          "error"
                                        )
                            } else if(message == 1){
                              Swal.fire(
                                          this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['swal_title'],
                                          this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_message_swal_text'],
                                          "error"
                                        )
                            } else if(form_sr_i == 1 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
                              Swal.fire(
                                        this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['swal_title'],
                                        this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_form_sr_i_swal_text'],
                                        "error"
                                      )
                            } else if(message_sr_i == 1 && this.goalsData.campaign_objective == 'MESSAGES'){
                              Swal.fire(
                                        this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['swal_title'],
                                        this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_message_sr_i_swal_text'],
                                        "error"
                                      )
                            } else {
                              // console.log('#5');
                              axios
                                .post('https://www.autoturn.net/api/data/campaign_update.php', Qs.stringify({
                                  s_code: this.$route.params.id,
                                  form_data: formData,
                                  type: type,
                                  target: 'add_next_'+this.target,
                                }))
                                .then((response) => {
                                  // console.log(response.data);
                                  if(response.data.status == 'success'){
                                    // this.immediateList = response.data.return_data
                                    // this.formData = response.data.return_data.form

                                    // Swal.fire({
                                    //   icon: 'success',
                                    //   title: '儲存',
                                    //   text: response.data.info,
                                    //   showDenyButton: false,
                                    //   showCancelButton: false,
                                    //   confirmButtonText: '確定',
                                    //   // denyButtonText: `Don't save`,
                                    // }).then((result) => {
                                    //   if (result.isConfirmed) {
                                    //     // Swal.fire('Saved!', '', 'success')

                                    //     // window.location.href = "https://private.autoturn.net/events-list/f/"+this.$route.params.id+"/"+this.$route.params.adaccount_id;
                                    //   } else if (result.isDenied) {
                                    //     // Swal.fire('Changes are not saved', '', 'info')
                                    //   }
                                    // })

                                    // if(type == 1){
                                    //   var todayForm = new Date();
                                    //   var yearForm = todayForm.getFullYear();
                                    //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                                    //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                                    //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                                    //   todayForm = yearForm + monthForm + dateForm + timeForm;

                                    //   this.formTitle = 'title_'+todayForm;
                                    // } else {
                                    //   this.formTitle = response.data.return_data.name;
                                    // }

                                    // this.showModal = true
                                    // console.log('發佈 this.target');
                                    // console.log(this.target);
                                    if(this.target == 3){
                                      // console.log('按下一步的發佈');
                                      if(response.data.release_status == 'N' && response.data.release_writing_status == 'draft'){
                                        // let name = this.campaign_name;
                                        // let currency = this.currencyData.currency;
                                        // let addition = this.goalsData.form_addition;
                                        // let daily_budget = this.methodData.daily_budget;
                                        // // let campaignInfo = "依您的預算設定，<br/>在未來兩週將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
                                        // // if(addition == '' || addition == 0){
                                        // //   campaignInfo = "依您的預算比率與行銷日期設定，<br/>將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
                                        // // }

                                        // let addition_text = '（'+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['campaign_update']['success']['addition_text']+'：<span style="color:red; font-weight:bold;">'+addition+'%</span>）';
                                        // let two_week_budget = Math.round((daily_budget*7)+(daily_budget*7)+(daily_budget*7*(addition/100)));
                                        // let campaignInfo = this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['campaign_update']['success']['swal_text_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['campaign_update']['success']['swal_text_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['campaign_update']['success']['swal_text_total_budget_c']+"</span>"+addition_text;
                                        // if(this.dateData.end_date != '0000-00-00'){
                                        //   two_week_budget = this.total_budget;
                                        //   campaignInfo = this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['campaign_update']['success']['swal_text_not_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['campaign_update']['success']['swal_text_not_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['campaign_update']['success']['swal_text_not_total_budget_c']+"</span>"+addition_text;
                                        // }

                                        // Swal.fire({
                                        //   title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['campaign_update']['success']['swal_title']+"「"+name+"」",
                                        //   html: campaignInfo + "<br/><br/>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['campaign_update']['success']['swal_text_a']+"<span style='color:red;'>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['campaign_update']['success']['swal_text_b']+"</span>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['campaign_update']['success']['swal_text_c'],
                                        //   icon: 'warning',
                                        //   showCancelButton: true,
                                        //   confirmButtonColor: '#3085d6',
                                        //   cancelButtonColor: '#d33',
                                        //   confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['campaign_update']['success']['yes_button'],
                                        //   cancelButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['campaign_update']['success']['no_button'],
                                        // }).then((result) => {
                                        //   if (result.isConfirmed) {
                                        //     // console.log(this.$route.params.id);

                                        //     this.releaseType = true
                                        //     this.style = 'z-index:100;';
                                        //     this.releasePercent = 5;
                                        //     let status = 1;
                                        //     let num = 0;
                                        //     let member_hash = this.$route.params.id;
                                        //     let adaccount_id = this.adaccount_id
                                        //     var bar5 = new ldBar("#myItem5");
                                        //     bar5.set(this.releasePercent);

                                        //     axios
                                        //       .post('https://www.autoturn.net/api/campaign_release.php', Qs.stringify({
                                        //         s_code: member_hash,
                                        //         campaign_id: this.db_campaign_id,
                                        //       }))
                                        //       .then((caResponse) => {
                                        //         // console.log('caResponse:'+caResponse.data.return_data);
                                        //         if(caResponse.data.status == 'success'){
                                        //           //進行進度條
                                        //           // console.log('發佈莞成，開始跑進度條');
                                        //           setInterval( () => {
                                        //             num++;
                                        //             if(num < 1200){
                                        //               // console.log('num:'+num);
                                        //               // console.log(this.releaseType);

                                        //               if(this.releaseType == true){
                                        //                 axios
                                        //                   .post('https://www.autoturn.net/api/campaign_states.php', Qs.stringify({
                                        //                     s_code: member_hash,
                                        //                     adaccount_id: this.adaccount_id,
                                        //                     campaign_id: this.db_campaign_id,
                                        //                   }))
                                        //                   .then((csResponse) => {
                                        //                     // console.log('csResponse:'+csResponse.data.return_data);
                                        //                     //進行進度條
                                        //                     if(status == 1){
                                        //                       if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'FAILURE'){
                                        //                         this.releaseType = false
                                        //                         this.style = 'z-index:-1;';
                                        //                         bar5.set(0);
                                        //                         status = 0;
                                        //                         // Swal.fire({
                                        //                         //   icon: 'error',
                                        //                         //   title: '正式發佈',
                                        //                         //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
                                        //                         //   showDenyButton: false,
                                        //                         //   showCancelButton: false,
                                        //                         //   confirmButtonText: '確定',
                                        //                         //   timer: 5000
                                        //                         //   // denyButtonText: `Don't save`,
                                        //                         // }).then((result) => {
                                        //                         //   if (result.isConfirmed) {
                                        //                         //     // Swal.fire('Saved!', '', 'success')
                                        //                         //     this.allPageLoading = true
                                        //                         //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                        //                         //   } else if (result.isDenied) {
                                        //                         //     // Swal.fire('Changes are not saved', '', 'info')
                                        //                         //     this.allPageLoading = true
                                        //                         //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                        //                         //   }

                                        //                         //   if (result.dismiss === Swal.DismissReason.timer) {
                                        //                         //     this.allPageLoading = true
                                        //                         //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                        //                         //   }
                                        //                         // })
                                        //                         Swal.fire({
                                        //                           icon: 'error',
                                        //                           title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['campaign_update']['success']['info_state_failure']['swal_title'],
                                        //                           text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['campaign_update']['success']['info_state_failure']['swal_html']+csResponse.data.return_data.info_text,
                                        //                           showDenyButton: false,
                                        //                           showCancelButton: false,
                                        //                           confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['campaign_update']['success']['info_state_failure']['confirm_button']
                                        //                         }).then((result) => {

                                        //                         })
                                        //                       } else if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'SUCCESS'){
                                        //                         status = 0;

                                        //                         axios
                                        //                           .get('https://www.autoturn.net/udnapi/public/send_notice_email.php?s_code='+member_hash+'&form=release&sr_i='+this.db_campaign_id)
                                        //                           .then((csResponse) => {
                                        //                             this.releaseType = false

                                        //                             Swal.fire({
                                        //                               icon: 'success',
                                        //                               title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['campaign_update']['success']['info_state_success']['swal_title'],
                                        //                               text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['campaign_update']['success']['info_state_success']['swal_html'],
                                        //                               showDenyButton: false,
                                        //                               showCancelButton: false,
                                        //                               confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['campaign_update']['success']['info_state_success']['confirm_button'],
                                        //                               timer: 5000
                                        //                               // denyButtonText: `Don't save`,
                                        //                             }).then((result) => {
                                        //                               /* Read more about isConfirmed, isDenied below */
                                        //                               if (result.isConfirmed) {
                                        //                                 // Swal.fire('Saved!', '', 'success')
                                        //                                 this.allPageLoading = true
                                        //                                 window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                        //                               } else if (result.isDenied) {
                                        //                                 // Swal.fire('Changes are not saved', '', 'info')
                                        //                                 this.allPageLoading = true
                                        //                                 window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                        //                               }

                                        //                               if (result.dismiss === Swal.DismissReason.timer) {
                                        //                                 this.allPageLoading = true
                                        //                                 window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                        //                               }
                                        //                             })
                                        //                           });
                                        //                       } else if(csResponse.data.return_data.state == 'FAILURE' && csResponse.data.return_data.info_state == 'FAILURE'){
                                        //                         this.releaseType = false
                                        //                         this.style = 'z-index:-1;';
                                        //                         bar5.set(0);
                                        //                         status = 0;
                                        //                         // Swal.fire({
                                        //                         //   icon: 'error',
                                        //                         //   title: '正式發佈',
                                        //                         //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
                                        //                         //   showDenyButton: false,
                                        //                         //   showCancelButton: false,
                                        //                         //   confirmButtonText: '確定',
                                        //                         //   timer: 5000
                                        //                         //   // denyButtonText: `Don't save`,
                                        //                         // }).then((result) => {
                                        //                         //   /* Read more about isConfirmed, isDenied below */
                                        //                         //   if (result.isConfirmed) {
                                        //                         //     // Swal.fire('Saved!', '', 'success')
                                        //                         //     this.allPageLoading = true
                                        //                         //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                        //                         //   } else if (result.isDenied) {
                                        //                         //     // Swal.fire('Changes are not saved', '', 'info')
                                        //                         //     this.allPageLoading = true
                                        //                         //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                        //                         //   }

                                        //                         //   if (result.dismiss === Swal.DismissReason.timer) {
                                        //                         //     this.allPageLoading = true
                                        //                         //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                        //                         //   }
                                        //                         // })
                                        //                         Swal.fire({
                                        //                           icon: 'error',
                                        //                           title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['campaign_update']['success']['state_failure']['swal_title'],
                                        //                           text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['campaign_update']['success']['state_failure']['swal_html']+csResponse.data.return_data.info_text,
                                        //                           showDenyButton: false,
                                        //                           showCancelButton: false,
                                        //                           confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['campaign_update']['success']['state_failure']['confirm_button']
                                        //                         }).then((result) => {

                                        //                         })
                                        //                       } else {
                                        //                         this.releaseText = csResponse.data.return_data.info_text
                                        //                         this.releasePercent = csResponse.data.return_data.info_pct

                                        //                         bar5.set(this.releasePercent);
                                        //                         // console.log('csResponse.data.return_data.info_text:'+csResponse.data.return_data.info_text);
                                        //                         // console.log('csResponse.data.return_data.info_pct:'+csResponse.data.return_data.info_pct);
                                        //                         // console.log('this.releaseText:'+this.releaseText);
                                        //                         // console.log('this.releasePercent:'+this.releasePercent);

                                        //                         if(csResponse.data.return_data.info_pct == 100){
                                        //                           this.releaseType = false
                                        //                           this.style = 'z-index:-1;';
                                        //                           bar5.set(0);
                                        //                           status = 0;
                                        //                         }
                                        //                       }
                                        //                     }
                                        //                   });
                                        //               }
                                        //             } else {
                                        //               Swal.fire({
                                        //                 icon: 'warning',
                                        //                 title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['campaign_update']['success']['else']['swal_title'],
                                        //                 text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['campaign_update']['success']['else']['swal_html'],
                                        //                 showDenyButton: false,
                                        //                 showCancelButton: false,
                                        //                 confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['campaign_update']['success']['else']['confirm_button'],
                                        //                 timer: 1000
                                        //                 // denyButtonText: `Don't save`,
                                        //               }).then((result) => {
                                        //                 /* Read more about isConfirmed, isDenied below */
                                        //                 if (result.isConfirmed) {
                                        //                   // Swal.fire('Saved!', '', 'success')
                                        //                   this.allPageLoading = true
                                        //                   window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                        //                 } else if (result.isDenied) {
                                        //                   // Swal.fire('Changes are not saved', '', 'info')
                                        //                   this.allPageLoading = true
                                        //                   window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                        //                 }

                                        //                 if (result.dismiss === Swal.DismissReason.timer) {
                                        //                   this.allPageLoading = true
                                        //                   window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                        //                 }
                                        //               })
                                        //             }
                                        //           }, 3000);
                                        //         }
                                        //       });
                                        //   }
                                        // })
                                        this.release();
                                      } else {
                                        Swal.fire(
                                          this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['campaign_update']['success']['swal_title'],
                                          response.data.info,
                                          'error'
                                        )
                                      }
                                    }

                                    // console.log('333222發佈 this.target');
                                    // console.log(this.target);

                                    // if(this.menu[1].show == false){

                                      if(this.methodData.Target_CR == true){
                                        // console.log('now target:'+this.target);
                                        if (this.target <= 1) {
                                          this.process += 50
                                          this.target += 1
                                          this.menu[this.target-1].open = true
                                          this.menu[this.target-1].click = 1
                                        }
                                      } else {
                                        if(this.process < 66){
                                          this.process += 33
                                          // console.log('now target:'+this.target);
                                          if (this.target <= 3) {
                                            this.target += 1
                                            this.menu[this.target-1].open = true
                                            this.menu[this.target-1].click = 1
                                          }
                                          // if(this.target == 2){
                                          //   this.target += 1
                                          // }
                                        }
                                      }
                                    // } else {
                                    //   if(this.process < 75){
                                    //     this.process += 25
                                    //     // console.log('now target:'+this.target);
                                    //     if (this.target <= 4) {
                                    //       this.target += 1
                                    //       this.menu[this.target-1].open = true
                                    //       this.menu[this.target-1].click = 1
                                    //     }
                                    //     // console.log('next target:'+this.target);
                                    //   }
                                    // }
                                    // console.log('next target:'+this.target);
                                    document.getElementById('edit_content').scrollTop = 0;

                                    //console.log('#4 this.process', this.process);
                                    this.getAutoTarget(isMenu);
                                  } else {
                                    let text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['campaign_update']['not_success']['default_swal_text'];
                                    if(response.data.info != '' && response.data.info != null){
                                      text = response.data.info
                                    }
                                    Swal.fire(
                                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['campaign_update']['not_success']['swal_title'],
                                      text,
                                      'error'
                                    )
                                  }
                                });
                            }
                          } else {
                            // console.log('#3');
                            Swal.fire(
                                        this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['not_creative_array_swal_title'],
                                        this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['not_creative_array_swal_text'],
                                        "error"
                                      )
                          }
                        } else {
                          axios
                            .post('https://www.autoturn.net/api/data/campaign_update.php', Qs.stringify({
                              s_code: this.$route.params.id,
                              form_data: formData,
                              type: type,
                              target: 'add_next_'+this.target,
                            }))
                            .then((response) => {
                              // console.log(response.data);
                              if(response.data.status == 'success'){
                                // this.immediateList = response.data.return_data
                                // this.formData = response.data.return_data.form

                                // Swal.fire({
                                //   icon: 'success',
                                //   title: '儲存',
                                //   text: response.data.info,
                                //   showDenyButton: false,
                                //   showCancelButton: false,
                                //   confirmButtonText: '確定',
                                //   // denyButtonText: `Don't save`,
                                // }).then((result) => {
                                //   if (result.isConfirmed) {
                                //     // Swal.fire('Saved!', '', 'success')

                                //     // window.location.href = "https://private.autoturn.net/events-list/f/"+this.$route.params.id+"/"+this.$route.params.adaccount_id;
                                //   } else if (result.isDenied) {
                                //     // Swal.fire('Changes are not saved', '', 'info')
                                //   }
                                // })

                                // if(type == 1){
                                //   var todayForm = new Date();
                                //   var yearForm = todayForm.getFullYear();
                                //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                                //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                                //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                                //   todayForm = yearForm + monthForm + dateForm + timeForm;

                                //   this.formTitle = 'title_'+todayForm;
                                // } else {
                                //   this.formTitle = response.data.return_data.name;
                                // }

                                // this.showModal = true
                                // console.log('發佈 this.target');
                                // console.log(this.target);
                                if(this.target == 3){
                                  // console.log('按下一步的發佈');
                                  if(response.data.release_status == 'N' && response.data.release_writing_status == 'draft'){
                                    // let name = this.campaign_name;
                                    // let currency = this.currencyData.currency;
                                    // let addition = this.goalsData.form_addition;
                                    // let daily_budget = this.methodData.daily_budget;
                                    // // let campaignInfo = "依您的預算設定，<br/>在未來兩週將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
                                    // // if(addition == '' || addition == 0){
                                    // //   campaignInfo = "依您的預算比率與行銷日期設定，<br/>將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
                                    // // }

                                    // let addition_text = '（'+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_target_3']['campaign_update']['success']['addition_text']+'：<span style="color:red; font-weight:bold;">'+addition+'%</span>）';
                                    // let two_week_budget = Math.round((daily_budget*7)+(daily_budget*7)+(daily_budget*7*(addition/100)));
                                    // let campaignInfo = this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['not_lead_messages']['campaign_update']['success']['swal_text_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_target_3']['campaign_update']['success']['swal_text_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_target_3']['campaign_update']['success']['swal_text_total_budget_c']+"</span>"+addition_text;
                                    // if(this.dateData.end_date != '0000-00-00'){
                                    //   two_week_budget = this.total_budget;
                                    //   campaignInfo = this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_target_3']['campaign_update']['success']['swal_text_not_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_target_3']['campaign_update']['success']['swal_text_not_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_target_3']['campaign_update']['success']['swal_text_not_total_budget_c']+"</span>"+addition_text;
                                    // }

                                    // Swal.fire({
                                    //   title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_target_3']['campaign_update']['success']['swal_title']+"「"+name+"」",
                                    //   html: campaignInfo + "<br/><br/>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_target_3']['campaign_update']['success']['swal_text_a']+"<span style='color:red;'>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_target_3']['campaign_update']['success']['swal_text_b']+"</span>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_target_3']['campaign_update']['success']['swal_text_c'],
                                    //   icon: 'warning',
                                    //   showCancelButton: true,
                                    //   confirmButtonColor: '#3085d6',
                                    //   cancelButtonColor: '#d33',
                                    //   confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_target_3']['campaign_update']['success']['yes_button'],
                                    //   cancelButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_target_3']['campaign_update']['success']['no_button'],
                                    // }).then((result) => {
                                    //   if (result.isConfirmed) {
                                    //     // console.log(this.$route.params.id);

                                    //     this.releaseType = true
                                    //     this.style = 'z-index:100;';
                                    //     this.releasePercent = 5;
                                    //     let status = 1;
                                    //     let num = 0;
                                    //     let member_hash = this.$route.params.id;
                                    //     let adaccount_id = this.adaccount_id
                                    //     var bar5 = new ldBar("#myItem5");
                                    //     bar5.set(this.releasePercent);

                                    //     axios
                                    //       .post('https://www.autoturn.net/api/campaign_release.php', Qs.stringify({
                                    //         s_code: member_hash,
                                    //         campaign_id: this.db_campaign_id,
                                    //       }))
                                    //       .then((caResponse) => {
                                    //         // console.log('caResponse:'+caResponse.data.return_data);
                                    //         if(caResponse.data.status == 'success'){
                                    //           //進行進度條
                                    //           // console.log('發佈莞成，開始跑進度條');
                                    //           setInterval( () => {
                                    //             num++;
                                    //             if(num < 1200){
                                    //               // console.log('num:'+num);
                                    //               // console.log(this.releaseType);

                                    //               if(this.releaseType == true){
                                    //                 axios
                                    //                   .post('https://www.autoturn.net/api/campaign_states.php', Qs.stringify({
                                    //                     s_code: member_hash,
                                    //                     adaccount_id: this.adaccount_id,
                                    //                     campaign_id: this.db_campaign_id,
                                    //                   }))
                                    //                   .then((csResponse) => {
                                    //                     // console.log('csResponse:'+csResponse.data.return_data);
                                    //                     //進行進度條
                                    //                     if(status == 1){
                                    //                       if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'FAILURE'){
                                    //                         this.releaseType = false
                                    //                         this.style = 'z-index:-1;';
                                    //                         bar5.set(0);
                                    //                         status = 0;
                                    //                         // Swal.fire({
                                    //                         //   icon: 'error',
                                    //                         //   title: '正式發佈',
                                    //                         //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
                                    //                         //   showDenyButton: false,
                                    //                         //   showCancelButton: false,
                                    //                         //   confirmButtonText: '確定',
                                    //                         //   timer: 5000
                                    //                         //   // denyButtonText: `Don't save`,
                                    //                         // }).then((result) => {
                                    //                         //   if (result.isConfirmed) {
                                    //                         //     // Swal.fire('Saved!', '', 'success')
                                    //                         //     this.allPageLoading = true
                                    //                         //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                    //                         //   } else if (result.isDenied) {
                                    //                         //     // Swal.fire('Changes are not saved', '', 'info')
                                    //                         //     this.allPageLoading = true
                                    //                         //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                    //                         //   }

                                    //                         //   if (result.dismiss === Swal.DismissReason.timer) {
                                    //                         //     this.allPageLoading = true
                                    //                         //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                    //                         //   }
                                    //                         // })
                                    //                         Swal.fire({
                                    //                           icon: 'error',
                                    //                           title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_target_3']['campaign_update']['success']['info_state_failure']['swal_title'],
                                    //                           text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_target_3']['campaign_update']['success']['info_state_failure']['swal_html']+csResponse.data.return_data.info_text,
                                    //                           showDenyButton: false,
                                    //                           showCancelButton: false,
                                    //                           confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_target_3']['campaign_update']['success']['info_state_failure']['confirm_button']
                                    //                         }).then((result) => {

                                    //                         })
                                    //                       } else if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'SUCCESS'){
                                    //                         status = 0;

                                    //                         axios
                                    //                           .get('https://www.autoturn.net/udnapi/public/send_notice_email.php?s_code='+member_hash+'&form=release&sr_i='+this.db_campaign_id)
                                    //                           .then((csResponse) => {
                                    //                             this.releaseType = false

                                    //                             Swal.fire({
                                    //                               icon: 'success',
                                    //                               title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_target_3']['campaign_update']['success']['info_state_success']['swal_title'],
                                    //                               text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_target_3']['campaign_update']['success']['info_state_success']['swal_html'],
                                    //                               showDenyButton: false,
                                    //                               showCancelButton: false,
                                    //                               confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_target_3']['campaign_update']['success']['info_state_success']['confirm_button'],
                                    //                               timer: 5000
                                    //                               // denyButtonText: `Don't save`,
                                    //                             }).then((result) => {
                                    //                               /* Read more about isConfirmed, isDenied below */
                                    //                               if (result.isConfirmed) {
                                    //                                 // Swal.fire('Saved!', '', 'success')
                                    //                                 this.allPageLoading = true
                                    //                                 window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                    //                               } else if (result.isDenied) {
                                    //                                 // Swal.fire('Changes are not saved', '', 'info')
                                    //                                 this.allPageLoading = true
                                    //                                 window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                    //                               }

                                    //                               if (result.dismiss === Swal.DismissReason.timer) {
                                    //                                 this.allPageLoading = true
                                    //                                 window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                    //                               }
                                    //                             })
                                    //                           });
                                    //                       } else if(csResponse.data.return_data.state == 'FAILURE' && csResponse.data.return_data.info_state == 'FAILURE'){
                                    //                         this.releaseType = false
                                    //                         this.style = 'z-index:-1;';
                                    //                         bar5.set(0);
                                    //                         status = 0;
                                    //                         // Swal.fire({
                                    //                         //   icon: 'error',
                                    //                         //   title: '正式發佈',
                                    //                         //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
                                    //                         //   showDenyButton: false,
                                    //                         //   showCancelButton: false,
                                    //                         //   confirmButtonText: '確定',
                                    //                         //   timer: 5000
                                    //                         //   // denyButtonText: `Don't save`,
                                    //                         // }).then((result) => {
                                    //                         //   /* Read more about isConfirmed, isDenied below */
                                    //                         //   if (result.isConfirmed) {
                                    //                         //     // Swal.fire('Saved!', '', 'success')
                                    //                         //     this.allPageLoading = true
                                    //                         //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                    //                         //   } else if (result.isDenied) {
                                    //                         //     // Swal.fire('Changes are not saved', '', 'info')
                                    //                         //     this.allPageLoading = true
                                    //                         //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                    //                         //   }

                                    //                         //   if (result.dismiss === Swal.DismissReason.timer) {
                                    //                         //     this.allPageLoading = true
                                    //                         //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                    //                         //   }
                                    //                         // })
                                    //                         Swal.fire({
                                    //                           icon: 'error',
                                    //                           title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_target_3']['campaign_update']['success']['state_failure']['swal_title'],
                                    //                           text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_target_3']['campaign_update']['success']['state_failure']['swal_html']+csResponse.data.return_data.info_text,
                                    //                           showDenyButton: false,
                                    //                           showCancelButton: false,
                                    //                           confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_target_3']['campaign_update']['success']['state_failure']['confirm_button']
                                    //                         }).then((result) => {

                                    //                         })
                                    //                       } else {
                                    //                         this.releaseText = csResponse.data.return_data.info_text
                                    //                         this.releasePercent = csResponse.data.return_data.info_pct

                                    //                         bar5.set(this.releasePercent);
                                    //                         // console.log('csResponse.data.return_data.info_text:'+csResponse.data.return_data.info_text);
                                    //                         // console.log('csResponse.data.return_data.info_pct:'+csResponse.data.return_data.info_pct);
                                    //                         // console.log('this.releaseText:'+this.releaseText);
                                    //                         // console.log('this.releasePercent:'+this.releasePercent);

                                    //                         if(csResponse.data.return_data.info_pct == 100){
                                    //                           this.releaseType = false
                                    //                           this.style = 'z-index:-1;';
                                    //                           bar5.set(0);
                                    //                           status = 0;
                                    //                         }
                                    //                       }
                                    //                     }
                                    //                   });
                                    //               }
                                    //             } else {
                                    //               Swal.fire({
                                    //                 icon: 'warning',
                                    //                 title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_target_3']['campaign_update']['success']['else']['swal_title'],
                                    //                 text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_target_3']['campaign_update']['success']['else']['swal_html'],
                                    //                 showDenyButton: false,
                                    //                 showCancelButton: false,
                                    //                 confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_target_3']['campaign_update']['success']['else']['confirm_button'],
                                    //                 timer: 1000
                                    //                 // denyButtonText: `Don't save`,
                                    //               }).then((result) => {
                                    //                 /* Read more about isConfirmed, isDenied below */
                                    //                 if (result.isConfirmed) {
                                    //                   // Swal.fire('Saved!', '', 'success')
                                    //                   this.allPageLoading = true
                                    //                   window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                    //                 } else if (result.isDenied) {
                                    //                   // Swal.fire('Changes are not saved', '', 'info')
                                    //                   this.allPageLoading = true
                                    //                   window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                    //                 }

                                    //                 if (result.dismiss === Swal.DismissReason.timer) {
                                    //                   this.allPageLoading = true
                                    //                   window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                    //                 }
                                    //               })
                                    //             }
                                    //           }, 3000);
                                    //         }
                                    //       });
                                    //   }
                                    // })

                                    this.release();
                                  } else {
                                    Swal.fire(
                                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_target_3']['campaign_update']['success']['swal_title'],
                                      response.data.info,
                                      'error'
                                    )
                                  }
                                }

                                // console.log('333222發佈 this.target');
                                // console.log(this.target);

                                // if(this.menu[1].show == false){
                                  if(this.methodData.Target_CR == true){
                                    // console.log('now target:'+this.target);
                                    if (this.target <= 1) {
                                      this.process += 50
                                      this.target += 1
                                      this.menu[this.target-1].open = true
                                      this.menu[this.target-1].click = 1
                                    }
                                  } else {
                                    if(this.process < 66){
                                      this.process += 33
                                      // console.log('now target:'+this.target);
                                      if (this.target <= 3) {
                                        this.target += 1
                                        this.menu[this.target-1].open = true
                                        this.menu[this.target-1].click = 1
                                      }
                                      // if(this.target == 2){
                                      //   this.target += 1
                                      // }
                                    }
                                  }
                                // } else {
                                //   if(this.process < 75){
                                //     this.process += 25
                                //     // console.log('now target:'+this.target);
                                //     if (this.target <= 4) {
                                //       this.target += 1
                                //       this.menu[this.target-1].open = true
                                //       this.menu[this.target-1].click = 1
                                //     }
                                //     // console.log('next target:'+this.target);
                                //   }
                                // }
                                // console.log('next target:'+this.target);
                                document.getElementById('edit_content').scrollTop = 0;

                                //console.log('#5 this.process', this.process);
                                this.getAutoTarget(isMenu);
                              } else {
                                let text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_target_3']['campaign_update']['not_success']['default_swal_text'];
                                if(response.data.info != '' && response.data.info != null){
                                  text = response.data.info
                                }
                                Swal.fire(
                                  this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_target_3']['campaign_update']['not_success']['swal_title'],
                                  text,
                                  'error'
                                )
                              }
                            });
                        }
                      } else {
                        axios
                          .post('https://www.autoturn.net/api/data/campaign_update.php', Qs.stringify({
                            s_code: this.$route.params.id,
                            form_data: formData,
                            type: type,
                            target: 'add_next_'+this.target,
                          }))
                          .then((response) => {
                            // console.log(response.data);
                            if(response.data.status == 'success'){
                              // this.immediateList = response.data.return_data
                              // this.formData = response.data.return_data.form

                              // Swal.fire({
                              //   icon: 'success',
                              //   title: '儲存',
                              //   text: response.data.info,
                              //   showDenyButton: false,
                              //   showCancelButton: false,
                              //   confirmButtonText: '確定',
                              //   // denyButtonText: `Don't save`,
                              // }).then((result) => {
                              //   if (result.isConfirmed) {
                              //     // Swal.fire('Saved!', '', 'success')

                              //     // window.location.href = "https://private.autoturn.net/events-list/f/"+this.$route.params.id+"/"+this.$route.params.adaccount_id;
                              //   } else if (result.isDenied) {
                              //     // Swal.fire('Changes are not saved', '', 'info')
                              //   }
                              // })

                              // if(type == 1){
                              //   var todayForm = new Date();
                              //   var yearForm = todayForm.getFullYear();
                              //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                              //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                              //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                              //   todayForm = yearForm + monthForm + dateForm + timeForm;

                              //   this.formTitle = 'title_'+todayForm;
                              // } else {
                              //   this.formTitle = response.data.return_data.name;
                              // }

                              // this.showModal = true
                              // console.log('發佈 this.target');
                              // console.log(this.target);
                              if(this.target == 3){
                                // console.log('按下一步的發佈');
                                if(response.data.release_status == 'N' && response.data.release_writing_status == 'draft'){
                                  // let name = this.campaign_name;
                                  // let currency = this.currencyData.currency;
                                  // let addition = this.goalsData.form_addition;
                                  // let daily_budget = this.methodData.daily_budget;
                                  // // let campaignInfo = "依您的預算設定，<br/>在未來兩週將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
                                  // // if(addition == '' || addition == 0){
                                  // //   campaignInfo = "依您的預算比率與行銷日期設定，<br/>將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
                                  // // }

                                  // let addition_text = '（'+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['not_lead_messages']['campaign_update']['success']['addition_text']+'：<span style="color:red; font-weight:bold;">'+addition+'%</span>）';
                                  // let two_week_budget = Math.round((daily_budget*7)+(daily_budget*7)+(daily_budget*7*(addition/100)));
                                  // let campaignInfo = this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['not_lead_messages']['campaign_update']['success']['swal_text_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['not_lead_messages']['campaign_update']['success']['swal_text_total_budget_c']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['not_lead_messages']['campaign_update']['success']['swal_text_total_budget_c']+"</span>"+addition_text;
                                  // if(this.dateData.end_date != '0000-00-00'){
                                  //   two_week_budget = this.total_budget;
                                  //   campaignInfo = this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['not_lead_messages']['campaign_update']['success']['swal_text_not_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['not_lead_messages']['campaign_update']['success']['swal_text_not_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['not_lead_messages']['campaign_update']['success']['swal_text_not_total_budget_c']+"</span>"+addition_text;
                                  // }

                                  // Swal.fire({
                                  //   title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['not_lead_messages']['campaign_update']['success']['swal_title']+"「"+name+"」",
                                  //   html: campaignInfo + "<br/><br/>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['not_lead_messages']['campaign_update']['success']['swal_text_a']+"<span style='color:red;'>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['not_lead_messages']['campaign_update']['success']['swal_text_b']+"</span>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['not_lead_messages']['campaign_update']['success']['swal_text_c'],
                                  //   icon: 'warning',
                                  //   showCancelButton: true,
                                  //   confirmButtonColor: '#3085d6',
                                  //   cancelButtonColor: '#d33',
                                  //   confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['not_lead_messages']['campaign_update']['success']['yes_button'],
                                  //   cancelButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['not_lead_messages']['campaign_update']['success']['no_button'],
                                  // }).then((result) => {
                                  //   if (result.isConfirmed) {
                                  //     // console.log(this.$route.params.id);

                                  //     this.releaseType = true
                                  //     this.style = 'z-index:100;';
                                  //     this.releasePercent = 5;
                                  //     let status = 1;
                                  //     let num = 0;
                                  //     let member_hash = this.$route.params.id;
                                  //     let adaccount_id = this.adaccount_id
                                  //     var bar5 = new ldBar("#myItem5");
                                  //     bar5.set(this.releasePercent);

                                  //     axios
                                  //       .post('https://www.autoturn.net/api/campaign_release.php', Qs.stringify({
                                  //         s_code: member_hash,
                                  //         campaign_id: this.db_campaign_id,
                                  //       }))
                                  //       .then((caResponse) => {
                                  //         // console.log('caResponse:'+caResponse.data.return_data);
                                  //         if(caResponse.data.status == 'success'){
                                  //           //進行進度條
                                  //           // console.log('發佈莞成，開始跑進度條');
                                  //           setInterval( () => {
                                  //             num++;
                                  //             if(num < 1200){
                                  //               // console.log('num:'+num);
                                  //               // console.log(this.releaseType);

                                  //               if(this.releaseType == true){
                                  //                 axios
                                  //                   .post('https://www.autoturn.net/api/campaign_states.php', Qs.stringify({
                                  //                     s_code: member_hash,
                                  //                     adaccount_id: this.adaccount_id,
                                  //                     campaign_id: this.db_campaign_id,
                                  //                   }))
                                  //                   .then((csResponse) => {
                                  //                     // console.log('csResponse:'+csResponse.data.return_data);
                                  //                     //進行進度條
                                  //                     if(status == 1){
                                  //                       if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'FAILURE'){
                                  //                         this.releaseType = false
                                  //                         this.style = 'z-index:-1;';
                                  //                         bar5.set(0);
                                  //                         status = 0;
                                  //                         // Swal.fire({
                                  //                         //   icon: 'error',
                                  //                         //   title: '正式發佈',
                                  //                         //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
                                  //                         //   showDenyButton: false,
                                  //                         //   showCancelButton: false,
                                  //                         //   confirmButtonText: '確定',
                                  //                         //   timer: 5000
                                  //                         //   // denyButtonText: `Don't save`,
                                  //                         // }).then((result) => {
                                  //                         //   if (result.isConfirmed) {
                                  //                         //     // Swal.fire('Saved!', '', 'success')
                                  //                         //     this.allPageLoading = true
                                  //                         //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                  //                         //   } else if (result.isDenied) {
                                  //                         //     // Swal.fire('Changes are not saved', '', 'info')
                                  //                         //     this.allPageLoading = true
                                  //                         //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                  //                         //   }

                                  //                         //   if (result.dismiss === Swal.DismissReason.timer) {
                                  //                         //     this.allPageLoading = true
                                  //                         //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                  //                         //   }
                                  //                         // })
                                  //                         Swal.fire({
                                  //                           icon: 'error',
                                  //                           title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['not_lead_messages']['campaign_update']['success']['info_state_failure']['swal_title'],
                                  //                           text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['not_lead_messages']['campaign_update']['success']['info_state_failure']['swal_html']+csResponse.data.return_data.info_text,
                                  //                           showDenyButton: false,
                                  //                           showCancelButton: false,
                                  //                           confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['not_lead_messages']['campaign_update']['success']['info_state_failure']['confirm_button']
                                  //                         }).then((result) => {

                                  //                         })
                                  //                       } else if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'SUCCESS'){
                                  //                         status = 0;

                                  //                         axios
                                  //                           .get('https://www.autoturn.net/udnapi/public/send_notice_email.php?s_code='+member_hash+'&form=release&sr_i='+this.db_campaign_id)
                                  //                           .then((csResponse) => {
                                  //                             this.releaseType = false

                                  //                             Swal.fire({
                                  //                               icon: 'success',
                                  //                               title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['not_lead_messages']['campaign_update']['success']['info_state_success']['swal_title'],
                                  //                               text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['not_lead_messages']['campaign_update']['success']['info_state_success']['swal_html'],
                                  //                               showDenyButton: false,
                                  //                               showCancelButton: false,
                                  //                               confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['not_lead_messages']['campaign_update']['success']['info_state_success']['confirm_button'],
                                  //                               timer: 5000
                                  //                               // denyButtonText: `Don't save`,
                                  //                             }).then((result) => {
                                  //                               /* Read more about isConfirmed, isDenied below */
                                  //                               if (result.isConfirmed) {
                                  //                                 // Swal.fire('Saved!', '', 'success')
                                  //                                 this.allPageLoading = true
                                  //                                 window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                  //                               } else if (result.isDenied) {
                                  //                                 // Swal.fire('Changes are not saved', '', 'info')
                                  //                                 this.allPageLoading = true
                                  //                                 window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                  //                               }

                                  //                               if (result.dismiss === Swal.DismissReason.timer) {
                                  //                                 this.allPageLoading = true
                                  //                                 window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                  //                               }
                                  //                             })
                                  //                           });
                                  //                       } else if(csResponse.data.return_data.state == 'FAILURE' && csResponse.data.return_data.info_state == 'FAILURE'){
                                  //                         this.releaseType = false
                                  //                         this.style = 'z-index:-1;';
                                  //                         bar5.set(0);
                                  //                         status = 0;
                                  //                         // Swal.fire({
                                  //                         //   icon: 'error',
                                  //                         //   title: '正式發佈',
                                  //                         //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
                                  //                         //   showDenyButton: false,
                                  //                         //   showCancelButton: false,
                                  //                         //   confirmButtonText: '確定',
                                  //                         //   timer: 5000
                                  //                         //   // denyButtonText: `Don't save`,
                                  //                         // }).then((result) => {
                                  //                         //   /* Read more about isConfirmed, isDenied below */
                                  //                         //   if (result.isConfirmed) {
                                  //                         //     // Swal.fire('Saved!', '', 'success')
                                  //                         //     this.allPageLoading = true
                                  //                         //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                  //                         //   } else if (result.isDenied) {
                                  //                         //     // Swal.fire('Changes are not saved', '', 'info')
                                  //                         //     this.allPageLoading = true
                                  //                         //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                  //                         //   }

                                  //                         //   if (result.dismiss === Swal.DismissReason.timer) {
                                  //                         //     this.allPageLoading = true
                                  //                         //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                  //                         //   }
                                  //                         // })
                                  //                         Swal.fire({
                                  //                           icon: 'error',
                                  //                           title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['not_lead_messages']['campaign_update']['success']['state_failure']['swal_title'],
                                  //                           text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['not_lead_messages']['campaign_update']['success']['state_failure']['swal_html']+csResponse.data.return_data.info_text,
                                  //                           showDenyButton: false,
                                  //                           showCancelButton: false,
                                  //                           confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['not_lead_messages']['campaign_update']['success']['state_failure']['confirm_button']
                                  //                         }).then((result) => {

                                  //                         })
                                  //                       } else {
                                  //                         this.releaseText = csResponse.data.return_data.info_text
                                  //                         this.releasePercent = csResponse.data.return_data.info_pct

                                  //                         bar5.set(this.releasePercent);
                                  //                         // console.log('csResponse.data.return_data.info_text:'+csResponse.data.return_data.info_text);
                                  //                         // console.log('csResponse.data.return_data.info_pct:'+csResponse.data.return_data.info_pct);
                                  //                         // console.log('this.releaseText:'+this.releaseText);
                                  //                         // console.log('this.releasePercent:'+this.releasePercent);

                                  //                         if(csResponse.data.return_data.info_pct == 100){
                                  //                           this.releaseType = false
                                  //                           this.style = 'z-index:-1;';
                                  //                           bar5.set(0);
                                  //                           status = 0;
                                  //                         }
                                  //                       }
                                  //                     }
                                  //                   });
                                  //               }
                                  //             } else {
                                  //               Swal.fire({
                                  //                 icon: 'warning',
                                  //                 title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['not_lead_messages']['campaign_update']['success']['else']['swal_title'],
                                  //                 text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['not_lead_messages']['campaign_update']['success']['else']['swal_html'],
                                  //                 showDenyButton: false,
                                  //                 showCancelButton: false,
                                  //                 confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['not_lead_messages']['campaign_update']['success']['else']['confirm_button'],
                                  //                 timer: 1000
                                  //                 // denyButtonText: `Don't save`,
                                  //               }).then((result) => {
                                  //                 /* Read more about isConfirmed, isDenied below */
                                  //                 if (result.isConfirmed) {
                                  //                   // Swal.fire('Saved!', '', 'success')
                                  //                   this.allPageLoading = true
                                  //                   window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                  //                 } else if (result.isDenied) {
                                  //                   // Swal.fire('Changes are not saved', '', 'info')
                                  //                   this.allPageLoading = true
                                  //                   window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                  //                 }

                                  //                 if (result.dismiss === Swal.DismissReason.timer) {
                                  //                   this.allPageLoading = true
                                  //                   window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                  //                 }
                                  //               })
                                  //             }
                                  //           }, 3000);
                                  //         }
                                  //       });
                                  //   }
                                  // })

                                  this.release();
                                } else {
                                  Swal.fire(
                                    this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['not_lead_messages']['campaign_update']['success']['swal_title'],
                                    response.data.info,
                                    'error'
                                  )
                                }
                              }

                              // console.log('333222發佈 this.target');
                              // console.log(this.target);

                              // if(this.menu[1].show == false){
                                if(this.methodData.Target_CR == true){
                                  // console.log('now target:'+this.target);
                                  if (this.target <= 1) {
                                    this.process += 50
                                    this.target += 1
                                    this.menu[this.target-1].open = true
                                    this.menu[this.target-1].click = 1
                                  }
                                } else {
                                  if(this.process < 66){
                                    this.process += 33
                                    // console.log('now target:'+this.target);
                                    if (this.target <= 3) {
                                      this.target += 1
                                      this.menu[this.target-1].open = true
                                      this.menu[this.target-1].click = 1
                                    }
                                    // if(this.target == 2){
                                    //   this.target += 1
                                    // }
                                  }
                                }
                              // } else {
                              //   if(this.process < 75){
                              //     this.process += 25
                              //     // console.log('now target:'+this.target);
                              //     if (this.target <= 4) {
                              //       this.target += 1
                              //       this.menu[this.target-1].open = true
                              //       this.menu[this.target-1].click = 1
                              //     }
                              //     // console.log('next target:'+this.target);
                              //   }
                              // }
                              // console.log('next target:'+this.target);
                              document.getElementById('edit_content').scrollTop = 0;

                              //console.log('#6 this.process', this.process);
                              this.getAutoTarget(isMenu);
                            } else {
                              let text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['not_lead_messages']['campaign_update']['not_success']['default_swal_text'];
                              if(response.data.info != '' && response.data.info != null){
                                text = response.data.info
                              }
                              Swal.fire(
                                this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['not_lead_messages']['campaign_update']['not_success']['swal_title'],
                                text,
                                'error'
                              )
                            }
                          });
                      }
                    }
                  });
                }

                if(caResponse.data.status == 'success'){
                  if(this.db_campaign_id == null || this.db_campaign_id == '' || typeof this.db_campaign_id == 'undefined'){
                    var daily_keyword_split_budget = this.methodData.Budget_KW;
                    var daily_demo_budget = this.methodData.Budget_DM;
                    var budget_addition = this.goalsData.form_addition;

                    if(this.dateData.start_date != "" && this.dateData.end_date != ""){
                        var d1 = new Date(this.dateData.start_date);
                        var d2 = new Date(this.dateData.end_date);
                        var days = parseInt((d2-d1)/86400000) + parseInt(1);
                    } else {
                        var days = 0;
                    }

                    var keyword_split_budget = 0;
                    if(this.methodData.Budget_KW != ''){
                        keyword_split_budget = Math.round(this.methodData.Budget_KW * days * (1+(budget_addition/100)));
                    }

                    var demo_budget = 0;
                    if(this.methodData.Budget_DM != ''){
                        demo_budget = this.methodData.Budget_DM * days;
                    }

                    var _tmp_audience_budget = 0;
                    var audience_budget = 0;
                    // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.5)');
                    _tmp_audience_budget = this.methodData.Budget_LA;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.5);
                    // console.log('Math.round('+_tmp_audience_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                    audience_budget = Math.round(_tmp_audience_budget * days * (1+(budget_addition/100)));

                    var _tmp_marketing_again_budget = 0;
                    var marketing_again_budget = 0;
                    // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.25)');
                    _tmp_marketing_again_budget = this.methodData.Budget_RT;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.25);
                    // console.log('Math.round('+_tmp_marketing_again_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                    marketing_again_budget = Math.round(_tmp_marketing_again_budget * days * (1+(budget_addition/100)));

                    // console.log(parseInt(keyword_split_budget)+' + '+parseInt(demo_budget)+' + '+parseInt(audience_budget)+' + '+parseInt(marketing_again_budget));
                    var ac_budget = 0;
                    if(this.methodData.Budget_AC != '' && this.methodData.Budget_AC != 0){
                        ac_budget = Math.round(this.methodData.Budget_AC * days);
                    }
                    var html = parseInt(keyword_split_budget) + parseInt(demo_budget) + parseInt(audience_budget) + parseInt(marketing_again_budget) + parseInt(ac_budget);

                    if(isNaN(html)){
                        html = '0';
                    }

                    this.total_budget = html;

                    let _tmp_goalsData = this.goalsData;
                    const _view_goalsData = JSON.parse(JSON.stringify(_tmp_goalsData));
                    let _tmp_exAudiencesData = this.exAudiencesData;
                    const _view_exAudiencesData = JSON.parse(JSON.stringify(_tmp_exAudiencesData));

                //  console.log(this.goalsData);
                //  console.log(this.exAudiencesData);
                //  console.log(_tmp_goalsData);
                //  console.log(_tmp_exAudiencesData);
                //  console.log(_view_goalsData);
                //  console.log(_view_exAudiencesData);

                //  console.log('======b');

                    delete _view_goalsData['objective_list'];
                    delete _view_exAudiencesData['custom_excluded_audiences'];

                //  console.log('======a');

                //  console.log(this.goalsData);
                //  console.log(this.exAudiencesData);
                //  console.log(_tmp_goalsData);
                //  console.log(_tmp_exAudiencesData);
                //  console.log(_view_goalsData);
                //  console.log(_view_exAudiencesData);

                    let formData = {
                      campaign_name: this.campaign_name,
                      budget_type: this.budget_type,
                      special_ad_category: this.special_ad_category,
                      adaccount_id: this.adaccount_id,
                      Budget_KW_result: this.Budget_KW_result,
                      total_budget: this.total_budget,
                      useDefaultLayout: this.useDefaultLayout,
                      dynBudgetData: this.dynBudgetData,
                      methodData: this.methodData,
                      benefitsAndInvestmentData: this.benefitsAndInvestmentData,
                      dateData: this.dateData,
                      keywordData: this.keywordData,
                      lookData: this.lookData,
                      audiencesData: this.audiencesData,
                      goalsData: _view_goalsData,
                      regionsData: this.regionsData,
                      selectCountries: this.selectCountries,
                      selectLangs: this.selectLangs,
                      exAudiencesData: _view_exAudiencesData,
                      pdData: this.pdData,
                      idData: this.idData,
                      postData: this.postData,
                      adMaterialData: this.adMaterialDataNew,
                      autoAdjustData: this.autoAdjustData
                    }

                    axios
                      .post('https://www.autoturn.net/api/data/campaign_add_update.php', Qs.stringify({
                        s_code: this.$route.params.id,
                        form_data: formData,
                      }))
                      .then((response) => {
                        // console.log(response.data);

                        if(response.data.status == 'success'){
                          this.db_campaign_id = response.data.campaign_id
                          axios
                            .post('https://www.autoturn.net/api/data/teaching_update.php', Qs.stringify({
                              s_code: this.$route.params.id,
                              id: this.teaching_id,
                              campaign_id: this.db_campaign_id,
                              campaign_objective: '',
                              skip: '',
                              step: '',
                              active: 'campaign_id'
                            }));

                          // console.log('333111發佈 this.target');
                          // console.log(this.target);

                          // if(this.menu[1].show == false){
                            if(this.methodData.Target_CR == true){
                              // console.log('now target:'+this.target);
                              if (this.target <= 1) {
                                this.process += 50
                                this.target += 1
                                this.menu[this.target-1].open = true
                                this.menu[this.target-1].click = 1
                              }
                            } else {
                              if(this.process < 66){
                                this.process += 33
                                // console.log('now target:'+this.target);
                                if (this.target <= 3) {
                                  this.target += 1
                                  this.menu[this.target-1].open = true
                                  this.menu[this.target-1].click = 1
                                }
                                // if(this.target == 2){
                                //   this.target += 1
                                // }
                              }
                            }
                          // } else {
                          //   if(this.process < 75){
                          //     this.process += 25
                          //     // console.log('now target:'+this.target);
                          //     if (this.target <= 4) {
                          //       this.target += 1
                          //       this.menu[this.target-1].open = true
                          //       this.menu[this.target-1].click = 1
                          //     }
                          //     // console.log('next target:'+this.target);
                          //   }
                          // }
                          // console.log('next target:'+this.target);
                          document.getElementById('edit_content').scrollTop = 0;

                          //console.log('#7 this.process', this.process);
                          this.getAutoTarget(isMenu);
                        } else {
                          let text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['empty_campaign_id']['campaign_add_update']['default_swal_text'];
                          if(response.data.info != '' && response.data.info != null){
                            text = response.data.info
                          }
                          Swal.fire(
                            this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['empty_campaign_id']['campaign_add_update']['swal_title'],
                            text,
                            'error'
                          )
                        }
                      });
                  } else {
                    var daily_keyword_split_budget = this.methodData.Budget_KW;
                    var daily_demo_budget = this.methodData.Budget_DM;
                    var budget_addition = this.goalsData.form_addition;

                    if(this.dateData.start_date != "" && this.dateData.end_date != ""){
                        var d1 = new Date(this.dateData.start_date);
                        var d2 = new Date(this.dateData.end_date);
                        var days = parseInt((d2-d1)/86400000) + parseInt(1);
                    } else {
                        var days = 0;
                    }

                    var keyword_split_budget = 0;
                    if(this.methodData.Budget_KW != ''){
                        keyword_split_budget = Math.round(this.methodData.Budget_KW * days * (1+(budget_addition/100)));
                    }

                    var demo_budget = 0;
                    if(this.methodData.Budget_DM != ''){
                        demo_budget = this.methodData.Budget_DM * days;
                    }

                    var _tmp_audience_budget = 0;
                    var audience_budget = 0;
                    // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.5)');
                    _tmp_audience_budget = this.methodData.Budget_LA;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.5);
                    // console.log('Math.round('+_tmp_audience_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                    audience_budget = Math.round(_tmp_audience_budget * days * (1+(budget_addition/100)));

                    var _tmp_marketing_again_budget = 0;
                    var marketing_again_budget = 0;
                    // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.25)');
                    _tmp_marketing_again_budget = this.methodData.Budget_RT;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.25);
                    // console.log('Math.round('+_tmp_marketing_again_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                    marketing_again_budget = Math.round(_tmp_marketing_again_budget * days * (1+(budget_addition/100)));

                    // console.log(parseInt(keyword_split_budget)+' + '+parseInt(demo_budget)+' + '+parseInt(audience_budget)+' + '+parseInt(marketing_again_budget));
                    var ac_budget = 0;
                    if(this.methodData.Budget_AC != '' && this.methodData.Budget_AC != 0){
                        ac_budget = Math.round(this.methodData.Budget_AC * days);
                    }
                    var html = parseInt(keyword_split_budget) + parseInt(demo_budget) + parseInt(audience_budget) + parseInt(marketing_again_budget) + parseInt(ac_budget);

                    if(isNaN(html)){
                        html = '0';
                    }

                    this.total_budget = html;

                    let _tmp_goalsData = this.goalsData;
                    const _view_goalsData = JSON.parse(JSON.stringify(_tmp_goalsData));
                    let _tmp_exAudiencesData = this.exAudiencesData;
                    const _view_exAudiencesData = JSON.parse(JSON.stringify(_tmp_exAudiencesData));

                    // console.log(_tmp_exAudiencesData);

                    delete _view_goalsData['objective_list'];
                    delete _view_exAudiencesData['custom_excluded_audiences'];

                    let formData = {
                      campaign_id: this.db_campaign_id,
                      campaign_name: this.campaign_name,
                      budget_type: this.budget_type,
                      special_ad_category: this.special_ad_category,
                      adaccount_id: this.adaccount_id,
                      Budget_KW_result: this.Budget_KW_result,
                      total_budget: this.total_budget,
                      useDefaultLayout: this.useDefaultLayout,
                      dynBudgetData: this.dynBudgetData,
                      methodData: this.methodData,
                      benefitsAndInvestmentData: this.benefitsAndInvestmentData,
                      dateData: this.dateData,
                      keywordData: this.keywordData,
                      lookData: this.lookData,
                      audiencesData: this.audiencesData,
                      goalsData: _view_goalsData,
                      regionsData: this.regionsData,
                      selectCountries: this.selectCountries,
                      selectLangs: this.selectLangs,
                      exAudiencesData: _view_exAudiencesData,
                      pdData: this.pdData,
                      idData: this.idData,
                      postData: this.postData,
                      adMaterialData: this.adMaterialDataNew,
                      autoAdjustData: this.autoAdjustData
                    }

                    let type = '';
                    if(this.target == 3){
                      type = 'finish';
                    }

                    if(this.goalsData.campaign_objective == 'LEAD_GENERATION' || this.goalsData.campaign_objective == 'MESSAGES'){
                      // console.log('#1');
                      if(this.target == 3){
                        let materialType = 0;
                        let selectArticleLength = 0;
                        if(this.postData.select_article != '' && this.postData.select_article != null && typeof this.postData.select_article != 'undefined'){
                          selectArticleLength = this.postData.select_article.length;
                        }

                        let selectCreativesMessageLength = 0;
                        if(this.postData.select_creatives_message != '' && this.postData.select_creatives_message != null && typeof this.postData.select_creatives_message != 'undefined'){
                          selectCreativesMessageLength = this.postData.select_creatives_message.length;
                        }

                        let selectCreativesAdsetAdsMessageLength = 0;
                        if(this.postData.select_creatives_adset_ads_message != '' && this.postData.select_creatives_adset_ads_message != null && typeof this.postData.select_creatives_adset_ads_message != 'undefined'){
                          selectCreativesAdsetAdsMessageLength = this.postData.select_creatives_adset_ads_message.length;
                        }

                        let creativeArrayLength = 0;
                        if(this.adMaterialDataNew.creative_array != '' && this.adMaterialDataNew.creative_array != null && typeof this.adMaterialDataNew.creative_array != 'undefined'){
                          creativeArrayLength = this.adMaterialDataNew.creative_array.length;
                        }

                        if(creativeArrayLength == 0 && (!this.postData.select_creatives || this.postData.select_creatives.length == 0) && selectArticleLength == 0 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
                          materialType = 1;
                        } else if(selectArticleLength == 0 && selectCreativesMessageLength == 0 && selectCreativesAdsetAdsMessageLength == 0 && creativeArrayLength == 0 && this.goalsData.campaign_objective == 'MESSAGES'){
                          materialType = 2;
                        }

                    //  console.log('this.postData.select_article');
                    //  console.log(this.postData.select_article);
                    //  console.log('this.postData.select_creatives_message');
                    //  console.log(this.postData.select_creatives_message);
                    //  console.log('this.adMaterialDataNew.creative_array');
                    //  console.log(this.adMaterialDataNew.creative_array);
                    //  console.log('this.goalsData.campaign_objective');
                    //  console.log(this.goalsData.campaign_objective);
                    //  console.log(selectArticleLength +' == 0 && '+ selectCreativesMessageLength +' == 0 && '+ creativeArrayLength +' == 0');
                    //  console.log('#2 materialType:'+materialType);

                        if(materialType == 0){
                          // console.log('#2');
                          let message_sr_i = 0;
                          let form_sr_i = 0;
                          let message = 0;
                          let single_object_spec = 0;
                          let single_title = 0;
                          let materials_item = 0;
                          let materials_object_spec = 0;
                          let materials_title = 0;
                          let ad_name = 0;

                          for(let i = 0; i < creativeArrayLength; i++){
                            if(this.adMaterialDataNew.creative_array[i].title == '' || this.adMaterialDataNew.creative_array[i].title == null || typeof this.adMaterialDataNew.creative_array[i].title == 'undefined'){
                              ad_name = 1;
                            }

                            if(this.adMaterialDataNew.creative_array[i].type == 2){
                              let materials_length = this.adMaterialDataNew.creative_array[i].materials.length

                              if(materials_length < 2){
                                materials_item = 1;
                              } else {
                                for(let j = 0; j < materials_length; j++){
                                  if(this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == '' || this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == null || typeof this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == 'undefined'){
                                    materials_object_spec = 1;
                                  }

                                  if(this.adMaterialDataNew.creative_array[i].materials[j].title == '' || this.adMaterialDataNew.creative_array[i].materials[j].title == null || typeof this.adMaterialDataNew.creative_array[i].materials[j].title == 'undefined'){
                                    materials_title = 1;
                                  }
                                }
                              }
                            }

                            if(this.adMaterialDataNew.creative_array[i].type == 1){
                              if(this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == '' || this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == null || typeof this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == 'undefined'){
                                single_object_spec = 1;
                              }

                              if(this.adMaterialDataNew.creative_array[i].materialSingle[0].title == '' || this.adMaterialDataNew.creative_array[i].materialSingle[0].title == null || typeof this.adMaterialDataNew.creative_array[i].materialSingle[0].title == 'undefined'){
                                single_title = 1;
                              }
                            }

                            if(this.adMaterialDataNew.creative_array[i].message == '' || this.adMaterialDataNew.creative_array[i].message == null || typeof this.adMaterialDataNew.creative_array[i].message == 'undefined'){
                              message = 1;
                            }

                            if(this.adMaterialDataNew.creative_array[i].form_sr_i == '' || this.adMaterialDataNew.creative_array[i].form_sr_i == null || typeof this.adMaterialDataNew.creative_array[i].form_sr_i == 'undefined'){
                              form_sr_i = 1;
                            }

                            if(this.adMaterialDataNew.creative_array[i].message_sr_i == '' || this.adMaterialDataNew.creative_array[i].message_sr_i == null || typeof this.adMaterialDataNew.creative_array[i].message_sr_i == 'undefined'){
                              message_sr_i = 1;
                            }
                          }

                          if(ad_name == 1){
                            Swal.fire(
                                        this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['swal_title'],
                                        this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_ad_name_swal_text'],
                                        "error"
                                      )
                          } else if(single_object_spec == 1){
                            Swal.fire(
                                        this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['swal_title'],
                                        this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_single_object_spec_swal_text'],
                                        "error"
                                      )
                          } else if(single_title == 1){
                            Swal.fire(
                                        this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['swal_title'],
                                        this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_single_title_swal_text'],
                                        "error"
                                      )
                          } else if(materials_item == 1){
                            Swal.fire(
                                        this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['swal_title'],
                                        this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_materials_item_swal_text'],
                                        "error"
                                      )
                          } else if(materials_object_spec == 1){
                            Swal.fire(
                                        this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['swal_title'],
                                        this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_materials_object_spec_swal_text'],
                                        "error"
                                      )
                          } else if(materials_title == 1){
                            Swal.fire(
                                        this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['swal_title'],
                                        this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_materials_title_swal_text'],
                                        "error"
                                      )
                          } else if(message == 1){
                            Swal.fire(
                                        this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['swal_title'],
                                        this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_message_swal_text'],
                                        "error"
                                      )
                          } else if(form_sr_i == 1 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
                            Swal.fire(
                                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['swal_title'],
                                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_form_sr_i_swal_text'],
                                      "error"
                                    )
                          } else if(message_sr_i == 1 && this.goalsData.campaign_objective == 'MESSAGES'){
                            Swal.fire(
                                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['swal_title'],
                                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_message_sr_i_swal_text'],
                                      "error"
                                    )
                          } else {
                            // console.log('#5');
                            axios
                              .post('https://www.autoturn.net/api/data/campaign_update.php', Qs.stringify({
                                s_code: this.$route.params.id,
                                form_data: formData,
                                type: type,
                                target: 'add_next_'+this.target,
                              }))
                              .then((response) => {
                                // console.log(response.data);
                                if(response.data.status == 'success'){
                                  // this.immediateList = response.data.return_data
                                  // this.formData = response.data.return_data.form

                                  // Swal.fire({
                                  //   icon: 'success',
                                  //   title: '儲存',
                                  //   text: response.data.info,
                                  //   showDenyButton: false,
                                  //   showCancelButton: false,
                                  //   confirmButtonText: '確定',
                                  //   // denyButtonText: `Don't save`,
                                  // }).then((result) => {
                                  //   if (result.isConfirmed) {
                                  //     // Swal.fire('Saved!', '', 'success')

                                  //     // window.location.href = "https://private.autoturn.net/events-list/f/"+this.$route.params.id+"/"+this.$route.params.adaccount_id;
                                  //   } else if (result.isDenied) {
                                  //     // Swal.fire('Changes are not saved', '', 'info')
                                  //   }
                                  // })

                                  // if(type == 1){
                                  //   var todayForm = new Date();
                                  //   var yearForm = todayForm.getFullYear();
                                  //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                                  //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                                  //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                                  //   todayForm = yearForm + monthForm + dateForm + timeForm;

                                  //   this.formTitle = 'title_'+todayForm;
                                  // } else {
                                  //   this.formTitle = response.data.return_data.name;
                                  // }

                                  // this.showModal = true
                                  // console.log('發佈 this.target');
                                  // console.log(this.target);
                                  if(this.target == 3){
                                    // console.log('按下一步的發佈');
                                    if(response.data.release_status == 'N' && response.data.release_writing_status == 'draft'){
                                //       let name = this.campaign_name;
                                //       let currency = this.currencyData.currency;
                                //       let addition = this.goalsData.form_addition;
                                //       let daily_budget = this.methodData.daily_budget;
                                //       // let campaignInfo = "依您的預算設定，<br/>在未來兩週將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
                                //       // if(addition == '' || addition == 0){
                                //       //   campaignInfo = "依您的預算比率與行銷日期設定，<br/>將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
                                //       // }

                                //       let addition_text = '（'+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['campaign_update']['success']['addition_text']+'：<span style="color:red; font-weight:bold;">'+addition+'%</span>）';
                                //       let two_week_budget = Math.round((daily_budget*7)+(daily_budget*7)+(daily_budget*7*(addition/100)));
                                //       let campaignInfo = this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['campaign_update']['success']['swal_text_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['campaign_update']['success']['swal_text_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['campaign_update']['success']['swal_text_total_budget_c']+"</span>"+addition_text;
                                //       if(this.dateData.end_date != '0000-00-00'){
                                //         two_week_budget = this.total_budget;
                                //         campaignInfo = this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['campaign_update']['success']['swal_text_not_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['campaign_update']['success']['swal_text_not_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['campaign_update']['success']['swal_text_not_total_budget_c']+"</span>"+addition_text;
                                //       }

                                //       Swal.fire({
                                //         title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['campaign_update']['success']['swal_title']+"「"+name+"」",
                                //         html: campaignInfo + "<br/><br/>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['campaign_update']['success']['swal_text_a']+"<span style='color:red;'>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['campaign_update']['success']['swal_text_b']+"</span>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['campaign_update']['success']['swal_text_c'],
                                //         icon: 'warning',
                                //         showCancelButton: true,
                                //         confirmButtonColor: '#3085d6',
                                //         cancelButtonColor: '#d33',
                                //         confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['campaign_update']['success']['yes_button'],
                                //         cancelButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['campaign_update']['success']['no_button'],
                                //       }).then((result) => {
                                //         if (result.isConfirmed) {
                                //           // console.log(this.$route.params.id);

                                //           this.releaseType = true
                                //           this.style = 'z-index:100;';
                                //           this.releasePercent = 5;
                                //           let status = 1;
                                //           let num = 0;
                                //           let member_hash = this.$route.params.id;
                                //           let adaccount_id = this.adaccount_id
                                          // var bar5 = new ldBar("#myItem5");
                                          // bar5.set(this.releasePercent);

                                //           axios
                                //             .post('https://www.autoturn.net/api/campaign_release.php', Qs.stringify({
                                //               s_code: member_hash,
                                //               campaign_id: this.db_campaign_id,
                                //             }))
                                //             .then((caResponse) => {
                                //               // console.log('caResponse:'+caResponse.data.return_data);
                                //               if(caResponse.data.status == 'success'){
                                //                 //進行進度條
                                //                 // console.log('發佈莞成，開始跑進度條');
                                //                 setInterval( () => {
                                //                   num++;
                                //                   if(num < 1200){
                                //                     // console.log('num:'+num);
                                //                     // console.log(this.releaseType);

                                //                     if(this.releaseType == true){
                                //                       axios
                                //                         .post('https://www.autoturn.net/api/campaign_states.php', Qs.stringify({
                                //                           s_code: member_hash,
                                //                           adaccount_id: this.adaccount_id,
                                //                           campaign_id: this.db_campaign_id,
                                //                         }))
                                //                         .then((csResponse) => {
                                //                           // console.log('csResponse:'+csResponse.data.return_data);
                                //                           //進行進度條
                                //                           if(status == 1){
                                //                             if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'FAILURE'){
                                //                               this.releaseType = false
                                //                               this.style = 'z-index:-1;';
                                //                               bar5.set(0);
                                //                               status = 0;
                                //                               // Swal.fire({
                                //                               //   icon: 'error',
                                //                               //   title: '正式發佈',
                                //                               //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
                                //                               //   showDenyButton: false,
                                //                               //   showCancelButton: false,
                                //                               //   confirmButtonText: '確定',
                                //                               //   timer: 5000
                                //                               //   // denyButtonText: `Don't save`,
                                //                               // }).then((result) => {
                                //                               //   if (result.isConfirmed) {
                                //                               //     // Swal.fire('Saved!', '', 'success')
                                //                               //     this.allPageLoading = true
                                //                               //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                //                               //   } else if (result.isDenied) {
                                //                               //     // Swal.fire('Changes are not saved', '', 'info')
                                //                               //     this.allPageLoading = true
                                //                               //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                //                               //   }

                                //                               //   if (result.dismiss === Swal.DismissReason.timer) {
                                //                               //     this.allPageLoading = true
                                //                               //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                //                               //   }
                                //                               // })
                                //                               Swal.fire({
                                //                                 icon: 'error',
                                //                                 title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['campaign_update']['success']['info_state_failure']['swal_title'],
                                //                                 text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['campaign_update']['success']['info_state_failure']['swal_html']+csResponse.data.return_data.info_text,
                                //                                 showDenyButton: false,
                                //                                 showCancelButton: false,
                                //                                 confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['campaign_update']['success']['info_state_failure']['confirm_button']
                                //                               }).then((result) => {

                                //                               })
                                //                             } else if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'SUCCESS'){
                                //                               status = 0;

                                //                               axios
                                //                                 .get('https://www.autoturn.net/udnapi/public/send_notice_email.php?s_code='+member_hash+'&form=release&sr_i='+this.db_campaign_id)
                                //                                 .then((csResponse) => {
                                //                                   this.releaseType = false

                                //                                   Swal.fire({
                                //                                     icon: 'success',
                                //                                     title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['campaign_update']['success']['info_state_success']['swal_title'],
                                //                                     text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['campaign_update']['success']['info_state_success']['swal_html'],
                                //                                     showDenyButton: false,
                                //                                     showCancelButton: false,
                                //                                     confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['campaign_update']['success']['info_state_success']['confirm_button'],
                                //                                     timer: 5000
                                //                                     // denyButtonText: `Don't save`,
                                //                                   }).then((result) => {
                                //                                     /* Read more about isConfirmed, isDenied below */
                                //                                     if (result.isConfirmed) {
                                //                                       // Swal.fire('Saved!', '', 'success')
                                //                                       this.allPageLoading = true
                                //                                       window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                //                                     } else if (result.isDenied) {
                                //                                       // Swal.fire('Changes are not saved', '', 'info')
                                //                                       this.allPageLoading = true
                                //                                       window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                //                                     }

                                //                                     if (result.dismiss === Swal.DismissReason.timer) {
                                //                                       this.allPageLoading = true
                                //                                       window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                //                                     }
                                //                                   })
                                //                                 });
                                //                             } else if(csResponse.data.return_data.state == 'FAILURE' && csResponse.data.return_data.info_state == 'FAILURE'){
                                //                               this.releaseType = false
                                //                               this.style = 'z-index:-1;';
                                //                               bar5.set(0);
                                //                               status = 0;
                                //                               // Swal.fire({
                                //                               //   icon: 'error',
                                //                               //   title: '正式發佈',
                                //                               //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
                                //                               //   showDenyButton: false,
                                //                               //   showCancelButton: false,
                                //                               //   confirmButtonText: '確定',
                                //                               //   timer: 5000
                                //                               //   // denyButtonText: `Don't save`,
                                //                               // }).then((result) => {
                                //                               //   /* Read more about isConfirmed, isDenied below */
                                //                               //   if (result.isConfirmed) {
                                //                               //     // Swal.fire('Saved!', '', 'success')
                                //                               //     this.allPageLoading = true
                                //                               //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                //                               //   } else if (result.isDenied) {
                                //                               //     // Swal.fire('Changes are not saved', '', 'info')
                                //                               //     this.allPageLoading = true
                                //                               //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                //                               //   }

                                //                               //   if (result.dismiss === Swal.DismissReason.timer) {
                                //                               //     this.allPageLoading = true
                                //                               //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                //                               //   }
                                //                               // })
                                //                               Swal.fire({
                                //                                 icon: 'error',
                                //                                 title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['campaign_update']['success']['state_failure']['swal_title'],
                                //                                 text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['campaign_update']['success']['state_failure']['swal_html']+csResponse.data.return_data.info_text,
                                //                                 showDenyButton: false,
                                //                                 showCancelButton: false,
                                //                                 confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['campaign_update']['success']['state_failure']['confirm_button']
                                //                               }).then((result) => {

                                //                               })
                                //                             } else {
                                //                               this.releaseText = csResponse.data.return_data.info_text
                                //                               this.releasePercent = csResponse.data.return_data.info_pct

                                //                               bar5.set(this.releasePercent);
                                //                               // console.log('csResponse.data.return_data.info_text:'+csResponse.data.return_data.info_text);
                                //                               // console.log('csResponse.data.return_data.info_pct:'+csResponse.data.return_data.info_pct);
                                //                               // console.log('this.releaseText:'+this.releaseText);
                                //                               // console.log('this.releasePercent:'+this.releasePercent);

                                //                               if(csResponse.data.return_data.info_pct == 100){
                                //                                 this.releaseType = false
                                //                                 this.style = 'z-index:-1;';
                                //                                 bar5.set(0);
                                //                                 status = 0;
                                //                               }
                                //                             }
                                //                           }
                                //                         });
                                //                     }
                                //                   } else {
                                //                     Swal.fire({
                                //                       icon: 'warning',
                                //                       title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['campaign_update']['success']['else']['swal_title'],
                                //                       text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['campaign_update']['success']['else']['swal_html'],
                                //                       showDenyButton: false,
                                //                       showCancelButton: false,
                                //                       confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['campaign_update']['success']['else']['confirm_button'],
                                //                       timer: 1000
                                //                       // denyButtonText: `Don't save`,
                                //                     }).then((result) => {
                                //                       /* Read more about isConfirmed, isDenied below */
                                //                       if (result.isConfirmed) {
                                //                         // Swal.fire('Saved!', '', 'success')
                                //                         this.allPageLoading = true
                                //                         window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                //                       } else if (result.isDenied) {
                                //                         // Swal.fire('Changes are not saved', '', 'info')
                                //                         this.allPageLoading = true
                                //                         window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                //                       }

                                //                       if (result.dismiss === Swal.DismissReason.timer) {
                                //                         this.allPageLoading = true
                                //                         window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                //                       }
                                //                     })
                                //                   }
                                //                 }, 3000);
                                //               }
                                //             });
                                //         }
                                //       })
                                      this.release();
                                    } else {
                                      Swal.fire(
                                        this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['campaign_update']['success']['swal_title'],
                                        response.data.info,
                                        'error'
                                      )
                                    }
                                  }

                                  // console.log('333222發佈 this.target');
                                  // console.log(this.target);

                                  // if(this.menu[1].show == false){
                                    if(this.methodData.Target_CR == true){
                                      // console.log('now target:'+this.target);
                                      if (this.target <= 1) {
                                        this.process += 50
                                        this.target += 1
                                        this.menu[this.target-1].open = true
                                        this.menu[this.target-1].click = 1
                                      }
                                    } else {
                                      if(this.process < 66){
                                        this.process += 33
                                        // console.log('now target:'+this.target);
                                        if (this.target <= 3) {
                                          this.target += 1
                                          this.menu[this.target-1].open = true
                                          this.menu[this.target-1].click = 1
                                        }
                                        // if(this.target == 2){
                                        //   this.target += 1
                                        // }
                                      }
                                    }
                                  // } else {
                                  //   if(this.process < 75){
                                  //     this.process += 25
                                  //     // console.log('now target:'+this.target);
                                  //     if (this.target <= 4) {
                                  //       this.target += 1
                                  //       this.menu[this.target-1].open = true
                                  //       this.menu[this.target-1].click = 1
                                  //     }
                                  //     // console.log('next target:'+this.target);
                                  //   }
                                  // }
                                  // console.log('next target:'+this.target);
                                  document.getElementById('edit_content').scrollTop = 0;

                                  //console.log('#8 this.process', this.process);
                                  this.getAutoTarget(isMenu);
                                } else {
                                  let text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['campaign_update']['not_success']['default_swal_text'];
                                  if(response.data.info != '' && response.data.info != null){
                                    text = response.data.info
                                  }
                                  Swal.fire(
                                    this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['campaign_update']['not_success']['swal_title'],
                                    text,
                                    'error'
                                  )
                                }
                              });
                          }
                        } else {
                          // console.log('#3');
                          Swal.fire(
                                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['not_creative_array_swal_title'],
                                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['not_creative_array_swal_text'],
                                      "error"
                                    )
                        }
                      } else {
                        axios
                          .post('https://www.autoturn.net/api/data/campaign_update.php', Qs.stringify({
                            s_code: this.$route.params.id,
                            form_data: formData,
                            type: type,
                            target: 'add_next_'+this.target,
                          }))
                          .then((response) => {
                            // console.log(response.data);
                            if(response.data.status == 'success'){
                              // this.immediateList = response.data.return_data
                              // this.formData = response.data.return_data.form

                              // Swal.fire({
                              //   icon: 'success',
                              //   title: '儲存',
                              //   text: response.data.info,
                              //   showDenyButton: false,
                              //   showCancelButton: false,
                              //   confirmButtonText: '確定',
                              //   // denyButtonText: `Don't save`,
                              // }).then((result) => {
                              //   if (result.isConfirmed) {
                              //     // Swal.fire('Saved!', '', 'success')

                              //     // window.location.href = "https://private.autoturn.net/events-list/"+this.$route.params.id+"/"+this.$route.params.adaccount_id;
                              //   } else if (result.isDenied) {
                              //     // Swal.fire('Changes are not saved', '', 'info')
                              //   }
                              // })

                              // if(type == 1){
                              //   var todayForm = new Date();
                              //   var yearForm = todayForm.getFullYear();
                              //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                              //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                              //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                              //   todayForm = yearForm + monthForm + dateForm + timeForm;

                              //   this.formTitle = 'title_'+todayForm;
                              // } else {
                              //   this.formTitle = response.data.return_data.name;
                              // }

                              // this.showModal = true
                              // console.log('發佈 this.target');
                              // console.log(this.target);
                              if(this.target == 3){
                                // console.log('按下一步的發佈');
                                if(response.data.release_status == 'N' && response.data.release_writing_status == 'draft'){
                                  // let name = this.campaign_name;
                                  // let currency = this.currencyData.currency;
                                  // let addition = this.goalsData.form_addition;
                                  // let daily_budget = this.methodData.daily_budget;
                                  // // let campaignInfo = "依您的預算設定，<br/>在未來兩週將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
                                  // // if(addition == '' || addition == 0){
                                  // //   campaignInfo = "依您的預算比率與行銷日期設定，<br/>將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
                                  // // }

                                  // let addition_text = '（預算比率：<span style="color:red; font-weight:bold;">'+addition+'%</span>）';
                                  // let two_week_budget = Math.round((daily_budget*7)+(daily_budget*7)+(daily_budget*7*(addition/100)));
                                  // let campaignInfo = "依您的預算設定，<br/>在未來兩週將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+"元</span>"+addition_text;
                                  // if(this.dateData.end_date != '0000-00-00'){
                                  //   two_week_budget = this.total_budget;
                                  //   campaignInfo = "依您的預算比率與行銷日期設定，<br/>將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+"元</span>"+addition_text;
                                  // }

                                  // Swal.fire({
                                  //   title: "發佈「"+name+"」",
                                  //   html: campaignInfo + "<br/><br/>發佈完成之後，<span style='color:red;'>請勿在facebook廣告後台修改行銷活動設定、受眾資料(AUTOTURN開頭)，若修改到系統便會暫停自動化</span>，您確定要發佈嗎？",
                                  //   icon: 'warning',
                                  //   showCancelButton: true,
                                  //   confirmButtonColor: '#3085d6',
                                  //   cancelButtonColor: '#d33',
                                  //   confirmButtonText: '是',
                                  //   cancelButtonText: '取消',
                                  // }).then((result) => {
                                  //   if (result.isConfirmed) {
                                  //     // console.log(this.$route.params.id);

                                  //     this.releaseType = true
                                  //     this.style = 'z-index:100;';
                                  //     this.releasePercent = 5;
                                  //     let status = 1;
                                  //     let num = 0;
                                  //     let member_hash = this.$route.params.id;
                                  //     let adaccount_id = this.adaccount_id
                                  //     var bar5 = new ldBar("#myItem5");
                                  //     bar5.set(this.releasePercent);

                                  //     axios
                                  //       .post('https://www.autoturn.net/api/campaign_release.php', Qs.stringify({
                                  //         s_code: member_hash,
                                  //         campaign_id: this.db_campaign_id,
                                  //       }))
                                  //       .then((caResponse) => {
                                  //         // console.log('caResponse:'+caResponse.data.return_data);
                                  //         fbq('trackCustom', 'Release');
                                  //         if(caResponse.data.status == 'success'){
                                  //           //進行進度條
                                  //           // console.log('發佈莞成，開始跑進度條');
                                  //           setInterval( () => {
                                  //             num++;
                                  //             if(num < 1200){
                                  //               // console.log('num:'+num);
                                  //               // console.log(this.releaseType);

                                  //               if(this.releaseType == true){
                                  //                 axios
                                  //                   .post('https://www.autoturn.net/api/campaign_states.php', Qs.stringify({
                                  //                     s_code: member_hash,
                                  //                     adaccount_id: this.adaccount_id,
                                  //                     campaign_id: this.db_campaign_id,
                                  //                   }))
                                  //                   .then((csResponse) => {
                                  //                     // console.log('csResponse:'+csResponse.data.return_data);
                                  //                     //進行進度條
                                  //                     if(status == 1){
                                  //                       if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'FAILURE'){
                                  //                         this.releaseType = false
                                  //                         this.style = 'z-index:-1;';
                                  //                         bar5.set(0);
                                  //                         status = 0;
                                  //                         // Swal.fire({
                                  //                         //   icon: 'error',
                                  //                         //   title: '正式發佈',
                                  //                         //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
                                  //                         //   showDenyButton: false,
                                  //                         //   showCancelButton: false,
                                  //                         //   confirmButtonText: '確定',
                                  //                         //   timer: 5000
                                  //                         //   // denyButtonText: `Don't save`,
                                  //                         // }).then((result) => {
                                  //                         //   if (result.isConfirmed) {
                                  //                         //     // Swal.fire('Saved!', '', 'success')
                                  //                         //     this.allPageLoading = true
                                  //                         //     window.location.href = "https://private.autoturn.net/events-list/"+member_hash+"/"+adaccount_id;
                                  //                         //   } else if (result.isDenied) {
                                  //                         //     // Swal.fire('Changes are not saved', '', 'info')
                                  //                         //     this.allPageLoading = true
                                  //                         //     window.location.href = "https://private.autoturn.net/events-list/"+member_hash+"/"+adaccount_id;
                                  //                         //   }

                                  //                         //   if (result.dismiss === Swal.DismissReason.timer) {
                                  //                         //     this.allPageLoading = true
                                  //                         //     window.location.href = "https://private.autoturn.net/events-list/"+member_hash+"/"+adaccount_id;
                                  //                         //   }
                                  //                         // })
                                  //                         Swal.fire({
                                  //                           icon: 'error',
                                  //                           title: '正式發佈',
                                  //                           text: '發佈失敗：'+csResponse.data.return_data.info_text,
                                  //                           showDenyButton: false,
                                  //                           showCancelButton: false,
                                  //                           confirmButtonText: '確定'
                                  //                         }).then((result) => {

                                  //                         })
                                  //                       } else if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'SUCCESS'){
                                  //                         status = 0;

                                  //                         axios
                                  //                           .get('https://www.autoturn.net/udnapi/public/send_notice_email.php?s_code='+member_hash+'&form=release&sr_i='+this.db_campaign_id)
                                  //                           .then((csResponse) => {
                                  //                             this.releaseType = false

                                  //                             Swal.fire({
                                  //                               icon: 'success',
                                  //                               title: '正式發佈',
                                  //                               text: '已發佈完成，將於行銷起始日期的當天00:00正式啟動，5秒後將為您重新整理頁面。',
                                  //                               showDenyButton: false,
                                  //                               showCancelButton: false,
                                  //                               confirmButtonText: '確定',
                                  //                               timer: 5000
                                  //                               // denyButtonText: `Don't save`,
                                  //                             }).then((result) => {
                                  //                               /* Read more about isConfirmed, isDenied below */
                                  //                               if (result.isConfirmed) {
                                  //                                 // Swal.fire('Saved!', '', 'success')
                                  //                                 this.allPageLoading = true
                                  //                                 window.location.href = "https://private.autoturn.net/events-list/"+member_hash+"/"+adaccount_id;
                                  //                               } else if (result.isDenied) {
                                  //                                 // Swal.fire('Changes are not saved', '', 'info')
                                  //                                 this.allPageLoading = true
                                  //                                 window.location.href = "https://private.autoturn.net/events-list/"+member_hash+"/"+adaccount_id;
                                  //                               }

                                  //                               if (result.dismiss === Swal.DismissReason.timer) {
                                  //                                 this.allPageLoading = true
                                  //                                 window.location.href = "https://private.autoturn.net/events-list/"+member_hash+"/"+adaccount_id;
                                  //                               }
                                  //                             })
                                  //                           });
                                  //                       } else if(csResponse.data.return_data.state == 'FAILURE' && csResponse.data.return_data.info_state == 'FAILURE'){
                                  //                         this.releaseType = false
                                  //                         this.style = 'z-index:-1;';
                                  //                         bar5.set(0);
                                  //                         status = 0;
                                  //                         // Swal.fire({
                                  //                         //   icon: 'error',
                                  //                         //   title: '正式發佈',
                                  //                         //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
                                  //                         //   showDenyButton: false,
                                  //                         //   showCancelButton: false,
                                  //                         //   confirmButtonText: '確定',
                                  //                         //   timer: 5000
                                  //                         //   // denyButtonText: `Don't save`,
                                  //                         // }).then((result) => {
                                  //                         //   /* Read more about isConfirmed, isDenied below */
                                  //                         //   if (result.isConfirmed) {
                                  //                         //     // Swal.fire('Saved!', '', 'success')
                                  //                         //     this.allPageLoading = true
                                  //                         //     window.location.href = "https://private.autoturn.net/events-list/"+member_hash+"/"+adaccount_id;
                                  //                         //   } else if (result.isDenied) {
                                  //                         //     // Swal.fire('Changes are not saved', '', 'info')
                                  //                         //     this.allPageLoading = true
                                  //                         //     window.location.href = "https://private.autoturn.net/events-list/"+member_hash+"/"+adaccount_id;
                                  //                         //   }

                                  //                         //   if (result.dismiss === Swal.DismissReason.timer) {
                                  //                         //     this.allPageLoading = true
                                  //                         //     window.location.href = "https://private.autoturn.net/events-list/"+member_hash+"/"+adaccount_id;
                                  //                         //   }
                                  //                         // })
                                  //                         Swal.fire({
                                  //                           icon: 'error',
                                  //                           title: '正式發佈',
                                  //                           text: '發佈失敗：'+csResponse.data.return_data.info_text,
                                  //                           showDenyButton: false,
                                  //                           showCancelButton: false,
                                  //                           confirmButtonText: '確定'
                                  //                         }).then((result) => {

                                  //                         })
                                  //                       } else {
                                  //                         this.releaseText = csResponse.data.return_data.info_text
                                  //                         this.releasePercent = csResponse.data.return_data.info_pct

                                  //                         bar5.set(this.releasePercent);
                                  //                         // console.log('csResponse.data.return_data.info_text:'+csResponse.data.return_data.info_text);
                                  //                         // console.log('csResponse.data.return_data.info_pct:'+csResponse.data.return_data.info_pct);
                                  //                         // console.log('this.releaseText:'+this.releaseText);
                                  //                         // console.log('this.releasePercent:'+this.releasePercent);

                                  //                         if(csResponse.data.return_data.info_pct == 100){
                                  //                           this.releaseType = false
                                  //                           this.style = 'z-index:-1;';
                                  //                           bar5.set(0);
                                  //                           status = 0;
                                  //                         }
                                  //                       }
                                  //                     }
                                  //                   });
                                  //               }
                                  //             } else {
                                  //               Swal.fire({
                                  //                 icon: 'warning',
                                  //                 title: '正式發佈',
                                  //                 text: '將為您重新整理頁面。',
                                  //                 showDenyButton: false,
                                  //                 showCancelButton: false,
                                  //                 confirmButtonText: '確定',
                                  //                 timer: 1000
                                  //                 // denyButtonText: `Don't save`,
                                  //               }).then((result) => {
                                  //                 /* Read more about isConfirmed, isDenied below */
                                  //                 if (result.isConfirmed) {
                                  //                   // Swal.fire('Saved!', '', 'success')
                                  //                   this.allPageLoading = true
                                  //                   window.location.href = "https://private.autoturn.net/events-list/"+member_hash+"/"+adaccount_id;
                                  //                 } else if (result.isDenied) {
                                  //                   // Swal.fire('Changes are not saved', '', 'info')
                                  //                   this.allPageLoading = true
                                  //                   window.location.href = "https://private.autoturn.net/events-list/"+member_hash+"/"+adaccount_id;
                                  //                 }

                                  //                 if (result.dismiss === Swal.DismissReason.timer) {
                                  //                   this.allPageLoading = true
                                  //                   window.location.href = "https://private.autoturn.net/events-list/"+member_hash+"/"+adaccount_id;
                                  //                 }
                                  //               })
                                  //             }
                                  //           }, 3000);
                                  //         }
                                  //       });
                                  //   }
                                  // })
                                  this.release();
                                } else {
                                  Swal.fire(
                                    this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_target_3']['campaign_update']['success']['swal_title'],
                                    response.data.info,
                                    'error'
                                  )
                                }
                              }

                              // console.log('333222發佈 this.target');
                              // console.log(this.target);

                              // if(this.menu[1].show == false){
                                if(this.methodData.Target_CR == true){
                                  // console.log('now target:'+this.target);
                                  if (this.target <= 1) {
                                    this.process += 50
                                    this.target += 1
                                    this.menu[this.target-1].open = true
                                    this.menu[this.target-1].click = 1
                                  }
                                } else {
                                  if(this.process < 66){
                                    this.process += 33
                                    // console.log('now target:'+this.target);
                                    if (this.target <= 3) {
                                      this.target += 1
                                      this.menu[this.target-1].open = true
                                      this.menu[this.target-1].click = 1
                                    }
                                    // if(this.target == 2){
                                    //   this.target += 1
                                    // }
                                  }
                                }
                              // } else {
                              //   if(this.process < 75){
                              //     this.process += 25
                              //     // console.log('now target:'+this.target);
                              //     if (this.target <= 4) {
                              //       this.target += 1
                              //       this.menu[this.target-1].open = true
                              //       this.menu[this.target-1].click = 1
                              //     }
                              //     // console.log('next target:'+this.target);
                              //   }
                              // }
                              // console.log('next target:'+this.target);
                              document.getElementById('edit_content').scrollTop = 0;

                              //console.log('#9 this.process', this.process);
                              this.getAutoTarget(isMenu);
                            } else {
                              let text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_target_3']['campaign_update']['not_success']['default_swal_text'];
                              if(response.data.info != '' && response.data.info != null){
                                text = response.data.info
                              }
                              Swal.fire(
                                this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_target_3']['campaign_update']['not_success']['swal_title'],
                                text,
                                'error'
                              )
                            }
                          });
                      }
                    } else {
                      axios
                        .post('https://www.autoturn.net/api/data/campaign_update.php', Qs.stringify({
                          s_code: this.$route.params.id,
                          form_data: formData,
                          type: type,
                          target: 'add_next_'+this.target,
                        }))
                        .then((response) => {
                          // console.log(response.data);
                          if(response.data.status == 'success'){
                            // this.immediateList = response.data.return_data
                            // this.formData = response.data.return_data.form

                            // Swal.fire({
                            //   icon: 'success',
                            //   title: '儲存',
                            //   text: response.data.info,
                            //   showDenyButton: false,
                            //   showCancelButton: false,
                            //   confirmButtonText: '確定',
                            //   // denyButtonText: `Don't save`,
                            // }).then((result) => {
                            //   if (result.isConfirmed) {
                            //     // Swal.fire('Saved!', '', 'success')

                            //     // window.location.href = "https://private.autoturn.net/events-list/"+this.$route.params.id+"/"+this.$route.params.adaccount_id;
                            //   } else if (result.isDenied) {
                            //     // Swal.fire('Changes are not saved', '', 'info')
                            //   }
                            // })

                            // if(type == 1){
                            //   var todayForm = new Date();
                            //   var yearForm = todayForm.getFullYear();
                            //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                            //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                            //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                            //   todayForm = yearForm + monthForm + dateForm + timeForm;

                            //   this.formTitle = 'title_'+todayForm;
                            // } else {
                            //   this.formTitle = response.data.return_data.name;
                            // }

                            // this.showModal = true
                            // console.log('發佈 this.target');
                            // console.log(this.target);
                            if(this.target == 3){
                              // console.log('按下一步的發佈');
                              if(response.data.release_status == 'N' && response.data.release_writing_status == 'draft'){
                                // let name = this.campaign_name;
                                // let currency = this.currencyData.currency;
                                // let addition = this.goalsData.form_addition;
                                // let daily_budget = this.methodData.daily_budget;
                                // // let campaignInfo = "依您的預算設定，<br/>在未來兩週將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
                                // // if(addition == '' || addition == 0){
                                // //   campaignInfo = "依您的預算比率與行銷日期設定，<br/>將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
                                // // }

                                // let addition_text = '（預算比率：<span style="color:red; font-weight:bold;">'+addition+'%</span>）';
                                // let two_week_budget = Math.round((daily_budget*7)+(daily_budget*7)+(daily_budget*7*(addition/100)));
                                // let campaignInfo = "依您的預算設定，<br/>在未來兩週將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+"元</span>"+addition_text;
                                // if(this.dateData.end_date != '0000-00-00'){
                                //   two_week_budget = this.total_budget;
                                //   campaignInfo = "依您的預算比率與行銷日期設定，<br/>將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+"元</span>"+addition_text;
                                // }

                                // Swal.fire({
                                //   title: "發佈「"+name+"」",
                                //   html: campaignInfo + "<br/><br/>發佈完成之後，<span style='color:red;'>請勿在facebook廣告後台修改行銷活動設定、受眾資料(AUTOTURN開頭)，若修改到系統便會暫停自動化</span>，您確定要發佈嗎？",
                                //   icon: 'warning',
                                //   showCancelButton: true,
                                //   confirmButtonColor: '#3085d6',
                                //   cancelButtonColor: '#d33',
                                //   confirmButtonText: '是',
                                //   cancelButtonText: '取消',
                                // }).then((result) => {
                                //   if (result.isConfirmed) {
                                //     // console.log(this.$route.params.id);

                                //     this.releaseType = true
                                //     this.style = 'z-index:100;';
                                //     this.releasePercent = 5;
                                //     let status = 1;
                                //     let num = 0;
                                //     let member_hash = this.$route.params.id;
                                //     let adaccount_id = this.adaccount_id
                                //     var bar5 = new ldBar("#myItem5");
                                //     bar5.set(this.releasePercent);

                                //     axios
                                //       .post('https://www.autoturn.net/api/campaign_release.php', Qs.stringify({
                                //         s_code: member_hash,
                                //         campaign_id: this.db_campaign_id,
                                //       }))
                                //       .then((caResponse) => {
                                //         // console.log('caResponse:'+caResponse.data.return_data);
                                //         fbq('trackCustom', 'Release');
                                //         if(caResponse.data.status == 'success'){
                                //           //進行進度條
                                //           // console.log('發佈莞成，開始跑進度條');
                                //           setInterval( () => {
                                //             num++;
                                //             if(num < 1200){
                                //               // console.log('num:'+num);
                                //               // console.log(this.releaseType);

                                //               if(this.releaseType == true){
                                //                 axios
                                //                   .post('https://www.autoturn.net/api/campaign_states.php', Qs.stringify({
                                //                     s_code: member_hash,
                                //                     adaccount_id: this.adaccount_id,
                                //                     campaign_id: this.db_campaign_id,
                                //                   }))
                                //                   .then((csResponse) => {
                                //                     // console.log('csResponse:'+csResponse.data.return_data);
                                //                     //進行進度條
                                //                     if(status == 1){
                                //                       if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'FAILURE'){
                                //                         this.releaseType = false
                                //                         this.style = 'z-index:-1;';
                                //                         bar5.set(0);
                                //                         status = 0;
                                //                         // Swal.fire({
                                //                         //   icon: 'error',
                                //                         //   title: '正式發佈',
                                //                         //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
                                //                         //   showDenyButton: false,
                                //                         //   showCancelButton: false,
                                //                         //   confirmButtonText: '確定',
                                //                         //   timer: 5000
                                //                         //   // denyButtonText: `Don't save`,
                                //                         // }).then((result) => {
                                //                         //   if (result.isConfirmed) {
                                //                         //     // Swal.fire('Saved!', '', 'success')
                                //                         //     this.allPageLoading = true
                                //                         //     window.location.href = "https://private.autoturn.net/events-list/"+member_hash+"/"+adaccount_id;
                                //                         //   } else if (result.isDenied) {
                                //                         //     // Swal.fire('Changes are not saved', '', 'info')
                                //                         //     this.allPageLoading = true
                                //                         //     window.location.href = "https://private.autoturn.net/events-list/"+member_hash+"/"+adaccount_id;
                                //                         //   }

                                //                         //   if (result.dismiss === Swal.DismissReason.timer) {
                                //                         //     this.allPageLoading = true
                                //                         //     window.location.href = "https://private.autoturn.net/events-list/"+member_hash+"/"+adaccount_id;
                                //                         //   }
                                //                         // })
                                //                         Swal.fire({
                                //                           icon: 'error',
                                //                           title: '正式發佈',
                                //                           text: '發佈失敗：'+csResponse.data.return_data.info_text,
                                //                           showDenyButton: false,
                                //                           showCancelButton: false,
                                //                           confirmButtonText: '確定'
                                //                         }).then((result) => {

                                //                         })
                                //                       } else if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'SUCCESS'){
                                //                         status = 0;

                                //                         axios
                                //                           .get('https://www.autoturn.net/udnapi/public/send_notice_email.php?s_code='+member_hash+'&form=release&sr_i='+this.db_campaign_id)
                                //                           .then((csResponse) => {
                                //                             this.releaseType = false

                                //                             Swal.fire({
                                //                               icon: 'success',
                                //                               title: '正式發佈',
                                //                               text: '已發佈完成，將於行銷起始日期的當天00:00正式啟動，5秒後將為您重新整理頁面。',
                                //                               showDenyButton: false,
                                //                               showCancelButton: false,
                                //                               confirmButtonText: '確定',
                                //                               timer: 5000
                                //                               // denyButtonText: `Don't save`,
                                //                             }).then((result) => {
                                //                               /* Read more about isConfirmed, isDenied below */
                                //                               if (result.isConfirmed) {
                                //                                 // Swal.fire('Saved!', '', 'success')
                                //                                 this.allPageLoading = true
                                //                                 window.location.href = "https://private.autoturn.net/events-list/"+member_hash+"/"+adaccount_id;
                                //                               } else if (result.isDenied) {
                                //                                 // Swal.fire('Changes are not saved', '', 'info')
                                //                                 this.allPageLoading = true
                                //                                 window.location.href = "https://private.autoturn.net/events-list/"+member_hash+"/"+adaccount_id;
                                //                               }

                                //                               if (result.dismiss === Swal.DismissReason.timer) {
                                //                                 this.allPageLoading = true
                                //                                 window.location.href = "https://private.autoturn.net/events-list/"+member_hash+"/"+adaccount_id;
                                //                               }
                                //                             })
                                //                           });
                                //                       } else if(csResponse.data.return_data.state == 'FAILURE' && csResponse.data.return_data.info_state == 'FAILURE'){
                                //                         this.releaseType = false
                                //                         this.style = 'z-index:-1;';
                                //                         bar5.set(0);
                                //                         status = 0;
                                //                         // Swal.fire({
                                //                         //   icon: 'error',
                                //                         //   title: '正式發佈',
                                //                         //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
                                //                         //   showDenyButton: false,
                                //                         //   showCancelButton: false,
                                //                         //   confirmButtonText: '確定',
                                //                         //   timer: 5000
                                //                         //   // denyButtonText: `Don't save`,
                                //                         // }).then((result) => {
                                //                         //   /* Read more about isConfirmed, isDenied below */
                                //                         //   if (result.isConfirmed) {
                                //                         //     // Swal.fire('Saved!', '', 'success')
                                //                         //     this.allPageLoading = true
                                //                         //     window.location.href = "https://private.autoturn.net/events-list/"+member_hash+"/"+adaccount_id;
                                //                         //   } else if (result.isDenied) {
                                //                         //     // Swal.fire('Changes are not saved', '', 'info')
                                //                         //     this.allPageLoading = true
                                //                         //     window.location.href = "https://private.autoturn.net/events-list/"+member_hash+"/"+adaccount_id;
                                //                         //   }

                                //                         //   if (result.dismiss === Swal.DismissReason.timer) {
                                //                         //     this.allPageLoading = true
                                //                         //     window.location.href = "https://private.autoturn.net/events-list/"+member_hash+"/"+adaccount_id;
                                //                         //   }
                                //                         // })
                                //                         Swal.fire({
                                //                           icon: 'error',
                                //                           title: '正式發佈',
                                //                           text: '發佈失敗：'+csResponse.data.return_data.info_text,
                                //                           showDenyButton: false,
                                //                           showCancelButton: false,
                                //                           confirmButtonText: '確定'
                                //                         }).then((result) => {

                                //                         })
                                //                       } else {
                                //                         this.releaseText = csResponse.data.return_data.info_text
                                //                         this.releasePercent = csResponse.data.return_data.info_pct

                                //                         bar5.set(this.releasePercent);
                                //                         // console.log('csResponse.data.return_data.info_text:'+csResponse.data.return_data.info_text);
                                //                         // console.log('csResponse.data.return_data.info_pct:'+csResponse.data.return_data.info_pct);
                                //                         // console.log('this.releaseText:'+this.releaseText);
                                //                         // console.log('this.releasePercent:'+this.releasePercent);

                                //                         if(csResponse.data.return_data.info_pct == 100){
                                //                           this.releaseType = false
                                //                           this.style = 'z-index:-1;';
                                //                           bar5.set(0);
                                //                           status = 0;
                                //                         }
                                //                       }
                                //                     }
                                //                   });
                                //               }
                                //             } else {
                                //               Swal.fire({
                                //                 icon: 'warning',
                                //                 title: '正式發佈',
                                //                 text: '將為您重新整理頁面。',
                                //                 showDenyButton: false,
                                //                 showCancelButton: false,
                                //                 confirmButtonText: '確定',
                                //                 timer: 1000
                                //                 // denyButtonText: `Don't save`,
                                //               }).then((result) => {
                                //                 /* Read more about isConfirmed, isDenied below */
                                //                 if (result.isConfirmed) {
                                //                   // Swal.fire('Saved!', '', 'success')
                                //                   this.allPageLoading = true
                                //                   window.location.href = "https://private.autoturn.net/events-list/"+member_hash+"/"+adaccount_id;
                                //                 } else if (result.isDenied) {
                                //                   // Swal.fire('Changes are not saved', '', 'info')
                                //                   this.allPageLoading = true
                                //                   window.location.href = "https://private.autoturn.net/events-list/"+member_hash+"/"+adaccount_id;
                                //                 }

                                //                 if (result.dismiss === Swal.DismissReason.timer) {
                                //                   this.allPageLoading = true
                                //                   window.location.href = "https://private.autoturn.net/events-list/"+member_hash+"/"+adaccount_id;
                                //                 }
                                //               })
                                //             }
                                //           }, 3000);
                                //         }
                                //       });
                                //   }
                                // })
                                this.release();
                              } else {
                                Swal.fire(
                                  this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['not_lead_messages']['campaign_update']['success']['swal_title'],
                                  response.data.info,
                                  'error'
                                )
                              }
                            }

                            // console.log('333222發佈 this.target');
                            // console.log(this.target);

                            // if(this.menu[1].show == false){
                              if(this.methodData.Target_CR == true){
                                // console.log('now target:'+this.target);
                                if (this.target <= 1) {
                                  this.process += 50
                                  this.target += 1
                                  this.menu[this.target-1].open = true
                                  this.menu[this.target-1].click = 1
                                }
                              } else {
                                if(this.process < 66){
                                  this.process += 33
                                  // console.log('now target:'+this.target);
                                  if (this.target <= 3) {
                                    this.target += 1
                                    this.menu[this.target-1].open = true
                                    this.menu[this.target-1].click = 1
                                  }
                                  // if(this.target == 2){
                                  //   this.target += 1
                                  // }
                                }
                              }
                            // } else {
                            //   if(this.process < 75){
                            //     this.process += 25
                            //     // console.log('now target:'+this.target);
                            //     if (this.target <= 4) {
                            //       this.target += 1
                            //       this.menu[this.target-1].open = true
                            //       this.menu[this.target-1].click = 1
                            //     }
                            //     // console.log('next target:'+this.target);
                            //   }
                            // }
                            // console.log('next target:'+this.target);
                            document.getElementById('edit_content').scrollTop = 0;

                            //console.log('#10 this.process', this.process);
                            this.getAutoTarget(isMenu);
                          } else {
                            let text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['not_lead_messages']['campaign_update']['not_success']['default_swal_text'];
                            if(response.data.info != '' && response.data.info != null){
                              text = response.data.info
                            }
                            Swal.fire(
                              this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['not_lead_messages']['campaign_update']['not_success']['swal_title'],
                              text,
                              'error'
                            )
                          }
                        });
                    }
                  }
                }

                if(caResponse.data.status == 'login'){
                  Swal.fire({
                    icon: 'error',
                    title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['login']['swal_title'],
                    text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['login']['swal_text'],
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['login']['confirm_button']
                    // denyButtonText: `Don't save`,
                  }).then((result) => {
                    /* Read more about isConfirmed, isDenied below */
                    if (result.isConfirmed) {
                      // Swal.fire('Saved!', '', 'success')
                      // this.allPageLoading = true
                      window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
                    } else if (result.isDenied) {
                      // Swal.fire('Changes are not saved', '', 'info')
                      // this.allPageLoading = true
                      window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
                    }
                  })
                }
              });
          }
        }
      },
      async form_update(){
        // console.log('form_update');
        let isTrue = 1;

        this.changeYoutubeType();
        this.clearLookalikeForSpecialAdCategory();
        if (!this.validateBudgetTypeAndSpecialAdCategory()) {
          return
        }

        // if(isTrue == 1){
        let member_hash = this.$route.params.id
        let adaccount_id = this.$route.params.adaccount_id

        if(this.nextLoading == false){
          this.nextLoading = true;
          this.showCampaignData = false;

          if(this.methodData.Target_CR == true || this.methodData.Other_Target_CR == true || this.useDefaultLayout !== null){
            let _tmpSubCampaignsContentLength = this.customRulesData.subCampaignsContent.length;
            let _stageData = [];
            let _tableData = [];
            let _campaign_writing_status = [];
            let isTrue = 1;
            let member_hash = this.$route.params.id;
            const promises = [];

            for(let i = 0; i < _tmpSubCampaignsContentLength; i++){
              let _tmpFormData = [];

              if(this.customRulesData.subCampaignsContent[i].method == 'META_TEST' && this.customRulesData.haveTest == true){
                // _tmpFormData['PreStage'] = [];
                _tmpFormData['ThisStage'] = this.customRulesData.subCampaignsContent[i];
              } else {
                let PreIndex = i - parseInt(1);
                // _tmpFormData['PreStage'] = this.customRulesData.subCampaignsContent[PreIndex];
                _tmpFormData['ThisStage'] = this.customRulesData.subCampaignsContent[i];
              }

              const promise = axios.post('https://www.autoturn.net/api/data/campaign_subset_update_dev.php', Qs.stringify({
                s_code: this.$route.params.id,
                adaccount_id: this.$route.params.adaccount_id,
                date: this.dateData,
                stage: i,
                benefitsAndInvestmentData: this.benefitsAndInvestmentData,
                useDoForward: this.doForwardData.useDoForward,
                sub_length: _tmpSubCampaignsContentLength,
                haveTest: this.customRulesData.haveTest,
                campaign_id: this.db_campaign_id,
                form_data: _tmpFormData,
              }))
              .then((response) => {
                if (response.data.status === 'success') {
              //  console.log('campaign_subset_update response');
              //  console.log(response);

                  // 正确更新 stageData 和 _campaign_writing_status
                  // Vue.set(this.customRulesData.subCampaignsContent[i].release, 'sr_i', parseInt(response.data.campaign_id));
                  this.customRulesData.subCampaignsContent[i].release.sr_i = parseInt(response.data.campaign_id);

                  if (response.data.campaign_id) {
                    _stageData[i] = parseInt(response.data.campaign_id);
                  }

                  _campaign_writing_status[i] = response.data.campaign_writing_status;
                }
              })
              .catch((error) => {
                // console.error(`Error in form_update stage ${i}:`, error);
              });

              promises.push(promise); // 將 promise 加入數組

              // axios
              //   .post('https://www.autoturn.net/api/data/campaign_subset_update_dev.php', Qs.stringify({
              //     s_code: this.$route.params.id,
              //     adaccount_id: this.$route.params.adaccount_id,
              //     date: this.dateData,
              //     stage: i,
              //     sub_length: _tmpSubCampaignsContentLength,
              //     haveTest: this.customRulesData.haveTest,
              //     form_data: _tmpFormData,
              //   }))
              //   .then((response) => {
              //     if(response.data.status == 'success'){
              //   //  console.log('campaign_subset_update response');
              //   //  console.log(response);
              //       this.customRulesData.subCampaignsContent[i].release.sr_i = parseInt(response.data.campaign_id);
              //       if(response.data.campaign_id != '' && response.data.campaign_id != null && typeof response.data.campaign_id != 'undefined'){
              //         _stageData[i] = parseInt(response.data.campaign_id);
              //       }

              //       _campaign_writing_status[i] = response.data.campaign_writing_status;

              //       let doIndex = i + parseInt(1);

              //   //  console.log('doIndex');
              //   //  console.log(doIndex);

              //       if(doIndex == _tmpSubCampaignsContentLength){
              //     //  console.log(_stageData);
              //     //  console.log(_stageData.length +'=='+ _tmpSubCampaignsContentLength);

              //         if(_stageData.length == _tmpSubCampaignsContentLength){
              //           const hasKey = _campaign_writing_status.some(item => item === 'key');

              //           let campaign_writing_status = 'draft';
              //           if(hasKey == true){
              //             campaign_writing_status = 'key';
              //           }

              //           axios
              //             .post('https://www.autoturn.net/api/campaign_member_status.php', Qs.stringify({
              //               s_code: member_hash,
              //               route_type: this.$route.params.type,
              //               active: 'add',
              //             }))
              //             .then((caResponse) => {

              //               if(caResponse.data.status == 'error'){
              //                 if(caResponse.data.type == 2){
              //                   Swal.fire({
              //                     icon: caResponse.data.status,
              //                     title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['error']['swal_title'],
              //                     text: caResponse.data.info,
              //                     showDenyButton: false,
              //                     showCancelButton: false,
              //                     confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['error']['confirm_button']
              //                     // denyButtonText: `Don't save`,
              //                   }).then((result) => {
              //                     if (result.isConfirmed) {
              //                       // Swal.fire('Saved!', '', 'success')
              //                       this.allPageLoading = true
              //                       window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                     } else if (result.isDenied) {
              //                       // Swal.fire('Changes are not saved', '', 'info')
              //                       this.allPageLoading = true
              //                       window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                     }
              //                   })
              //                 } else if(caResponse.data.type == 3){
              //                   Swal.fire({
              //                     icon: caResponse.data.status,
              //                     title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['error']['swal_title'],
              //                     text: caResponse.data.info,
              //                     showDenyButton: false,
              //                     showCancelButton: false,
              //                     confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['error']['confirm_button']
              //                     // denyButtonText: `Don't save`,
              //                   }).then((result) => {
              //                     if (result.isConfirmed) {
              //                       // Swal.fire('Saved!', '', 'success')
              //                       this.allPageLoading = true
              //                       window.location.href = "https://private.autoturn.net/f/"+member_hash;
              //                     } else if (result.isDenied) {
              //                       // Swal.fire('Changes are not saved', '', 'info')
              //                       this.allPageLoading = true
              //                       window.location.href = "https://private.autoturn.net/f/"+member_hash;
              //                     }
              //                   })
              //                 } else {
              //                   Swal.fire(
              //                             this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['error']['swal_title'],
              //                             caResponse.data.info,
              //                             caResponse.data.status
              //                           )
              //                 }
              //               }

              //               if(caResponse.data.status == 'warning'){
              //                 Swal.fire({
              //                   icon: 'warning',
              //                   title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['swal_title'],
              //                   text: caResponse.data.info,
              //                   showDenyButton: false,
              //                   showCancelButton: false,
              //                   confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['confirm_button']
              //                   // denyButtonText: `Don't save`,
              //                 }).then((result) => {
              //                   if(this.db_campaign_id == null || this.db_campaign_id == '' || typeof this.db_campaign_id == 'undefined'){
              //                     var daily_keyword_split_budget = this.methodData.Budget_KW;
              //                     var daily_demo_budget = this.methodData.Budget_DM;
              //                     var budget_addition = this.goalsData.form_addition;

              //                     if(this.dateData.start_date != "" && this.dateData.end_date != ""){
              //                         var d1 = new Date(this.dateData.start_date);
              //                         var d2 = new Date(this.dateData.end_date);
              //                         var days = parseInt((d2-d1)/86400000) + parseInt(1);
              //                     } else {
              //                         var days = 0;
              //                     }

              //                     var keyword_split_budget = 0;
              //                     if(this.methodData.Budget_KW != ''){
              //                         keyword_split_budget = Math.round(this.methodData.Budget_KW * days * (1+(budget_addition/100)));
              //                     }

              //                     var demo_budget = 0;
              //                     if(this.methodData.Budget_DM != ''){
              //                         demo_budget = this.methodData.Budget_DM * days;
              //                     }

              //                     var _tmp_audience_budget = 0;
              //                     var audience_budget = 0;
              //                     // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.5)');
              //                     _tmp_audience_budget = this.methodData.Budget_LA;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.5);
              //                     // console.log('Math.round('+_tmp_audience_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
              //                     audience_budget = Math.round(_tmp_audience_budget * days * (1+(budget_addition/100)));

              //                     var _tmp_marketing_again_budget = 0;
              //                     var marketing_again_budget = 0;
              //                     // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.25)');
              //                     _tmp_marketing_again_budget = this.methodData.Budget_RT;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.25);
              //                     // console.log('Math.round('+_tmp_marketing_again_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
              //                     marketing_again_budget = Math.round(_tmp_marketing_again_budget * days * (1+(budget_addition/100)));

              //                     // console.log(parseInt(keyword_split_budget)+' + '+parseInt(demo_budget)+' + '+parseInt(audience_budget)+' + '+parseInt(marketing_again_budget));
              //                     var ac_budget = 0;
                    if(this.methodData.Budget_AC != '' && this.methodData.Budget_AC != 0){
                        ac_budget = Math.round(this.methodData.Budget_AC * days);
                    }
                    var html = parseInt(keyword_split_budget) + parseInt(demo_budget) + parseInt(audience_budget) + parseInt(marketing_again_budget) + parseInt(ac_budget);

              //                     if(isNaN(html)){
              //                         html = '0';
              //                     }

              //                     this.total_budget = html;

              //                     let _tmp_goalsData = this.goalsData;
              //                     const _view_goalsData = JSON.parse(JSON.stringify(_tmp_goalsData));
              //                     let _tmp_exAudiencesData = this.exAudiencesData;
              //                     const _view_exAudiencesData = JSON.parse(JSON.stringify(_tmp_exAudiencesData));

              //                     // console.log(_tmp_exAudiencesData);

              //                     delete _view_goalsData['objective_list'];
              //                     delete _view_exAudiencesData['custom_excluded_audiences'];

              //                     let formData = {
              //                       campaign_name: this.campaign_name,
              //                       adaccount_id: this.adaccount_id,
              //                       Budget_KW_result: this.Budget_KW_result,
              //                       total_budget: this.total_budget,
              //                       dynBudgetData: this.dynBudgetData,
              //                       methodData: this.methodData,
              //                       benefitsAndInvestmentData: this.benefitsAndInvestmentData,
              //                       dateData: this.dateData,
              //                       keywordData: this.keywordData,
              //                       lookData: this.lookData,
              //                       audiencesData: this.audiencesData,
              //                       goalsData: _view_goalsData,
              //                       regionsData: this.regionsData,
              //                       selectCountries: this.selectCountries,
              //                       selectLangs: this.selectLangs,
              //                       exAudiencesData: _view_exAudiencesData,
              //                       pdData: this.pdData,
              //                       idData: this.idData,
              //                       postData: this.postData,
              //                       adMaterialData: this.adMaterialDataNew,
              //                       stageData: _stageData
              //                     }

              //                     axios
              //                       .post('https://www.autoturn.net/api/data/campaign_add_update.php', Qs.stringify({
              //                         s_code: this.$route.params.id,
              //                         form_data: formData,
              //                       }))
              //                       .then((response) => {
              //                         // console.log(response.data);

              //                         if(response.data.status == 'success'){
              //                           this.db_campaign_id = response.data.campaign_id
              //                           axios
              //                             .post('https://www.autoturn.net/api/data/teaching_update.php', Qs.stringify({
              //                               s_code: this.$route.params.id,
              //                               id: this.teaching_id,
              //                               campaign_id: this.db_campaign_id,
              //                               campaign_objective: '',
              //                               skip: '',
              //                               step: '',
              //                               active: 'campaign_id'
              //                             }));

              //                           ////////////////
              //                           Swal.fire({
              //                             icon: 'success',
              //                             title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['swal_title'],
              //                             text: response.data.info,
              //                             showDenyButton: false,
              //                             showCancelButton: false,
              //                             confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['confirm_button'],
              //                             // denyButtonText: `Don't save`,
              //                           }).then((result) => {
              //                             /* Read more about isConfirmed, isDenied below */
              //                             if (result.isConfirmed) {
              //                               // Swal.fire('Saved!', '', 'success')

              //                               window.location.href = "https://private.autoturn.net/events-list/f/"+this.$route.params.id+"/"+this.$route.params.adaccount_id;
              //                             } else if (result.isDenied) {
              //                               // Swal.fire('Changes are not saved', '', 'info')
              //                             }
              //                           })
              //                         } else {
              //                           let text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['empty_campaign_id']['swal_text'];
              //                           if(response.data.info != '' && response.data.info != null){
              //                             text = response.data.info
              //                           }
              //                           Swal.fire(
              //                             this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['empty_campaign_id']['swal_title'],
              //                             text,
              //                             'error'
              //                           )
              //                         }
              //                       });
              //                   } else {
              //                     var daily_keyword_split_budget = this.methodData.Budget_KW;
              //                     var daily_demo_budget = this.methodData.Budget_DM;
              //                     var budget_addition = this.goalsData.form_addition;

              //                     if(this.dateData.start_date != "" && this.dateData.end_date != ""){
              //                         var d1 = new Date(this.dateData.start_date);
              //                         var d2 = new Date(this.dateData.end_date);
              //                         var days = parseInt((d2-d1)/86400000) + parseInt(1);
              //                     } else {
              //                         var days = 0;
              //                     }

              //                     var keyword_split_budget = 0;
              //                     if(this.methodData.Budget_KW != ''){
              //                         keyword_split_budget = Math.round(this.methodData.Budget_KW * days * (1+(budget_addition/100)));
              //                     }

              //                     var demo_budget = 0;
              //                     if(this.methodData.Budget_DM != ''){
              //                         demo_budget = this.methodData.Budget_DM * days;
              //                     }

              //                     var _tmp_audience_budget = 0;
              //                     var audience_budget = 0;
              //                     // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.5)');
              //                     _tmp_audience_budget = this.methodData.Budget_LA;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.5);
              //                     // console.log('Math.round('+_tmp_audience_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
              //                     audience_budget = Math.round(_tmp_audience_budget * days * (1+(budget_addition/100)));

              //                     var _tmp_marketing_again_budget = 0;
              //                     var marketing_again_budget = 0;
              //                     // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.25)');
              //                     _tmp_marketing_again_budget = this.methodData.Budget_RT;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.25);
              //                     // console.log('Math.round('+_tmp_marketing_again_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
              //                     marketing_again_budget = Math.round(_tmp_marketing_again_budget * days * (1+(budget_addition/100)));

              //                     // console.log(parseInt(keyword_split_budget)+' + '+parseInt(demo_budget)+' + '+parseInt(audience_budget)+' + '+parseInt(marketing_again_budget));
              //                     var ac_budget = 0;
                    if(this.methodData.Budget_AC != '' && this.methodData.Budget_AC != 0){
                        ac_budget = Math.round(this.methodData.Budget_AC * days);
                    }
                    var html = parseInt(keyword_split_budget) + parseInt(demo_budget) + parseInt(audience_budget) + parseInt(marketing_again_budget) + parseInt(ac_budget);

              //                     if(isNaN(html)){
              //                         html = '0';
              //                     }

              //                     this.total_budget = html;

              //                     let _tmp_goalsData = this.goalsData;
              //                     const _view_goalsData = JSON.parse(JSON.stringify(_tmp_goalsData));
              //                     let _tmp_exAudiencesData = this.exAudiencesData;
              //                     const _view_exAudiencesData = JSON.parse(JSON.stringify(_tmp_exAudiencesData));

              //                     // console.log(_tmp_exAudiencesData);

              //                     delete _view_goalsData['objective_list'];
              //                     delete _view_exAudiencesData['custom_excluded_audiences'];

              //                     let formData = {
              //                       campaign_id: this.db_campaign_id,
              //                       campaign_name: this.campaign_name,
              //                       adaccount_id: this.adaccount_id,
              //                       Budget_KW_result: this.Budget_KW_result,
              //                       total_budget: this.total_budget,
              //                       dynBudgetData: this.dynBudgetData,
              //                       methodData: this.methodData,
              //                       benefitsAndInvestmentData: this.benefitsAndInvestmentData,
              //                       dateData: this.dateData,
              //                       keywordData: this.keywordData,
              //                       lookData: this.lookData,
              //                       audiencesData: this.audiencesData,
              //                       goalsData: _view_goalsData,
              //                       regionsData: this.regionsData,
              //                       selectCountries: this.selectCountries,
              //                       selectLangs: this.selectLangs,
              //                       exAudiencesData: _view_exAudiencesData,
              //                       pdData: this.pdData,
              //                       idData: this.idData,
              //                       postData: this.postData,
              //                       adMaterialData: this.adMaterialDataNew,
              //                       stageData: _stageData
              //                     }

              //                     // console.log('a this.adMaterialDataNew');
              //                     // console.log(this.adMaterialDataNew);

              //                     if(this.goalsData.campaign_objective == 'LEAD_GENERATION' || this.goalsData.campaign_objective == 'MESSAGES'){
              //                       // console.log('#1');
              //                       let materialType = 0;
              //                       let selectArticleLength = 0;
              //                       if(this.postData.select_article != '' && this.postData.select_article != null && typeof this.postData.select_article != 'undefined'){
              //                         selectArticleLength = this.postData.select_article.length;
              //                       }

              //                       let selectCreativesMessageLength = 0;
              //                       if(this.postData.select_creatives_message != '' && this.postData.select_creatives_message != null && typeof this.postData.select_creatives_message != 'undefined'){
              //                         selectCreativesMessageLength = this.postData.select_creatives_message.length;
              //                       }

              //                       let selectCreativesAdsetAdsMessageLength = 0;
              //                       if(this.postData.select_creatives_adset_ads_message != '' && this.postData.select_creatives_adset_ads_message != null && typeof this.postData.select_creatives_adset_ads_message != 'undefined'){
              //                         selectCreativesAdsetAdsMessageLength = this.postData.select_creatives_adset_ads_message.length;
              //                       }

              //                       let creativeArrayLength = 0;
              //                       if(this.adMaterialDataNew.creative_array != '' && this.adMaterialDataNew.creative_array != null && typeof this.adMaterialDataNew.creative_array != 'undefined'){
              //                         creativeArrayLength = this.adMaterialDataNew.creative_array.length;
              //                       }

              //                       if(creativeArrayLength == 0 && (!this.postData.select_creatives || this.postData.select_creatives.length == 0) && selectArticleLength == 0 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
              //                         materialType = 1;
              //                       } else if(selectArticleLength == 0 && selectCreativesMessageLength == 0 && selectCreativesAdsetAdsMessageLength == 0 && creativeArrayLength == 0 && this.goalsData.campaign_objective == 'MESSAGES'){
              //                         materialType = 2;
              //                       }

              //                       if(materialType == 0){
              //                         // console.log('#2');
              //                         // let message_sr_i = 0;
              //                         // let form_sr_i = 0;
              //                         // let message = 0;
              //                         // let single_object_spec = 0;
              //                         // let single_title = 0;
              //                         // let materials_item = 0;
              //                         // let materials_object_spec = 0;
              //                         // let materials_title = 0;
              //                         // let ad_name = 0;

              //                         // for(let i = 0; i < creativeArrayLength; i++){
              //                         //   if(this.adMaterialDataNew.creative_array[i].title == '' || this.adMaterialDataNew.creative_array[i].title == null || typeof this.adMaterialDataNew.creative_array[i].title == 'undefined'){
              //                         //     ad_name = 1;
              //                         //   }

              //                         //   if(this.adMaterialDataNew.creative_array[i].type == 2){
              //                         //     let materials_length = this.adMaterialDataNew.creative_array[i].materials.length

              //                         //     if(materials_length < 2){
              //                         //       materials_item = 1;
              //                         //     } else {
              //                         //       for(let j = 0; j < materials_length; j++){
              //                         //         if(this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == '' || this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == null || typeof this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == 'undefined'){
              //                         //           materials_object_spec = 1;
              //                         //         }

              //                         //         if(this.adMaterialDataNew.creative_array[i].materials[j].title == '' || this.adMaterialDataNew.creative_array[i].materials[j].title == null || typeof this.adMaterialDataNew.creative_array[i].materials[j].title == 'undefined'){
              //                         //           materials_title = 1;
              //                         //         }
              //                         //       }
              //                         //     }
              //                         //   }

              //                         //   if(this.adMaterialDataNew.creative_array[i].type == 1){
              //                         //     if(this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == '' || this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == null || typeof this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == 'undefined'){
              //                         //       single_object_spec = 1;
              //                         //     }

              //                         //     if(this.adMaterialDataNew.creative_array[i].materialSingle[0].title == '' || this.adMaterialDataNew.creative_array[i].materialSingle[0].title == null || typeof this.adMaterialDataNew.creative_array[i].materialSingle[0].title == 'undefined'){
              //                         //       single_title = 1;
              //                         //     }
              //                         //   }

              //                         //   if(this.adMaterialDataNew.creative_array[i].message == '' || this.adMaterialDataNew.creative_array[i].message == null || typeof this.adMaterialDataNew.creative_array[i].message == 'undefined'){
              //                         //     message = 1;
              //                         //   }

              //                         //   if(this.adMaterialDataNew.creative_array[i].form_sr_i == '' || this.adMaterialDataNew.creative_array[i].form_sr_i == null || typeof this.adMaterialDataNew.creative_array[i].form_sr_i == 'undefined'){
              //                         //     form_sr_i = 1;
              //                         //   }

              //                         //   if(this.adMaterialDataNew.creative_array[i].message_sr_i == '' || this.adMaterialDataNew.creative_array[i].message_sr_i == null || typeof this.adMaterialDataNew.creative_array[i].message_sr_i == 'undefined'){
              //                         //     message_sr_i = 1;
              //                         //   }
              //                         // }

              //                         // if(ad_name == 1){
              //                         //   Swal.fire(
              //                         //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['swal_title'],
              //                         //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['not_ad_name_swal_text'],
              //                         //               "error"
              //                         //             )
              //                         // } else if(single_object_spec == 1){
              //                         //   Swal.fire(
              //                         //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['swal_title'],
              //                         //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['not_single_object_spec_swal_text'],
              //                         //               "error"
              //                         //             )
              //                         // } else if(single_title == 1){
              //                         //   Swal.fire(
              //                         //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['swal_title'],
              //                         //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['not_single_title_swal_text'],
              //                         //               "error"
              //                         //             )
              //                         // } else if(materials_item == 1){
              //                         //   Swal.fire(
              //                         //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['swal_title'],
              //                         //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['not_materials_item_swal_text'],
              //                         //               "error"
              //                         //             )
              //                         // } else if(materials_object_spec == 1){
              //                         //   Swal.fire(
              //                         //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['swal_title'],
              //                         //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['not_materials_object_spec_swal_text'],
              //                         //               "error"
              //                         //             )
              //                         // } else if(materials_title == 1){
              //                         //   Swal.fire(
              //                         //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['swal_title'],
              //                         //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['not_materials_title_swal_text'],
              //                         //               "error"
              //                         //             )
              //                         // } else if(message == 1){
              //                         //   Swal.fire(
              //                         //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['swal_title'],
              //                         //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['not_message_swal_text'],
              //                         //               "error"
              //                         //             )
              //                         // } else if(form_sr_i == 1 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
              //                         //   Swal.fire(
              //                         //             this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['swal_title'],
              //                         //             this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['not_form_sr_i_swal_text'],
              //                         //             "error"
              //                         //           )
              //                         // } else if(message_sr_i == 1 && this.goalsData.campaign_objective == 'MESSAGES'){
              //                         //   Swal.fire(
              //                         //             this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['swal_title'],
              //                         //             this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['not_message_sr_i_swal_text'],
              //                         //             "error"
              //                         //           )
              //                         // } else {
              //                           // console.log('#5');
              //                           axios
              //                             .post('https://www.autoturn.net/api/data/campaign_update.php', Qs.stringify({
              //                               s_code: this.$route.params.id,
              //                               form_data: formData,
              //                               type: 'finish',
              //                               target: 'add_update_'+this.target,
              //                               CT_writing_status: campaign_writing_status,
              //                             }))
              //                             .then((response) => {
              //                               // console.log(response.data);
              //                               if(response.data.status == 'success'){
              //                                 // this.immediateList = response.data.return_data
              //                                 // this.formData = response.data.return_data.form

              //                                 Swal.fire({
              //                                   icon: 'success',
              //                                   title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['campaign_update']['success']['swal_title'],
              //                                   text: response.data.info,
              //                                   showDenyButton: false,
              //                                   showCancelButton: false,
              //                                   confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['campaign_update']['success']['confirm_button'],
              //                                   // denyButtonText: `Don't save`,
              //                                 }).then((result) => {
              //                                   /* Read more about isConfirmed, isDenied below */
              //                                   if (result.isConfirmed) {
              //                                     // Swal.fire('Saved!', '', 'success')

              //                                     window.location.href = "https://private.autoturn.net/events-list/f/"+this.$route.params.id+"/"+this.$route.params.adaccount_id;
              //                                   } else if (result.isDenied) {
              //                                     // Swal.fire('Changes are not saved', '', 'info')
              //                                   }
              //                                 })

              //                                 // if(type == 1){
              //                                 //   var todayForm = new Date();
              //                                 //   var yearForm = todayForm.getFullYear();
              //                                 //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
              //                                 //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
              //                                 //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

              //                                 //   todayForm = yearForm + monthForm + dateForm + timeForm;

              //                                 //   this.formTitle = 'title_'+todayForm;
              //                                 // } else {
              //                                 //   this.formTitle = response.data.return_data.name;
              //                                 // }

              //                                 // this.showModal = true
              //                               } else {
              //                                 let text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['campaign_update']['not_success']['default_swal_text'];
              //                                 if(response.data.info != '' && response.data.info != null){
              //                                   text = response.data.info
              //                                 }
              //                                 Swal.fire(
              //                                   this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['campaign_update']['not_success']['swal_title'],
              //                                   text,
              //                                   'error'
              //                                 )
              //                               }
              //                             });
              //                         // }
              //                       } else {
              //                         // console.log('#3');
              //                         Swal.fire(
              //                                     this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['not_creative_array_swal_title'],
              //                                     this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['not_creative_array_swal_text'],
              //                                     "error"
              //                                   )
              //                       }
              //                     } else {
              //                       axios
              //                         .post('https://www.autoturn.net/api/data/campaign_update.php', Qs.stringify({
              //                           s_code: this.$route.params.id,
              //                           form_data: formData,
              //                           type: 'finish',
              //                           target: 'add_update_'+this.target,
              //                           CT_writing_status: campaign_writing_status,
              //                         }))
              //                         .then((response) => {
              //                           // console.log(response.data);
              //                           if(response.data.status == 'success'){
              //                             // this.immediateList = response.data.return_data
              //                             // this.formData = response.data.return_data.form

              //                             Swal.fire({
              //                               icon: 'success',
              //                               title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['not_lead_messages']['campaign_update']['success']['swal_title'],
              //                               text: response.data.info,
              //                               showDenyButton: false,
              //                               showCancelButton: false,
              //                               confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['not_lead_messages']['campaign_update']['success']['confirm_button'],
              //                               // denyButtonText: `Don't save`,
              //                             }).then((result) => {
              //                               /* Read more about isConfirmed, isDenied below */
              //                               if (result.isConfirmed) {
              //                                 // Swal.fire('Saved!', '', 'success')

              //                                 window.location.href = "https://private.autoturn.net/events-list/f/"+this.$route.params.id+"/"+this.$route.params.adaccount_id;
              //                               } else if (result.isDenied) {
              //                                 // Swal.fire('Changes are not saved', '', 'info')
              //                               }
              //                             })

              //                             // if(type == 1){
              //                             //   var todayForm = new Date();
              //                             //   var yearForm = todayForm.getFullYear();
              //                             //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
              //                             //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
              //                             //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

              //                             //   todayForm = yearForm + monthForm + dateForm + timeForm;

              //                             //   this.formTitle = 'title_'+todayForm;
              //                             // } else {
              //                             //   this.formTitle = response.data.return_data.name;
              //                             // }

              //                             // this.showModal = true
              //                           } else {
              //                             let text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['not_lead_messages']['campaign_update']['not_success']['default_swal_text'];
              //                             if(response.data.info != '' && response.data.info != null){
              //                               text = response.data.info
              //                             }
              //                             Swal.fire(
              //                               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['not_lead_messages']['campaign_update']['not_success']['swal_title'],
              //                               text,
              //                               'error'
              //                             )
              //                           }
              //                         });
              //                     }
              //                   }
              //                 });
              //               }

              //               if(caResponse.data.status == 'success'){
              //                 if(this.db_campaign_id == null || this.db_campaign_id == '' || typeof this.db_campaign_id == 'undefined'){
              //                   var daily_keyword_split_budget = this.methodData.Budget_KW;
              //                   var daily_demo_budget = this.methodData.Budget_DM;
              //                   var budget_addition = this.goalsData.form_addition;

              //                   if(this.dateData.start_date != "" && this.dateData.end_date != ""){
              //                       var d1 = new Date(this.dateData.start_date);
              //                       var d2 = new Date(this.dateData.end_date);
              //                       var days = parseInt((d2-d1)/86400000) + parseInt(1);
              //                   } else {
              //                       var days = 0;
              //                   }

              //                   var keyword_split_budget = 0;
              //                   if(this.methodData.Budget_KW != ''){
              //                       keyword_split_budget = Math.round(this.methodData.Budget_KW * days * (1+(budget_addition/100)));
              //                   }

              //                   var demo_budget = 0;
              //                   if(this.methodData.Budget_DM != ''){
              //                       demo_budget = this.methodData.Budget_DM * days;
              //                   }

              //                   var _tmp_audience_budget = 0;
              //                   var audience_budget = 0;
              //                   // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.5)');
              //                   _tmp_audience_budget = this.methodData.Budget_LA;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.5);
              //                   // console.log('Math.round('+_tmp_audience_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
              //                   audience_budget = Math.round(_tmp_audience_budget * days * (1+(budget_addition/100)));

              //                   var _tmp_marketing_again_budget = 0;
              //                   var marketing_again_budget = 0;
              //                   // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.25)');
              //                   _tmp_marketing_again_budget = this.methodData.Budget_RT;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.25);
              //                   // console.log('Math.round('+_tmp_marketing_again_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
              //                   marketing_again_budget = Math.round(_tmp_marketing_again_budget * days * (1+(budget_addition/100)));

              //                   // console.log(parseInt(keyword_split_budget)+' + '+parseInt(demo_budget)+' + '+parseInt(audience_budget)+' + '+parseInt(marketing_again_budget));
              //                   var ac_budget = 0;
                  if(this.methodData.Budget_AC != '' && this.methodData.Budget_AC != 0){
                      ac_budget = Math.round(this.methodData.Budget_AC * days);
                  }
                  var html = parseInt(keyword_split_budget) + parseInt(demo_budget) + parseInt(audience_budget) + parseInt(marketing_again_budget) + parseInt(ac_budget);

              //                   if(isNaN(html)){
              //                       html = '0';
              //                   }

              //                   this.total_budget = html;

              //                   let _tmp_goalsData = this.goalsData;
              //                   const _view_goalsData = JSON.parse(JSON.stringify(_tmp_goalsData));
              //                   let _tmp_exAudiencesData = this.exAudiencesData;
              //                   const _view_exAudiencesData = JSON.parse(JSON.stringify(_tmp_exAudiencesData));

              //                   // console.log(_tmp_exAudiencesData);

              //                   delete _view_goalsData['objective_list'];
              //                   delete _view_exAudiencesData['custom_excluded_audiences'];

              //                   let formData = {
              //                     campaign_name: this.campaign_name,
              //                     adaccount_id: this.adaccount_id,
              //                     Budget_KW_result: this.Budget_KW_result,
              //                     total_budget: this.total_budget,
              //                     dynBudgetData: this.dynBudgetData,
              //                     methodData: this.methodData,
              //                     benefitsAndInvestmentData: this.benefitsAndInvestmentData,
              //                     dateData: this.dateData,
              //                     keywordData: this.keywordData,
              //                     lookData: this.lookData,
              //                     audiencesData: this.audiencesData,
              //                     goalsData: _view_goalsData,
              //                     regionsData: this.regionsData,
              //                     selectCountries: this.selectCountries,
              //                     selectLangs: this.selectLangs,
              //                     exAudiencesData: _view_exAudiencesData,
              //                     pdData: this.pdData,
              //                     idData: this.idData,
              //                     postData: this.postData,
              //                     adMaterialData: this.adMaterialDataNew,
              //                     stageData: _stageData
              //                   }

              //                   axios
              //                     .post('https://www.autoturn.net/api/data/campaign_add_update.php', Qs.stringify({
              //                       s_code: this.$route.params.id,
              //                       form_data: formData,
              //                     }))
              //                     .then((response) => {
              //                       // console.log(response.data);

              //                       if(response.data.status == 'success'){
              //                         this.db_campaign_id = response.data.campaign_id
              //                         axios
              //                           .post('https://www.autoturn.net/api/data/teaching_update.php', Qs.stringify({
              //                             s_code: this.$route.params.id,
              //                             id: this.teaching_id,
              //                             campaign_id: this.db_campaign_id,
              //                             campaign_objective: '',
              //                             skip: '',
              //                             step: '',
              //                             active: 'campaign_id'
              //                           }));

              //                         Swal.fire({
              //                           icon: 'success',
              //                           title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['swal_title'],
              //                           text: response.data.info,
              //                           showDenyButton: false,
              //                           showCancelButton: false,
              //                           confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['confirm_button'],
              //                           // denyButtonText: `Don't save`,
              //                         }).then((result) => {
              //                           /* Read more about isConfirmed, isDenied below */
              //                           if (result.isConfirmed) {
              //                             // Swal.fire('Saved!', '', 'success')

              //                             window.location.href = "https://private.autoturn.net/events-list/f/"+this.$route.params.id+"/"+this.$route.params.adaccount_id;
              //                           } else if (result.isDenied) {
              //                             // Swal.fire('Changes are not saved', '', 'info')
              //                           }
              //                         })
              //                       } else {
              //                         let text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['empty_campaign_id']['swal_text'];
              //                         if(response.data.info != '' && response.data.info != null){
              //                           text = response.data.info
              //                         }
              //                         Swal.fire(
              //                           this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['empty_campaign_id']['swal_title'],
              //                           text,
              //                           'error'
              //                         )
              //                       }
              //                     });
              //                 } else {
              //                   var daily_keyword_split_budget = this.methodData.Budget_KW;
              //                   var daily_demo_budget = this.methodData.Budget_DM;
              //                   var budget_addition = this.goalsData.form_addition;

              //                   if(this.dateData.start_date != "" && this.dateData.end_date != ""){
              //                       var d1 = new Date(this.dateData.start_date);
              //                       var d2 = new Date(this.dateData.end_date);
              //                       var days = parseInt((d2-d1)/86400000) + parseInt(1);
              //                   } else {
              //                       var days = 0;
              //                   }

              //                   var keyword_split_budget = 0;
              //                   if(this.methodData.Budget_KW != ''){
              //                       keyword_split_budget = Math.round(this.methodData.Budget_KW * days * (1+(budget_addition/100)));
              //                   }

              //                   var demo_budget = 0;
              //                   if(this.methodData.Budget_DM != ''){
              //                       demo_budget = this.methodData.Budget_DM * days;
              //                   }

              //                   var _tmp_audience_budget = 0;
              //                   var audience_budget = 0;
              //                   // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.5)');
              //                   _tmp_audience_budget = this.methodData.Budget_LA;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.5);
              //                   // console.log('Math.round('+_tmp_audience_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
              //                   audience_budget = Math.round(_tmp_audience_budget * days * (1+(budget_addition/100)));

              //                   var _tmp_marketing_again_budget = 0;
              //                   var marketing_again_budget = 0;
              //                   // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.25)');
              //                   _tmp_marketing_again_budget = this.methodData.Budget_RT;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.25);
              //                   // console.log('Math.round('+_tmp_marketing_again_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
              //                   marketing_again_budget = Math.round(_tmp_marketing_again_budget * days * (1+(budget_addition/100)));

              //                   // console.log(parseInt(keyword_split_budget)+' + '+parseInt(demo_budget)+' + '+parseInt(audience_budget)+' + '+parseInt(marketing_again_budget));
              //                   var ac_budget = 0;
                  if(this.methodData.Budget_AC != '' && this.methodData.Budget_AC != 0){
                      ac_budget = Math.round(this.methodData.Budget_AC * days);
                  }
                  var html = parseInt(keyword_split_budget) + parseInt(demo_budget) + parseInt(audience_budget) + parseInt(marketing_again_budget) + parseInt(ac_budget);

              //                   if(isNaN(html)){
              //                       html = '0';
              //                   }

              //                   this.total_budget = html;

              //                   let _tmp_goalsData = this.goalsData;
              //                   const _view_goalsData = JSON.parse(JSON.stringify(_tmp_goalsData));
              //                   let _tmp_exAudiencesData = this.exAudiencesData;
              //                   const _view_exAudiencesData = JSON.parse(JSON.stringify(_tmp_exAudiencesData));

              //                   // console.log(_tmp_exAudiencesData);

              //                   delete _view_goalsData['objective_list'];
              //                   delete _view_exAudiencesData['custom_excluded_audiences'];

              //                   let formData = {
              //                     campaign_id: this.db_campaign_id,
              //                     campaign_name: this.campaign_name,
              //                     adaccount_id: this.adaccount_id,
              //                     Budget_KW_result: this.Budget_KW_result,
              //                     total_budget: this.total_budget,
              //                     dynBudgetData: this.dynBudgetData,
              //                     methodData: this.methodData,
              //                     benefitsAndInvestmentData: this.benefitsAndInvestmentData,
              //                     dateData: this.dateData,
              //                     keywordData: this.keywordData,
              //                     lookData: this.lookData,
              //                     audiencesData: this.audiencesData,
              //                     goalsData: _view_goalsData,
              //                     regionsData: this.regionsData,
              //                     selectCountries: this.selectCountries,
              //                     selectLangs: this.selectLangs,
              //                     exAudiencesData: _view_exAudiencesData,
              //                     pdData: this.pdData,
              //                     idData: this.idData,
              //                     postData: this.postData,
              //                     adMaterialData: this.adMaterialDataNew,
              //                     stageData: _stageData
              //                   }

              //                   // console.log('b this.adMaterialDataNew');
              //                   // console.log(this.adMaterialDataNew);

              //                   if(this.goalsData.campaign_objective == 'LEAD_GENERATION' || this.goalsData.campaign_objective == 'MESSAGES'){
              //                     // console.log('#1');
              //                     let materialType = 0;
              //                     let selectArticleLength = 0;
              //                     if(this.postData.select_article != '' && this.postData.select_article != null && typeof this.postData.select_article != 'undefined'){
              //                       selectArticleLength = this.postData.select_article.length;
              //                     }

              //                     let selectCreativesMessageLength = 0;
              //                     if(this.postData.select_creatives_message != '' && this.postData.select_creatives_message != null && typeof this.postData.select_creatives_message != 'undefined'){
              //                       selectCreativesMessageLength = this.postData.select_creatives_message.length;
              //                     }

              //                     let selectCreativesAdsetAdsMessageLength = 0;
              //                     if(this.postData.select_creatives_adset_ads_message != '' && this.postData.select_creatives_adset_ads_message != null && typeof this.postData.select_creatives_adset_ads_message != 'undefined'){
              //                       selectCreativesAdsetAdsMessageLength = this.postData.select_creatives_adset_ads_message.length;
              //                     }

              //                     let creativeArrayLength = 0;
              //                     if(this.adMaterialDataNew.creative_array != '' && this.adMaterialDataNew.creative_array != null && typeof this.adMaterialDataNew.creative_array != 'undefined'){
              //                       creativeArrayLength = this.adMaterialDataNew.creative_array.length;
              //                     }

              //                     if(creativeArrayLength == 0 && (!this.postData.select_creatives || this.postData.select_creatives.length == 0) && selectArticleLength == 0 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
              //                       materialType = 1;
              //                     } else if(selectArticleLength == 0 && selectCreativesMessageLength == 0 && selectCreativesAdsetAdsMessageLength == 0 && creativeArrayLength == 0 && this.goalsData.campaign_objective == 'MESSAGES'){
              //                       materialType = 2;
              //                     }

              //                     if(materialType == 0){
              //                       // console.log('#2');
              //                       // let message_sr_i = 0;
              //                       // let form_sr_i = 0;
              //                       // let message = 0;
              //                       // let single_object_spec = 0;
              //                       // let single_title = 0;
              //                       // let materials_item = 0;
              //                       // let materials_object_spec = 0;
              //                       // let materials_title = 0;
              //                       // let ad_name = 0;

              //                       // for(let i = 0; i < creativeArrayLength; i++){
              //                       //   if(this.adMaterialDataNew.creative_array[i].title == '' || this.adMaterialDataNew.creative_array[i].title == null || typeof this.adMaterialDataNew.creative_array[i].title == 'undefined'){
              //                       //     ad_name = 1;
              //                       //   }

              //                       //   if(this.adMaterialDataNew.creative_array[i].type == 2){
              //                       //     let materials_length = this.adMaterialDataNew.creative_array[i].materials.length

              //                       //     if(materials_length < 2){
              //                       //       materials_item = 1;
              //                       //     } else {
              //                       //       for(let j = 0; j < materials_length; j++){
              //                       //         if(this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == '' || this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == null || typeof this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == 'undefined'){
              //                       //           materials_object_spec = 1;
              //                       //         }

              //                       //         if(this.adMaterialDataNew.creative_array[i].materials[j].title == '' || this.adMaterialDataNew.creative_array[i].materials[j].title == null || typeof this.adMaterialDataNew.creative_array[i].materials[j].title == 'undefined'){
              //                       //           materials_title = 1;
              //                       //         }
              //                       //       }
              //                       //     }
              //                       //   }

              //                       //   if(this.adMaterialDataNew.creative_array[i].type == 1){
              //                       //     if(this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == '' || this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == null || typeof this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == 'undefined'){
              //                       //       single_object_spec = 1;
              //                       //     }

              //                       //     if(this.adMaterialDataNew.creative_array[i].materialSingle[0].title == '' || this.adMaterialDataNew.creative_array[i].materialSingle[0].title == null || typeof this.adMaterialDataNew.creative_array[i].materialSingle[0].title == 'undefined'){
              //                       //       single_title = 1;
              //                       //     }
              //                       //   }

              //                       //   if(this.adMaterialDataNew.creative_array[i].message == '' || this.adMaterialDataNew.creative_array[i].message == null || typeof this.adMaterialDataNew.creative_array[i].message == 'undefined'){
              //                       //     message = 1;
              //                       //   }

              //                       //   if(this.adMaterialDataNew.creative_array[i].form_sr_i == '' || this.adMaterialDataNew.creative_array[i].form_sr_i == null || typeof this.adMaterialDataNew.creative_array[i].form_sr_i == 'undefined'){
              //                       //     form_sr_i = 1;
              //                       //   }

              //                       //   if(this.adMaterialDataNew.creative_array[i].message_sr_i == '' || this.adMaterialDataNew.creative_array[i].message_sr_i == null || typeof this.adMaterialDataNew.creative_array[i].message_sr_i == 'undefined'){
              //                       //     message_sr_i = 1;
              //                       //   }
              //                       // }

              //                       // if(ad_name == 1){
              //                       //   Swal.fire(
              //                       //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['swal_title'],
              //                       //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_ad_name_swal_text'],
              //                       //               "error"
              //                       //             )
              //                       // } else if(single_object_spec == 1){
              //                       //   Swal.fire(
              //                       //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['swal_title'],
              //                       //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_single_object_spec_swal_text'],
              //                       //               "error"
              //                       //             )
              //                       // } else if(single_title == 1){
              //                       //   Swal.fire(
              //                       //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['swal_title'],
              //                       //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_single_title_swal_text'],
              //                       //               "error"
              //                       //             )
              //                       // } else if(materials_item == 1){
              //                       //   Swal.fire(
              //                       //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['swal_title'],
              //                       //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_materials_item_swal_text'],
              //                       //               "error"
              //                       //             )
              //                       // } else if(materials_object_spec == 1){
              //                       //   Swal.fire(
              //                       //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['swal_title'],
              //                       //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_materials_object_spec_swal_text'],
              //                       //               "error"
              //                       //             )
              //                       // } else if(materials_title == 1){
              //                       //   Swal.fire(
              //                       //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['swal_title'],
              //                       //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_materials_title_swal_text'],
              //                       //               "error"
              //                       //             )
              //                       // } else if(message == 1){
              //                       //   Swal.fire(
              //                       //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['swal_title'],
              //                       //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_message_swal_text'],
              //                       //               "error"
              //                       //             )
              //                       // } else if(form_sr_i == 1 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
              //                       //   Swal.fire(
              //                       //             this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['swal_title'],
              //                       //             this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_form_sr_i_swal_text'],
              //                       //             "error"
              //                       //           )
              //                       // } else if(message_sr_i == 1 && this.goalsData.campaign_objective == 'MESSAGES'){
              //                       //   Swal.fire(
              //                       //             this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['swal_title'],
              //                       //             this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_message_sr_i_swal_text'],
              //                       //             "error"
              //                       //           )
              //                       // } else {
              //                         // console.log('#5');
              //                         axios
              //                           .post('https://www.autoturn.net/api/data/campaign_update.php', Qs.stringify({
              //                             s_code: this.$route.params.id,
              //                             form_data: formData,
              //                             type: 'finish',
              //                             target: 'add_update_'+this.target,
              //                             CT_writing_status: campaign_writing_status,
              //                           }))
              //                           .then((response) => {
              //                             // console.log(response.data);
              //                             if(response.data.status == 'success'){
              //                               // this.immediateList = response.data.return_data
              //                               // this.formData = response.data.return_data.form

              //                               Swal.fire({
              //                                 icon: 'success',
              //                                 title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['campaign_update']['success']['swal_title'],
              //                                 text: response.data.info,
              //                                 showDenyButton: false,
              //                                 showCancelButton: false,
              //                                 confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['campaign_update']['success']['confirm_button'],
              //                                 // denyButtonText: `Don't save`,
              //                               }).then((result) => {
              //                                 /* Read more about isConfirmed, isDenied below */
              //                                 if (result.isConfirmed) {
              //                                   // Swal.fire('Saved!', '', 'success')

              //                                   window.location.href = "https://private.autoturn.net/events-list/f/"+this.$route.params.id+"/"+this.$route.params.adaccount_id;
              //                                 } else if (result.isDenied) {
              //                                   // Swal.fire('Changes are not saved', '', 'info')
              //                                 }
              //                               })

              //                               // if(type == 1){
              //                               //   var todayForm = new Date();
              //                               //   var yearForm = todayForm.getFullYear();
              //                               //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
              //                               //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
              //                               //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

              //                               //   todayForm = yearForm + monthForm + dateForm + timeForm;

              //                               //   this.formTitle = 'title_'+todayForm;
              //                               // } else {
              //                               //   this.formTitle = response.data.return_data.name;
              //                               // }

              //                               // this.showModal = true
              //                             } else {
              //                               let text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['campaign_update']['not_success']['default_swal_text'];
              //                               if(response.data.info != '' && response.data.info != null){
              //                                 text = response.data.info
              //                               }
              //                               Swal.fire(
              //                                 this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['campaign_update']['not_success']['swal_title'],
              //                                 text,
              //                                 'error'
              //                               )
              //                             }
              //                           });
              //                       // }
              //                     } else {
              //                       // console.log('#3');
              //                       Swal.fire(
              //                                   this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_creative_array_swal_title'],
              //                                   this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_creative_array_swal_text'],
              //                                   "error"
              //                                 )
              //                     }
              //                   } else {
              //                     axios
              //                       .post('https://www.autoturn.net/api/data/campaign_update.php', Qs.stringify({
              //                         s_code: this.$route.params.id,
              //                         form_data: formData,
              //                         type: 'finish',
              //                         target: 'add_update_'+this.target,
              //                         CT_writing_status: campaign_writing_status,
              //                       }))
              //                       .then((response) => {
              //                         // console.log(response.data);
              //                         if(response.data.status == 'success'){
              //                           // this.immediateList = response.data.return_data
              //                           // this.formData = response.data.return_data.form

              //                           Swal.fire({
              //                             icon: 'success',
              //                             title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['not_lead_messages']['campaign_update']['success']['swal_title'],
              //                             text: response.data.info,
              //                             showDenyButton: false,
              //                             showCancelButton: false,
              //                             confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['not_lead_messages']['campaign_update']['success']['confirm_button'],
              //                             // denyButtonText: `Don't save`,
              //                           }).then((result) => {
              //                             /* Read more about isConfirmed, isDenied below */
              //                             if (result.isConfirmed) {
              //                               // Swal.fire('Saved!', '', 'success')

              //                               window.location.href = "https://private.autoturn.net/events-list/f/"+this.$route.params.id+"/"+this.$route.params.adaccount_id;
              //                             } else if (result.isDenied) {
              //                               // Swal.fire('Changes are not saved', '', 'info')
              //                             }
              //                           })

              //                           // if(type == 1){
              //                           //   var todayForm = new Date();
              //                           //   var yearForm = todayForm.getFullYear();
              //                           //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
              //                           //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
              //                           //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

              //                           //   todayForm = yearForm + monthForm + dateForm + timeForm;

              //                           //   this.formTitle = 'title_'+todayForm;
              //                           // } else {
              //                           //   this.formTitle = response.data.return_data.name;
              //                           // }

              //                           // this.showModal = true
              //                         } else {
              //                           let text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['not_lead_messages']['campaign_update']['not_success']['default_swal_text'];
              //                           if(response.data.info != '' && response.data.info != null){
              //                             text = response.data.info
              //                           }
              //                           Swal.fire(
              //                             this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['not_lead_messages']['campaign_update']['not_success']['swal_title'],
              //                             text,
              //                             'error'
              //                           )
              //                         }
              //                       });
              //                   }
              //                 }
              //               }

              //               if(caResponse.data.status == 'login'){
              //                 Swal.fire({
              //                   icon: 'error',
              //                   title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['login']['swal_title'],
              //                   text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['login']['swal_text'],
              //                   showDenyButton: false,
              //                   showCancelButton: false,
              //                   confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['login']['confirm_button']
              //                   // denyButtonText: `Don't save`,
              //                 }).then((result) => {
              //                   /* Read more about isConfirmed, isDenied below */
              //                   if (result.isConfirmed) {
              //                     // Swal.fire('Saved!', '', 'success')
              //                     // this.allPageLoading = true
              //                     window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
              //                   } else if (result.isDenied) {
              //                     // Swal.fire('Changes are not saved', '', 'info')
              //                     // this.allPageLoading = true
              //                     window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
              //                   }
              //                 })
              //               }
              //             });

              //       //  console.log('customize end');
              //       //  console.log(this.customRulesData);

              //         } else {
              //           Swal.fire({
              //                       icon: 'error',
              //                       title: '自定義規則-儲存',
              //                       html: '資料更新失敗，請稍候再嘗試。',
              //                       showDenyButton: false,
              //                       showCancelButton: false,
              //                       confirmButtonText: 'OK',
              //                     });

              //       //  console.log('customize error end');
              //       //  console.log(this.customRulesData);
              //         }
              //       }
              //     }
              //   });
            }

            await Promise.all(promises);

        //  console.log('All axios requests finished');
        //  console.log(_stageData);
        //  console.log(_stageData.length +'=='+ _tmpSubCampaignsContentLength);

            // 在所有 axios 完成后，再执行以下逻辑
            if(_stageData.length == _tmpSubCampaignsContentLength){
              const hasKey = _campaign_writing_status.some(item => item === 'key');

              let campaign_writing_status = 'draft';
              if(hasKey == true){
                campaign_writing_status = 'key';
              }

              axios
                .post('https://www.autoturn.net/api/campaign_member_status.php', Qs.stringify({
                  s_code: member_hash,
                  route_type: this.$route.params.type,
                  active: 'add',
                }))
                .then((caResponse) => {

                  if(caResponse.data.status == 'error'){
                    this.nextLoading = false;
                    this.showCampaignData = true;

                    if(caResponse.data.type == 2){
                      Swal.fire({
                        icon: caResponse.data.status,
                        title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['error']['swal_title'],
                        text: caResponse.data.info,
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['error']['confirm_button']
                        // denyButtonText: `Don't save`,
                      }).then((result) => {
                        if (result.isConfirmed) {
                          // Swal.fire('Saved!', '', 'success')
                          this.allPageLoading = true
                          window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                        } else if (result.isDenied) {
                          // Swal.fire('Changes are not saved', '', 'info')
                          this.allPageLoading = true
                          window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                        }
                      })
                    } else if(caResponse.data.type == 3){
                      Swal.fire({
                        icon: caResponse.data.status,
                        title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['error']['swal_title'],
                        text: caResponse.data.info,
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['error']['confirm_button']
                        // denyButtonText: `Don't save`,
                      }).then((result) => {
                        if (result.isConfirmed) {
                          // Swal.fire('Saved!', '', 'success')
                          this.allPageLoading = true
                          window.location.href = "https://private.autoturn.net/f/"+member_hash;
                        } else if (result.isDenied) {
                          // Swal.fire('Changes are not saved', '', 'info')
                          this.allPageLoading = true
                          window.location.href = "https://private.autoturn.net/f/"+member_hash;
                        }
                      })
                    } else {
                      Swal.fire(
                                this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['error']['swal_title'],
                                caResponse.data.info,
                                caResponse.data.status
                              )
                    }
                  }

                  if(caResponse.data.status == 'warning'){
                    Swal.fire({
                      icon: 'warning',
                      title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['swal_title'],
                      text: caResponse.data.info,
                      showDenyButton: false,
                      showCancelButton: false,
                      confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['confirm_button']
                      // denyButtonText: `Don't save`,
                    }).then((result) => {
                      if(this.db_campaign_id == null || this.db_campaign_id == '' || typeof this.db_campaign_id == 'undefined'){
                        var daily_keyword_split_budget = this.methodData.Budget_KW;
                        var daily_demo_budget = this.methodData.Budget_DM;
                        var budget_addition = this.goalsData.form_addition;

                        if(this.dateData.start_date != "" && this.dateData.end_date != ""){
                            var d1 = new Date(this.dateData.start_date);
                            var d2 = new Date(this.dateData.end_date);
                            var days = parseInt((d2-d1)/86400000) + parseInt(1);
                        } else {
                            var days = 0;
                        }

                        var keyword_split_budget = 0;
                        if(this.methodData.Budget_KW != ''){
                            keyword_split_budget = Math.round(this.methodData.Budget_KW * days * (1+(budget_addition/100)));
                        }

                        var demo_budget = 0;
                        if(this.methodData.Budget_DM != ''){
                            demo_budget = this.methodData.Budget_DM * days;
                        }

                        var _tmp_audience_budget = 0;
                        var audience_budget = 0;
                        // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.5)');
                        _tmp_audience_budget = this.methodData.Budget_LA;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.5);
                        // console.log('Math.round('+_tmp_audience_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                        audience_budget = Math.round(_tmp_audience_budget * days * (1+(budget_addition/100)));

                        var _tmp_marketing_again_budget = 0;
                        var marketing_again_budget = 0;
                        // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.25)');
                        _tmp_marketing_again_budget = this.methodData.Budget_RT;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.25);
                        // console.log('Math.round('+_tmp_marketing_again_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                        marketing_again_budget = Math.round(_tmp_marketing_again_budget * days * (1+(budget_addition/100)));

                        // console.log(parseInt(keyword_split_budget)+' + '+parseInt(demo_budget)+' + '+parseInt(audience_budget)+' + '+parseInt(marketing_again_budget));
                        var ac_budget = 0;
                        if(this.methodData.Budget_AC != '' && this.methodData.Budget_AC != 0){
                            ac_budget = Math.round(this.methodData.Budget_AC * days);
                        }
                        var html = parseInt(keyword_split_budget) + parseInt(demo_budget) + parseInt(audience_budget) + parseInt(marketing_again_budget) + parseInt(ac_budget);

                        if(isNaN(html)){
                            html = '0';
                        }

                        this.total_budget = html;

                        let _tmp_goalsData = this.goalsData;
                        const _view_goalsData = JSON.parse(JSON.stringify(_tmp_goalsData));
                        let _tmp_exAudiencesData = this.exAudiencesData;
                        const _view_exAudiencesData = JSON.parse(JSON.stringify(_tmp_exAudiencesData));

                        // console.log(_tmp_exAudiencesData);

                        delete _view_goalsData['objective_list'];
                        delete _view_exAudiencesData['custom_excluded_audiences'];

                        let formData = {
                          campaign_name: this.campaign_name,
                          adaccount_id: this.adaccount_id,
                          Budget_KW_result: this.Budget_KW_result,
                          total_budget: this.total_budget,
                          useDefaultLayout: this.useDefaultLayout,
                          dynBudgetData: this.dynBudgetData,
                          doForwardData: this.doForwardData,
                          methodData: this.methodData,
                          benefitsAndInvestmentData: this.benefitsAndInvestmentData,
                          dateData: this.dateData,
                          keywordData: this.keywordData,
                          lookData: this.lookData,
                          audiencesData: this.audiencesData,
                          goalsData: _view_goalsData,
                          regionsData: this.regionsData,
                          selectCountries: this.selectCountries,
                          selectLangs: this.selectLangs,
                          exAudiencesData: _view_exAudiencesData,
                          pdData: this.pdData,
                          idData: this.idData,
                          postData: this.postData,
                          adMaterialData: this.adMaterialDataNew,
                          autoAdjustData: this.autoAdjustData,
                          stageData: _stageData
                        }

                        axios
                          .post('https://www.autoturn.net/api/data/campaign_add_update.php', Qs.stringify({
                            s_code: this.$route.params.id,
                            form_data: formData,
                          }))
                          .then((response) => {
                            // console.log(response.data);

                            if(response.data.status == 'success'){
                              this.db_campaign_id = response.data.campaign_id
                              axios
                                .post('https://www.autoturn.net/api/data/teaching_update.php', Qs.stringify({
                                  s_code: this.$route.params.id,
                                  id: this.teaching_id,
                                  campaign_id: this.db_campaign_id,
                                  campaign_objective: '',
                                  skip: '',
                                  step: '',
                                  active: 'campaign_id'
                                }));

                              ////////////////
                              Swal.fire({
                                icon: 'success',
                                title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['swal_title'],
                                text: response.data.info,
                                showDenyButton: false,
                                showCancelButton: false,
                                confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['confirm_button'],
                                // denyButtonText: `Don't save`,
                              }).then((result) => {
                                /* Read more about isConfirmed, isDenied below */
                                if (result.isConfirmed) {
                                  // Swal.fire('Saved!', '', 'success')

                                  window.location.href = "https://private.autoturn.net/events-list/f/"+this.$route.params.id+"/"+this.$route.params.adaccount_id;
                                } else if (result.isDenied) {
                                  // Swal.fire('Changes are not saved', '', 'info')
                                }
                              })
                            } else {
                              let text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['empty_campaign_id']['swal_text'];
                              if(response.data.info != '' && response.data.info != null){
                                text = response.data.info
                              }
                              Swal.fire(
                                this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['empty_campaign_id']['swal_title'],
                                text,
                                'error'
                              )
                            }

                            this.nextLoading = false;
                            this.showCampaignData = true;
                          });
                      } else {
                        var daily_keyword_split_budget = this.methodData.Budget_KW;
                        var daily_demo_budget = this.methodData.Budget_DM;
                        var budget_addition = this.goalsData.form_addition;

                        if(this.dateData.start_date != "" && this.dateData.end_date != ""){
                            var d1 = new Date(this.dateData.start_date);
                            var d2 = new Date(this.dateData.end_date);
                            var days = parseInt((d2-d1)/86400000) + parseInt(1);
                        } else {
                            var days = 0;
                        }

                        var keyword_split_budget = 0;
                        if(this.methodData.Budget_KW != ''){
                            keyword_split_budget = Math.round(this.methodData.Budget_KW * days * (1+(budget_addition/100)));
                        }

                        var demo_budget = 0;
                        if(this.methodData.Budget_DM != ''){
                            demo_budget = this.methodData.Budget_DM * days;
                        }

                        var _tmp_audience_budget = 0;
                        var audience_budget = 0;
                        // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.5)');
                        _tmp_audience_budget = this.methodData.Budget_LA;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.5);
                        // console.log('Math.round('+_tmp_audience_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                        audience_budget = Math.round(_tmp_audience_budget * days * (1+(budget_addition/100)));

                        var _tmp_marketing_again_budget = 0;
                        var marketing_again_budget = 0;
                        // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.25)');
                        _tmp_marketing_again_budget = this.methodData.Budget_RT;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.25);
                        // console.log('Math.round('+_tmp_marketing_again_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                        marketing_again_budget = Math.round(_tmp_marketing_again_budget * days * (1+(budget_addition/100)));

                        // console.log(parseInt(keyword_split_budget)+' + '+parseInt(demo_budget)+' + '+parseInt(audience_budget)+' + '+parseInt(marketing_again_budget));
                        var ac_budget = 0;
                        if(this.methodData.Budget_AC != '' && this.methodData.Budget_AC != 0){
                            ac_budget = Math.round(this.methodData.Budget_AC * days);
                        }
                        var html = parseInt(keyword_split_budget) + parseInt(demo_budget) + parseInt(audience_budget) + parseInt(marketing_again_budget) + parseInt(ac_budget);

                        if(isNaN(html)){
                            html = '0';
                        }

                        this.total_budget = html;

                        let _tmp_goalsData = this.goalsData;
                        const _view_goalsData = JSON.parse(JSON.stringify(_tmp_goalsData));
                        let _tmp_exAudiencesData = this.exAudiencesData;
                        const _view_exAudiencesData = JSON.parse(JSON.stringify(_tmp_exAudiencesData));

                        // console.log(_tmp_exAudiencesData);

                        delete _view_goalsData['objective_list'];
                        delete _view_exAudiencesData['custom_excluded_audiences'];

                        let formData = {
                          campaign_id: this.db_campaign_id,
                          campaign_name: this.campaign_name,
                      budget_type: this.budget_type,
                      special_ad_category: this.special_ad_category,
                          adaccount_id: this.adaccount_id,
                          Budget_KW_result: this.Budget_KW_result,
                          total_budget: this.total_budget,
                          useDefaultLayout: this.useDefaultLayout,
                          dynBudgetData: this.dynBudgetData,
                          doForwardData: this.doForwardData,
                          methodData: this.methodData,
                          benefitsAndInvestmentData: this.benefitsAndInvestmentData,
                          dateData: this.dateData,
                          keywordData: this.keywordData,
                          lookData: this.lookData,
                          audiencesData: this.audiencesData,
                          goalsData: _view_goalsData,
                          regionsData: this.regionsData,
                          selectCountries: this.selectCountries,
                          selectLangs: this.selectLangs,
                          exAudiencesData: _view_exAudiencesData,
                          pdData: this.pdData,
                          idData: this.idData,
                          postData: this.postData,
                          adMaterialData: this.adMaterialDataNew,
                          autoAdjustData: this.autoAdjustData,
                          stageData: _stageData
                        }

                        // console.log('a this.adMaterialDataNew');
                        // console.log(this.adMaterialDataNew);

                        if(this.goalsData.campaign_objective == 'LEAD_GENERATION' || this.goalsData.campaign_objective == 'MESSAGES'){
                          // console.log('#1');
                          let materialType = 0;
                          let selectArticleLength = 0;
                          if(this.postData.select_article != '' && this.postData.select_article != null && typeof this.postData.select_article != 'undefined'){
                            selectArticleLength = this.postData.select_article.length;
                          }

                          let selectCreativesMessageLength = 0;
                          if(this.postData.select_creatives_message != '' && this.postData.select_creatives_message != null && typeof this.postData.select_creatives_message != 'undefined'){
                            selectCreativesMessageLength = this.postData.select_creatives_message.length;
                          }

                          let selectCreativesAdsetAdsMessageLength = 0;
                          if(this.postData.select_creatives_adset_ads_message != '' && this.postData.select_creatives_adset_ads_message != null && typeof this.postData.select_creatives_adset_ads_message != 'undefined'){
                            selectCreativesAdsetAdsMessageLength = this.postData.select_creatives_adset_ads_message.length;
                          }

                          let creativeArrayLength = 0;
                          if(this.adMaterialDataNew.creative_array != '' && this.adMaterialDataNew.creative_array != null && typeof this.adMaterialDataNew.creative_array != 'undefined'){
                            creativeArrayLength = this.adMaterialDataNew.creative_array.length;
                          }

                          if(creativeArrayLength == 0 && (!this.postData.select_creatives || this.postData.select_creatives.length == 0) && selectArticleLength == 0 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
                            materialType = 1;
                          } else if(selectArticleLength == 0 && selectCreativesMessageLength == 0 && selectCreativesAdsetAdsMessageLength == 0 && creativeArrayLength == 0 && this.goalsData.campaign_objective == 'MESSAGES'){
                            materialType = 2;
                          }

                          if(materialType == 0){
                            // console.log('#2');
                            // let message_sr_i = 0;
                            // let form_sr_i = 0;
                            // let message = 0;
                            // let single_object_spec = 0;
                            // let single_title = 0;
                            // let materials_item = 0;
                            // let materials_object_spec = 0;
                            // let materials_title = 0;
                            // let ad_name = 0;

                            // for(let i = 0; i < creativeArrayLength; i++){
                            //   if(this.adMaterialDataNew.creative_array[i].title == '' || this.adMaterialDataNew.creative_array[i].title == null || typeof this.adMaterialDataNew.creative_array[i].title == 'undefined'){
                            //     ad_name = 1;
                            //   }

                            //   if(this.adMaterialDataNew.creative_array[i].type == 2){
                            //     let materials_length = this.adMaterialDataNew.creative_array[i].materials.length

                            //     if(materials_length < 2){
                            //       materials_item = 1;
                            //     } else {
                            //       for(let j = 0; j < materials_length; j++){
                            //         if(this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == '' || this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == null || typeof this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == 'undefined'){
                            //           materials_object_spec = 1;
                            //         }

                            //         if(this.adMaterialDataNew.creative_array[i].materials[j].title == '' || this.adMaterialDataNew.creative_array[i].materials[j].title == null || typeof this.adMaterialDataNew.creative_array[i].materials[j].title == 'undefined'){
                            //           materials_title = 1;
                            //         }
                            //       }
                            //     }
                            //   }

                            //   if(this.adMaterialDataNew.creative_array[i].type == 1){
                            //     if(this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == '' || this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == null || typeof this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == 'undefined'){
                            //       single_object_spec = 1;
                            //     }

                            //     if(this.adMaterialDataNew.creative_array[i].materialSingle[0].title == '' || this.adMaterialDataNew.creative_array[i].materialSingle[0].title == null || typeof this.adMaterialDataNew.creative_array[i].materialSingle[0].title == 'undefined'){
                            //       single_title = 1;
                            //     }
                            //   }

                            //   if(this.adMaterialDataNew.creative_array[i].message == '' || this.adMaterialDataNew.creative_array[i].message == null || typeof this.adMaterialDataNew.creative_array[i].message == 'undefined'){
                            //     message = 1;
                            //   }

                            //   if(this.adMaterialDataNew.creative_array[i].form_sr_i == '' || this.adMaterialDataNew.creative_array[i].form_sr_i == null || typeof this.adMaterialDataNew.creative_array[i].form_sr_i == 'undefined'){
                            //     form_sr_i = 1;
                            //   }

                            //   if(this.adMaterialDataNew.creative_array[i].message_sr_i == '' || this.adMaterialDataNew.creative_array[i].message_sr_i == null || typeof this.adMaterialDataNew.creative_array[i].message_sr_i == 'undefined'){
                            //     message_sr_i = 1;
                            //   }
                            // }

                            // if(ad_name == 1){
                            //   Swal.fire(
                            //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['swal_title'],
                            //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['not_ad_name_swal_text'],
                            //               "error"
                            //             )
                            // } else if(single_object_spec == 1){
                            //   Swal.fire(
                            //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['swal_title'],
                            //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['not_single_object_spec_swal_text'],
                            //               "error"
                            //             )
                            // } else if(single_title == 1){
                            //   Swal.fire(
                            //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['swal_title'],
                            //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['not_single_title_swal_text'],
                            //               "error"
                            //             )
                            // } else if(materials_item == 1){
                            //   Swal.fire(
                            //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['swal_title'],
                            //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['not_materials_item_swal_text'],
                            //               "error"
                            //             )
                            // } else if(materials_object_spec == 1){
                            //   Swal.fire(
                            //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['swal_title'],
                            //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['not_materials_object_spec_swal_text'],
                            //               "error"
                            //             )
                            // } else if(materials_title == 1){
                            //   Swal.fire(
                            //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['swal_title'],
                            //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['not_materials_title_swal_text'],
                            //               "error"
                            //             )
                            // } else if(message == 1){
                            //   Swal.fire(
                            //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['swal_title'],
                            //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['not_message_swal_text'],
                            //               "error"
                            //             )
                            // } else if(form_sr_i == 1 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
                            //   Swal.fire(
                            //             this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['swal_title'],
                            //             this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['not_form_sr_i_swal_text'],
                            //             "error"
                            //           )
                            // } else if(message_sr_i == 1 && this.goalsData.campaign_objective == 'MESSAGES'){
                            //   Swal.fire(
                            //             this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['swal_title'],
                            //             this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['not_message_sr_i_swal_text'],
                            //             "error"
                            //           )
                            // } else {
                              // console.log('#5');
                              axios
                                .post('https://www.autoturn.net/api/data/campaign_update.php', Qs.stringify({
                                  s_code: this.$route.params.id,
                                  form_data: formData,
                                  type: 'finish',
                                  target: 'add_update_'+this.target,
                                  CT_writing_status: campaign_writing_status,
                                }))
                                .then((response) => {
                                  // console.log(response.data);
                                  if(response.data.status == 'success'){
                                    // this.immediateList = response.data.return_data
                                    // this.formData = response.data.return_data.form

                                    Swal.fire({
                                      icon: 'success',
                                      title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['campaign_update']['success']['swal_title'],
                                      text: response.data.info,
                                      showDenyButton: false,
                                      showCancelButton: false,
                                      confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['campaign_update']['success']['confirm_button'],
                                      // denyButtonText: `Don't save`,
                                    }).then((result) => {
                                      /* Read more about isConfirmed, isDenied below */
                                      if (result.isConfirmed) {
                                        // Swal.fire('Saved!', '', 'success')

                                        window.location.href = "https://private.autoturn.net/events-list/f/"+this.$route.params.id+"/"+this.$route.params.adaccount_id;
                                      } else if (result.isDenied) {
                                        // Swal.fire('Changes are not saved', '', 'info')
                                      }
                                    })

                                    // if(type == 1){
                                    //   var todayForm = new Date();
                                    //   var yearForm = todayForm.getFullYear();
                                    //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                                    //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                                    //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                                    //   todayForm = yearForm + monthForm + dateForm + timeForm;

                                    //   this.formTitle = 'title_'+todayForm;
                                    // } else {
                                    //   this.formTitle = response.data.return_data.name;
                                    // }

                                    // this.showModal = true
                                  } else {
                                    let text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['campaign_update']['not_success']['default_swal_text'];
                                    if(response.data.info != '' && response.data.info != null){
                                      text = response.data.info
                                    }
                                    Swal.fire(
                                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['campaign_update']['not_success']['swal_title'],
                                      text,
                                      'error'
                                    )
                                  }

                                  this.nextLoading = false;
                                  this.showCampaignData = true;
                                });
                            // }
                          } else {
                            // console.log('#3');
                            Swal.fire(
                                        this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['not_creative_array_swal_title'],
                                        this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['not_creative_array_swal_text'],
                                        "error"
                                      )

                            this.nextLoading = false;
                            this.showCampaignData = true;
                          }
                        } else {
                          axios
                            .post('https://www.autoturn.net/api/data/campaign_update.php', Qs.stringify({
                              s_code: this.$route.params.id,
                              form_data: formData,
                              type: 'finish',
                              target: 'add_update_'+this.target,
                              CT_writing_status: campaign_writing_status,
                            }))
                            .then((response) => {
                              // console.log(response.data);
                              if(response.data.status == 'success'){
                                // this.immediateList = response.data.return_data
                                // this.formData = response.data.return_data.form

                                Swal.fire({
                                  icon: 'success',
                                  title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['not_lead_messages']['campaign_update']['success']['swal_title'],
                                  text: response.data.info,
                                  showDenyButton: false,
                                  showCancelButton: false,
                                  confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['not_lead_messages']['campaign_update']['success']['confirm_button'],
                                  // denyButtonText: `Don't save`,
                                }).then((result) => {
                                  /* Read more about isConfirmed, isDenied below */
                                  if (result.isConfirmed) {
                                    // Swal.fire('Saved!', '', 'success')

                                    window.location.href = "https://private.autoturn.net/events-list/f/"+this.$route.params.id+"/"+this.$route.params.adaccount_id;
                                  } else if (result.isDenied) {
                                    // Swal.fire('Changes are not saved', '', 'info')
                                  }
                                })

                                // if(type == 1){
                                //   var todayForm = new Date();
                                //   var yearForm = todayForm.getFullYear();
                                //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                                //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                                //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                                //   todayForm = yearForm + monthForm + dateForm + timeForm;

                                //   this.formTitle = 'title_'+todayForm;
                                // } else {
                                //   this.formTitle = response.data.return_data.name;
                                // }

                                // this.showModal = true
                              } else {
                                let text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['not_lead_messages']['campaign_update']['not_success']['default_swal_text'];
                                if(response.data.info != '' && response.data.info != null){
                                  text = response.data.info
                                }
                                Swal.fire(
                                  this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['not_lead_messages']['campaign_update']['not_success']['swal_title'],
                                  text,
                                  'error'
                                )
                              }

                              this.nextLoading = false;
                              this.showCampaignData = true;
                            });
                        }
                      }
                    });
                  }

                  if(caResponse.data.status == 'success'){
                    if(this.db_campaign_id == null || this.db_campaign_id == '' || typeof this.db_campaign_id == 'undefined'){
                      var daily_keyword_split_budget = this.methodData.Budget_KW;
                      var daily_demo_budget = this.methodData.Budget_DM;
                      var budget_addition = this.goalsData.form_addition;

                      if(this.dateData.start_date != "" && this.dateData.end_date != ""){
                          var d1 = new Date(this.dateData.start_date);
                          var d2 = new Date(this.dateData.end_date);
                          var days = parseInt((d2-d1)/86400000) + parseInt(1);
                      } else {
                          var days = 0;
                      }

                      var keyword_split_budget = 0;
                      if(this.methodData.Budget_KW != ''){
                          keyword_split_budget = Math.round(this.methodData.Budget_KW * days * (1+(budget_addition/100)));
                      }

                      var demo_budget = 0;
                      if(this.methodData.Budget_DM != ''){
                          demo_budget = this.methodData.Budget_DM * days;
                      }

                      var _tmp_audience_budget = 0;
                      var audience_budget = 0;
                      // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.5)');
                      _tmp_audience_budget = this.methodData.Budget_LA;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.5);
                      // console.log('Math.round('+_tmp_audience_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                      audience_budget = Math.round(_tmp_audience_budget * days * (1+(budget_addition/100)));

                      var _tmp_marketing_again_budget = 0;
                      var marketing_again_budget = 0;
                      // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.25)');
                      _tmp_marketing_again_budget = this.methodData.Budget_RT;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.25);
                      // console.log('Math.round('+_tmp_marketing_again_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                      marketing_again_budget = Math.round(_tmp_marketing_again_budget * days * (1+(budget_addition/100)));

                      // console.log(parseInt(keyword_split_budget)+' + '+parseInt(demo_budget)+' + '+parseInt(audience_budget)+' + '+parseInt(marketing_again_budget));
                      var ac_budget = 0;
                      if(this.methodData.Budget_AC != '' && this.methodData.Budget_AC != 0){
                          ac_budget = Math.round(this.methodData.Budget_AC * days);
                      }
                      var html = parseInt(keyword_split_budget) + parseInt(demo_budget) + parseInt(audience_budget) + parseInt(marketing_again_budget) + parseInt(ac_budget);

                      if(isNaN(html)){
                          html = '0';
                      }

                      this.total_budget = html;

                      let _tmp_goalsData = this.goalsData;
                      const _view_goalsData = JSON.parse(JSON.stringify(_tmp_goalsData));
                      let _tmp_exAudiencesData = this.exAudiencesData;
                      const _view_exAudiencesData = JSON.parse(JSON.stringify(_tmp_exAudiencesData));

                      // console.log(_tmp_exAudiencesData);

                      delete _view_goalsData['objective_list'];
                      delete _view_exAudiencesData['custom_excluded_audiences'];

                      let formData = {
                        campaign_name: this.campaign_name,
                        adaccount_id: this.adaccount_id,
                        Budget_KW_result: this.Budget_KW_result,
                        total_budget: this.total_budget,
                        useDefaultLayout: this.useDefaultLayout,
                        dynBudgetData: this.dynBudgetData,
                        doForwardData: this.doForwardData,
                        methodData: this.methodData,
                        benefitsAndInvestmentData: this.benefitsAndInvestmentData,
                        dateData: this.dateData,
                        keywordData: this.keywordData,
                        lookData: this.lookData,
                        audiencesData: this.audiencesData,
                        goalsData: _view_goalsData,
                        regionsData: this.regionsData,
                        selectCountries: this.selectCountries,
                        selectLangs: this.selectLangs,
                        exAudiencesData: _view_exAudiencesData,
                        pdData: this.pdData,
                        idData: this.idData,
                        postData: this.postData,
                        adMaterialData: this.adMaterialDataNew,
                        autoAdjustData: this.autoAdjustData,
                        stageData: _stageData
                      }

                      axios
                        .post('https://www.autoturn.net/api/data/campaign_add_update.php', Qs.stringify({
                          s_code: this.$route.params.id,
                          form_data: formData,
                        }))
                        .then((response) => {
                          // console.log(response.data);
                          if(response.data.status == 'success'){
                            this.db_campaign_id = response.data.campaign_id
                            axios
                              .post('https://www.autoturn.net/api/data/teaching_update.php', Qs.stringify({
                                s_code: this.$route.params.id,
                                id: this.teaching_id,
                                campaign_id: this.db_campaign_id,
                                campaign_objective: '',
                                skip: '',
                                step: '',
                                active: 'campaign_id'
                              }));

                            Swal.fire({
                              icon: 'success',
                              title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['swal_title'],
                              text: response.data.info,
                              showDenyButton: false,
                              showCancelButton: false,
                              confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['confirm_button'],
                              // denyButtonText: `Don't save`,
                            }).then((result) => {
                              /* Read more about isConfirmed, isDenied below */
                              if (result.isConfirmed) {
                                // Swal.fire('Saved!', '', 'success')

                                window.location.href = "https://private.autoturn.net/events-list/f/"+this.$route.params.id+"/"+this.$route.params.adaccount_id;
                              } else if (result.isDenied) {
                                // Swal.fire('Changes are not saved', '', 'info')
                              }
                            })
                          } else {
                            let text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['empty_campaign_id']['swal_text'];
                            if(response.data.info != '' && response.data.info != null){
                              text = response.data.info
                            }
                            Swal.fire(
                              this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['empty_campaign_id']['swal_title'],
                              text,
                              'error'
                            )
                          }

                          this.nextLoading = false;
                          this.showCampaignData = true;
                        });
                    } else {
                      var daily_keyword_split_budget = this.methodData.Budget_KW;
                      var daily_demo_budget = this.methodData.Budget_DM;
                      var budget_addition = this.goalsData.form_addition;

                      if(this.dateData.start_date != "" && this.dateData.end_date != ""){
                          var d1 = new Date(this.dateData.start_date);
                          var d2 = new Date(this.dateData.end_date);
                          var days = parseInt((d2-d1)/86400000) + parseInt(1);
                      } else {
                          var days = 0;
                      }

                      var keyword_split_budget = 0;
                      if(this.methodData.Budget_KW != ''){
                          keyword_split_budget = Math.round(this.methodData.Budget_KW * days * (1+(budget_addition/100)));
                      }

                      var demo_budget = 0;
                      if(this.methodData.Budget_DM != ''){
                          demo_budget = this.methodData.Budget_DM * days;
                      }

                      var _tmp_audience_budget = 0;
                      var audience_budget = 0;
                      // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.5)');
                      _tmp_audience_budget = this.methodData.Budget_LA;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.5);
                      // console.log('Math.round('+_tmp_audience_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                      audience_budget = Math.round(_tmp_audience_budget * days * (1+(budget_addition/100)));

                      var _tmp_marketing_again_budget = 0;
                      var marketing_again_budget = 0;
                      // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.25)');
                      _tmp_marketing_again_budget = this.methodData.Budget_RT;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.25);
                      // console.log('Math.round('+_tmp_marketing_again_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                      marketing_again_budget = Math.round(_tmp_marketing_again_budget * days * (1+(budget_addition/100)));

                      // console.log(parseInt(keyword_split_budget)+' + '+parseInt(demo_budget)+' + '+parseInt(audience_budget)+' + '+parseInt(marketing_again_budget));
                      var ac_budget = 0;
                      if(this.methodData.Budget_AC != '' && this.methodData.Budget_AC != 0){
                          ac_budget = Math.round(this.methodData.Budget_AC * days);
                      }
                      var html = parseInt(keyword_split_budget) + parseInt(demo_budget) + parseInt(audience_budget) + parseInt(marketing_again_budget) + parseInt(ac_budget);

                      if(isNaN(html)){
                          html = '0';
                      }

                      this.total_budget = html;

                      let _tmp_goalsData = this.goalsData;
                      const _view_goalsData = JSON.parse(JSON.stringify(_tmp_goalsData));
                      let _tmp_exAudiencesData = this.exAudiencesData;
                      const _view_exAudiencesData = JSON.parse(JSON.stringify(_tmp_exAudiencesData));

                      // console.log(_tmp_exAudiencesData);

                      delete _view_goalsData['objective_list'];
                      delete _view_exAudiencesData['custom_excluded_audiences'];

                      let formData = {
                        campaign_id: this.db_campaign_id,
                        campaign_name: this.campaign_name,
                      budget_type: this.budget_type,
                      special_ad_category: this.special_ad_category,
                        adaccount_id: this.adaccount_id,
                        Budget_KW_result: this.Budget_KW_result,
                        total_budget: this.total_budget,
                        useDefaultLayout: this.useDefaultLayout,
                        dynBudgetData: this.dynBudgetData,
                        doForwardData: this.doForwardData,
                        methodData: this.methodData,
                        benefitsAndInvestmentData: this.benefitsAndInvestmentData,
                        dateData: this.dateData,
                        keywordData: this.keywordData,
                        lookData: this.lookData,
                        audiencesData: this.audiencesData,
                        goalsData: _view_goalsData,
                        regionsData: this.regionsData,
                        selectCountries: this.selectCountries,
                        selectLangs: this.selectLangs,
                        exAudiencesData: _view_exAudiencesData,
                        pdData: this.pdData,
                        idData: this.idData,
                        postData: this.postData,
                        adMaterialData: this.adMaterialDataNew,
                        autoAdjustData: this.autoAdjustData,
                        stageData: _stageData
                      }

                      // console.log('b this.adMaterialDataNew');
                      // console.log(this.adMaterialDataNew);

                      if(this.goalsData.campaign_objective == 'LEAD_GENERATION' || this.goalsData.campaign_objective == 'MESSAGES'){
                        // console.log('#1');
                        let materialType = 0;
                        let selectArticleLength = 0;
                        if(this.postData.select_article != '' && this.postData.select_article != null && typeof this.postData.select_article != 'undefined'){
                          selectArticleLength = this.postData.select_article.length;
                        }

                        let selectCreativesMessageLength = 0;
                        if(this.postData.select_creatives_message != '' && this.postData.select_creatives_message != null && typeof this.postData.select_creatives_message != 'undefined'){
                          selectCreativesMessageLength = this.postData.select_creatives_message.length;
                        }

                        let selectCreativesAdsetAdsMessageLength = 0;
                        if(this.postData.select_creatives_adset_ads_message != '' && this.postData.select_creatives_adset_ads_message != null && typeof this.postData.select_creatives_adset_ads_message != 'undefined'){
                          selectCreativesAdsetAdsMessageLength = this.postData.select_creatives_adset_ads_message.length;
                        }

                        let creativeArrayLength = 0;
                        if(this.adMaterialDataNew.creative_array != '' && this.adMaterialDataNew.creative_array != null && typeof this.adMaterialDataNew.creative_array != 'undefined'){
                          creativeArrayLength = this.adMaterialDataNew.creative_array.length;
                        }

                        if(creativeArrayLength == 0 && (!this.postData.select_creatives || this.postData.select_creatives.length == 0) && selectArticleLength == 0 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
                          materialType = 1;
                        } else if(selectArticleLength == 0 && selectCreativesMessageLength == 0 && selectCreativesAdsetAdsMessageLength == 0 && creativeArrayLength == 0 && this.goalsData.campaign_objective == 'MESSAGES'){
                          materialType = 2;
                        }

                        if(materialType == 0){
                          // console.log('#2');
                          // let message_sr_i = 0;
                          // let form_sr_i = 0;
                          // let message = 0;
                          // let single_object_spec = 0;
                          // let single_title = 0;
                          // let materials_item = 0;
                          // let materials_object_spec = 0;
                          // let materials_title = 0;
                          // let ad_name = 0;

                          // for(let i = 0; i < creativeArrayLength; i++){
                          //   if(this.adMaterialDataNew.creative_array[i].title == '' || this.adMaterialDataNew.creative_array[i].title == null || typeof this.adMaterialDataNew.creative_array[i].title == 'undefined'){
                          //     ad_name = 1;
                          //   }

                          //   if(this.adMaterialDataNew.creative_array[i].type == 2){
                          //     let materials_length = this.adMaterialDataNew.creative_array[i].materials.length

                          //     if(materials_length < 2){
                          //       materials_item = 1;
                          //     } else {
                          //       for(let j = 0; j < materials_length; j++){
                          //         if(this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == '' || this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == null || typeof this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == 'undefined'){
                          //           materials_object_spec = 1;
                          //         }

                          //         if(this.adMaterialDataNew.creative_array[i].materials[j].title == '' || this.adMaterialDataNew.creative_array[i].materials[j].title == null || typeof this.adMaterialDataNew.creative_array[i].materials[j].title == 'undefined'){
                          //           materials_title = 1;
                          //         }
                          //       }
                          //     }
                          //   }

                          //   if(this.adMaterialDataNew.creative_array[i].type == 1){
                          //     if(this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == '' || this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == null || typeof this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == 'undefined'){
                          //       single_object_spec = 1;
                          //     }

                          //     if(this.adMaterialDataNew.creative_array[i].materialSingle[0].title == '' || this.adMaterialDataNew.creative_array[i].materialSingle[0].title == null || typeof this.adMaterialDataNew.creative_array[i].materialSingle[0].title == 'undefined'){
                          //       single_title = 1;
                          //     }
                          //   }

                          //   if(this.adMaterialDataNew.creative_array[i].message == '' || this.adMaterialDataNew.creative_array[i].message == null || typeof this.adMaterialDataNew.creative_array[i].message == 'undefined'){
                          //     message = 1;
                          //   }

                          //   if(this.adMaterialDataNew.creative_array[i].form_sr_i == '' || this.adMaterialDataNew.creative_array[i].form_sr_i == null || typeof this.adMaterialDataNew.creative_array[i].form_sr_i == 'undefined'){
                          //     form_sr_i = 1;
                          //   }

                          //   if(this.adMaterialDataNew.creative_array[i].message_sr_i == '' || this.adMaterialDataNew.creative_array[i].message_sr_i == null || typeof this.adMaterialDataNew.creative_array[i].message_sr_i == 'undefined'){
                          //     message_sr_i = 1;
                          //   }
                          // }

                          // if(ad_name == 1){
                          //   Swal.fire(
                          //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['swal_title'],
                          //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_ad_name_swal_text'],
                          //               "error"
                          //             )
                          // } else if(single_object_spec == 1){
                          //   Swal.fire(
                          //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['swal_title'],
                          //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_single_object_spec_swal_text'],
                          //               "error"
                          //             )
                          // } else if(single_title == 1){
                          //   Swal.fire(
                          //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['swal_title'],
                          //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_single_title_swal_text'],
                          //               "error"
                          //             )
                          // } else if(materials_item == 1){
                          //   Swal.fire(
                          //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['swal_title'],
                          //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_materials_item_swal_text'],
                          //               "error"
                          //             )
                          // } else if(materials_object_spec == 1){
                          //   Swal.fire(
                          //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['swal_title'],
                          //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_materials_object_spec_swal_text'],
                          //               "error"
                          //             )
                          // } else if(materials_title == 1){
                          //   Swal.fire(
                          //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['swal_title'],
                          //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_materials_title_swal_text'],
                          //               "error"
                          //             )
                          // } else if(message == 1){
                          //   Swal.fire(
                          //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['swal_title'],
                          //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_message_swal_text'],
                          //               "error"
                          //             )
                          // } else if(form_sr_i == 1 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
                          //   Swal.fire(
                          //             this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['swal_title'],
                          //             this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_form_sr_i_swal_text'],
                          //             "error"
                          //           )
                          // } else if(message_sr_i == 1 && this.goalsData.campaign_objective == 'MESSAGES'){
                          //   Swal.fire(
                          //             this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['swal_title'],
                          //             this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_message_sr_i_swal_text'],
                          //             "error"
                          //           )
                          // } else {
                            // console.log('#5');
                            axios
                              .post('https://www.autoturn.net/api/data/campaign_update.php', Qs.stringify({
                                s_code: this.$route.params.id,
                                form_data: formData,
                                type: 'finish',
                                target: 'add_update_'+this.target,
                                CT_writing_status: campaign_writing_status,
                              }))
                              .then((response) => {
                                // console.log(response.data);
                                if(response.data.status == 'success'){
                                  // this.immediateList = response.data.return_data
                                  // this.formData = response.data.return_data.form

                                  Swal.fire({
                                    icon: 'success',
                                    title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['campaign_update']['success']['swal_title'],
                                    text: response.data.info,
                                    showDenyButton: false,
                                    showCancelButton: false,
                                    confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['campaign_update']['success']['confirm_button'],
                                    // denyButtonText: `Don't save`,
                                  }).then((result) => {
                                    /* Read more about isConfirmed, isDenied below */
                                    if (result.isConfirmed) {
                                      // Swal.fire('Saved!', '', 'success')

                                      window.location.href = "https://private.autoturn.net/events-list/f/"+this.$route.params.id+"/"+this.$route.params.adaccount_id;
                                    } else if (result.isDenied) {
                                      // Swal.fire('Changes are not saved', '', 'info')
                                    }
                                  })

                                  // if(type == 1){
                                  //   var todayForm = new Date();
                                  //   var yearForm = todayForm.getFullYear();
                                  //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                                  //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                                  //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                                  //   todayForm = yearForm + monthForm + dateForm + timeForm;

                                  //   this.formTitle = 'title_'+todayForm;
                                  // } else {
                                  //   this.formTitle = response.data.return_data.name;
                                  // }

                                  // this.showModal = true
                                } else {
                                  let text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['campaign_update']['not_success']['default_swal_text'];
                                  if(response.data.info != '' && response.data.info != null){
                                    text = response.data.info
                                  }
                                  Swal.fire(
                                    this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['campaign_update']['not_success']['swal_title'],
                                    text,
                                    'error'
                                  )
                                }

                                this.nextLoading = false;
                                this.showCampaignData = true;
                              });
                          // }
                        } else {
                          // console.log('#3');
                          Swal.fire(
                                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_creative_array_swal_title'],
                                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_creative_array_swal_text'],
                                      "error"
                                    )

                          this.nextLoading = false;
                          this.showCampaignData = true;
                        }
                      } else {
                        axios
                          .post('https://www.autoturn.net/api/data/campaign_update.php', Qs.stringify({
                            s_code: this.$route.params.id,
                            form_data: formData,
                            type: 'finish',
                            target: 'add_update_'+this.target,
                            CT_writing_status: campaign_writing_status,
                          }))
                          .then((response) => {
                            // console.log(response.data);
                            if(response.data.status == 'success'){
                              // this.immediateList = response.data.return_data
                              // this.formData = response.data.return_data.form

                              Swal.fire({
                                icon: 'success',
                                title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['not_lead_messages']['campaign_update']['success']['swal_title'],
                                text: response.data.info,
                                showDenyButton: false,
                                showCancelButton: false,
                                confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['not_lead_messages']['campaign_update']['success']['confirm_button'],
                                // denyButtonText: `Don't save`,
                              }).then((result) => {
                                /* Read more about isConfirmed, isDenied below */
                                if (result.isConfirmed) {
                                  // Swal.fire('Saved!', '', 'success')

                                  window.location.href = "https://private.autoturn.net/events-list/f/"+this.$route.params.id+"/"+this.$route.params.adaccount_id;
                                } else if (result.isDenied) {
                                  // Swal.fire('Changes are not saved', '', 'info')
                                }
                              })

                              // if(type == 1){
                              //   var todayForm = new Date();
                              //   var yearForm = todayForm.getFullYear();
                              //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                              //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                              //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                              //   todayForm = yearForm + monthForm + dateForm + timeForm;

                              //   this.formTitle = 'title_'+todayForm;
                              // } else {
                              //   this.formTitle = response.data.return_data.name;
                              // }

                              // this.showModal = true
                            } else {
                              let text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['not_lead_messages']['campaign_update']['not_success']['default_swal_text'];
                              if(response.data.info != '' && response.data.info != null){
                                text = response.data.info
                              }
                              Swal.fire(
                                this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['not_lead_messages']['campaign_update']['not_success']['swal_title'],
                                text,
                                'error'
                              )
                            }

                            this.nextLoading = false;
                            this.showCampaignData = true;
                          });
                      }
                    }
                  }

                  if(caResponse.data.status == 'login'){
                    this.nextLoading = false;
                    this.showCampaignData = true;

                    Swal.fire({
                      icon: 'error',
                      title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['login']['swal_title'],
                      text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['login']['swal_text'],
                      showDenyButton: false,
                      showCancelButton: false,
                      confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['login']['confirm_button']
                      // denyButtonText: `Don't save`,
                    }).then((result) => {
                      /* Read more about isConfirmed, isDenied below */
                      if (result.isConfirmed) {
                        // Swal.fire('Saved!', '', 'success')
                        // this.allPageLoading = true
                        window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
                      } else if (result.isDenied) {
                        // Swal.fire('Changes are not saved', '', 'info')
                        // this.allPageLoading = true
                        window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
                      }
                    })
                  }
                });

          //  console.log('customize end');
          //  console.log(this.customRulesData);

            } else {
              Swal.fire({
                          icon: 'error',
                          title: '自定義規則-儲存',
                          html: '資料更新失敗，請稍候再嘗試。',
                          showDenyButton: false,
                          showCancelButton: false,
                          confirmButtonText: 'OK',
                        });

          //  console.log('customize error end');
          //  console.log(this.customRulesData);

              this.nextLoading = false;
              this.showCampaignData = true;
            }
          } else {
        //  console.log('非自定義');
            axios
              .post('https://www.autoturn.net/api/campaign_member_status.php', Qs.stringify({
                s_code: member_hash,
                route_type: this.$route.params.type,
                active: 'add',
              }))
              .then((caResponse) => {

                if(caResponse.data.status == 'error'){
                  this.nextLoading = false;
                  this.showCampaignData = true;

                  if(caResponse.data.type == 2){
                    Swal.fire({
                      icon: caResponse.data.status,
                      title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['error']['swal_title'],
                      text: caResponse.data.info,
                      showDenyButton: false,
                      showCancelButton: false,
                      confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['error']['confirm_button']
                      // denyButtonText: `Don't save`,
                    }).then((result) => {
                      if (result.isConfirmed) {
                        // Swal.fire('Saved!', '', 'success')
                        this.allPageLoading = true
                        window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                      } else if (result.isDenied) {
                        // Swal.fire('Changes are not saved', '', 'info')
                        this.allPageLoading = true
                        window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                      }
                    })
                  } else if(caResponse.data.type == 3){
                    Swal.fire({
                      icon: caResponse.data.status,
                      title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['error']['swal_title'],
                      text: caResponse.data.info,
                      showDenyButton: false,
                      showCancelButton: false,
                      confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['error']['confirm_button']
                      // denyButtonText: `Don't save`,
                    }).then((result) => {
                      if (result.isConfirmed) {
                        // Swal.fire('Saved!', '', 'success')
                        this.allPageLoading = true
                        window.location.href = "https://private.autoturn.net/f/"+member_hash;
                      } else if (result.isDenied) {
                        // Swal.fire('Changes are not saved', '', 'info')
                        this.allPageLoading = true
                        window.location.href = "https://private.autoturn.net/f/"+member_hash;
                      }
                    })
                  } else {
                    Swal.fire(
                              this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['error']['swal_title'],
                              caResponse.data.info,
                              caResponse.data.status
                            )
                  }
                }

                if(caResponse.data.status == 'warning'){
                  Swal.fire({
                    icon: 'warning',
                    title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['swal_title'],
                    text: caResponse.data.info,
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['confirm_button']
                    // denyButtonText: `Don't save`,
                  }).then((result) => {
                    if(this.db_campaign_id == null || this.db_campaign_id == '' || typeof this.db_campaign_id == 'undefined'){
                      // var daily_keyword_split_budget = this.methodData.Budget_KW;
                      // var daily_demo_budget = this.methodData.Budget_DM;
                      // var budget_addition = this.goalsData.form_addition;

                      // if(this.dateData.start_date != "" && this.dateData.end_date != ""){
                      //     var d1 = new Date(this.dateData.start_date);
                      //     var d2 = new Date(this.dateData.end_date);
                      //     var days = parseInt((d2-d1)/86400000) + parseInt(1);
                      // } else {
                      //     var days = 0;
                      // }

                      // var keyword_split_budget = 0;
                      // if(this.methodData.Budget_KW != ''){
                      //     keyword_split_budget = Math.round(this.methodData.Budget_KW * days * (1+(budget_addition/100)));
                      // }

                      // var demo_budget = 0;
                      // if(this.methodData.Budget_DM != ''){
                      //     demo_budget = this.methodData.Budget_DM * days;
                      // }

                      // var _tmp_audience_budget = 0;
                      // var audience_budget = 0;
                      // // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.5)');
                      // _tmp_audience_budget = this.methodData.Budget_LA;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.5);
                      // // console.log('Math.round('+_tmp_audience_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                      // audience_budget = Math.round(_tmp_audience_budget * days * (1+(budget_addition/100)));

                      // var _tmp_marketing_again_budget = 0;
                      // var marketing_again_budget = 0;
                      // // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.25)');
                      // _tmp_marketing_again_budget = this.methodData.Budget_RT;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.25);
                      // // console.log('Math.round('+_tmp_marketing_again_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                      // marketing_again_budget = Math.round(_tmp_marketing_again_budget * days * (1+(budget_addition/100)));

                      // // console.log(parseInt(keyword_split_budget)+' + '+parseInt(demo_budget)+' + '+parseInt(audience_budget)+' + '+parseInt(marketing_again_budget));
                      // var html = parseInt(keyword_split_budget) + parseInt(demo_budget) + parseInt(audience_budget) + parseInt(marketing_again_budget);

                      // if(isNaN(html)){
                      //     html = '0';
                      // }

                      // this.total_budget = html;

                      // let _tmp_goalsData = this.goalsData;
                      // const _view_goalsData = JSON.parse(JSON.stringify(_tmp_goalsData));
                      // let _tmp_exAudiencesData = this.exAudiencesData;
                      // const _view_exAudiencesData = JSON.parse(JSON.stringify(_tmp_exAudiencesData));

                      // // console.log(_tmp_exAudiencesData);

                      // delete _view_goalsData['objective_list'];
                      // delete _view_exAudiencesData['custom_excluded_audiences'];

                      // let formData = {
                      //   campaign_name: this.campaign_name,
                      //   adaccount_id: this.adaccount_id,
                      //   Budget_KW_result: this.Budget_KW_result,
                      //   total_budget: this.total_budget,
                      //   useDefaultLayout: this.useDefaultLayout,
                      //   dynBudgetData: this.dynBudgetData,
                      //   methodData: this.methodData,
                      //   benefitsAndInvestmentData: this.benefitsAndInvestmentData,
                      //   dateData: this.dateData,
                      //   keywordData: this.keywordData,
                      //   lookData: this.lookData,
                      //   audiencesData: this.audiencesData,
                      //   goalsData: _view_goalsData,
                      //   regionsData: this.regionsData,
                      //   selectCountries: this.selectCountries,
                      //   selectLangs: this.selectLangs,
                      //   exAudiencesData: _view_exAudiencesData,
                      //   pdData: this.pdData,
                      //   idData: this.idData,
                      //   postData: this.postData,
                      //   adMaterialData: this.adMaterialDataNew
                      // }

                      // axios
                      //   .post('https://www.autoturn.net/api/data/campaign_add_update.php', Qs.stringify({
                      //     s_code: this.$route.params.id,
                      //     form_data: formData,
                      //   }))
                      //   .then((response) => {
                      //     // console.log(response.data);

                      //     if(response.data.status == 'success'){
                      //       this.db_campaign_id = response.data.campaign_id
                      //       axios
                      //         .post('https://www.autoturn.net/api/data/teaching_update.php', Qs.stringify({
                      //           s_code: this.$route.params.id,
                      //           id: this.teaching_id,
                      //           campaign_id: this.db_campaign_id,
                      //           campaign_objective: '',
                      //           skip: '',
                      //           step: '',
                      //           active: 'campaign_id'
                      //         }));

                      //       ////////////////
                      //       Swal.fire({
                      //         icon: 'success',
                      //         title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['swal_title'],
                      //         text: response.data.info,
                      //         showDenyButton: false,
                      //         showCancelButton: false,
                      //         confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['confirm_button'],
                      //         // denyButtonText: `Don't save`,
                      //       }).then((result) => {
                      //         /* Read more about isConfirmed, isDenied below */
                      //         if (result.isConfirmed) {
                      //           // Swal.fire('Saved!', '', 'success')

                      //           window.location.href = "https://private.autoturn.net/events-list/f/"+this.$route.params.id+"/"+this.$route.params.adaccount_id;
                      //         } else if (result.isDenied) {
                      //           // Swal.fire('Changes are not saved', '', 'info')
                      //         }
                      //       })
                      //     } else {
                      //       let text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['empty_campaign_id']['swal_text'];
                      //       if(response.data.info != '' && response.data.info != null){
                      //         text = response.data.info
                      //       }
                      //       Swal.fire(
                      //         this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['empty_campaign_id']['swal_title'],
                      //         text,
                      //         'error'
                      //       )
                      //     }

                      //     this.nextLoading = false;
                      //     this.showCampaignData = true;
                      //   });
                    } else {
                      var daily_keyword_split_budget = this.methodData.Budget_KW;
                      var daily_demo_budget = this.methodData.Budget_DM;
                      var budget_addition = this.goalsData.form_addition;

                      if(this.dateData.start_date != "" && this.dateData.end_date != ""){
                          var d1 = new Date(this.dateData.start_date);
                          var d2 = new Date(this.dateData.end_date);
                          var days = parseInt((d2-d1)/86400000) + parseInt(1);
                      } else {
                          var days = 0;
                      }

                      var keyword_split_budget = 0;
                      if(this.methodData.Budget_KW != ''){
                          keyword_split_budget = Math.round(this.methodData.Budget_KW * days * (1+(budget_addition/100)));
                      }

                      var demo_budget = 0;
                      if(this.methodData.Budget_DM != ''){
                          demo_budget = this.methodData.Budget_DM * days;
                      }

                      var _tmp_audience_budget = 0;
                      var audience_budget = 0;
                      // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.5)');
                      _tmp_audience_budget = this.methodData.Budget_LA;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.5);
                      // console.log('Math.round('+_tmp_audience_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                      audience_budget = Math.round(_tmp_audience_budget * days * (1+(budget_addition/100)));

                      var _tmp_marketing_again_budget = 0;
                      var marketing_again_budget = 0;
                      // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.25)');
                      _tmp_marketing_again_budget = this.methodData.Budget_RT;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.25);
                      // console.log('Math.round('+_tmp_marketing_again_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                      marketing_again_budget = Math.round(_tmp_marketing_again_budget * days * (1+(budget_addition/100)));

                      // console.log(parseInt(keyword_split_budget)+' + '+parseInt(demo_budget)+' + '+parseInt(audience_budget)+' + '+parseInt(marketing_again_budget));
                      var ac_budget = 0;
                      if(this.methodData.Budget_AC != '' && this.methodData.Budget_AC != 0){
                          ac_budget = Math.round(this.methodData.Budget_AC * days);
                      }
                      var html = parseInt(keyword_split_budget) + parseInt(demo_budget) + parseInt(audience_budget) + parseInt(marketing_again_budget) + parseInt(ac_budget);

                      if(isNaN(html)){
                          html = '0';
                      }

                      this.total_budget = html;

                      let _tmp_goalsData = this.goalsData;
                      const _view_goalsData = JSON.parse(JSON.stringify(_tmp_goalsData));
                      let _tmp_exAudiencesData = this.exAudiencesData;
                      const _view_exAudiencesData = JSON.parse(JSON.stringify(_tmp_exAudiencesData));

                      // console.log(_tmp_exAudiencesData);

                      delete _view_goalsData['objective_list'];
                      delete _view_exAudiencesData['custom_excluded_audiences'];

                      let formData = {
                        campaign_id: this.db_campaign_id,
                        campaign_name: this.campaign_name,
                      budget_type: this.budget_type,
                      special_ad_category: this.special_ad_category,
                        adaccount_id: this.adaccount_id,
                        Budget_KW_result: this.Budget_KW_result,
                        total_budget: this.total_budget,
                        useDefaultLayout: this.useDefaultLayout,
                        dynBudgetData: this.dynBudgetData,
                        methodData: this.methodData,
                        benefitsAndInvestmentData: this.benefitsAndInvestmentData,
                        dateData: this.dateData,
                        keywordData: this.keywordData,
                        lookData: this.lookData,
                        audiencesData: this.audiencesData,
                        goalsData: _view_goalsData,
                        regionsData: this.regionsData,
                        selectCountries: this.selectCountries,
                        selectLangs: this.selectLangs,
                        exAudiencesData: _view_exAudiencesData,
                        pdData: this.pdData,
                        idData: this.idData,
                        postData: this.postData,
                        adMaterialData: this.adMaterialDataNew,
                        autoAdjustData: this.autoAdjustData
                      }

                      // console.log('a this.adMaterialDataNew');
                      // console.log(this.adMaterialDataNew);

                      if(this.goalsData.campaign_objective == 'LEAD_GENERATION' || this.goalsData.campaign_objective == 'MESSAGES'){
                        // console.log('#1');
                        let materialType = 0;
                        let selectArticleLength = 0;
                        if(this.postData.select_article != '' && this.postData.select_article != null && typeof this.postData.select_article != 'undefined'){
                          selectArticleLength = this.postData.select_article.length;
                        }

                        let selectCreativesMessageLength = 0;
                        if(this.postData.select_creatives_message != '' && this.postData.select_creatives_message != null && typeof this.postData.select_creatives_message != 'undefined'){
                          selectCreativesMessageLength = this.postData.select_creatives_message.length;
                        }

                        let selectCreativesAdsetAdsMessageLength = 0;
                        if(this.postData.select_creatives_adset_ads_message != '' && this.postData.select_creatives_adset_ads_message != null && typeof this.postData.select_creatives_adset_ads_message != 'undefined'){
                          selectCreativesAdsetAdsMessageLength = this.postData.select_creatives_adset_ads_message.length;
                        }

                        let creativeArrayLength = 0;
                        if(this.adMaterialDataNew.creative_array != '' && this.adMaterialDataNew.creative_array != null && typeof this.adMaterialDataNew.creative_array != 'undefined'){
                          creativeArrayLength = this.adMaterialDataNew.creative_array.length;
                        }

                        if(creativeArrayLength == 0 && (!this.postData.select_creatives || this.postData.select_creatives.length == 0) && selectArticleLength == 0 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
                          materialType = 1;
                        } else if(selectArticleLength == 0 && selectCreativesMessageLength == 0 && selectCreativesAdsetAdsMessageLength == 0 && creativeArrayLength == 0 && this.goalsData.campaign_objective == 'MESSAGES'){
                          materialType = 2;
                        }

                        if(materialType == 0){
                          // console.log('#2');
                          // let message_sr_i = 0;
                          // let form_sr_i = 0;
                          // let message = 0;
                          // let single_object_spec = 0;
                          // let single_title = 0;
                          // let materials_item = 0;
                          // let materials_object_spec = 0;
                          // let materials_title = 0;
                          // let ad_name = 0;

                          // for(let i = 0; i < creativeArrayLength; i++){
                          //   if(this.adMaterialDataNew.creative_array[i].title == '' || this.adMaterialDataNew.creative_array[i].title == null || typeof this.adMaterialDataNew.creative_array[i].title == 'undefined'){
                          //     ad_name = 1;
                          //   }

                          //   if(this.adMaterialDataNew.creative_array[i].type == 2){
                          //     let materials_length = this.adMaterialDataNew.creative_array[i].materials.length

                          //     if(materials_length < 2){
                          //       materials_item = 1;
                          //     } else {
                          //       for(let j = 0; j < materials_length; j++){
                          //         if(this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == '' || this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == null || typeof this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == 'undefined'){
                          //           materials_object_spec = 1;
                          //         }

                          //         if(this.adMaterialDataNew.creative_array[i].materials[j].title == '' || this.adMaterialDataNew.creative_array[i].materials[j].title == null || typeof this.adMaterialDataNew.creative_array[i].materials[j].title == 'undefined'){
                          //           materials_title = 1;
                          //         }
                          //       }
                          //     }
                          //   }

                          //   if(this.adMaterialDataNew.creative_array[i].type == 1){
                          //     if(this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == '' || this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == null || typeof this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == 'undefined'){
                          //       single_object_spec = 1;
                          //     }

                          //     if(this.adMaterialDataNew.creative_array[i].materialSingle[0].title == '' || this.adMaterialDataNew.creative_array[i].materialSingle[0].title == null || typeof this.adMaterialDataNew.creative_array[i].materialSingle[0].title == 'undefined'){
                          //       single_title = 1;
                          //     }
                          //   }

                          //   if(this.adMaterialDataNew.creative_array[i].message == '' || this.adMaterialDataNew.creative_array[i].message == null || typeof this.adMaterialDataNew.creative_array[i].message == 'undefined'){
                          //     message = 1;
                          //   }

                          //   if(this.adMaterialDataNew.creative_array[i].form_sr_i == '' || this.adMaterialDataNew.creative_array[i].form_sr_i == null || typeof this.adMaterialDataNew.creative_array[i].form_sr_i == 'undefined'){
                          //     form_sr_i = 1;
                          //   }

                          //   if(this.adMaterialDataNew.creative_array[i].message_sr_i == '' || this.adMaterialDataNew.creative_array[i].message_sr_i == null || typeof this.adMaterialDataNew.creative_array[i].message_sr_i == 'undefined'){
                          //     message_sr_i = 1;
                          //   }
                          // }

                          // if(ad_name == 1){
                          //   Swal.fire(
                          //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['swal_title'],
                          //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['not_ad_name_swal_text'],
                          //               "error"
                          //             )
                          // } else if(single_object_spec == 1){
                          //   Swal.fire(
                          //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['swal_title'],
                          //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['not_single_object_spec_swal_text'],
                          //               "error"
                          //             )
                          // } else if(single_title == 1){
                          //   Swal.fire(
                          //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['swal_title'],
                          //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['not_single_title_swal_text'],
                          //               "error"
                          //             )
                          // } else if(materials_item == 1){
                          //   Swal.fire(
                          //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['swal_title'],
                          //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['not_materials_item_swal_text'],
                          //               "error"
                          //             )
                          // } else if(materials_object_spec == 1){
                          //   Swal.fire(
                          //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['swal_title'],
                          //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['not_materials_object_spec_swal_text'],
                          //               "error"
                          //             )
                          // } else if(materials_title == 1){
                          //   Swal.fire(
                          //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['swal_title'],
                          //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['not_materials_title_swal_text'],
                          //               "error"
                          //             )
                          // } else if(message == 1){
                          //   Swal.fire(
                          //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['swal_title'],
                          //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['not_message_swal_text'],
                          //               "error"
                          //             )
                          // } else if(form_sr_i == 1 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
                          //   Swal.fire(
                          //             this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['swal_title'],
                          //             this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['not_form_sr_i_swal_text'],
                          //             "error"
                          //           )
                          // } else if(message_sr_i == 1 && this.goalsData.campaign_objective == 'MESSAGES'){
                          //   Swal.fire(
                          //             this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['swal_title'],
                          //             this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['not_message_sr_i_swal_text'],
                          //             "error"
                          //           )
                          // } else {
                            // console.log('#5');
                            axios
                              .post('https://www.autoturn.net/api/data/campaign_update.php', Qs.stringify({
                                s_code: this.$route.params.id,
                                form_data: formData,
                                type: 'finish',
                                target: 'add_update_'+this.target,
                              }))
                              .then((response) => {
                                // console.log(response.data);
                                if(response.data.status == 'success'){
                                  // this.immediateList = response.data.return_data
                                  // this.formData = response.data.return_data.form

                                  Swal.fire({
                                    icon: 'success',
                                    title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['campaign_update']['success']['swal_title'],
                                    text: response.data.info,
                                    showDenyButton: false,
                                    showCancelButton: false,
                                    confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['campaign_update']['success']['confirm_button'],
                                    // denyButtonText: `Don't save`,
                                  }).then((result) => {
                                    /* Read more about isConfirmed, isDenied below */
                                    if (result.isConfirmed) {
                                      // Swal.fire('Saved!', '', 'success')

                                      window.location.href = "https://private.autoturn.net/events-list/f/"+this.$route.params.id+"/"+this.$route.params.adaccount_id;
                                    } else if (result.isDenied) {
                                      // Swal.fire('Changes are not saved', '', 'info')
                                    }
                                  })

                                  // if(type == 1){
                                  //   var todayForm = new Date();
                                  //   var yearForm = todayForm.getFullYear();
                                  //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                                  //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                                  //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                                  //   todayForm = yearForm + monthForm + dateForm + timeForm;

                                  //   this.formTitle = 'title_'+todayForm;
                                  // } else {
                                  //   this.formTitle = response.data.return_data.name;
                                  // }

                                  // this.showModal = true
                                } else {
                                  let text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['campaign_update']['not_success']['default_swal_text'];
                                  if(response.data.info != '' && response.data.info != null){
                                    text = response.data.info
                                  }
                                  Swal.fire(
                                    this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['campaign_update']['not_success']['swal_title'],
                                    text,
                                    'error'
                                  )
                                }

                                this.nextLoading = false;
                                this.showCampaignData = true;
                              });
                          // }
                        } else {
                          // console.log('#3');
                          Swal.fire(
                                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['not_creative_array_swal_title'],
                                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['not_creative_array_swal_text'],
                                      "error"
                                    )

                          this.nextLoading = false;
                          this.showCampaignData = true;
                        }
                      } else {
                        axios
                          .post('https://www.autoturn.net/api/data/campaign_update.php', Qs.stringify({
                            s_code: this.$route.params.id,
                            form_data: formData,
                            type: 'finish',
                            target: 'add_update_'+this.target,
                          }))
                          .then((response) => {
                            // console.log(response.data);
                            if(response.data.status == 'success'){
                              // this.immediateList = response.data.return_data
                              // this.formData = response.data.return_data.form

                              Swal.fire({
                                icon: 'success',
                                title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['not_lead_messages']['campaign_update']['success']['swal_title'],
                                text: response.data.info,
                                showDenyButton: false,
                                showCancelButton: false,
                                confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['not_lead_messages']['campaign_update']['success']['confirm_button'],
                                // denyButtonText: `Don't save`,
                              }).then((result) => {
                                /* Read more about isConfirmed, isDenied below */
                                if (result.isConfirmed) {
                                  // Swal.fire('Saved!', '', 'success')

                                  window.location.href = "https://private.autoturn.net/events-list/f/"+this.$route.params.id+"/"+this.$route.params.adaccount_id;
                                } else if (result.isDenied) {
                                  // Swal.fire('Changes are not saved', '', 'info')
                                }
                              })

                              // if(type == 1){
                              //   var todayForm = new Date();
                              //   var yearForm = todayForm.getFullYear();
                              //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                              //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                              //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                              //   todayForm = yearForm + monthForm + dateForm + timeForm;

                              //   this.formTitle = 'title_'+todayForm;
                              // } else {
                              //   this.formTitle = response.data.return_data.name;
                              // }

                              // this.showModal = true
                            } else {
                              let text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['not_lead_messages']['campaign_update']['not_success']['default_swal_text'];
                              if(response.data.info != '' && response.data.info != null){
                                text = response.data.info
                              }
                              Swal.fire(
                                this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['not_lead_messages']['campaign_update']['not_success']['swal_title'],
                                text,
                                'error'
                              )
                            }

                            this.nextLoading = false;
                            this.showCampaignData = true;
                          });
                      }
                    }
                  });
                }

                if(caResponse.data.status == 'success'){
                  if(this.db_campaign_id == null || this.db_campaign_id == '' || typeof this.db_campaign_id == 'undefined'){
                    var daily_keyword_split_budget = this.methodData.Budget_KW;
                    var daily_demo_budget = this.methodData.Budget_DM;
                    var budget_addition = this.goalsData.form_addition;

                    if(this.dateData.start_date != "" && this.dateData.end_date != ""){
                        var d1 = new Date(this.dateData.start_date);
                        var d2 = new Date(this.dateData.end_date);
                        var days = parseInt((d2-d1)/86400000) + parseInt(1);
                    } else {
                        var days = 0;
                    }

                    var keyword_split_budget = 0;
                    if(this.methodData.Budget_KW != ''){
                        keyword_split_budget = Math.round(this.methodData.Budget_KW * days * (1+(budget_addition/100)));
                    }

                    var demo_budget = 0;
                    if(this.methodData.Budget_DM != ''){
                        demo_budget = this.methodData.Budget_DM * days;
                    }

                    var _tmp_audience_budget = 0;
                    var audience_budget = 0;
                    // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.5)');
                    _tmp_audience_budget = this.methodData.Budget_LA;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.5);
                    // console.log('Math.round('+_tmp_audience_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                    audience_budget = Math.round(_tmp_audience_budget * days * (1+(budget_addition/100)));

                    var _tmp_marketing_again_budget = 0;
                    var marketing_again_budget = 0;
                    // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.25)');
                    _tmp_marketing_again_budget = this.methodData.Budget_RT;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.25);
                    // console.log('Math.round('+_tmp_marketing_again_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                    marketing_again_budget = Math.round(_tmp_marketing_again_budget * days * (1+(budget_addition/100)));

                    // console.log(parseInt(keyword_split_budget)+' + '+parseInt(demo_budget)+' + '+parseInt(audience_budget)+' + '+parseInt(marketing_again_budget));
                    var ac_budget = 0;
                    if(this.methodData.Budget_AC != '' && this.methodData.Budget_AC != 0){
                        ac_budget = Math.round(this.methodData.Budget_AC * days);
                    }
                    var html = parseInt(keyword_split_budget) + parseInt(demo_budget) + parseInt(audience_budget) + parseInt(marketing_again_budget) + parseInt(ac_budget);

                    if(isNaN(html)){
                        html = '0';
                    }

                    this.total_budget = html;

                    let _tmp_goalsData = this.goalsData;
                    const _view_goalsData = JSON.parse(JSON.stringify(_tmp_goalsData));
                    let _tmp_exAudiencesData = this.exAudiencesData;
                    const _view_exAudiencesData = JSON.parse(JSON.stringify(_tmp_exAudiencesData));

                    // console.log(_tmp_exAudiencesData);

                    delete _view_goalsData['objective_list'];
                    delete _view_exAudiencesData['custom_excluded_audiences'];

                    let formData = {
                      campaign_id: this.db_campaign_id,
                      campaign_name: this.campaign_name,
                      budget_type: this.budget_type,
                      special_ad_category: this.special_ad_category,
                      adaccount_id: this.adaccount_id,
                      Budget_KW_result: this.Budget_KW_result,
                      total_budget: this.total_budget,
                      useDefaultLayout: this.useDefaultLayout,
                      dynBudgetData: this.dynBudgetData,
                      methodData: this.methodData,
                      benefitsAndInvestmentData: this.benefitsAndInvestmentData,
                      dateData: this.dateData,
                      keywordData: this.keywordData,
                      lookData: this.lookData,
                      audiencesData: this.audiencesData,
                      goalsData: _view_goalsData,
                      regionsData: this.regionsData,
                      selectCountries: this.selectCountries,
                      selectLangs: this.selectLangs,
                      exAudiencesData: _view_exAudiencesData,
                      pdData: this.pdData,
                      idData: this.idData,
                      postData: this.postData,
                      adMaterialData: this.adMaterialDataNew,
                      autoAdjustData: this.autoAdjustData
                    }

                    axios
                      .post('https://www.autoturn.net/api/data/campaign_add_update.php', Qs.stringify({
                        s_code: this.$route.params.id,
                        form_data: formData,
                      }))
                      .then((response) => {
                        // console.log(response.data);

                        if(response.data.status == 'success'){
                          this.db_campaign_id = response.data.campaign_id
                          axios
                            .post('https://www.autoturn.net/api/data/teaching_update.php', Qs.stringify({
                              s_code: this.$route.params.id,
                              id: this.teaching_id,
                              campaign_id: this.db_campaign_id,
                              campaign_objective: '',
                              skip: '',
                              step: '',
                              active: 'campaign_id'
                            }));

                          Swal.fire({
                            icon: 'success',
                            title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['swal_title'],
                            text: response.data.info,
                            showDenyButton: false,
                            showCancelButton: false,
                            confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['confirm_button'],
                            // denyButtonText: `Don't save`,
                          }).then((result) => {
                            /* Read more about isConfirmed, isDenied below */
                            if (result.isConfirmed) {
                              // Swal.fire('Saved!', '', 'success')

                              window.location.href = "https://private.autoturn.net/events-list/f/"+this.$route.params.id+"/"+this.$route.params.adaccount_id;
                            } else if (result.isDenied) {
                              // Swal.fire('Changes are not saved', '', 'info')
                            }
                          })
                        } else {
                          let text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['empty_campaign_id']['swal_text'];
                          if(response.data.info != '' && response.data.info != null){
                            text = response.data.info
                          }
                          Swal.fire(
                            this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['empty_campaign_id']['swal_title'],
                            text,
                            'error'
                          )
                        }

                        this.nextLoading = false;
                        this.showCampaignData = true;
                      });
                  } else {
                    var daily_keyword_split_budget = this.methodData.Budget_KW;
                    var daily_demo_budget = this.methodData.Budget_DM;
                    var budget_addition = this.goalsData.form_addition;

                    if(this.dateData.start_date != "" && this.dateData.end_date != ""){
                        var d1 = new Date(this.dateData.start_date);
                        var d2 = new Date(this.dateData.end_date);
                        var days = parseInt((d2-d1)/86400000) + parseInt(1);
                    } else {
                        var days = 0;
                    }

                    var keyword_split_budget = 0;
                    if(this.methodData.Budget_KW != ''){
                        keyword_split_budget = Math.round(this.methodData.Budget_KW * days * (1+(budget_addition/100)));
                    }

                    var demo_budget = 0;
                    if(this.methodData.Budget_DM != ''){
                        demo_budget = this.methodData.Budget_DM * days;
                    }

                    var _tmp_audience_budget = 0;
                    var audience_budget = 0;
                    // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.5)');
                    _tmp_audience_budget = this.methodData.Budget_LA;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.5);
                    // console.log('Math.round('+_tmp_audience_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                    audience_budget = Math.round(_tmp_audience_budget * days * (1+(budget_addition/100)));

                    var _tmp_marketing_again_budget = 0;
                    var marketing_again_budget = 0;
                    // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.25)');
                    _tmp_marketing_again_budget = this.methodData.Budget_RT;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.25);
                    // console.log('Math.round('+_tmp_marketing_again_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                    marketing_again_budget = Math.round(_tmp_marketing_again_budget * days * (1+(budget_addition/100)));

                    // console.log(parseInt(keyword_split_budget)+' + '+parseInt(demo_budget)+' + '+parseInt(audience_budget)+' + '+parseInt(marketing_again_budget));
                    var ac_budget = 0;
                    if(this.methodData.Budget_AC != '' && this.methodData.Budget_AC != 0){
                        ac_budget = Math.round(this.methodData.Budget_AC * days);
                    }
                    var html = parseInt(keyword_split_budget) + parseInt(demo_budget) + parseInt(audience_budget) + parseInt(marketing_again_budget) + parseInt(ac_budget);

                    if(isNaN(html)){
                        html = '0';
                    }

                    this.total_budget = html;

                    let _tmp_goalsData = this.goalsData;
                    const _view_goalsData = JSON.parse(JSON.stringify(_tmp_goalsData));
                    let _tmp_exAudiencesData = this.exAudiencesData;
                    const _view_exAudiencesData = JSON.parse(JSON.stringify(_tmp_exAudiencesData));

                    // console.log(_tmp_exAudiencesData);

                    delete _view_goalsData['objective_list'];
                    delete _view_exAudiencesData['custom_excluded_audiences'];

                    let formData = {
                      campaign_id: this.db_campaign_id,
                      campaign_name: this.campaign_name,
                      budget_type: this.budget_type,
                      special_ad_category: this.special_ad_category,
                      adaccount_id: this.adaccount_id,
                      Budget_KW_result: this.Budget_KW_result,
                      total_budget: this.total_budget,
                      useDefaultLayout: this.useDefaultLayout,
                      dynBudgetData: this.dynBudgetData,
                      methodData: this.methodData,
                      benefitsAndInvestmentData: this.benefitsAndInvestmentData,
                      dateData: this.dateData,
                      keywordData: this.keywordData,
                      lookData: this.lookData,
                      audiencesData: this.audiencesData,
                      goalsData: _view_goalsData,
                      regionsData: this.regionsData,
                      selectCountries: this.selectCountries,
                      selectLangs: this.selectLangs,
                      exAudiencesData: _view_exAudiencesData,
                      pdData: this.pdData,
                      idData: this.idData,
                      postData: this.postData,
                      adMaterialData: this.adMaterialDataNew,
                      autoAdjustData: this.autoAdjustData
                    }

                    // console.log('b this.adMaterialDataNew');
                    // console.log(this.adMaterialDataNew);

                    if(this.goalsData.campaign_objective == 'LEAD_GENERATION' || this.goalsData.campaign_objective == 'MESSAGES'){
                      // console.log('#1');
                      let materialType = 0;
                      let selectArticleLength = 0;
                      if(this.postData.select_article != '' && this.postData.select_article != null && typeof this.postData.select_article != 'undefined'){
                        selectArticleLength = this.postData.select_article.length;
                      }

                      let selectCreativesMessageLength = 0;
                      if(this.postData.select_creatives_message != '' && this.postData.select_creatives_message != null && typeof this.postData.select_creatives_message != 'undefined'){
                        selectCreativesMessageLength = this.postData.select_creatives_message.length;
                      }

                      let selectCreativesAdsetAdsMessageLength = 0;
                      if(this.postData.select_creatives_adset_ads_message != '' && this.postData.select_creatives_adset_ads_message != null && typeof this.postData.select_creatives_adset_ads_message != 'undefined'){
                        selectCreativesAdsetAdsMessageLength = this.postData.select_creatives_adset_ads_message.length;
                      }

                      let creativeArrayLength = 0;
                      if(this.adMaterialDataNew.creative_array != '' && this.adMaterialDataNew.creative_array != null && typeof this.adMaterialDataNew.creative_array != 'undefined'){
                        creativeArrayLength = this.adMaterialDataNew.creative_array.length;
                      }

                      if(creativeArrayLength == 0 && (!this.postData.select_creatives || this.postData.select_creatives.length == 0) && selectArticleLength == 0 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
                        materialType = 1;
                      } else if(selectArticleLength == 0 && selectCreativesMessageLength == 0 && selectCreativesAdsetAdsMessageLength == 0 && creativeArrayLength == 0 && this.goalsData.campaign_objective == 'MESSAGES'){
                        materialType = 2;
                      }

                      if(materialType == 0){
                        // console.log('#2');
                        // let message_sr_i = 0;
                        // let form_sr_i = 0;
                        // let message = 0;
                        // let single_object_spec = 0;
                        // let single_title = 0;
                        // let materials_item = 0;
                        // let materials_object_spec = 0;
                        // let materials_title = 0;
                        // let ad_name = 0;

                        // for(let i = 0; i < creativeArrayLength; i++){
                        //   if(this.adMaterialDataNew.creative_array[i].title == '' || this.adMaterialDataNew.creative_array[i].title == null || typeof this.adMaterialDataNew.creative_array[i].title == 'undefined'){
                        //     ad_name = 1;
                        //   }

                        //   if(this.adMaterialDataNew.creative_array[i].type == 2){
                        //     let materials_length = this.adMaterialDataNew.creative_array[i].materials.length

                        //     if(materials_length < 2){
                        //       materials_item = 1;
                        //     } else {
                        //       for(let j = 0; j < materials_length; j++){
                        //         if(this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == '' || this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == null || typeof this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == 'undefined'){
                        //           materials_object_spec = 1;
                        //         }

                        //         if(this.adMaterialDataNew.creative_array[i].materials[j].title == '' || this.adMaterialDataNew.creative_array[i].materials[j].title == null || typeof this.adMaterialDataNew.creative_array[i].materials[j].title == 'undefined'){
                        //           materials_title = 1;
                        //         }
                        //       }
                        //     }
                        //   }

                        //   if(this.adMaterialDataNew.creative_array[i].type == 1){
                        //     if(this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == '' || this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == null || typeof this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == 'undefined'){
                        //       single_object_spec = 1;
                        //     }

                        //     if(this.adMaterialDataNew.creative_array[i].materialSingle[0].title == '' || this.adMaterialDataNew.creative_array[i].materialSingle[0].title == null || typeof this.adMaterialDataNew.creative_array[i].materialSingle[0].title == 'undefined'){
                        //       single_title = 1;
                        //     }
                        //   }

                        //   if(this.adMaterialDataNew.creative_array[i].message == '' || this.adMaterialDataNew.creative_array[i].message == null || typeof this.adMaterialDataNew.creative_array[i].message == 'undefined'){
                        //     message = 1;
                        //   }

                        //   if(this.adMaterialDataNew.creative_array[i].form_sr_i == '' || this.adMaterialDataNew.creative_array[i].form_sr_i == null || typeof this.adMaterialDataNew.creative_array[i].form_sr_i == 'undefined'){
                        //     form_sr_i = 1;
                        //   }

                        //   if(this.adMaterialDataNew.creative_array[i].message_sr_i == '' || this.adMaterialDataNew.creative_array[i].message_sr_i == null || typeof this.adMaterialDataNew.creative_array[i].message_sr_i == 'undefined'){
                        //     message_sr_i = 1;
                        //   }
                        // }

                        // if(ad_name == 1){
                        //   Swal.fire(
                        //               "廣告素材",
                        //               "每組廣告素材，必須填寫廣告名稱。",
                        //               "error"
                        //             )
                        // } else if(single_object_spec == 1){
                        //   Swal.fire(
                        //               "廣告素材",
                        //               "每組廣告素材，必須設定素材。",
                        //               "error"
                        //             )
                        // } else if(single_title == 1){
                        //   Swal.fire(
                        //               "廣告素材",
                        //               "每組廣告的「標題」，為必填欄位。",
                        //               "error"
                        //             )
                        // } else if(materials_item == 1){
                        //   Swal.fire(
                        //               "廣告素材",
                        //               "輪播廣告，必須設定至少兩個素材。",
                        //               "error"
                        //             )
                        // } else if(materials_object_spec == 1){
                        //   Swal.fire(
                        //               "廣告素材",
                        //               "每組廣告素材，必須設定素材。",
                        //               "error"
                        //             )
                        // } else if(materials_title == 1){
                        //   Swal.fire(
                        //               "廣告素材",
                        //               "每組廣告的「標題」，為必填欄位。",
                        //               "error"
                        //             )
                        // } else if(message == 1){
                        //   Swal.fire(
                        //               "廣告素材",
                        //               "「主要內容/主要文字」，為必填欄位。",
                        //               "error"
                        //             )
                        // } else if(form_sr_i == 1 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
                        //   Swal.fire(
                        //             "廣告素材",
                        //             "每組廣告素材，需選擇一個「即時表單」",
                        //             "error"
                        //           )
                        // } else if(message_sr_i == 1 && this.goalsData.campaign_objective == 'MESSAGES'){
                        //   Swal.fire(
                        //             "廣告素材",
                        //             "每組廣告素材，需選擇一個「訊息範本」",
                        //             "error"
                        //           )
                        // } else {
                          // console.log('#5');
                          axios
                            .post('https://www.autoturn.net/api/data/campaign_update.php', Qs.stringify({
                              s_code: this.$route.params.id,
                              form_data: formData,
                              type: 'finish',
                              target: 'add_update_'+this.target,
                            }))
                            .then((response) => {
                              // console.log(response.data);
                              if(response.data.status == 'success'){
                                // this.immediateList = response.data.return_data
                                // this.formData = response.data.return_data.form

                                Swal.fire({
                                  icon: 'success',
                                  title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['campaign_update']['success']['swal_title'],
                                  text: response.data.info,
                                  showDenyButton: false,
                                  showCancelButton: false,
                                  confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['campaign_update']['success']['confirm_button'],
                                  // denyButtonText: `Don't save`,
                                }).then((result) => {
                                  /* Read more about isConfirmed, isDenied below */
                                  if (result.isConfirmed) {
                                    // Swal.fire('Saved!', '', 'success')

                                    window.location.href = "https://private.autoturn.net/events-list/f/"+this.$route.params.id+"/"+this.$route.params.adaccount_id;
                                  } else if (result.isDenied) {
                                    // Swal.fire('Changes are not saved', '', 'info')
                                  }
                                })

                                // if(type == 1){
                                //   var todayForm = new Date();
                                //   var yearForm = todayForm.getFullYear();
                                //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                                //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                                //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                                //   todayForm = yearForm + monthForm + dateForm + timeForm;

                                //   this.formTitle = 'title_'+todayForm;
                                // } else {
                                //   this.formTitle = response.data.return_data.name;
                                // }

                                // this.showModal = true
                              } else if(response.data.status == 'login'){
                                Swal.fire({
                                  icon: 'error',
                                  title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['login']['swal_title'],
                                  text: response.data.info,
                                  showDenyButton: false,
                                  showCancelButton: false,
                                  confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['login']['confirm_button']
                                  // denyButtonText: `Don't save`,
                                }).then((result) => {
                                  /* Read more about isConfirmed, isDenied below */
                                  if (result.isConfirmed) {
                                    // Swal.fire('Saved!', '', 'success')
                                    // this.allPageLoading = true
                                    window.location.href = "https://www.autoturn.net/index.php/index/logout/"+this.$route.params.id+"?o=1";
                                  } else if (result.isDenied) {
                                    // Swal.fire('Changes are not saved', '', 'info')
                                    // this.allPageLoading = true
                                    window.location.href = "https://www.autoturn.net/index.php/index/logout/"+this.$route.params.id+"?o=1";
                                  }
                                })
                              } else {
                                let text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['campaign_update']['not_success']['default_swal_text'];
                                if(response.data.info != '' && response.data.info != null){
                                  text = response.data.info
                                }
                                Swal.fire(
                                  this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['campaign_update']['not_success']['swal_title'],
                                  text,
                                  'error'
                                )
                              }

                              this.nextLoading = false;
                              this.showCampaignData = true;
                            });
                        // }
                      } else {
                        // console.log('#3');
                        Swal.fire(
                                    this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_creative_array_swal_title'],
                                    this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_creative_array_swal_text'],
                                    "error"
                                  )

                        this.nextLoading = false;
                        this.showCampaignData = true;
                      }
                    } else {
                      axios
                        .post('https://www.autoturn.net/api/data/campaign_update.php', Qs.stringify({
                          s_code: this.$route.params.id,
                          form_data: formData,
                          type: 'finish',
                          target: 'add_update_'+this.target,
                        }))
                        .then((response) => {
                          // console.log(response.data);
                          if(response.data.status == 'success'){
                            // this.immediateList = response.data.return_data
                            // this.formData = response.data.return_data.form

                            Swal.fire({
                              icon: 'success',
                              title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['not_lead_messages']['campaign_update']['success']['swal_title'],
                              text: response.data.info,
                              showDenyButton: false,
                              showCancelButton: false,
                              confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['not_lead_messages']['campaign_update']['success']['confirm_button'],
                              // denyButtonText: `Don't save`,
                            }).then((result) => {
                              /* Read more about isConfirmed, isDenied below */
                              if (result.isConfirmed) {
                                // Swal.fire('Saved!', '', 'success')

                                window.location.href = "https://private.autoturn.net/events-list/f/"+this.$route.params.id+"/"+this.$route.params.adaccount_id;
                              } else if (result.isDenied) {
                                // Swal.fire('Changes are not saved', '', 'info')
                              }
                            })

                            // if(type == 1){
                            //   var todayForm = new Date();
                            //   var yearForm = todayForm.getFullYear();
                            //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                            //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                            //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                            //   todayForm = yearForm + monthForm + dateForm + timeForm;

                            //   this.formTitle = 'title_'+todayForm;
                            // } else {
                            //   this.formTitle = response.data.return_data.name;
                            // }

                            // this.showModal = true
                          } else if(response.data.status == 'login'){
                            Swal.fire({
                              icon: 'error',
                              title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['login']['swal_title'],
                              text: response.data.info,
                              showDenyButton: false,
                              showCancelButton: false,
                              confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['login']['confirm_button']
                              // denyButtonText: `Don't save`,
                            }).then((result) => {
                              /* Read more about isConfirmed, isDenied below */
                              if (result.isConfirmed) {
                                // Swal.fire('Saved!', '', 'success')
                                // this.allPageLoading = true
                                window.location.href = "https://www.autoturn.net/index.php/index/logout/"+this.$route.params.id+"?o=1";
                              } else if (result.isDenied) {
                                // Swal.fire('Changes are not saved', '', 'info')
                                // this.allPageLoading = true
                                window.location.href = "https://www.autoturn.net/index.php/index/logout/"+this.$route.params.id+"?o=1";
                              }
                            })
                          } else {
                            let text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['not_lead_messages']['campaign_update']['not_success']['default_swal_text'];
                            if(response.data.info != '' && response.data.info != null){
                              text = response.data.info
                            }
                            Swal.fire(
                              this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['not_lead_messages']['campaign_update']['not_success']['swal_title'],
                              text,
                              'error'
                            )
                          }

                          this.nextLoading = false;
                          this.showCampaignData = true;
                        });
                    }
                  }
                }

                if(caResponse.data.status == 'login'){
                  this.nextLoading = false;
                  this.showCampaignData = true;

                  Swal.fire({
                    icon: 'error',
                    title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['login']['swal_title'],
                    text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['login']['swal_text'],
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['login']['confirm_button']
                    // denyButtonText: `Don't save`,
                  }).then((result) => {
                    /* Read more about isConfirmed, isDenied below */
                    if (result.isConfirmed) {
                      // Swal.fire('Saved!', '', 'success')
                      // this.allPageLoading = true
                      window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
                    } else if (result.isDenied) {
                      // Swal.fire('Changes are not saved', '', 'info')
                      // this.allPageLoading = true
                      window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
                    }
                  })
                }

                this.nextLoading = false;
                this.showCampaignData = true;
              });
          }
        }
        // }
      },
      release(){
    //  console.log('release');
        this.changeYoutubeType();
        this.clearLookalikeForSpecialAdCategory();
        if (!this.validateBudgetTypeAndSpecialAdCategory()) {
          return
        }

        if(this.methodData.Target_CR == true || this.methodData.Other_Target_CR == true || this.useDefaultLayout !== null){
      //  console.log('自定義發布');
          this.customize();
        } else {
          let isTrue = 1;

          if(this.db_campaign_id == null || this.db_campaign_id == '' || typeof this.db_campaign_id == 'undefined'){
            Swal.fire(
              this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['empty_campaign_id']['swal_title'],
              this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['empty_campaign_id']['swal_text'],
              'error'
            )
          } else if(this.isClass == 'y'){
            Swal.fire(
              this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['class_check_release_permissions']['swal_title'],
              this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['class_check_release_permissions']['swal_text'],
              'warning'
            )
          } else {
            let member_hash = this.$route.params.id
            let adaccount_id = this.$route.params.adaccount_id

            axios
              .post('https://www.autoturn.net/api/campaign_member_status.php', Qs.stringify({
                s_code: member_hash,
                route_type: this.$route.params.type,
                active: 'release',
              }))
              .then((caResponse) => {

                if(caResponse.data.status == 'error'){
                  if(caResponse.data.type == 2){
                    Swal.fire({
                      icon: caResponse.data.status,
                      title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['error']['swal_title'],
                      text: caResponse.data.info,
                      showDenyButton: false,
                      showCancelButton: false,
                      confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['error']['confirm_button']
                      // denyButtonText: `Don't save`,
                    }).then((result) => {
                      if (result.isConfirmed) {
                        // Swal.fire('Saved!', '', 'success')
                        this.allPageLoading = true
                        window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                      } else if (result.isDenied) {
                        // Swal.fire('Changes are not saved', '', 'info')
                        this.allPageLoading = true
                        window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                      }
                    })
                  } else if(caResponse.data.type == 3){
                    Swal.fire({
                      icon: caResponse.data.status,
                      title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['error']['swal_title'],
                      text: caResponse.data.info,
                      showDenyButton: false,
                      showCancelButton: false,
                      confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['error']['confirm_button']
                      // denyButtonText: `Don't save`,
                    }).then((result) => {
                      if (result.isConfirmed) {
                        // Swal.fire('Saved!', '', 'success')
                        this.allPageLoading = true
                        window.location.href = "https://private.autoturn.net/f/"+member_hash;
                      } else if (result.isDenied) {
                        // Swal.fire('Changes are not saved', '', 'info')
                        this.allPageLoading = true
                        window.location.href = "https://private.autoturn.net/f/"+member_hash;
                      }
                    })
                  } else {
                    Swal.fire(
                              this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['error']['swal_title'],
                              caResponse.data.info,
                              caResponse.data.status
                            )
                  }
                }

                if(caResponse.data.status == 'warning'){
                  Swal.fire({
                    icon: 'warning',
                    title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['swal_title'],
                    text: caResponse.data.info,
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['confirm_button']
                    // denyButtonText: `Don't save`,
                  }).then((result) => {
                    var daily_keyword_split_budget = this.methodData.Budget_KW;
                    var daily_demo_budget = this.methodData.Budget_DM;
                    var budget_addition = this.goalsData.form_addition;

                    if(this.dateData.start_date != "" && this.dateData.end_date != ""){
                        var d1 = new Date(this.dateData.start_date);
                        var d2 = new Date(this.dateData.end_date);
                        var days = parseInt((d2-d1)/86400000) + parseInt(1);
                    } else {
                        var days = 0;
                    }

                    var keyword_split_budget = 0;
                    if(this.methodData.Budget_KW != ''){
                        keyword_split_budget = Math.round(this.methodData.Budget_KW * days * (1+(budget_addition/100)));
                    }

                    var demo_budget = 0;
                    if(this.methodData.Budget_DM != ''){
                        demo_budget = this.methodData.Budget_DM * days;
                    }

                    var _tmp_audience_budget = 0;
                    var audience_budget = 0;
                    // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.5)');
                    _tmp_audience_budget = this.methodData.Budget_LA;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.5);
                    // console.log('Math.round('+_tmp_audience_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                    audience_budget = Math.round(_tmp_audience_budget * days * (1+(budget_addition/100)));

                    var _tmp_marketing_again_budget = 0;
                    var marketing_again_budget = 0;
                    // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.25)');
                    _tmp_marketing_again_budget = this.methodData.Budget_RT;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.25);
                    // console.log('Math.round('+_tmp_marketing_again_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                    marketing_again_budget = Math.round(_tmp_marketing_again_budget * days * (1+(budget_addition/100)));

                    // console.log(parseInt(keyword_split_budget)+' + '+parseInt(demo_budget)+' + '+parseInt(audience_budget)+' + '+parseInt(marketing_again_budget));
                    var ac_budget = 0;
                    if(this.methodData.Budget_AC != '' && this.methodData.Budget_AC != 0){
                        ac_budget = Math.round(this.methodData.Budget_AC * days);
                    }
                    var html = parseInt(keyword_split_budget) + parseInt(demo_budget) + parseInt(audience_budget) + parseInt(marketing_again_budget) + parseInt(ac_budget);

                    if(isNaN(html)){
                        html = '0';
                    }

                    this.total_budget = html;
                    this.syncLifetimeTotalBudget();

                    let _tmp_goalsData = this.goalsData;
                    const _view_goalsData = JSON.parse(JSON.stringify(_tmp_goalsData));
                    let _tmp_exAudiencesData = this.exAudiencesData;
                    const _view_exAudiencesData = JSON.parse(JSON.stringify(_tmp_exAudiencesData));

                    // console.log(_tmp_exAudiencesData);

                    delete _view_goalsData['objective_list'];
                    delete _view_exAudiencesData['custom_excluded_audiences'];

                    let formData = {
                      campaign_id: this.db_campaign_id,
                      campaign_name: this.campaign_name,
                      budget_type: this.budget_type,
                      special_ad_category: this.special_ad_category,
                      adaccount_id: this.adaccount_id,
                      Budget_KW_result: this.Budget_KW_result,
                      total_budget: this.total_budget,
                      useDefaultLayout: this.useDefaultLayout,
                      dynBudgetData: this.dynBudgetData,
                      methodData: this.methodData,
                      benefitsAndInvestmentData: this.benefitsAndInvestmentData,
                      dateData: this.dateData,
                      keywordData: this.keywordData,
                      lookData: this.lookData,
                      audiencesData: this.audiencesData,
                      goalsData: _view_goalsData,
                      regionsData: this.regionsData,
                      selectCountries: this.selectCountries,
                      selectLangs: this.selectLangs,
                      exAudiencesData: _view_exAudiencesData,
                      pdData: this.pdData,
                      idData: this.idData,
                      postData: this.postData,
                      adMaterialData: this.adMaterialDataNew,
                      autoAdjustData: this.autoAdjustData
                    }

                    let adaccount_id = this.adaccount_id

                    if(this.goalsData.campaign_objective == 'LEAD_GENERATION' || this.goalsData.campaign_objective == 'MESSAGES'){
                      // console.log('#1');
                      let materialType = 0;
                      let selectArticleLength = 0;
                      if(this.postData.select_article != '' && this.postData.select_article != null && typeof this.postData.select_article != 'undefined'){
                        selectArticleLength = this.postData.select_article.length;
                      }

                      let selectCreativesMessageLength = 0;
                      if(this.postData.select_creatives_message != '' && this.postData.select_creatives_message != null && typeof this.postData.select_creatives_message != 'undefined'){
                        selectCreativesMessageLength = this.postData.select_creatives_message.length;
                      }

                      let selectCreativesAdsetAdsMessageLength = 0;
                      if(this.postData.select_creatives_adset_ads_message != '' && this.postData.select_creatives_adset_ads_message != null && typeof this.postData.select_creatives_adset_ads_message != 'undefined'){
                        selectCreativesAdsetAdsMessageLength = this.postData.select_creatives_adset_ads_message.length;
                      }

                      let creativeArrayLength = 0;
                      if(this.adMaterialDataNew.creative_array != '' && this.adMaterialDataNew.creative_array != null && typeof this.adMaterialDataNew.creative_array != 'undefined'){
                        creativeArrayLength = this.adMaterialDataNew.creative_array.length;
                      }

                      if(creativeArrayLength == 0 && (!this.postData.select_creatives || this.postData.select_creatives.length == 0) && selectArticleLength == 0 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
                        materialType = 1;
                      } else if(selectArticleLength == 0 && selectCreativesMessageLength == 0 && selectCreativesAdsetAdsMessageLength == 0 && creativeArrayLength == 0 && this.goalsData.campaign_objective == 'MESSAGES'){
                        materialType = 2;
                      }

                  //  console.log('#3 materialType:'+materialType);

                      if(materialType == 0){
                        // console.log('#2');
                        let message_sr_i = 0;
                        let form_sr_i = 0;
                        let message = 0;
                        let single_object_spec = 0;
                        let single_title = 0;
                        let materials_item = 0;
                        let materials_object_spec = 0;
                        let materials_title = 0;
                        let ad_name = 0;

                        for(let i = 0; i < creativeArrayLength; i++){
                          if(this.adMaterialDataNew.creative_array[i].title == '' || this.adMaterialDataNew.creative_array[i].title == null || typeof this.adMaterialDataNew.creative_array[i].title == 'undefined'){
                            ad_name = 1;
                          }

                          if(this.adMaterialDataNew.creative_array[i].type == 2){
                            let materials_length = this.adMaterialDataNew.creative_array[i].materials.length

                            if(materials_length < 2){
                              materials_item = 1;
                            } else {
                              for(let j = 0; j < materials_length; j++){
                                if(this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == '' || this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == null || typeof this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == 'undefined'){
                                  materials_object_spec = 1;
                                }

                                if(this.adMaterialDataNew.creative_array[i].materials[j].title == '' || this.adMaterialDataNew.creative_array[i].materials[j].title == null || typeof this.adMaterialDataNew.creative_array[i].materials[j].title == 'undefined'){
                                  materials_title = 1;
                                }
                              }
                            }
                          }

                          if(this.adMaterialDataNew.creative_array[i].type == 1){
                            if(this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == '' || this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == null || typeof this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == 'undefined'){
                              single_object_spec = 1;
                            }

                            if(this.adMaterialDataNew.creative_array[i].materialSingle[0].title == '' || this.adMaterialDataNew.creative_array[i].materialSingle[0].title == null || typeof this.adMaterialDataNew.creative_array[i].materialSingle[0].title == 'undefined'){
                              single_title = 1;
                            }
                          }

                          if(this.adMaterialDataNew.creative_array[i].message == '' || this.adMaterialDataNew.creative_array[i].message == null || typeof this.adMaterialDataNew.creative_array[i].message == 'undefined'){
                            message = 1;
                          }

                          if(this.adMaterialDataNew.creative_array[i].form_sr_i == '' || this.adMaterialDataNew.creative_array[i].form_sr_i == null || typeof this.adMaterialDataNew.creative_array[i].form_sr_i == 'undefined'){
                            form_sr_i = 1;
                          }

                          if(this.adMaterialDataNew.creative_array[i].message_sr_i == '' || this.adMaterialDataNew.creative_array[i].message_sr_i == null || typeof this.adMaterialDataNew.creative_array[i].message_sr_i == 'undefined'){
                            message_sr_i = 1;
                          }
                        }

                        if(ad_name == 1){
                          Swal.fire(
                                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['swal_title'],
                                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['not_ad_name_swal_text'],
                                      "error"
                                    )
                        } else if(single_object_spec == 1){
                          Swal.fire(
                                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['swal_title'],
                                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['not_single_object_spec_swal_text'],
                                      "error"
                                    )
                        } else if(single_title == 1){
                          Swal.fire(
                                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['swal_title'],
                                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['not_single_title_swal_text'],
                                      "error"
                                    )
                        } else if(materials_item == 1){
                          Swal.fire(
                                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['swal_title'],
                                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['not_materials_item_swal_text'],
                                      "error"
                                    )
                        } else if(materials_object_spec == 1){
                          Swal.fire(
                                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['swal_title'],
                                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['not_materials_object_spec_swal_text'],
                                      "error"
                                    )
                        } else if(materials_title == 1){
                          Swal.fire(
                                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['swal_title'],
                                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['not_materials_title_swal_text'],
                                      "error"
                                    )
                        } else if(message == 1){
                          Swal.fire(
                                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['swal_title'],
                                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['not_message_swal_text'],
                                      "error"
                                    )
                        } else if(form_sr_i == 1 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
                          Swal.fire(
                                    this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['swal_title'],
                                    this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['not_form_sr_i_swal_text'],
                                    "error"
                                  )
                        } else if(message_sr_i == 1 && this.goalsData.campaign_objective == 'MESSAGES'){
                          Swal.fire(
                                    this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['swal_title'],
                                    this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['not_message_sr_i_swal_text'],
                                    "error"
                                  )
                        } else {
                          // console.log('#5');
                          axios
                            .post('https://www.autoturn.net/api/data/campaign_update.php', Qs.stringify({
                              s_code: this.$route.params.id,
                              form_data: formData,
                              type: 'release',
                              target: 'add_release_'+this.target,
                            }))
                            .then((response) => {
                              // console.log(response.data);
                              if(response.data.status == 'success'){
                                // this.immediateList = response.data.return_data
                                // this.formData = response.data.return_data.form

                                if(response.data.release_status == 'N' && response.data.release_writing_status == 'draft'){
                                  let name = this.campaign_name;
                                  let currency = this.currencyData.currency;
                                  let addition = this.goalsData.form_addition;
                                  let daily_budget = this.methodData.daily_budget;
                                  // let campaignInfo = "依您的預算設定，<br/>在未來兩週將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
                                  // if(addition == '' || addition == 0){
                                  //   campaignInfo = "依您的預算比率與行銷日期設定，<br/>將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
                                  // }

                                  // let addition_text = '（'+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['success']['addition_text']+'：<span style="color:red; font-weight:bold;">'+addition+'%</span>）';
                                  // if(this.methodData.Target_AD == true){
                                  //   addition_text = '';
                                  // }
                                  let addition_text = '';
                                  let two_week_budget = Math.round((daily_budget*7)+(daily_budget*7)+(daily_budget*7*(addition/100)));
                                  let campaignInfo = this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['success']['swal_text_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['success']['swal_text_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['success']['swal_text_total_budget_c']+"</span>"+addition_text;
                                  if(this.budget_type === 'lifetime' || this.dateData.end_date != '0000-00-00'){
                                    two_week_budget = this.total_budget;
                                    campaignInfo = this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['success']['swal_text_not_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['success']['swal_text_not_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['success']['swal_text_not_total_budget_c']+"</span>"+addition_text;
                                  }

                                  Swal.fire({
                                    // title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['success']['swal_title']+"「"+name+"」",
                                    title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['success']['swal_title'],
                                    html: campaignInfo + "<br/><br/>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['success']['swal_text_a']+"<span style='color:red;'>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['success']['swal_text_b']+"</span>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['success']['swal_text_c'],
                                    icon: 'warning',
                                    showCancelButton: true,
                                    confirmButtonColor: '#3085d6',
                                    cancelButtonColor: '#d33',
                                    confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['success']['yes_button'],
                                    cancelButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['success']['no_button'],
                                  }).then((result) => {
                                    if (result.isConfirmed) {
                                      // console.log(this.$route.params.id);

                                      this.releaseType = true
                                      this.style = 'z-index:100;';
                                      this.releasePercent = 5;
                                      let status = 1;
                                      let num = 0;
                                      let member_hash = this.$route.params.id;
                                      var bar5 = new ldBar("#myItem5");
                                      bar5.set(this.releasePercent);

                                      axios
                                        .post('https://www.autoturn.net/api/campaign_release.php', Qs.stringify({
                                          s_code: member_hash,
                                          campaign_id: this.db_campaign_id,
                                        }))
                                        .then((caResponse) => {
                                          // console.log('caResponse:'+caResponse.data.return_data);
                                          if(caResponse.data.status == 'success'){
                                            //進行進度條
                                            // console.log('發佈莞成，開始跑進度條');
                                            setInterval( () => {
                                              num++;
                                              if(num < 1200){
                                                // console.log('num:'+num);
                                                // console.log(this.releaseType);

                                                if(this.releaseType == true){
                                                  axios
                                                    .post('https://www.autoturn.net/api/campaign_states.php', Qs.stringify({
                                                      s_code: member_hash,
                                                      adaccount_id: this.adaccount_id,
                                                      campaign_id: this.db_campaign_id,
                                                    }))
                                                    .then((csResponse) => {
                                                      // console.log('csResponse:'+csResponse.data.return_data);
                                                      //進行進度條
                                                      if(status == 1){
                                                        if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'FAILURE'){
                                                          this.releaseType = false
                                                          this.style = 'z-index:-1;';
                                                          bar5.set(0);
                                                          status = 0;
                                                          // Swal.fire({
                                                          //   icon: 'error',
                                                          //   title: '正式發佈',
                                                          //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
                                                          //   showDenyButton: false,
                                                          //   showCancelButton: false,
                                                          //   confirmButtonText: '確定',
                                                          //   timer: 5000
                                                          //   // denyButtonText: `Don't save`,
                                                          // }).then((result) => {
                                                          //   /* Read more about isConfirmed, isDenied below */
                                                          //   if (result.isConfirmed) {
                                                          //     // Swal.fire('Saved!', '', 'success')
                                                          //     this.allPageLoading = true
                                                          //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                                          //   } else if (result.isDenied) {
                                                          //     // Swal.fire('Changes are not saved', '', 'info')
                                                          //     this.allPageLoading = true
                                                          //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                                          //   }

                                                          //   if (result.dismiss === Swal.DismissReason.timer) {
                                                          //     this.allPageLoading = true
                                                          //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                                          //   }
                                                          // })
                                                          Swal.fire({
                                                            icon: 'error',
                                                            title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['success']['info_state_failure']['swal_title'],
                                                            text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['success']['info_state_failure']['swal_html']+csResponse.data.return_data.info_text,
                                                            showDenyButton: false,
                                                            showCancelButton: false,
                                                            confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['success']['info_state_failure']['confirm_button']
                                                          }).then((result) => {

                                                          })
                                                        } else if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'SUCCESS'){
                                                          status = 0;

                                                          let postData = {adaccount_id: this.$route.params.adaccount_id};
                                                          let codeHash = ['de', 'di']

                                                          const data = new URLSearchParams();
                                                          data.append('s_code', this.$route.params.id);
                                                          data.append('post_data', JSON.stringify(postData));
                                                          data.append('code_hash', JSON.stringify(codeHash));
                                                          data.append('update_type', true);

                                                          // 發送請求
                                                          navigator.sendBeacon(
                                                            'https://www.autoturn.net/api/update_cache.php',
                                                            data
                                                          );

                                                          axios
                                                            .post('https://www.autoturn.net/api/data/campaign_creative_optimize_update.php', Qs.stringify({
                                                              s_code: member_hash,
                                                              id: this.db_campaign_id,
                                                            }))
                                                            .then((response) => {
                                                              axios
                                                                .get('https://www.autoturn.net/udnapi/public/send_notice_email.php?s_code='+member_hash+'&form=release&sr_i='+this.db_campaign_id)
                                                                .then((csResponse) => {
                                                                  this.releaseType = false

                                                                  Swal.fire({
                                                                    icon: 'success',
                                                                    title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['success']['info_state_success']['swal_title'],
                                                                    text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['success']['info_state_success']['swal_html'],
                                                                    showDenyButton: false,
                                                                    showCancelButton: false,
                                                                    confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['success']['info_state_success']['confirm_button'],
                                                                    timer: 5000
                                                                    // denyButtonText: `Don't save`,
                                                                  }).then((result) => {
                                                                    /* Read more about isConfirmed, isDenied below */
                                                                    if (result.isConfirmed) {
                                                                      // Swal.fire('Saved!', '', 'success')
                                                                      this.allPageLoading = true
                                                                      window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                                                    } else if (result.isDenied) {
                                                                      // Swal.fire('Changes are not saved', '', 'info')
                                                                      this.allPageLoading = true
                                                                      window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                                                    }

                                                                    if (result.dismiss === Swal.DismissReason.timer) {
                                                                      this.allPageLoading = true
                                                                      window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                                                    }
                                                                  })
                                                                });
                                                            });
                                                        } else if(csResponse.data.return_data.state == 'FAILURE' && csResponse.data.return_data.info_state == 'FAILURE'){
                                                          this.releaseType = false
                                                          this.style = 'z-index:-1;';
                                                          bar5.set(0);
                                                          status = 0;
                                                          // Swal.fire({
                                                          //   icon: 'error',
                                                          //   title: '正式發佈',
                                                          //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
                                                          //   showDenyButton: false,
                                                          //   showCancelButton: false,
                                                          //   confirmButtonText: '確定',
                                                          //   timer: 5000
                                                          //   // denyButtonText: `Don't save`,
                                                          // }).then((result) => {
                                                          //   /* Read more about isConfirmed, isDenied below */
                                                          //   if (result.isConfirmed) {
                                                          //     // Swal.fire('Saved!', '', 'success')
                                                          //     this.allPageLoading = true
                                                          //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                                          //   } else if (result.isDenied) {
                                                          //     // Swal.fire('Changes are not saved', '', 'info')
                                                          //     this.allPageLoading = true
                                                          //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                                          //   }

                                                          //   if (result.dismiss === Swal.DismissReason.timer) {
                                                          //     this.allPageLoading = true
                                                          //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                                          //   }
                                                          // })
                                                          Swal.fire({
                                                            icon: 'error',
                                                            title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['success']['state_failure']['swal_title'],
                                                            text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['success']['state_failure']['swal_html']+csResponse.data.return_data.info_text,
                                                            showDenyButton: false,
                                                            showCancelButton: false,
                                                            confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['success']['state_failure']['confirm_button']
                                                          }).then((result) => {

                                                          })
                                                        } else {
                                                          this.releaseText = csResponse.data.return_data.info_text
                                                          this.releasePercent = csResponse.data.return_data.info_pct

                                                          bar5.set(this.releasePercent);
                                                          // console.log('csResponse.data.return_data.info_text:'+csResponse.data.return_data.info_text);
                                                          // console.log('csResponse.data.return_data.info_pct:'+csResponse.data.return_data.info_pct);
                                                          // console.log('this.releaseText:'+this.releaseText);
                                                          // console.log('this.releasePercent:'+this.releasePercent);

                                                          if(csResponse.data.return_data.info_pct == 100){
                                                            this.releaseType = false
                                                            this.style = 'z-index:-1;';
                                                            bar5.set(0);
                                                            status = 0;
                                                          }
                                                        }
                                                      }
                                                    });
                                                }
                                              } else {
                                                Swal.fire({
                                                  icon: 'warning',
                                                  title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['success']['else']['swal_title'],
                                                  text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['success']['else']['swal_html'],
                                                  showDenyButton: false,
                                                  showCancelButton: false,
                                                  confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['success']['else']['confirm_button'],
                                                  timer: 1000
                                                  // denyButtonText: `Don't save`,
                                                }).then((result) => {
                                                  /* Read more about isConfirmed, isDenied below */
                                                  if (result.isConfirmed) {
                                                    // Swal.fire('Saved!', '', 'success')
                                                    this.allPageLoading = true
                                                    window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                                  } else if (result.isDenied) {
                                                    // Swal.fire('Changes are not saved', '', 'info')
                                                    this.allPageLoading = true
                                                    window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                                  }

                                                  if (result.dismiss === Swal.DismissReason.timer) {
                                                    this.allPageLoading = true
                                                    window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                                  }
                                                })
                                              }
                                            }, 3000);
                                          }
                                        });
                                    }
                                  })
                                } else {
                                  Swal.fire(
                                    this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['success']['swal_title'],
                                    response.data.info,
                                    'error'
                                  )
                                }

                                // if(type == 1){
                                //   var todayForm = new Date();
                                //   var yearForm = todayForm.getFullYear();
                                //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                                //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                                //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                                //   todayForm = yearForm + monthForm + dateForm + timeForm;

                                //   this.formTitle = 'title_'+todayForm;
                                // } else {
                                //   this.formTitle = response.data.return_data.name;
                                // }

                                // this.showModal = true
                              } else {
                                let text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['not_success']['default_swal_text'];
                                if(response.data.info != '' && response.data.info != null){
                                  text = response.data.info
                                }
                                Swal.fire(
                                  this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['not_success']['swal_title'],
                                  text,
                                  'error'
                                )
                              }
                            });
                        }
                      } else {
                        // console.log('#3');
                        Swal.fire(
                                    this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['not_creative_array_swal_title'],
                                    this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['not_creative_array_swal_text'],
                                    "error"
                                  )
                      }
                    } else {
                      axios
                        .post('https://www.autoturn.net/api/data/campaign_update.php', Qs.stringify({
                          s_code: this.$route.params.id,
                          form_data: formData,
                          type: 'release',
                          target: 'add_release_'+this.target,
                        }))
                        .then((response) => {
                          // console.log(response.data);
                          if(response.data.status == 'success'){
                            // this.immediateList = response.data.return_data
                            // this.formData = response.data.return_data.form

                            if(response.data.release_status == 'N' && response.data.release_writing_status == 'draft'){
                              let name = this.campaign_name;
                              let currency = this.currencyData.currency;
                              let addition = this.goalsData.form_addition;
                              let daily_budget = this.methodData.daily_budget;
                              // let campaignInfo = "依您的預算設定，<br/>在未來兩週將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
                              // if(addition == '' || addition == 0){
                              //   campaignInfo = "依您的預算比率與行銷日期設定，<br/>將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
                              // }

                              // let addition_text = '（'+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['not_lead_messages']['campaign_update']['success']['addition_text']+'：<span style="color:red; font-weight:bold;">'+addition+'%</span>）';
                              // if(this.methodData.Target_AD == true){
                              //   addition_text = '';
                              // }
                              let addition_text = '';
                              let two_week_budget = Math.round((daily_budget*7)+(daily_budget*7)+(daily_budget*7*(addition/100)));
                              let campaignInfo = this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['not_lead_messages']['campaign_update']['success']['swal_text_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['not_lead_messages']['campaign_update']['success']['swal_text_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['not_lead_messages']['campaign_update']['success']['swal_text_total_budget_c']+"</span>"+addition_text;
                              if(this.budget_type === 'lifetime' || this.dateData.end_date != '0000-00-00'){
                                two_week_budget = this.total_budget;
                                campaignInfo = this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['not_lead_messages']['campaign_update']['success']['swal_text_not_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['not_lead_messages']['campaign_update']['success']['swal_text_not_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['not_lead_messages']['campaign_update']['success']['swal_text_not_total_budget_c']+"</span>"+addition_text;
                              }

                              Swal.fire({
                                // title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['not_lead_messages']['campaign_update']['success']['swal_title']+"「"+name+"」",
                                title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['not_lead_messages']['campaign_update']['success']['swal_title'],
                                html: campaignInfo + "<br/><br/>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['not_lead_messages']['campaign_update']['success']['swal_text_a']+"<span style='color:red;'>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['not_lead_messages']['campaign_update']['success']['swal_text_b']+"</span>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['not_lead_messages']['campaign_update']['success']['swal_text_c'],
                                icon: 'warning',
                                showCancelButton: true,
                                confirmButtonColor: '#3085d6',
                                cancelButtonColor: '#d33',
                                confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['not_lead_messages']['campaign_update']['success']['yes_button'],
                                cancelButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['not_lead_messages']['campaign_update']['success']['no_button'],
                              }).then((result) => {
                                if (result.isConfirmed) {
                                  // console.log(this.$route.params.id);

                                  this.releaseType = true
                                  this.style = 'z-index:100;';
                                  this.releasePercent = 5;
                                  let status = 1;
                                  let num = 0;
                                  let member_hash = this.$route.params.id;
                                  var bar5 = new ldBar("#myItem5");
                                  bar5.set(this.releasePercent);

                                  axios
                                    .post('https://www.autoturn.net/api/campaign_release.php', Qs.stringify({
                                      s_code: member_hash,
                                      campaign_id: this.db_campaign_id,
                                    }))
                                    .then((caResponse) => {
                                      // console.log('caResponse:'+caResponse.data.return_data);
                                      if(caResponse.data.status == 'success'){
                                        //進行進度條
                                        // console.log('發佈莞成，開始跑進度條');
                                        setInterval( () => {
                                          num++;
                                          if(num < 1200){
                                            // console.log('num:'+num);
                                            // console.log(this.releaseType);

                                            if(this.releaseType == true){
                                              axios
                                                .post('https://www.autoturn.net/api/campaign_states.php', Qs.stringify({
                                                  s_code: member_hash,
                                                  adaccount_id: this.adaccount_id,
                                                  campaign_id: this.db_campaign_id,
                                                }))
                                                .then((csResponse) => {
                                                  // console.log('csResponse:'+csResponse.data.return_data);
                                                  //進行進度條
                                                  if(status == 1){
                                                    if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'FAILURE'){
                                                      this.releaseType = false
                                                      this.style = 'z-index:-1;';
                                                      bar5.set(0);
                                                      status = 0;
                                                      // Swal.fire({
                                                      //   icon: 'error',
                                                      //   title: '正式發佈',
                                                      //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
                                                      //   showDenyButton: false,
                                                      //   showCancelButton: false,
                                                      //   confirmButtonText: '確定',
                                                      //   timer: 5000
                                                      //   // denyButtonText: `Don't save`,
                                                      // }).then((result) => {
                                                      //   /* Read more about isConfirmed, isDenied below */
                                                      //   if (result.isConfirmed) {
                                                      //     // Swal.fire('Saved!', '', 'success')
                                                      //     this.allPageLoading = true
                                                      //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                                      //   } else if (result.isDenied) {
                                                      //     // Swal.fire('Changes are not saved', '', 'info')
                                                      //     this.allPageLoading = true
                                                      //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                                      //   }

                                                      //   if (result.dismiss === Swal.DismissReason.timer) {
                                                      //     this.allPageLoading = true
                                                      //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                                      //   }
                                                      // })
                                                      Swal.fire({
                                                        icon: 'error',
                                                        title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['not_lead_messages']['campaign_update']['success']['info_state_failure']['swal_title'],
                                                        text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['not_lead_messages']['campaign_update']['success']['info_state_failure']['swal_html']+csResponse.data.return_data.info_text,
                                                        showDenyButton: false,
                                                        showCancelButton: false,
                                                        confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['not_lead_messages']['campaign_update']['success']['info_state_failure']['confirm_button']
                                                      }).then((result) => {

                                                      })
                                                    } else if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'SUCCESS'){
                                                      status = 0;

                                                      let postData = {adaccount_id: this.$route.params.adaccount_id};
                                                      let codeHash = ['de', 'di']

                                                      const data = new URLSearchParams();
                                                      data.append('s_code', this.$route.params.id);
                                                      data.append('post_data', JSON.stringify(postData));
                                                      data.append('code_hash', JSON.stringify(codeHash));
                                                      data.append('update_type', true);

                                                      // 發送請求
                                                      navigator.sendBeacon(
                                                        'https://www.autoturn.net/api/update_cache.php',
                                                        data
                                                      );

                                                      axios
                                                        .post('https://www.autoturn.net/api/data/campaign_creative_optimize_update.php', Qs.stringify({
                                                          s_code: member_hash,
                                                          id: this.db_campaign_id,
                                                        }))
                                                        .then((response) => {
                                                          axios
                                                            .get('https://www.autoturn.net/udnapi/public/send_notice_email.php?s_code='+member_hash+'&form=release&sr_i='+this.db_campaign_id)
                                                            .then((csResponse) => {
                                                              this.releaseType = false

                                                              Swal.fire({
                                                                icon: 'success',
                                                                title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['not_lead_messages']['campaign_update']['success']['info_state_success']['swal_title'],
                                                                text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['not_lead_messages']['campaign_update']['success']['info_state_success']['swal_html'],
                                                                showDenyButton: false,
                                                                showCancelButton: false,
                                                                confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['not_lead_messages']['campaign_update']['success']['info_state_success']['confirm_button'],
                                                                timer: 5000
                                                                // denyButtonText: `Don't save`,
                                                              }).then((result) => {
                                                                /* Read more about isConfirmed, isDenied below */
                                                                if (result.isConfirmed) {
                                                                  // Swal.fire('Saved!', '', 'success')
                                                                  this.allPageLoading = true
                                                                  window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                                                } else if (result.isDenied) {
                                                                  // Swal.fire('Changes are not saved', '', 'info')
                                                                  this.allPageLoading = true
                                                                  window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                                                }

                                                                if (result.dismiss === Swal.DismissReason.timer) {
                                                                  this.allPageLoading = true
                                                                  window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                                                }
                                                              })
                                                            });
                                                        });
                                                    } else if(csResponse.data.return_data.state == 'FAILURE' && csResponse.data.return_data.info_state == 'FAILURE'){
                                                      this.releaseType = false
                                                      this.style = 'z-index:-1;';
                                                      bar5.set(0);
                                                      status = 0;
                                                      // Swal.fire({
                                                      //   icon: 'error',
                                                      //   title: '正式發佈',
                                                      //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
                                                      //   showDenyButton: false,
                                                      //   showCancelButton: false,
                                                      //   confirmButtonText: '確定',
                                                      //   timer: 5000
                                                      //   // denyButtonText: `Don't save`,
                                                      // }).then((result) => {
                                                      //   /* Read more about isConfirmed, isDenied below */
                                                      //   if (result.isConfirmed) {
                                                      //     // Swal.fire('Saved!', '', 'success')
                                                      //     this.allPageLoading = true
                                                      //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                                      //   } else if (result.isDenied) {
                                                      //     // Swal.fire('Changes are not saved', '', 'info')
                                                      //     this.allPageLoading = true
                                                      //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                                      //   }

                                                      //   if (result.dismiss === Swal.DismissReason.timer) {
                                                      //     this.allPageLoading = true
                                                      //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                                      //   }
                                                      // })
                                                      Swal.fire({
                                                        icon: 'error',
                                                        title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['not_lead_messages']['campaign_update']['success']['state_failure']['swal_title'],
                                                        text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['not_lead_messages']['campaign_update']['success']['state_failure']['swal_html']+csResponse.data.return_data.info_text,
                                                        showDenyButton: false,
                                                        showCancelButton: false,
                                                        confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['not_lead_messages']['campaign_update']['success']['state_failure']['confirm_button']
                                                      }).then((result) => {

                                                      })
                                                    } else {
                                                      this.releaseText = csResponse.data.return_data.info_text
                                                      this.releasePercent = csResponse.data.return_data.info_pct

                                                      bar5.set(this.releasePercent);
                                                      // console.log('csResponse.data.return_data.info_text:'+csResponse.data.return_data.info_text);
                                                      // console.log('csResponse.data.return_data.info_pct:'+csResponse.data.return_data.info_pct);
                                                      // console.log('this.releaseText:'+this.releaseText);
                                                      // console.log('this.releasePercent:'+this.releasePercent);

                                                      if(csResponse.data.return_data.info_pct == 100){
                                                        this.releaseType = false
                                                        this.style = 'z-index:-1;';
                                                        bar5.set(0);
                                                        status = 0;
                                                      }
                                                    }
                                                  }
                                                });
                                            }
                                          } else {
                                            Swal.fire({
                                              icon: 'warning',
                                              title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['not_lead_messages']['campaign_update']['success']['else']['swal_title'],
                                              text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['not_lead_messages']['campaign_update']['success']['else']['swal_html'],
                                              showDenyButton: false,
                                              showCancelButton: false,
                                              confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['not_lead_messages']['campaign_update']['success']['else']['confirm_button'],
                                              timer: 1000
                                              // denyButtonText: `Don't save`,
                                            }).then((result) => {
                                              /* Read more about isConfirmed, isDenied below */
                                              if (result.isConfirmed) {
                                                // Swal.fire('Saved!', '', 'success')
                                                this.allPageLoading = true
                                                window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                              } else if (result.isDenied) {
                                                // Swal.fire('Changes are not saved', '', 'info')
                                                this.allPageLoading = true
                                                window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                              }

                                              if (result.dismiss === Swal.DismissReason.timer) {
                                                this.allPageLoading = true
                                                window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                              }
                                            })
                                          }
                                        }, 3000);
                                      }
                                    });
                                }
                              })
                            } else {
                              Swal.fire(
                                this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['not_lead_messages']['campaign_update']['success']['swal_title'],
                                response.data.info,
                                'error'
                              )
                            }

                            // if(type == 1){
                            //   var todayForm = new Date();
                            //   var yearForm = todayForm.getFullYear();
                            //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                            //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                            //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                            //   todayForm = yearForm + monthForm + dateForm + timeForm;

                            //   this.formTitle = 'title_'+todayForm;
                            // } else {
                            //   this.formTitle = response.data.return_data.name;
                            // }

                            // this.showModal = true
                          } else {
                            let text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['not_lead_messages']['campaign_update']['not_success']['default_swal_text'];
                            if(response.data.info != '' && response.data.info != null){
                              text = response.data.info
                            }
                            Swal.fire(
                              this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['not_lead_messages']['campaign_update']['not_success']['swal_title'],
                              text,
                              'error'
                            )
                          }
                        });
                    }
                  });
                }

                if(caResponse.data.status == 'success'){
                  var daily_keyword_split_budget = this.methodData.Budget_KW;
                  var daily_demo_budget = this.methodData.Budget_DM;
                  var budget_addition = this.goalsData.form_addition;

                  if(this.dateData.start_date != "" && this.dateData.end_date != ""){
                      var d1 = new Date(this.dateData.start_date);
                      var d2 = new Date(this.dateData.end_date);
                      var days = parseInt((d2-d1)/86400000) + parseInt(1);
                  } else {
                      var days = 0;
                  }

                  var keyword_split_budget = 0;
                  if(this.methodData.Budget_KW != ''){
                      keyword_split_budget = Math.round(this.methodData.Budget_KW * days * (1+(budget_addition/100)));
                  }

                  var demo_budget = 0;
                  if(this.methodData.Budget_DM != ''){
                      demo_budget = this.methodData.Budget_DM * days;
                  }

                  var _tmp_audience_budget = 0;
                  var audience_budget = 0;
                  // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.5)');
                  _tmp_audience_budget = this.methodData.Budget_LA;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.5);
                  // console.log('Math.round('+_tmp_audience_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                  audience_budget = Math.round(_tmp_audience_budget * days * (1+(budget_addition/100)));

                  var _tmp_marketing_again_budget = 0;
                  var marketing_again_budget = 0;
                  // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.25)');
                  _tmp_marketing_again_budget = this.methodData.Budget_RT;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.25);
                  // console.log('Math.round('+_tmp_marketing_again_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                  marketing_again_budget = Math.round(_tmp_marketing_again_budget * days * (1+(budget_addition/100)));

                  // console.log(parseInt(keyword_split_budget)+' + '+parseInt(demo_budget)+' + '+parseInt(audience_budget)+' + '+parseInt(marketing_again_budget));
                  var ac_budget = 0;
                  if(this.methodData.Budget_AC != '' && this.methodData.Budget_AC != 0){
                      ac_budget = Math.round(this.methodData.Budget_AC * days);
                  }
                  var html = parseInt(keyword_split_budget) + parseInt(demo_budget) + parseInt(audience_budget) + parseInt(marketing_again_budget) + parseInt(ac_budget);

                  if(isNaN(html)){
                      html = '0';
                  }

                  this.total_budget = html;
                  this.syncLifetimeTotalBudget();

                  let _tmp_goalsData = this.goalsData;
                  const _view_goalsData = JSON.parse(JSON.stringify(_tmp_goalsData));
                  let _tmp_exAudiencesData = this.exAudiencesData;
                  const _view_exAudiencesData = JSON.parse(JSON.stringify(_tmp_exAudiencesData));

                  delete _view_goalsData['objective_list'];
                  delete _view_exAudiencesData['custom_excluded_audiences'];

                  let formData = {
                    campaign_id: this.db_campaign_id,
                    campaign_name: this.campaign_name,
                      budget_type: this.budget_type,
                      special_ad_category: this.special_ad_category,
                    adaccount_id: this.adaccount_id,
                    Budget_KW_result: this.Budget_KW_result,
                    total_budget: this.total_budget,
                    useDefaultLayout: this.useDefaultLayout,
                    dynBudgetData: this.dynBudgetData,
                    methodData: this.methodData,
                    benefitsAndInvestmentData: this.benefitsAndInvestmentData,
                    dateData: this.dateData,
                    keywordData: this.keywordData,
                    lookData: this.lookData,
                    audiencesData: this.audiencesData,
                    goalsData: _view_goalsData,
                    regionsData: this.regionsData,
                    selectCountries: this.selectCountries,
                    selectLangs: this.selectLangs,
                    exAudiencesData: _view_exAudiencesData,
                    pdData: this.pdData,
                    idData: this.idData,
                    postData: this.postData,
                    adMaterialData: this.adMaterialDataNew,
                    autoAdjustData: this.autoAdjustData
                  }

                  let adaccount_id = this.adaccount_id

                  if(this.goalsData.campaign_objective == 'LEAD_GENERATION' || this.goalsData.campaign_objective == 'MESSAGES'){
                    // console.log('#1');
                    let materialType = 0;
                    let selectArticleLength = 0;
                    if(this.postData.select_article != '' && this.postData.select_article != null && typeof this.postData.select_article != 'undefined'){
                      selectArticleLength = this.postData.select_article.length;
                    }

                    let selectCreativesMessageLength = 0;
                    if(this.postData.select_creatives_message != '' && this.postData.select_creatives_message != null && typeof this.postData.select_creatives_message != 'undefined'){
                      selectCreativesMessageLength = this.postData.select_creatives_message.length;
                    }

                    let selectCreativesAdsetAdsMessageLength = 0;
                    if(this.postData.select_creatives_adset_ads_message != '' && this.postData.select_creatives_adset_ads_message != null && typeof this.postData.select_creatives_adset_ads_message != 'undefined'){
                      selectCreativesAdsetAdsMessageLength = this.postData.select_creatives_adset_ads_message.length;
                    }

                    let creativeArrayLength = 0;
                    if(this.adMaterialDataNew.creative_array != '' && this.adMaterialDataNew.creative_array != null && typeof this.adMaterialDataNew.creative_array != 'undefined'){
                      creativeArrayLength = this.adMaterialDataNew.creative_array.length;
                    }

                    if(creativeArrayLength == 0 && (!this.postData.select_creatives || this.postData.select_creatives.length == 0) && selectArticleLength == 0 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
                      materialType = 1;
                    } else if(selectArticleLength == 0 && selectCreativesMessageLength == 0 && selectCreativesAdsetAdsMessageLength == 0 && creativeArrayLength == 0 && this.goalsData.campaign_objective == 'MESSAGES'){
                      materialType = 2;
                    }

                    if(materialType == 0){
                      // console.log('#2');
                      let message_sr_i = 0;
                      let form_sr_i = 0;
                      let message = 0;
                      let single_object_spec = 0;
                      let single_title = 0;
                      let materials_item = 0;
                      let materials_object_spec = 0;
                      let materials_title = 0;
                      let ad_name = 0;

                      for(let i = 0; i < creativeArrayLength; i++){
                        if(this.adMaterialDataNew.creative_array[i].title == '' || this.adMaterialDataNew.creative_array[i].title == null || typeof this.adMaterialDataNew.creative_array[i].title == 'undefined'){
                          ad_name = 1;
                        }

                        if(this.adMaterialDataNew.creative_array[i].type == 2){
                          let materials_length = this.adMaterialDataNew.creative_array[i].materials.length

                          if(materials_length < 2){
                            materials_item = 1;
                          } else {
                            for(let j = 0; j < materials_length; j++){
                              if(this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == '' || this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == null || typeof this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == 'undefined'){
                                materials_object_spec = 1;
                              }

                              if(this.adMaterialDataNew.creative_array[i].materials[j].title == '' || this.adMaterialDataNew.creative_array[i].materials[j].title == null || typeof this.adMaterialDataNew.creative_array[i].materials[j].title == 'undefined'){
                                materials_title = 1;
                              }
                            }
                          }
                        }

                        if(this.adMaterialDataNew.creative_array[i].type == 1){
                          if(this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == '' || this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == null || typeof this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == 'undefined'){
                            single_object_spec = 1;
                          }

                          if(this.adMaterialDataNew.creative_array[i].materialSingle[0].title == '' || this.adMaterialDataNew.creative_array[i].materialSingle[0].title == null || typeof this.adMaterialDataNew.creative_array[i].materialSingle[0].title == 'undefined'){
                            single_title = 1;
                          }
                        }

                        if(this.adMaterialDataNew.creative_array[i].message == '' || this.adMaterialDataNew.creative_array[i].message == null || typeof this.adMaterialDataNew.creative_array[i].message == 'undefined'){
                          message = 1;
                        }

                        if(this.adMaterialDataNew.creative_array[i].form_sr_i == '' || this.adMaterialDataNew.creative_array[i].form_sr_i == null || typeof this.adMaterialDataNew.creative_array[i].form_sr_i == 'undefined'){
                          form_sr_i = 1;
                        }

                        if(this.adMaterialDataNew.creative_array[i].message_sr_i == '' || this.adMaterialDataNew.creative_array[i].message_sr_i == null || typeof this.adMaterialDataNew.creative_array[i].message_sr_i == 'undefined'){
                          message_sr_i = 1;
                        }
                      }

                      if(ad_name == 1){
                        Swal.fire(
                                    this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['swal_title'],
                                    this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['not_ad_name_swal_text'],
                                    "error"
                                  )
                      } else if(single_object_spec == 1){
                        Swal.fire(
                                    this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['swal_title'],
                                    this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['not_single_object_spec_swal_text'],
                                    "error"
                                  )
                      } else if(single_title == 1){
                        Swal.fire(
                                    this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['swal_title'],
                                    this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['not_single_title_swal_text'],
                                    "error"
                                  )
                      } else if(materials_item == 1){
                        Swal.fire(
                                    this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['swal_title'],
                                    this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['not_materials_item_swal_text'],
                                    "error"
                                  )
                      } else if(materials_object_spec == 1){
                        Swal.fire(
                                    this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['swal_title'],
                                    this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['not_materials_object_spec_swal_text'],
                                    "error"
                                  )
                      } else if(materials_title == 1){
                        Swal.fire(
                                    this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['swal_title'],
                                    this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['not_materials_title_swal_text'],
                                    "error"
                                  )
                      } else if(message == 1){
                        Swal.fire(
                                    this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['swal_title'],
                                    this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['not_message_swal_text'],
                                    "error"
                                  )
                      } else if(form_sr_i == 1 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
                        Swal.fire(
                                  this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['swal_title'],
                                  this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['not_form_sr_i_swal_text'],
                                  "error"
                                )
                      } else if(message_sr_i == 1 && this.goalsData.campaign_objective == 'MESSAGES'){
                        Swal.fire(
                                  this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['swal_title'],
                                  this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['not_message_sr_i_swal_text'],
                                  "error"
                                )
                      } else {
                        // console.log('#5');
                        axios
                          .post('https://www.autoturn.net/api/data/campaign_update.php', Qs.stringify({
                            s_code: this.$route.params.id,
                            form_data: formData,
                            type: 'release',
                            target: 'add_release_'+this.target,
                          }))
                          .then((response) => {
                            // console.log(response.data);
                            if(response.data.status == 'success'){
                              // this.immediateList = response.data.return_data
                              // this.formData = response.data.return_data.form

                              if(response.data.release_status == 'N' && response.data.release_writing_status == 'draft'){
                                let name = this.campaign_name;
                                let currency = this.currencyData.currency;
                                let addition = this.goalsData.form_addition;
                                let daily_budget = this.methodData.daily_budget;
                                // let campaignInfo = "依您的預算設定，<br/>在未來兩週將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
                                // if(addition == '' || addition == 0){
                                //   campaignInfo = "依您的預算比率與行銷日期設定，<br/>將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
                                // }

                                // let addition_text = '（'+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['campaign_update']['success']['addition_text']+'：<span style="color:red; font-weight:bold;">'+addition+'%</span>）';
                                // if(this.methodData.Target_AD == true){
                                //   addition_text = '';
                                // }
                                let addition_text = '';
                                let two_week_budget = Math.round((daily_budget*7)+(daily_budget*7)+(daily_budget*7*(addition/100)));
                                let campaignInfo = this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['campaign_update']['success']['swal_text_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['campaign_update']['success']['swal_text_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['campaign_update']['success']['swal_text_total_budget_c']+"</span>"+addition_text;
                                if(this.budget_type === 'lifetime' || this.dateData.end_date != '0000-00-00'){
                                  two_week_budget = this.total_budget;
                                  campaignInfo = this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['campaign_update']['success']['swal_text_not_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['campaign_update']['success']['swal_text_not_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['campaign_update']['success']['swal_text_not_total_budget_c']+"</span>"+addition_text;
                                }

                                Swal.fire({
                                  // title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['campaign_update']['success']['swal_title']+"「"+name+"」",
                                  title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['campaign_update']['success']['swal_title'],
                                  html: campaignInfo + "<br/><br/>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['campaign_update']['success']['swal_text_a']+"<span style='color:red;'>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['campaign_update']['success']['swal_text_b']+"</span>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['campaign_update']['success']['swal_text_c'],
                                  icon: 'warning',
                                  showCancelButton: true,
                                  confirmButtonColor: '#3085d6',
                                  cancelButtonColor: '#d33',
                                  confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['campaign_update']['success']['yes_button'],
                                  cancelButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['campaign_update']['success']['no_button'],
                                }).then((result) => {
                                  if (result.isConfirmed) {
                                    // console.log(this.$route.params.id);

                                    this.releaseType = true
                                    this.style = 'z-index:100;';
                                    this.releasePercent = 5;
                                    let status = 1;
                                    let num = 0;
                                    let member_hash = this.$route.params.id;
                                    var bar5 = new ldBar("#myItem5");
                                    bar5.set(this.releasePercent);

                                    axios
                                      .post('https://www.autoturn.net/api/campaign_release.php', Qs.stringify({
                                        s_code: member_hash,
                                        campaign_id: this.db_campaign_id,
                                      }))
                                      .then((caResponse) => {
                                        // console.log('caResponse:'+caResponse.data.return_data);
                                        fbq('trackCustom', 'Release');
                                        if(caResponse.data.status == 'success'){
                                          //進行進度條
                                          // console.log('發佈莞成，開始跑進度條');
                                          setInterval( () => {
                                            num++;
                                            if(num < 1200){
                                              // console.log('num:'+num);
                                              // console.log(this.releaseType);

                                              if(this.releaseType == true){
                                                axios
                                                  .post('https://www.autoturn.net/api/campaign_states.php', Qs.stringify({
                                                    s_code: member_hash,
                                                    adaccount_id: this.adaccount_id,
                                                    campaign_id: this.db_campaign_id,
                                                  }))
                                                  .then((csResponse) => {
                                                    // console.log('csResponse:'+csResponse.data.return_data);
                                                    //進行進度條
                                                    if(status == 1){
                                                      if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'FAILURE'){
                                                        this.releaseType = false
                                                        this.style = 'z-index:-1;';
                                                        bar5.set(0);
                                                        status = 0;
                                                        // Swal.fire({
                                                        //   icon: 'error',
                                                        //   title: '正式發佈',
                                                        //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
                                                        //   showDenyButton: false,
                                                        //   showCancelButton: false,
                                                        //   confirmButtonText: '確定',
                                                        //   timer: 5000
                                                        //   // denyButtonText: `Don't save`,
                                                        // }).then((result) => {
                                                        //   /* Read more about isConfirmed, isDenied below */
                                                        //   if (result.isConfirmed) {
                                                        //     // Swal.fire('Saved!', '', 'success')
                                                        //     this.allPageLoading = true
                                                        //     window.location.href = "https://private.autoturn.net/events-list/"+member_hash+"/"+adaccount_id;
                                                        //   } else if (result.isDenied) {
                                                        //     // Swal.fire('Changes are not saved', '', 'info')
                                                        //     this.allPageLoading = true
                                                        //     window.location.href = "https://private.autoturn.net/events-list/"+member_hash+"/"+adaccount_id;
                                                        //   }

                                                        //   if (result.dismiss === Swal.DismissReason.timer) {
                                                        //     this.allPageLoading = true
                                                        //     window.location.href = "https://private.autoturn.net/events-list/"+member_hash+"/"+adaccount_id;
                                                        //   }
                                                        // })
                                                        Swal.fire({
                                                          icon: 'error',
                                                          title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['campaign_update']['success']['info_state_failure']['swal_title'],
                                                          text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['campaign_update']['success']['info_state_failure']['swal_html']+csResponse.data.return_data.info_text,
                                                          showDenyButton: false,
                                                          showCancelButton: false,
                                                          confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['campaign_update']['success']['info_state_failure']['confirm_button']
                                                        }).then((result) => {
                                                          let info_text = csResponse.data.return_data.info_text;
                                                          let tosStatus = info_text.includes("/leadgen/tos");
                                                          if(tosStatus == true){
                                                            window.open('https://www.facebook.com/ads/leadgen/tos', '', 'height=768,width=1024');
                                                          }
                                                        })
                                                      } else if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'SUCCESS'){
                                                        status = 0;

                                                        let postData = {adaccount_id: this.$route.params.adaccount_id};
                                                        let codeHash = ['de', 'di']

                                                        const data = new URLSearchParams();
                                                        data.append('s_code', this.$route.params.id);
                                                        data.append('post_data', JSON.stringify(postData));
                                                        data.append('code_hash', JSON.stringify(codeHash));
                                                        data.append('update_type', true);

                                                        // 發送請求
                                                        navigator.sendBeacon(
                                                          'https://www.autoturn.net/api/update_cache.php',
                                                          data
                                                        );

                                                        axios
                                                          .post('https://www.autoturn.net/api/data/campaign_creative_optimize_update.php', Qs.stringify({
                                                            s_code: member_hash,
                                                            id: this.db_campaign_id,
                                                          }))
                                                          .then((response) => {
                                                            axios
                                                              .get('https://www.autoturn.net/udnapi/public/send_notice_email.php?s_code='+member_hash+'&form=release&sr_i='+this.db_campaign_id)
                                                              .then((csResponse) => {
                                                                this.releaseType = false

                                                                Swal.fire({
                                                                  icon: 'success',
                                                                  title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['campaign_update']['success']['info_state_success']['swal_title'],
                                                                  text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['campaign_update']['success']['info_state_success']['swal_html'],
                                                                  showDenyButton: false,
                                                                  showCancelButton: false,
                                                                  confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['campaign_update']['success']['info_state_success']['confirm_button'],
                                                                  timer: 5000
                                                                  // denyButtonText: `Don't save`,
                                                                }).then((result) => {
                                                                  /* Read more about isConfirmed, isDenied below */
                                                                  if (result.isConfirmed) {
                                                                    // Swal.fire('Saved!', '', 'success')
                                                                    this.allPageLoading = true
                                                                    window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                                                  } else if (result.isDenied) {
                                                                    // Swal.fire('Changes are not saved', '', 'info')
                                                                    this.allPageLoading = true
                                                                    window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                                                  }

                                                                  if (result.dismiss === Swal.DismissReason.timer) {
                                                                    this.allPageLoading = true
                                                                    window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                                                  }
                                                                })
                                                              });
                                                          });
                                                      } else if(csResponse.data.return_data.state == 'FAILURE' && csResponse.data.return_data.info_state == 'FAILURE'){
                                                        this.releaseType = false
                                                        this.style = 'z-index:-1;';
                                                        bar5.set(0);
                                                        status = 0;
                                                        // Swal.fire({
                                                        //   icon: 'error',
                                                        //   title: '正式發佈',
                                                        //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
                                                        //   showDenyButton: false,
                                                        //   showCancelButton: false,
                                                        //   confirmButtonText: '確定',
                                                        //   timer: 5000
                                                        //   // denyButtonText: `Don't save`,
                                                        // }).then((result) => {
                                                        //   /* Read more about isConfirmed, isDenied below */
                                                        //   if (result.isConfirmed) {
                                                        //     // Swal.fire('Saved!', '', 'success')
                                                        //     this.allPageLoading = true
                                                        //     window.location.href = "https://private.autoturn.net/events-list/"+member_hash+"/"+adaccount_id;
                                                        //   } else if (result.isDenied) {
                                                        //     // Swal.fire('Changes are not saved', '', 'info')
                                                        //     this.allPageLoading = true
                                                        //     window.location.href = "https://private.autoturn.net/events-list/"+member_hash+"/"+adaccount_id;
                                                        //   }

                                                        //   if (result.dismiss === Swal.DismissReason.timer) {
                                                        //     this.allPageLoading = true
                                                        //     window.location.href = "https://private.autoturn.net/events-list/"+member_hash+"/"+adaccount_id;
                                                        //   }
                                                        // })
                                                        Swal.fire({
                                                          icon: 'error',
                                                          title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['campaign_update']['success']['state_failure']['swal_title'],
                                                          text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['campaign_update']['success']['state_failure']['swal_html']+csResponse.data.return_data.info_text,
                                                          showDenyButton: false,
                                                          showCancelButton: false,
                                                          confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['campaign_update']['success']['state_failure']['confirm_button']
                                                        }).then((result) => {
                                                          let info_text = csResponse.data.return_data.info_text;
                                                          let tosStatus = info_text.includes("/leadgen/tos");
                                                          if(tosStatus == true){
                                                            window.open('https://www.facebook.com/ads/leadgen/tos', '', 'height=768,width=1024');
                                                          }
                                                        })
                                                      } else {
                                                        this.releaseText = csResponse.data.return_data.info_text
                                                        this.releasePercent = csResponse.data.return_data.info_pct

                                                        bar5.set(this.releasePercent);
                                                        // console.log('csResponse.data.return_data.info_text:'+csResponse.data.return_data.info_text);
                                                        // console.log('csResponse.data.return_data.info_pct:'+csResponse.data.return_data.info_pct);
                                                        // console.log('this.releaseText:'+this.releaseText);
                                                        // console.log('this.releasePercent:'+this.releasePercent);

                                                        if(csResponse.data.return_data.info_pct == 100){
                                                          this.releaseType = false
                                                          this.style = 'z-index:-1;';
                                                          bar5.set(0);
                                                          status = 0;
                                                        }
                                                      }
                                                    }
                                                  });
                                              }
                                            } else {
                                              Swal.fire({
                                                icon: 'warning',
                                                title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['campaign_update']['success']['else']['swal_title'],
                                                text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['campaign_update']['success']['else']['swal_html'],
                                                showDenyButton: false,
                                                showCancelButton: false,
                                                confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['campaign_update']['success']['else']['confirm_button'],
                                                timer: 1000
                                                // denyButtonText: `Don't save`,
                                              }).then((result) => {
                                                /* Read more about isConfirmed, isDenied below */
                                                if (result.isConfirmed) {
                                                  // Swal.fire('Saved!', '', 'success')
                                                  this.allPageLoading = true
                                                  window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                                } else if (result.isDenied) {
                                                  // Swal.fire('Changes are not saved', '', 'info')
                                                  this.allPageLoading = true
                                                  window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                                }

                                                if (result.dismiss === Swal.DismissReason.timer) {
                                                  this.allPageLoading = true
                                                  window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                                }
                                              })
                                            }
                                          }, 3000);
                                        }
                                      });
                                  }
                                })
                              } else {
                                Swal.fire(
                                  this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['success']['swal_title'],
                                  response.data.info,
                                  'error'
                                )
                              }

                              // if(type == 1){
                              //   var todayForm = new Date();
                              //   var yearForm = todayForm.getFullYear();
                              //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                              //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                              //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                              //   todayForm = yearForm + monthForm + dateForm + timeForm;

                              //   this.formTitle = 'title_'+todayForm;
                              // } else {
                              //   this.formTitle = response.data.return_data.name;
                              // }

                              // this.showModal = true
                            } else if(response.data.status == 'login'){
                              Swal.fire({
                                icon: 'error',
                                title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['login']['swal_title'],
                                text: response.data.info,
                                showDenyButton: false,
                                showCancelButton: false,
                                confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['login']['confirm_button']
                                // denyButtonText: `Don't save`,
                              }).then((result) => {
                                /* Read more about isConfirmed, isDenied below */
                                if (result.isConfirmed) {
                                  // Swal.fire('Saved!', '', 'success')
                                  // this.allPageLoading = true
                                  window.location.href = "https://www.autoturn.net/index.php/index/logout/"+this.$route.params.id+"?o=1";
                                } else if (result.isDenied) {
                                  // Swal.fire('Changes are not saved', '', 'info')
                                  // this.allPageLoading = true
                                  window.location.href = "https://www.autoturn.net/index.php/index/logout/"+this.$route.params.id+"?o=1";
                                }
                              })
                            } else {
                              let text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['campaign_update']['not_success']['default_swal_text'];
                              if(response.data.info != '' && response.data.info != null){
                                text = response.data.info
                              }
                              Swal.fire(
                                this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['campaign_update']['not_success']['swal_title'],
                                text,
                                'error'
                              )
                            }
                          });
                      }
                    } else {
                      // console.log('#3');
                      Swal.fire(
                                  this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['not_creative_array_swal_title'],
                                  this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['not_creative_array_swal_text'],
                                  "error"
                                )
                    }
                  } else {
                    axios
                      .post('https://www.autoturn.net/api/data/campaign_update.php', Qs.stringify({
                        s_code: this.$route.params.id,
                        form_data: formData,
                        type: 'release',
                        target: 'add_release_'+this.target,
                      }))
                      .then((response) => {
                        // console.log(response.data);
                        if(response.data.status == 'success'){
                          // this.immediateList = response.data.return_data
                          // this.formData = response.data.return_data.form

                          if(response.data.release_status == 'N' && response.data.release_writing_status == 'draft'){
                            let name = this.campaign_name;
                            let currency = this.currencyData.currency;
                            let addition = this.goalsData.form_addition;
                            let daily_budget = this.methodData.daily_budget;
                            // let campaignInfo = "依您的預算設定，<br/>在未來兩週將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
                            // if(addition == '' || addition == 0){
                            //   campaignInfo = "依您的預算比率與行銷日期設定，<br/>將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
                            // }

                            // let addition_text = '（'+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['not_lead_messages']['campaign_update']['success']['addition_text']+'：<span style="color:red; font-weight:bold;">'+addition+'%</span>）';
                            // if(this.methodData.Target_AD == true){
                            //   addition_text = '';
                            // }
                            let addition_text = '';
                            let two_week_budget = Math.round((daily_budget*7)+(daily_budget*7)+(daily_budget*7*(addition/100)));
                            let campaignInfo = this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['not_lead_messages']['campaign_update']['success']['swal_text_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['not_lead_messages']['campaign_update']['success']['swal_text_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['not_lead_messages']['campaign_update']['success']['swal_text_total_budget_c']+"</span>"+addition_text;
                            if(this.budget_type === 'lifetime' || this.dateData.end_date != '0000-00-00'){
                              two_week_budget = this.total_budget;
                              campaignInfo = this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['not_lead_messages']['campaign_update']['success']['swal_text_not_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['not_lead_messages']['campaign_update']['success']['swal_text_not_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['not_lead_messages']['campaign_update']['success']['swal_text_not_total_budget_c']+"</span>"+addition_text;
                            }

                            Swal.fire({
                              // title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['not_lead_messages']['campaign_update']['success']['swal_title']+"「"+name+"」",
                              title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['not_lead_messages']['campaign_update']['success']['swal_title'],
                              html: campaignInfo + "<br/><br/>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['not_lead_messages']['campaign_update']['success']['swal_text_a']+"<span style='color:red;'>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['not_lead_messages']['campaign_update']['success']['swal_text_b']+"</span>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['not_lead_messages']['campaign_update']['success']['swal_text_c'],
                              icon: 'warning',
                              showCancelButton: true,
                              confirmButtonColor: '#3085d6',
                              cancelButtonColor: '#d33',
                              confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['not_lead_messages']['campaign_update']['success']['yes_button'],
                              cancelButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['not_lead_messages']['campaign_update']['success']['no_button'],
                            }).then((result) => {
                              if (result.isConfirmed) {
                                // console.log(this.$route.params.id);

                                this.releaseType = true
                                this.style = 'z-index:100;';
                                this.releasePercent = 5;
                                let status = 1;
                                let num = 0;
                                let member_hash = this.$route.params.id;
                                var bar5 = new ldBar("#myItem5");
                                bar5.set(this.releasePercent);

                                axios
                                  .post('https://www.autoturn.net/api/campaign_release.php', Qs.stringify({
                                    s_code: member_hash,
                                    campaign_id: this.db_campaign_id,
                                  }))
                                  .then((caResponse) => {
                                    // console.log('caResponse:'+caResponse.data.return_data);
                                    fbq('trackCustom', 'Release');
                                    if(caResponse.data.status == 'success'){
                                      //進行進度條
                                      // console.log('發佈莞成，開始跑進度條');
                                      setInterval( () => {
                                        num++;
                                        if(num < 1200){
                                          // console.log('num:'+num);
                                          // console.log(this.releaseType);

                                          if(this.releaseType == true){
                                            axios
                                              .post('https://www.autoturn.net/api/campaign_states.php', Qs.stringify({
                                                s_code: member_hash,
                                                adaccount_id: this.adaccount_id,
                                                campaign_id: this.db_campaign_id,
                                              }))
                                              .then((csResponse) => {
                                                // console.log('csResponse:'+csResponse.data.return_data);
                                                //進行進度條
                                                if(status == 1){
                                                  if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'FAILURE'){
                                                    this.releaseType = false
                                                    this.style = 'z-index:-1;';
                                                    bar5.set(0);
                                                    status = 0;
                                                    // Swal.fire({
                                                    //   icon: 'error',
                                                    //   title: '正式發佈',
                                                    //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
                                                    //   showDenyButton: false,
                                                    //   showCancelButton: false,
                                                    //   confirmButtonText: '確定',
                                                    //   timer: 5000
                                                    //   // denyButtonText: `Don't save`,
                                                    // }).then((result) => {
                                                    //   /* Read more about isConfirmed, isDenied below */
                                                    //   if (result.isConfirmed) {
                                                    //     // Swal.fire('Saved!', '', 'success')
                                                    //     this.allPageLoading = true
                                                    //     window.location.href = "https://private.autoturn.net/events-list/"+member_hash+"/"+adaccount_id;
                                                    //   } else if (result.isDenied) {
                                                    //     // Swal.fire('Changes are not saved', '', 'info')
                                                    //     this.allPageLoading = true
                                                    //     window.location.href = "https://private.autoturn.net/events-list/"+member_hash+"/"+adaccount_id;
                                                    //   }

                                                    //   if (result.dismiss === Swal.DismissReason.timer) {
                                                    //     this.allPageLoading = true
                                                    //     window.location.href = "https://private.autoturn.net/events-list/"+member_hash+"/"+adaccount_id;
                                                    //   }
                                                    // })
                                                    Swal.fire({
                                                      icon: 'error',
                                                      title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['not_lead_messages']['campaign_update']['success']['info_state_failure']['swal_title'],
                                                      text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['not_lead_messages']['campaign_update']['success']['info_state_failure']['swal_html']+csResponse.data.return_data.info_text,
                                                      showDenyButton: false,
                                                      showCancelButton: false,
                                                      confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['not_lead_messages']['campaign_update']['success']['info_state_failure']['confirm_button']
                                                    }).then((result) => {
                                                      let info_text = csResponse.data.return_data.info_text;
                                                      let tosStatus = info_text.includes("/leadgen/tos");
                                                      if(tosStatus == true){
                                                        window.open('https://www.facebook.com/ads/leadgen/tos', '', 'height=768,width=1024');
                                                      }
                                                    })
                                                  } else if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'SUCCESS'){
                                                    status = 0;

                                                    let postData = {adaccount_id: this.$route.params.adaccount_id};
                                                    let codeHash = ['de', 'di']

                                                    const data = new URLSearchParams();
                                                    data.append('s_code', this.$route.params.id);
                                                    data.append('post_data', JSON.stringify(postData));
                                                    data.append('code_hash', JSON.stringify(codeHash));
                                                    data.append('update_type', true);

                                                    // 發送請求
                                                    navigator.sendBeacon(
                                                      'https://www.autoturn.net/api/update_cache.php',
                                                      data
                                                    );

                                                    axios
                                                      .post('https://www.autoturn.net/api/data/campaign_creative_optimize_update.php', Qs.stringify({
                                                        s_code: member_hash,
                                                        id: this.db_campaign_id,
                                                      }))
                                                      .then((response) => {
                                                        axios
                                                          .get('https://www.autoturn.net/udnapi/public/send_notice_email.php?s_code='+member_hash+'&form=release&sr_i='+this.db_campaign_id)
                                                          .then((csResponse) => {
                                                            this.releaseType = false

                                                            Swal.fire({
                                                              icon: 'success',
                                                              title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['not_lead_messages']['campaign_update']['success']['info_state_success']['swal_title'],
                                                              text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['not_lead_messages']['campaign_update']['success']['info_state_success']['swal_html'],
                                                              showDenyButton: false,
                                                              showCancelButton: false,
                                                              confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['not_lead_messages']['campaign_update']['success']['info_state_success']['confirm_button'],
                                                              timer: 5000
                                                              // denyButtonText: `Don't save`,
                                                            }).then((result) => {
                                                              /* Read more about isConfirmed, isDenied below */
                                                              if (result.isConfirmed) {
                                                                // Swal.fire('Saved!', '', 'success')
                                                                this.allPageLoading = true
                                                                window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                                              } else if (result.isDenied) {
                                                                // Swal.fire('Changes are not saved', '', 'info')
                                                                this.allPageLoading = true
                                                                window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                                              }

                                                              if (result.dismiss === Swal.DismissReason.timer) {
                                                                this.allPageLoading = true
                                                                window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                                              }
                                                            })
                                                          });
                                                      });
                                                  } else if(csResponse.data.return_data.state == 'FAILURE' && csResponse.data.return_data.info_state == 'FAILURE'){
                                                    this.releaseType = false
                                                    this.style = 'z-index:-1;';
                                                    bar5.set(0);
                                                    status = 0;
                                                    // Swal.fire({
                                                    //   icon: 'error',
                                                    //   title: '正式發佈',
                                                    //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
                                                    //   showDenyButton: false,
                                                    //   showCancelButton: false,
                                                    //   confirmButtonText: '確定',
                                                    //   timer: 5000
                                                    //   // denyButtonText: `Don't save`,
                                                    // }).then((result) => {
                                                    //   /* Read more about isConfirmed, isDenied below */
                                                    //   if (result.isConfirmed) {
                                                    //     // Swal.fire('Saved!', '', 'success')
                                                    //     this.allPageLoading = true
                                                    //     window.location.href = "https://private.autoturn.net/events-list/"+member_hash+"/"+adaccount_id;
                                                    //   } else if (result.isDenied) {
                                                    //     // Swal.fire('Changes are not saved', '', 'info')
                                                    //     this.allPageLoading = true
                                                    //     window.location.href = "https://private.autoturn.net/events-list/"+member_hash+"/"+adaccount_id;
                                                    //   }

                                                    //   if (result.dismiss === Swal.DismissReason.timer) {
                                                    //     this.allPageLoading = true
                                                    //     window.location.href = "https://private.autoturn.net/events-list/"+member_hash+"/"+adaccount_id;
                                                    //   }
                                                    // })
                                                    Swal.fire({
                                                      icon: 'error',
                                                      title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['not_lead_messages']['campaign_update']['success']['state_failure']['swal_title'],
                                                      text:  this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['not_lead_messages']['campaign_update']['success']['state_failure']['swal_html']+csResponse.data.return_data.info_text,
                                                      showDenyButton: false,
                                                      showCancelButton: false,
                                                      confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['not_lead_messages']['campaign_update']['success']['state_failure']['confirm_button']
                                                    }).then((result) => {
                                                      let info_text = csResponse.data.return_data.info_text;
                                                      let tosStatus = info_text.includes("/leadgen/tos");
                                                      if(tosStatus == true){
                                                        window.open('https://www.facebook.com/ads/leadgen/tos', '', 'height=768,width=1024');
                                                      }
                                                    })
                                                  } else {
                                                    this.releaseText = csResponse.data.return_data.info_text
                                                    this.releasePercent = csResponse.data.return_data.info_pct

                                                    bar5.set(this.releasePercent);
                                                    // console.log('csResponse.data.return_data.info_text:'+csResponse.data.return_data.info_text);
                                                    // console.log('csResponse.data.return_data.info_pct:'+csResponse.data.return_data.info_pct);
                                                    // console.log('this.releaseText:'+this.releaseText);
                                                    // console.log('this.releasePercent:'+this.releasePercent);

                                                    if(csResponse.data.return_data.info_pct == 100){
                                                      this.releaseType = false
                                                      this.style = 'z-index:-1;';
                                                      bar5.set(0);
                                                      status = 0;
                                                    }
                                                  }
                                                }
                                              });
                                          }
                                        } else {
                                          Swal.fire({
                                            icon: 'warning',
                                            title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['not_lead_messages']['campaign_update']['success']['else']['swal_title'],
                                            text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['not_lead_messages']['campaign_update']['success']['else']['swal_html'],
                                            showDenyButton: false,
                                            showCancelButton: false,
                                            confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['not_lead_messages']['campaign_update']['success']['else']['confirm_button'],
                                            timer: 1000
                                            // denyButtonText: `Don't save`,
                                          }).then((result) => {
                                            /* Read more about isConfirmed, isDenied below */
                                            if (result.isConfirmed) {
                                              // Swal.fire('Saved!', '', 'success')
                                              this.allPageLoading = true
                                              window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                            } else if (result.isDenied) {
                                              // Swal.fire('Changes are not saved', '', 'info')
                                              this.allPageLoading = true
                                              window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                            }

                                            if (result.dismiss === Swal.DismissReason.timer) {
                                              this.allPageLoading = true
                                              window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                            }
                                          })
                                        }
                                      }, 3000);
                                    }
                                  });
                              }
                            })
                          } else {
                            Swal.fire(
                              this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['not_lead_messages']['campaign_update']['success']['swal_title'],
                              response.data.info,
                              'error'
                            )
                          }

                          // if(type == 1){
                          //   var todayForm = new Date();
                          //   var yearForm = todayForm.getFullYear();
                          //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                          //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                          //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                          //   todayForm = yearForm + monthForm + dateForm + timeForm;

                          //   this.formTitle = 'title_'+todayForm;
                          // } else {
                          //   this.formTitle = response.data.return_data.name;
                          // }

                          // this.showModal = true
                        } else if(response.data.status == 'login'){
                          Swal.fire({
                            icon: 'error',
                            title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['login']['swal_title'],
                            text: response.data.info,
                            showDenyButton: false,
                            showCancelButton: false,
                            confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['login']['confirm_button']
                            // denyButtonText: `Don't save`,
                          }).then((result) => {
                            /* Read more about isConfirmed, isDenied below */
                            if (result.isConfirmed) {
                              // Swal.fire('Saved!', '', 'success')
                              // this.allPageLoading = true
                              window.location.href = "https://www.autoturn.net/index.php/index/logout/"+this.$route.params.id+"?o=1";
                            } else if (result.isDenied) {
                              // Swal.fire('Changes are not saved', '', 'info')
                              // this.allPageLoading = true
                              window.location.href = "https://www.autoturn.net/index.php/index/logout/"+this.$route.params.id+"?o=1";
                            }
                          })
                        } else {
                          let text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['not_lead_messages']['campaign_update']['not_success']['default_swal_text'];
                          if(response.data.info != '' && response.data.info != null){
                            text = response.data.info
                          }
                          Swal.fire(
                            this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['not_lead_messages']['campaign_update']['not_success']['swal_title'],
                            text,
                            'error'
                          )
                        }
                      });
                  }
                }

                if(caResponse.data.status == 'login'){
                  Swal.fire({
                    icon: 'error',
                    title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['login']['swal_title'],
                    text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['login']['swal_text'],
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['login']['confirm_button']
                    // denyButtonText: `Don't save`,
                  }).then((result) => {
                    /* Read more about isConfirmed, isDenied below */
                    if (result.isConfirmed) {
                      // Swal.fire('Saved!', '', 'success')
                      // this.allPageLoading = true
                      window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
                    } else if (result.isDenied) {
                      // Swal.fire('Changes are not saved', '', 'info')
                      // this.allPageLoading = true
                      window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
                    }
                  })
                }
              });
          }
        }
      },
      methodName(value){
        switch(value){
          case 'META_TEST':
            return '測試素材';
            break;
          case 'META_KW':
            return '精準興趣';
            break;
          case 'META_LA':
            return '類似受眾';
            break;
          case 'META_RT':
            return '再行銷';
            break;
          case 'META_ASC':
            return 'ASC';
            break;
        }
      },
      objectiveName(value){
        switch(value){
          case 'CONVERSIONS':
            return '轉換次數';
            break;
          case 'LINK_CLICKS':
            return '流量';
            break;
          case 'POST_ENGAGEMENT':
            return '互動';
            break;
          case 'VIDEO_VIEWS':
            return '觀看影片';
            break;
          case 'LEAD_GENERATION':
            return '開發潛在顧客';
            break;
          case 'MESSAGES':
            return '發送訊息';
            break;
          case 'PRODUCT_CATALOG_SALES':
            return '目錄銷售';
            break;
        }
      },
      async customizeSave(status){
    //  console.log('customizeSave');
    //  console.log(status);
    //  console.log(this.customRulesData);

        if(this.nextLoading == false){
          this.nextLoading = true;
          this.showCampaignData = false;

          let _tmpSubCampaignsContentLength = this.customRulesData.subCampaignsContent.length;
          let _stageData = [];
          let _tableData = [];
          const promises = [];
          let isTrue = 0;

          for(let i = 0; i < _tmpSubCampaignsContentLength; i++){
            isTrue = 1;
            let _swalTitle = '';
            let _swalText = '';
            let menuIndex = i + parseInt(1);
            let stageName = this.menu[menuIndex].title;

        //  console.log('customize stageName');
        //  console.log(stageName);

            let onCheck = 1;
            if(this.customRulesData.haveTest == true){
              if(this.customRulesData.subCampaignsContent[i].method == 'META_KW' || this.customRulesData.subCampaignsContent[i].method == 'META_LA' || this.customRulesData.subCampaignsContent[i].method == 'META_RT' || this.customRulesData.subCampaignsContent[i].method == 'META_ASC'){
                onCheck = 0;
              }
            }

            if(onCheck == 1){
              //有測試階段時，精準興趣、類似受眾、再行銷、ASC不用檢查目標、素材
              let _tmpCampaignObjective = this.customRulesData.subCampaignsContent[i].goalsData.campaign_objective;
              if(_tmpCampaignObjective == '' || _tmpCampaignObjective == null || typeof _tmpCampaignObjective == 'undefined'){
                isTrue = 0;

                _swalTitle = '自定義規則-'+stageName+'-目標';
                _swalText = '請勾選任一項目標。';
              }

              let _tmpSelectArticleLength = this.customRulesData.subCampaignsContent[i].postData.select_article.length;
              let _tmpSelectCreativesLength = this.customRulesData.subCampaignsContent[i].postData.select_creatives.length;
              let _tmpSelectCreativesAdsetAdsLength = this.customRulesData.subCampaignsContent[i].postData.select_creatives_adset_ads.length;
              let _tmpSelectCreativesAdsetAdsMessageLength = this.customRulesData.subCampaignsContent[i].postData.select_creatives_adset_ads_message.length;
              let _tmpSelectCreativesMessageLength = this.customRulesData.subCampaignsContent[i].postData.select_creatives_message.length;
              let _tmpCreativeArrayLength = this.customRulesData.subCampaignsContent[i].adMaterialData.creative_array.length;
              let dataLength = _tmpSelectArticleLength + _tmpSelectCreativesLength + _tmpSelectCreativesAdsetAdsLength + _tmpSelectCreativesAdsetAdsMessageLength + _tmpSelectCreativesMessageLength;

              if(_tmpCampaignObjective == 'LEAD_GENERATION' || _tmpCampaignObjective == 'MESSAGES'){
                dataLength = _tmpSelectArticleLength + _tmpSelectCreativesLength + _tmpSelectCreativesAdsetAdsLength + _tmpSelectCreativesAdsetAdsMessageLength + _tmpSelectCreativesMessageLength + _tmpCreativeArrayLength;
              }

              if(dataLength <= 0){
                isTrue = 0;

                _swalTitle = '自定義規則-'+stageName+'-素材';
                _swalText = '請至少設定一組素材。';
              }

              if(_tmpCampaignObjective == 'LEAD_GENERATION' || _tmpCampaignObjective == 'MESSAGES'){
                for(let k = 0; k < _tmpCreativeArrayLength; k++){

                  let _tmpCreativeArrayTitle = this.customRulesData.subCampaignsContent[i].adMaterialData.creative_array[k].title;
                  if(_tmpCreativeArrayTitle == '' || _tmpCreativeArrayTitle == null || typeof _tmpCreativeArrayTitle == 'undefined'){
                    isTrue = 0;

                    _swalTitle = '自定義規則-'+stageName+'-素材相關設定';
                    _swalText = '每組廣告組合，都要輸入廣告名稱。';
                  }

                  let _tmpCreativeArrayType = this.customRulesData.subCampaignsContent[i].adMaterialData.creative_array[k].type;
                  if(_tmpCreativeArrayType == 2){
                    let materials_length = this.customRulesData.subCampaignsContent[i].adMaterialData.creative_array[k].materials.length

                    if(materials_length < 2){
                      materials_item = 1;
                    } else {
                      for(let j = 0; j < materials_length; j++){
                        let _tmpCreativeArrayMaterialsObjectSpecId = this.customRulesData.subCampaignsContent[i].adMaterialData.creative_array[k].materials[j].object_spec.id;
                        if(_tmpCreativeArrayMaterialsObjectSpecId == '' || _tmpCreativeArrayMaterialsObjectSpecId == null || typeof _tmpCreativeArrayMaterialsObjectSpecId == 'undefined'){
                          isTrue = 0;

                          _swalTitle = '自定義規則-'+stageName+'-素材相關設定';
                          _swalText = '每組輪播卡片，都要選取素材。';
                        }

                        let _tmpCreativeArrayMaterialsTitle = this.customRulesData.subCampaignsContent[i].adMaterialData.creative_array[k].materials[j].title;
                        if(_tmpCreativeArrayMaterialsTitle == '' || _tmpCreativeArrayMaterialsTitle == null || typeof _tmpCreativeArrayMaterialsTitle == 'undefined'){
                          isTrue = 0;

                          _swalTitle = '自定義規則-'+stageName+'-素材相關設定';
                          _swalText = '每組輪播卡片，都要填寫標題。';
                        }
                      }
                    }
                  }

                  if(_tmpCreativeArrayType == 1){
                    let _tmpCreativeArrayMaterialSingleObjectSpecId = this.customRulesData.subCampaignsContent[i].adMaterialData.creative_array[k].materialSingle[0].object_spec.id;
                    if(_tmpCreativeArrayMaterialSingleObjectSpecId == '' || _tmpCreativeArrayMaterialSingleObjectSpecId == null || typeof _tmpCreativeArrayMaterialSingleObjectSpecId == 'undefined'){
                      isTrue = 0;

                      _swalTitle = '自定義規則-'+stageName+'-素材相關設定';
                      _swalText = '每組廣告組合，都要選取素材。';
                    }

                    let _tmpCreativeArrayMaterialSingleTitle = this.customRulesData.subCampaignsContent[i].adMaterialData.creative_array[k].materialSingle[0].title;
                    if(_tmpCreativeArrayMaterialSingleTitle == '' || _tmpCreativeArrayMaterialSingleTitle == null || typeof _tmpCreativeArrayMaterialSingleTitle == 'undefined'){
                      isTrue = 0;

                      _swalTitle = '自定義規則-'+stageName+'-素材相關設定';
                      _swalText = '每組廣告組合，都要填寫標題。';
                    }
                  }

                  let _tmpCreativeArrayMessage = this.customRulesData.subCampaignsContent[i].adMaterialData.creative_array[k].message;
                  if(_tmpCreativeArrayMessage == '' || _tmpCreativeArrayMessage == null || typeof _tmpCreativeArrayMessage == 'undefined'){
                    isTrue = 0;

                    _swalTitle = '自定義規則-'+stageName+'-素材相關設定';
                    _swalText = '每組廣告組合，都要填寫主要文字。';
                  }

                  let _tmpCreativeArrayFormSrI = this.customRulesData.subCampaignsContent[i].adMaterialData.creative_array[k].form_sr_i;
                  if(_tmpCampaignObjective == 'LEAD_GENERATION' && (_tmpCreativeArrayFormSrI == '' || _tmpCreativeArrayFormSrI == null || typeof _tmpCreativeArrayFormSrI == 'undefined')){
                    isTrue = 0;

                    _swalTitle = '自定義規則-'+stageName+'-素材相關設定';
                    _swalText = '每組廣告組合，都要選取相對應的即時表單。';
                  }

                  let _tmpCreativeArrayMessageSrI = this.customRulesData.subCampaignsContent[i].adMaterialData.creative_array[k].message_sr_i;
                  if(_tmpCampaignObjective == 'MESSAGES' && (_tmpCreativeArrayMessageSrI == '' || _tmpCreativeArrayMessageSrI == null || typeof _tmpCreativeArrayMessageSrI == 'undefined')){
                    isTrue = 0;

                    _swalTitle = '自定義規則-'+stageName+'-素材相關設定';
                    _swalText = '每組廣告組合，都要選取相對應的訊息範本。';
                  }

                  if(isTrue == 0){
                    break;
                  }
                }
              }
            }

            let _tmpCampaignAmount = this.customRulesData.subCampaignsContent[i].budgetExtraData.amount;
            let _tmpCampaignBudgetExtraList = this.customRulesData.subCampaignsContent[i].budgetExtraData.budget_extra_list;
            let _tmpCampaignFrequency = this.customRulesData.subCampaignsContent[i].budgetExtraData.frequency;

        //  console.log('_tmpCampaignAmount');
        //  console.log(_tmpCampaignAmount);
        //  console.log('_tmpCampaignBudgetExtraList');
        //  console.log(_tmpCampaignBudgetExtraList);
        //  console.log('_tmpCampaignFrequency');
        //  console.log(_tmpCampaignFrequency);

            if ((_tmpCampaignAmount != 0 && _tmpCampaignAmount != '' && _tmpCampaignAmount != null) || (_tmpCampaignBudgetExtraList[0].num != 0 && _tmpCampaignBudgetExtraList[0].num != '' && _tmpCampaignBudgetExtraList[0].num != null) || (_tmpCampaignFrequency != 0 && _tmpCampaignFrequency != '' && _tmpCampaignFrequency != null)) {
              // 如果至少一個有填寫，檢查另外兩個是否都有填寫
              if ((_tmpCampaignAmount == 0 || _tmpCampaignAmount == '' || _tmpCampaignAmount == null) || (_tmpCampaignBudgetExtraList[0].num == 0 || _tmpCampaignBudgetExtraList[0].num == '' || _tmpCampaignBudgetExtraList[0].num == null) || (_tmpCampaignFrequency == 0 || _tmpCampaignFrequency == '' || _tmpCampaignFrequency == null)) {
                isTrue = 0;
                _swalTitle = '自定義規則-'+stageName+'-預算加碼';
                _swalText = '若要設定，請同時設定好金額、次數、CPA特定數值';
              }
            }

            let _tmpCampaignPageIdLength = this.customRulesData.subCampaignsContent[i].pdData.page_id;

            if(_tmpCampaignPageIdLength == '' || _tmpCampaignPageIdLength == null || typeof _tmpCampaignPageIdLength == 'undefined'){
              isTrue = 0;

              _swalTitle = '自定義規則-'+stageName+'-Facebook';
              _swalText = '請選擇Facebook。';
            }

            let _tmpCampaignPublisherPlatformsLength = this.customRulesData.subCampaignsContent[i].pdData.publisher_platforms.length;

            if(_tmpCampaignPublisherPlatformsLength <= 0){
              isTrue = 0;

              _swalTitle = '自定義規則-'+stageName+'-版位與裝置';
              _swalText = '請至少設定一個平台。';
            }

            let _tmpCampaignDevicePlatformsLength = this.customRulesData.subCampaignsContent[i].pdData.device_platforms.length;

            if(_tmpCampaignDevicePlatformsLength <= 0){
              isTrue = 0;

              _swalTitle = '自定義規則-'+stageName+'-版位與裝置';
              _swalText = '請至少設定一個裝置。';
            }

            let _tmpCampaignCustomExcludedAudiencesSelectedLength = this.customRulesData.subCampaignsContent[i].exAudiencesData.custom_excluded_audiences_selected.length;
            let _tmpCampaignDefaultExcludedAudiencesLength = this.customRulesData.subCampaignsContent[i].exAudiencesData.default_excluded_audiences.length;

            let default_excluded_audiences_num = 0;
            if(_tmpCampaignDefaultExcludedAudiencesLength > 0){
              for (var e = 0; e < _tmpCampaignDefaultExcludedAudiencesLength; e++) {
                if(this.customRulesData.subCampaignsContent[i].exAudiencesData.default_excluded_audiences[e].checked == true){
                  default_excluded_audiences_num = parseInt(default_excluded_audiences_num) + parseInt(1);
                }
              }
            }

            let excluded_audiences_num = parseInt(_tmpCampaignCustomExcludedAudiencesSelectedLength) + parseInt(default_excluded_audiences_num);

            if(excluded_audiences_num > 10){
              isTrue = 0;

              _swalTitle = '自定義規則-'+stageName+'-關系鏈與受眾';
              _swalText = '最多只能設定 10 個。';
            }

            let _tmpCampaignLocationsLength = this.customRulesData.subCampaignsContent[i].localData.locations.length;
            let _tmpCampaignLocationRangeLength = this.customRulesData.subCampaignsContent[i].localData.location_range.length;

            if((_tmpCampaignLocationsLength == 0 || _tmpCampaignLocationsLength == '' || _tmpCampaignLocationsLength == null || typeof _tmpCampaignLocationsLength == 'undefined') && (_tmpCampaignLocationRangeLength == 0 || _tmpCampaignLocationRangeLength == '' || _tmpCampaignLocationRangeLength == null || typeof _tmpCampaignLocationRangeLength == 'undefined')){
              isTrue = 0;

              _swalTitle = '自定義規則-'+stageName+'-地點';
              _swalText = '請至少設定一個地點。';
            }

            let _tmpCampaignRuleStopLength = this.customRulesData.subCampaignsContent[i].stopData.rule_stop.length;
            for(let f = 0; f < _tmpCampaignRuleStopLength; f++){
              let shopValue = this.customRulesData.subCampaignsContent[i].stopData.rule_stop[f].num;
              if(shopValue == 0 || shopValue == '' || shopValue == null || typeof shopValue == 'undefined'){
                isTrue = 0;

                _swalTitle = '自定義規則-'+stageName+'-暫停條件';
                _swalText = '請每個規則條件都必須填寫值。';
              }
            }

            let _tmpCampaignRuleFrequencyLength = this.customRulesData.subCampaignsContent[i].forwardData.rule_frequency.length;
            let checkIndex = _tmpSubCampaignsContentLength - parseInt(1);

            if(checkIndex != i){
              for(let f = 0; f < _tmpCampaignRuleFrequencyLength; f++){
                let frequencyValue = this.customRulesData.subCampaignsContent[i].forwardData.rule_frequency[f].num;
                if(frequencyValue == 0 || frequencyValue == '' || frequencyValue == null || typeof frequencyValue == 'undefined'){
                  isTrue = 0;

                  _swalTitle = '自定義規則-'+stageName+'-前進規則';
                  _swalText = '請每個規則條件都必須填寫值。';
                }
              }
            }

            let _tmpCampaignEffect = this.customRulesData.subCampaignsContent[i].budgetData.effect;
            if(_tmpCampaignEffect == 0 || _tmpCampaignEffect == '' || _tmpCampaignEffect == null || typeof _tmpCampaignEffect == 'undefined'){
              isTrue = 0;

              _swalTitle = '自定義規則-'+stageName+'-目標成本';
              _swalText = '請填寫目標成本。';
            }

            let _tmpCampaignDailyBudget = this.customRulesData.subCampaignsContent[i].budgetData.daily_budget;
        //  console.log('_tmpCampaignDailyBudget');
        //  console.log(_tmpCampaignDailyBudget);
            if(_tmpCampaignDailyBudget == 0 || _tmpCampaignDailyBudget == '' || _tmpCampaignDailyBudget == null || typeof _tmpCampaignDailyBudget == 'undefined'){
              isTrue = 0;

              _swalTitle = '自定義規則-'+stageName+'-預算';
              _swalText = '請填寫預算。';
            }

            if(this.customRulesData.subCampaignsContent[i].method == 'META_KW'){
              let _tmpKeywordLength = this.customRulesData.subCampaignsContent[i].keywordData.keywords.length;
              let select_keywords_num = 0;

              for (let g = 0; g < _tmpKeywordLength; g++) {
                if(this.customRulesData.subCampaignsContent[i].keywordData.keywords[g].checked == true){
                  select_keywords_num = parseInt(select_keywords_num) + parseInt(1);
                }
              }

              if(select_keywords_num != 5){
                isTrue = 0;

                _swalTitle = '自定義規則-'+stageName+'-精準興趣廣告組合與關鍵字';
                _swalText = '關鍵字需選擇 5 個。';
              }
            }

            if(this.customRulesData.subCampaignsContent[i].method == 'META_LA'){
              let _tmpDefaultLookalikesListLength = this.customRulesData.subCampaignsContent[i].lookData.default_lookalikes_list.length;
              let lookalikes_num = 0;
              if(_tmpDefaultLookalikesListLength > 0){
                for (let l = 0; l < _tmpDefaultLookalikesListLength; l++) {
                  // console.log('i1:'+i);
                  if(this.customRulesData.subCampaignsContent[i].lookData.default_lookalikes_list[l].checked == true){
                    lookalikes_num = parseInt(lookalikes_num) + parseInt(1);
                  }
                }
              }

              let _tmpCustomLookalikesSelectedLength = this.customRulesData.subCampaignsContent[i].lookData.custom_lookalikes_selected.length;
              if(_tmpCustomLookalikesSelectedLength > 0){
                for (let l = 0; l < _tmpCustomLookalikesSelectedLength; l++) {
                  // console.log('i2:'+i);
                  lookalikes_num = parseInt(lookalikes_num) + parseInt(1);
                }
              }

              if(lookalikes_num != 5){
                isTrue = 0;

                _swalTitle = '自定義規則-'+stageName+'-類似受眾廣告組合網址';
                _swalText = '類似受眾需選擇 5 個。';
              }
            }

            if(this.customRulesData.subCampaignsContent[i].method == 'META_RT'){
              let _tmpDefaultAudiencesListLength = this.customRulesData.subCampaignsContent[i].audiencesData.default_audiences_list.length;
              let audiences_num = 0;
              if(_tmpDefaultAudiencesListLength > 0){
                for (let r = 0; r < _tmpDefaultAudiencesListLength; r++) {
                  // console.log('i1:'+i);
                  if(this.customRulesData.subCampaignsContent[i].audiencesData.default_audiences_list[r].checked == true){
                    audiences_num = parseInt(audiences_num) + parseInt(1);
                  }
                }
              }

              let _tmpCustomAudiencesSelectedLength = this.customRulesData.subCampaignsContent[i].audiencesData.custom_audiences_selected.length;
              if(_tmpCustomAudiencesSelectedLength > 0){
                for (let r = 0; r < _tmpCustomAudiencesSelectedLength; r++) {
                  // console.log('i2:'+i);
                  audiences_num = parseInt(audiences_num) + parseInt(1);
                }
              }

              if(audiences_num < 1){
                isTrue = 0;

                _swalTitle = '自定義規則-'+stageName+'-再行銷廣告組合';
                _swalText = '請至少選擇 1 個再行銷受眾。';
              }
            }

        //  console.log('isTrue');
        //  console.log(isTrue);

            if(isTrue == 1){
              let _tmpFormData = [];

              if(this.customRulesData.subCampaignsContent[i].method == 'META_TEST' && this.customRulesData.haveTest == true){
                // _tmpFormData['PreStage'] = [];
                _tmpFormData['ThisStage'] = this.customRulesData.subCampaignsContent[i];
              } else {
                let PreIndex = i - parseInt(1);
                // _tmpFormData['PreStage'] = this.customRulesData.subCampaignsContent[PreIndex];
                _tmpFormData['ThisStage'] = this.customRulesData.subCampaignsContent[i];
              }

              const promise = axios.post('https://www.autoturn.net/api/data/campaign_subset_update_dev.php', Qs.stringify({
                s_code: this.$route.params.id,
                adaccount_id: this.$route.params.adaccount_id,
                date: this.dateData,
                stage: i,
                benefitsAndInvestmentData: this.benefitsAndInvestmentData,
                useDoForward: this.doForwardData.useDoForward,
                sub_length: _tmpSubCampaignsContentLength,
                haveTest: this.customRulesData.haveTest,
                campaign_id: this.db_campaign_id,
                form_data: _tmpFormData,
              }))
              .then((response) => {
                if (response.data.status === 'success') {
              //  console.log('campaign_subset_update response');
              //  console.log(response);

                  // 正确更新 stageData 和 _campaign_writing_status
                  // Vue.set(this.customRulesData.subCampaignsContent[i].release, 'sr_i', parseInt(response.data.campaign_id));
                  this.customRulesData.subCampaignsContent[i].release.sr_i = parseInt(response.data.campaign_id);

                  if (response.data.campaign_id) {
                    _stageData[i] = parseInt(response.data.campaign_id);
                  }
                }
              })
              .catch((error) => {
                // console.error(`Error in form_update stage ${i}:`, error);
              });

              promises.push(promise); // 將 promise 加入數組

              // axios
              //   .post('https://www.autoturn.net/api/data/campaign_subset_update_dev.php', Qs.stringify({
              //     s_code: this.$route.params.id,
              //     adaccount_id: this.$route.params.adaccount_id,
              //     date: this.dateData,
              //     stage: i,
              //     sub_length: _tmpSubCampaignsContentLength,
              //     haveTest: this.customRulesData.haveTest,
              //     form_data: _tmpFormData,
              //   }))
              //   .then((response) => {
              //     if(response.data.status == 'success'){
              //   //  console.log('campaign_subset_update response');
              //   //  console.log(response);
              //       this.customRulesData.subCampaignsContent[i].release.sr_i = parseInt(response.data.campaign_id);
              //       if(response.data.campaign_id != '' && response.data.campaign_id != null && typeof response.data.campaign_id != 'undefined'){
              //         _stageData[i] = parseInt(response.data.campaign_id);
              //       }

              //       let doIndex = i + parseInt(1);

              //   //  console.log('doIndex');
              //   //  console.log(doIndex);

              //       if(doIndex == _tmpSubCampaignsContentLength){
              //     //  console.log(_stageData);
              //     //  console.log(_stageData.length +'=='+ _tmpSubCampaignsContentLength);

              //         if(_stageData.length == _tmpSubCampaignsContentLength){
              //           var daily_keyword_split_budget = this.methodData.Budget_KW;
              //           var daily_demo_budget = this.methodData.Budget_DM;
              //           var budget_addition = this.goalsData.form_addition;

              //           this.total_budget = 0;

              //           let _tmp_goalsData = this.goalsData;
              //           const _view_goalsData = JSON.parse(JSON.stringify(_tmp_goalsData));
              //           let _tmp_exAudiencesData = this.exAudiencesData;
              //           const _view_exAudiencesData = JSON.parse(JSON.stringify(_tmp_exAudiencesData));

              //           // console.log(_tmp_exAudiencesData);

              //           delete _view_goalsData['objective_list'];
              //           delete _view_exAudiencesData['custom_excluded_audiences'];

              //           let formData = {
              //             campaign_id: this.db_campaign_id,
              //             campaign_name: this.campaign_name,
              //             adaccount_id: this.adaccount_id,
              //             Budget_KW_result: this.Budget_KW_result,
              //             total_budget: this.total_budget,
              //             dynBudgetData: this.dynBudgetData,
              //             methodData: this.methodData,
              //             benefitsAndInvestmentData: this.benefitsAndInvestmentData,
              //             dateData: this.dateData,
              //             keywordData: this.keywordData,
              //             lookData: this.lookData,
              //             audiencesData: this.audiencesData,
              //             goalsData: _view_goalsData,
              //             regionsData: this.regionsData,
              //             selectCountries: this.selectCountries,
              //             selectLangs: this.selectLangs,
              //             exAudiencesData: _view_exAudiencesData,
              //             pdData: this.pdData,
              //             idData: this.idData,
              //             postData: this.postData,
              //             adMaterialData: this.adMaterialDataNew,
              //             stageData: _stageData
              //           }

              //       //  console.log('warning formData');
              //       //  console.log(formData);

              //           let adaccount_id = this.adaccount_id

              //           axios
              //             .post('https://www.autoturn.net/api/data/campaign_update.php', Qs.stringify({
              //               s_code: this.$route.params.id,
              //               form_data: formData,
              //               type: 'release',
              //               target: 'edit_release_'+this.target,
              //             }))
              //             .then((response) => {
              //               if(response.data.status == 'success'){
              //                 if(response.data.release_status == 'N' && response.data.release_writing_status == 'draft'){
              //                   let _tableContent = '<div class="sub_table">\
              //                                   <div class="sub_row">\
              //                                     <div class="sub_cell header">階段</div>\
              //                                     <div class="sub_cell header">目標</div>\
              //                                     <div class="sub_cell header">預算</div>\
              //                                   </div>';

              //                   let _currency = this.currencyData.currency
              //                   for(let j = 0; j < _tmpSubCampaignsContentLength; j++){
              //                     let _methodName = this.methodName(this.customRulesData.subCampaignsContent[j].method);
              //                     let _objectiveName = this.objectiveName(this.customRulesData.subCampaignsContent[j].goalsData.campaign_objective);
              //                     let _budget = '<b>'+this.customRulesData.subCampaignsContent[j].budgetData.daily_budget+'</b><span style="font-size:14px; margin-left:4px; margin-top:4px;">'+_currency+'/day</span>';

              //                     _tableContent += '<div class="sub_row">\
              //                                         <div class="sub_cell">'+_methodName+'</div>\
              //                                         <div class="sub_cell">'+_objectiveName+'</div>\
              //                                         <div class="sub_cell">'+_budget+'</div>\
              //                                       </div>';
              //                   }

              //                   _tableContent += '</div>';
              //                   _tableContent += "<b style='color:red;'>請勿在Facebook廣告後台修改行銷活動設定、受眾資料(AutoTurn開頭)，<br/>若修改到系統便會暫停自動化</b><br/>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['swal_text_c'];

              //                   Swal.fire({
              //                     title: '自定義規則 - 發布',
              //                     html: _tableContent,
              //                     icon: 'warning',
              //                     showCancelButton: true,
              //                     confirmButtonColor: '#3085d6',
              //                     cancelButtonColor: '#d33',
              //                     width: 'auto', // 可選：根據內容自動調整寬度
              //                     padding: '1em',
              //                     confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['yes_button'],
              //                     cancelButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['no_button'],
              //                   }).then((result) => {
              //                     if (result.isConfirmed) {
              //                       this.releaseType = true
              //                       this.style = 'z-index:100;';
              //                       this.releasePercent = 5;
              //                       let status = 1;
              //                       let num = 0;
              //                       let member_hash = this.$route.params.id;
              //                       var bar5 = new ldBar("#myItem5");
              //                       bar5.set(this.releasePercent);

              //                       axios
              //                         .post('https://www.autoturn.net/api/campaign_release.php', Qs.stringify({
              //                           s_code: member_hash,
              //                           campaign_id: this.db_campaign_id,
              //                         }))
              //                         .then((caResponse) => {
              //                           // console.log('caResponse:'+caResponse.data.return_data);
              //                           if(caResponse.data.status == 'success'){
              //                             // console.log('#20');
              //                             //進行進度條
              //                             // console.log('發佈莞成，開始跑進度條');
              //                             setInterval( () => {
              //                               num++;
              //                               if(num < 1200){
              //                                 // console.log('num:'+num);
              //                                 // console.log(this.releaseType);

              //                                 if(this.releaseType == true){
              //                                   axios
              //                                     .post('https://www.autoturn.net/api/campaign_states.php', Qs.stringify({
              //                                       s_code: member_hash,
              //                                       adaccount_id: this.adaccount_id,
              //                                       campaign_id: this.db_campaign_id,
              //                                     }))
              //                                     .then((csResponse) => {
              //                                       // console.log('csResponse:'+csResponse.data.return_data);
              //                                       //進行進度條
              //                                       if(status == 1){
              //                                         if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'FAILURE'){
              //                                           this.releaseType = false
              //                                           this.style = 'z-index:-1;';
              //                                           bar5.set(0);
              //                                           status = 0;
              //                                           // Swal.fire({
              //                                           //   icon: 'error',
              //                                           //   title: '正式發佈',
              //                                           //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
              //                                           //   showDenyButton: false,
              //                                           //   showCancelButton: false,
              //                                           //   confirmButtonText: '確定',
              //                                           //   timer: 5000
              //                                           //   // denyButtonText: `Don't save`,
              //                                           // }).then((result) => {
              //                                           //   /* Read more about isConfirmed, isDenied below */
              //                                           //   if (result.isConfirmed) {
              //                                           //     // Swal.fire('Saved!', '', 'success')
              //                                           //     this.allPageLoading = true
              //                                           //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                           //   } else if (result.isDenied) {
              //                                           //     // Swal.fire('Changes are not saved', '', 'info')
              //                                           //     this.allPageLoading = true
              //                                           //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                           //   }

              //                                           //   if (result.dismiss === Swal.DismissReason.timer) {
              //                                           //     this.allPageLoading = true
              //                                           //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                           //   }
              //                                           // })
              //                                           Swal.fire({
              //                                             icon: 'error',
              //                                             title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['info_state_failure']['swal_title'],
              //                                             text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['info_state_failure']['swal_html']+csResponse.data.return_data.info_text,
              //                                             showDenyButton: false,
              //                                             showCancelButton: false,
              //                                             confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['info_state_failure']['confirm_button']
              //                                           }).then((result) => {
              //                                         //  console.log('#1');
              //                                             let info_text = csResponse.data.return_data.info_text;
              //                                             let tosStatus = info_text.includes("/leadgen/tos");
              //                                             if(tosStatus == true){
              //                                               window.open('https://www.facebook.com/ads/leadgen/tos', '', 'height=768,width=1024');
              //                                             }
              //                                           })
              //                                         } else if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'SUCCESS'){
              //                                           status = 0;

              //                                           axios
              //                                             .post('https://www.autoturn.net/api/data/campaign_creative_optimize_update.php', Qs.stringify({
              //                                               s_code: member_hash,
              //                                               id: this.db_campaign_id,
              //                                             }))
              //                                             .then((response) => {
              //                                               axios
              //                                                 .get('https://www.autoturn.net/udnapi/public/send_notice_email.php?s_code='+member_hash+'&form=release&sr_i='+this.db_campaign_id)
              //                                                 .then((csResponse) => {
              //                                                   this.releaseType = false

              //                                                   Swal.fire({
              //                                                     icon: 'success',
              //                                                     title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['info_state_success']['swal_title'],
              //                                                     text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['info_state_success']['swal_html'],
              //                                                     showDenyButton: false,
              //                                                     showCancelButton: false,
              //                                                     confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['info_state_success']['confirm_button'],
              //                                                     timer: 5000
              //                                                     // denyButtonText: `Don't save`,
              //                                                   }).then((result) => {
              //                                                     /* Read more about isConfirmed, isDenied below */
              //                                                     if (result.isConfirmed) {
              //                                                       // Swal.fire('Saved!', '', 'success')
              //                                                       this.allPageLoading = true
              //                                                       window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                                     } else if (result.isDenied) {
              //                                                       // Swal.fire('Changes are not saved', '', 'info')
              //                                                       this.allPageLoading = true
              //                                                       window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                                     }

              //                                                     if (result.dismiss === Swal.DismissReason.timer) {
              //                                                       this.allPageLoading = true
              //                                                       window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                                     }
              //                                                   })
              //                                                 });
              //                                             });
              //                                         } else if(csResponse.data.return_data.state == 'FAILURE' && csResponse.data.return_data.info_state == 'FAILURE'){
              //                                           this.releaseType = false
              //                                           this.style = 'z-index:-1;';
              //                                           bar5.set(0);
              //                                           status = 0;
              //                                           // Swal.fire({
              //                                           //   icon: 'error',
              //                                           //   title: '正式發佈',
              //                                           //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
              //                                           //   showDenyButton: false,
              //                                           //   showCancelButton: false,
              //                                           //   confirmButtonText: '確定',
              //                                           //   timer: 5000
              //                                           //   // denyButtonText: `Don't save`,
              //                                           // }).then((result) => {
              //                                           //   /* Read more about isConfirmed, isDenied below */
              //                                           //   if (result.isConfirmed) {
              //                                           //     // Swal.fire('Saved!', '', 'success')
              //                                           //     this.allPageLoading = true
              //                                           //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                           //   } else if (result.isDenied) {
              //                                           //     // Swal.fire('Changes are not saved', '', 'info')
              //                                           //     this.allPageLoading = true
              //                                           //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                           //   }

              //                                           //   if (result.dismiss === Swal.DismissReason.timer) {
              //                                           //     this.allPageLoading = true
              //                                           //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                           //   }
              //                                           // })
              //                                           Swal.fire({
              //                                             icon: 'error',
              //                                             title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['state_failure']['swal_title'],
              //                                             text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['state_failure']['swal_html']+csResponse.data.return_data.info_text,
              //                                             showDenyButton: false,
              //                                             showCancelButton: false,
              //                                             confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['state_failure']['confirm_button']
              //                                           }).then((result) => {
              //                                         //  console.log('#2');
              //                                             let info_text = csResponse.data.return_data.info_text;
              //                                             let tosStatus = info_text.includes("/leadgen/tos");
              //                                             if(tosStatus == true){
              //                                               window.open('https://www.facebook.com/ads/leadgen/tos', '', 'height=768,width=1024');
              //                                             }
              //                                           })
              //                                         } else {
              //                                           this.releaseText = csResponse.data.return_data.info_text
              //                                           this.releasePercent = csResponse.data.return_data.info_pct

              //                                           bar5.set(this.releasePercent);
              //                                           // console.log('csResponse.data.return_data.info_text:'+csResponse.data.return_data.info_text);
              //                                           // console.log('csResponse.data.return_data.info_pct:'+csResponse.data.return_data.info_pct);
              //                                           // console.log('this.releaseText:'+this.releaseText);
              //                                           // console.log('this.releasePercent:'+this.releasePercent);

              //                                           if(csResponse.data.return_data.info_pct == 100){
              //                                             this.releaseType = false
              //                                             this.style = 'z-index:-1;';
              //                                             bar5.set(0);
              //                                             status = 0;
              //                                           }
              //                                         }
              //                                       }
              //                                     });
              //                                 }
              //                               } else {
              //                                 Swal.fire({
              //                                   icon: 'warning',
              //                                   title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['else']['swal_title'],
              //                                   text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['else']['swal_html'],
              //                                   showDenyButton: false,
              //                                   showCancelButton: false,
              //                                   confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['else']['confirm_button'],
              //                                   timer: 1000
              //                                   // denyButtonText: `Don't save`,
              //                                 }).then((result) => {
              //                                   /* Read more about isConfirmed, isDenied below */
              //                                   if (result.isConfirmed) {
              //                                     // Swal.fire('Saved!', '', 'success')
              //                                     this.allPageLoading = true
              //                                     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                   } else if (result.isDenied) {
              //                                     // Swal.fire('Changes are not saved', '', 'info')
              //                                     this.allPageLoading = true
              //                                     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                   }

              //                                   if (result.dismiss === Swal.DismissReason.timer) {
              //                                     this.allPageLoading = true
              //                                     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                   }
              //                                 })
              //                               }
              //                             }, 3000);
              //                           }
              //                         });
              //                     }
              //                   });
              //                 } else {
              //                   Swal.fire(
              //                     this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['not_success']['swal_title'],
              //                     response.data.info,
              //                     'error'
              //                   )
              //                 }

              //               } else {
              //                 let text = this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['update_not_success_default_swal_text'];
              //                 if(response.data.info != '' && response.data.info != null){
              //                   text = response.data.info
              //                 }
              //                 Swal.fire(
              //                   this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['update_not_success_swal_title'],
              //                   text,
              //                   'error'
              //                 )
              //               }
              //             });











              //           // let _tableContent = '<div class="table">\
              //           //                         <div class="row">\
              //           //                           <div class="cell header">階段</div>\
              //           //                           <div class="cell header">目標</div>\
              //           //                           <div class="cell header">預算</div>\
              //           //                         </div>';

              //           // let _currency = this.currencyData.currency
              //           // for(let j = 0; j < _tmpSubCampaignsContentLength; j++){
              //           //   let _methodName = this.methodName(this.customRulesData.subCampaignsContent[j].method);
              //           //   let _objectiveName = this.objectiveName(this.customRulesData.subCampaignsContent[j].goalsData.campaign_objective);
              //           //   let _budget = '<b>'+this.customRulesData.subCampaignsContent[j].budgetData.daily_budget+'</b><span style="font-size:14px; margin-left:4px; margin-top:4px;">'+_currency+'/day</span>';

              //           //   _tableContent += '<div class="row">\
              //           //                       <div class="cell">'+_methodName+'</div>\
              //           //                       <div class="cell">'+_objectiveName+'</div>\
              //           //                       <div class="cell">'+_budget+'</div>\
              //           //                     </div>';
              //           // }

              //           // _tableContent += '</div>';
              //           // _tableContent += "<b style='color:red;'>請勿在Facebook廣告後台修改行銷活動設定、受眾資料(AutoTurn開頭)，<br/>若修改到系統便會暫停自動化</b><br/>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['swal_text_c'];

              //           // Swal.fire({
              //           //   title: '自定義規則 - 發布',
              //           //   html: _tableContent,
              //           //   icon: 'warning',
              //           //   showCancelButton: true,
              //           //   confirmButtonColor: '#3085d6',
              //           //   cancelButtonColor: '#d33',
              //           //   width: 'auto', // 可選：根據內容自動調整寬度
              //           //   padding: '1em',
              //           //   confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['yes_button'],
              //           //   cancelButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['no_button'],
              //           // }).then((result) => {
              //           //   if (result.isConfirmed) {
              //           // //  console.log(result.isConfirmed);

              //           //     if(status == 'warning'){
              //           //       // console.log('#15');
              //           //       Swal.fire({
              //           //         icon: 'warning',
              //           //         title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['swal_title'],
              //           //         text: caResponse.data.info,
              //           //         showDenyButton: false,
              //           //         showCancelButton: false,
              //           //         confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['confirm_button']
              //           //         // denyButtonText: `Don't save`,
              //           //       }).then((result) => {
              //           //         var daily_keyword_split_budget = this.methodData.Budget_KW;
              //           //         var daily_demo_budget = this.methodData.Budget_DM;
              //           //         var budget_addition = this.goalsData.form_addition;

              //           //         if(this.dateData.start_date != "" && this.dateData.end_date != ""){
              //           //             var d1 = new Date(this.dateData.start_date);
              //           //             var d2 = new Date(this.dateData.end_date);
              //           //             var days = parseInt((d2-d1)/86400000) + parseInt(1);
              //           //         } else {
              //           //             var days = 0;
              //           //         }

              //           //         var keyword_split_budget = 0;
              //           //         if(this.methodData.Budget_KW != ''){
              //           //             keyword_split_budget = Math.round(this.methodData.Budget_KW * days * (1+(budget_addition/100)));
              //           //         }

              //           //         var demo_budget = 0;
              //           //         if(this.methodData.Budget_DM != ''){
              //           //             demo_budget = this.methodData.Budget_DM * days;
              //           //         }

              //           //         var _tmp_audience_budget = 0;
              //           //         var audience_budget = 0;
              //           //         // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.5)');
              //           //         _tmp_audience_budget = this.methodData.Budget_LA;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.5);
              //           //         // console.log('Math.round('+_tmp_audience_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
              //           //         audience_budget = Math.round(_tmp_audience_budget * days * (1+(budget_addition/100)));

              //           //         var _tmp_marketing_again_budget = 0;
              //           //         var marketing_again_budget = 0;
              //           //         // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.25)');
              //           //         _tmp_marketing_again_budget = this.methodData.Budget_RT;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.25);
              //           //         // console.log('Math.round('+_tmp_marketing_again_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
              //           //         marketing_again_budget = Math.round(_tmp_marketing_again_budget * days * (1+(budget_addition/100)));

              //           //         // console.log(parseInt(keyword_split_budget)+' + '+parseInt(demo_budget)+' + '+parseInt(audience_budget)+' + '+parseInt(marketing_again_budget));
              //           //         var html = parseInt(keyword_split_budget) + parseInt(demo_budget) + parseInt(audience_budget) + parseInt(marketing_again_budget);

              //           //         if(isNaN(html)){
              //           //             html = '0';
              //           //         }

              //           //         this.total_budget = html;

              //           //         let _tmp_goalsData = this.goalsData;
              //           //         const _view_goalsData = JSON.parse(JSON.stringify(_tmp_goalsData));
              //           //         let _tmp_exAudiencesData = this.exAudiencesData;
              //           //         const _view_exAudiencesData = JSON.parse(JSON.stringify(_tmp_exAudiencesData));

              //           //         // console.log(_tmp_exAudiencesData);

              //           //         delete _view_goalsData['objective_list'];
              //           //         delete _view_exAudiencesData['custom_excluded_audiences'];

              //           //         let formData = {
              //           //           campaign_id: this.campaign_id,
              //           //           campaign_name: this.campaign_name,
              //           //           adaccount_id: this.adaccount_id,
              //           //           Budget_KW_result: this.Budget_KW_result,
              //           //           total_budget: this.total_budget,
              //           //           methodData: this.methodData,
              //           //           benefitsAndInvestmentData: this.benefitsAndInvestmentData,
              //           //           dateData: this.dateData,
              //           //           keywordData: this.keywordData,
              //           //           lookData: this.lookData,
              //           //           audiencesData: this.audiencesData,
              //           //           goalsData: _view_goalsData,
              //           //           regionsData: this.regionsData,
              //           //           selectCountries: this.selectCountries,
              //           //           selectLangs: this.selectLangs,
              //           //           exAudiencesData: _view_exAudiencesData,
              //           //           pdData: this.pdData,
              //           //           idData: this.idData,
              //           //           postData: this.postData,
              //           //           adMaterialData: this.adMaterialDataNew,
              //           //           stageData: _stageData
              //           //         }

              //           //     //  console.log('warning formData');
              //           //     //  console.log(formData);

              //           //         let adaccount_id = this.adaccount_id

              //           //         if(this.goalsData.campaign_objective == 'LEAD_GENERATION' || this.goalsData.campaign_objective == 'MESSAGES'){
              //           //           // console.log('開潛、訊息');
              //           //           let materialType = 0;
              //           //           let selectArticleLength = 0;
              //           //           if(this.postData.select_article != '' && this.postData.select_article != null && typeof this.postData.select_article != 'undefined'){
              //           //             selectArticleLength = this.postData.select_article.length;
              //           //           }

              //           //           let selectCreativesMessageLength = 0;
              //           //           if(this.postData.select_creatives_message != '' && this.postData.select_creatives_message != null && typeof this.postData.select_creatives_message != 'undefined'){
              //           //             selectCreativesMessageLength = this.postData.select_creatives_message.length;
              //           //           }

              //           //           let selectCreativesAdsetAdsMessageLength = 0;
              //           //           if(this.postData.select_creatives_adset_ads_message != '' && this.postData.select_creatives_adset_ads_message != null && typeof this.postData.select_creatives_adset_ads_message != 'undefined'){
              //           //             selectCreativesAdsetAdsMessageLength = this.postData.select_creatives_adset_ads_message.length;
              //           //           }

              //           //           let creativeArrayLength = 0;
              //           //           if(this.adMaterialDataNew.creative_array != '' && this.adMaterialDataNew.creative_array != null && typeof this.adMaterialDataNew.creative_array != 'undefined'){
              //           //             creativeArrayLength = this.adMaterialDataNew.creative_array.length;
              //           //           }

              //           //           if(creativeArrayLength == 0 && (!this.postData.select_creatives || this.postData.select_creatives.length == 0) && selectArticleLength == 0 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
              //           //             materialType = 1;
              //           //           } else if(selectArticleLength == 0 && selectCreativesMessageLength == 0 && selectCreativesAdsetAdsMessageLength == 0 && creativeArrayLength == 0 && this.goalsData.campaign_objective == 'MESSAGES'){
              //           //             materialType = 2;
              //           //           }

              //           //       //  console.log('#3 materialType:'+materialType);

              //           //           if(materialType == 0){
              //           //             // console.log('#2');
              //           //             let message_sr_i = 0;
              //           //             let form_sr_i = 0;
              //           //             let message = 0;
              //           //             let single_object_spec = 0;
              //           //             let single_title = 0;
              //           //             let materials_item = 0;
              //           //             let materials_object_spec = 0;
              //           //             let materials_title = 0;
              //           //             let ad_name = 0;

              //           //             for(let i = 0; i < creativeArrayLength; i++){
              //           //               if(this.adMaterialDataNew.creative_array[i].title == '' || this.adMaterialDataNew.creative_array[i].title == null || typeof this.adMaterialDataNew.creative_array[i].title == 'undefined'){
              //           //                 ad_name = 1;
              //           //               }

              //           //               if(this.adMaterialDataNew.creative_array[i].type == 2){
              //           //                 let materials_length = this.adMaterialDataNew.creative_array[i].materials.length

              //           //                 if(materials_length < 2){
              //           //                   materials_item = 1;
              //           //                 } else {
              //           //                   for(let j = 0; j < materials_length; j++){
              //           //                     if(this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == '' || this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == null || typeof this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == 'undefined'){
              //           //                       materials_object_spec = 1;
              //           //                     }

              //           //                     if(this.adMaterialDataNew.creative_array[i].materials[j].title == '' || this.adMaterialDataNew.creative_array[i].materials[j].title == null || typeof this.adMaterialDataNew.creative_array[i].materials[j].title == 'undefined'){
              //           //                       materials_title = 1;
              //           //                     }
              //           //                   }
              //           //                 }
              //           //               }

              //           //               if(this.adMaterialDataNew.creative_array[i].type == 1){
              //           //                 if(this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == '' || this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == null || typeof this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == 'undefined'){
              //           //                   single_object_spec = 1;
              //           //                 }

              //           //                 if(this.adMaterialDataNew.creative_array[i].materialSingle[0].title == '' || this.adMaterialDataNew.creative_array[i].materialSingle[0].title == null || typeof this.adMaterialDataNew.creative_array[i].materialSingle[0].title == 'undefined'){
              //           //                   single_title = 1;
              //           //                 }
              //           //               }

              //           //               if(this.adMaterialDataNew.creative_array[i].message == '' || this.adMaterialDataNew.creative_array[i].message == null || typeof this.adMaterialDataNew.creative_array[i].message == 'undefined'){
              //           //                 message = 1;
              //           //               }

              //           //               if(this.adMaterialDataNew.creative_array[i].form_sr_i == '' || this.adMaterialDataNew.creative_array[i].form_sr_i == null || typeof this.adMaterialDataNew.creative_array[i].form_sr_i == 'undefined'){
              //           //                 form_sr_i = 1;
              //           //               }

              //           //               if(this.adMaterialDataNew.creative_array[i].message_sr_i == '' || this.adMaterialDataNew.creative_array[i].message_sr_i == null || typeof this.adMaterialDataNew.creative_array[i].message_sr_i == 'undefined'){
              //           //                 message_sr_i = 1;
              //           //               }
              //           //             }

              //           //             if(ad_name == 1){
              //           //               Swal.fire(
              //           //                           this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['swal_title'],
              //           //                           this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['not_ad_name_swal_text'],
              //           //                           "error"
              //           //                         )
              //           //             } else if(single_object_spec == 1){
              //           //               Swal.fire(
              //           //                           this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['swal_title'],
              //           //                           this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['not_single_object_spec_swal_text'],
              //           //                           "error"
              //           //                         )
              //           //             } else if(single_title == 1){
              //           //               Swal.fire(
              //           //                           this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['swal_title'],
              //           //                           this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['not_single_title_swal_text'],
              //           //                           "error"
              //           //                         )
              //           //             } else if(materials_item == 1){
              //           //               Swal.fire(
              //           //                           this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['swal_title'],
              //           //                           this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['not_materials_item_swal_text'],
              //           //                           "error"
              //           //                         )
              //           //             } else if(materials_object_spec == 1){
              //           //               Swal.fire(
              //           //                           this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['swal_title'],
              //           //                           this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['not_materials_object_spec_swal_text'],
              //           //                           "error"
              //           //                         )
              //           //             } else if(materials_title == 1){
              //           //               Swal.fire(
              //           //                           this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['swal_title'],
              //           //                           this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['not_materials_title_swal_text'],
              //           //                           "error"
              //           //                         )
              //           //             } else if(message == 1){
              //           //               Swal.fire(
              //           //                           this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['swal_title'],
              //           //                           this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['not_message_swal_text'],
              //           //                           "error"
              //           //                         )
              //           //             } else if(form_sr_i == 1 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
              //           //               Swal.fire(
              //           //                         this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['swal_title'],
              //           //                         this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['not_form_sr_i_swal_text'],
              //           //                         "error"
              //           //                       )
              //           //             } else if(message_sr_i == 1 && this.goalsData.campaign_objective == 'MESSAGES'){
              //           //               Swal.fire(
              //           //                         this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['swal_title'],
              //           //                         this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['not_message_sr_i_swal_text'],
              //           //                         "error"
              //           //                       )
              //           //             } else {
              //           //               // console.log('#5');
              //           //               axios
              //           //                 .post('https://www.autoturn.net/api/data/campaign_update.php', Qs.stringify({
              //           //                   s_code: this.$route.params.id,
              //           //                   form_data: formData,
              //           //                   type: 'release',
              //           //                   target: 'edit_release_'+this.target,
              //           //                 }))
              //           //                 .then((response) => {
              //           //                   // console.log(response.data);
              //           //                   if(response.data.status == 'success'){
              //           //                     // console.log('#16');
              //           //                     // this.immediateList = response.data.return_data
              //           //                     // this.formData = response.data.return_data.form

              //           //                     if(response.data.release_status == 'N' && response.data.release_writing_status == 'draft'){
              //           //                       let name = this.campaign_name;
              //           //                       let currency = this.currencyData.currency;
              //           //                       let addition = this.goalsData.form_addition;
              //           //                       let daily_budget = this.methodData.daily_budget;
              //           //                       // let campaignInfo = "依您的預算設定，<br/>在未來兩週將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
              //           //                       // if(addition == '' || addition == 0){
              //           //                       //   campaignInfo = "依您的預算比率與行銷日期設定，<br/>將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
              //           //                       // }

              //           //                       let addition_text = '（'+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['addition_text']+'：<span style="color:red; font-weight:bold;">'+addition+'%</span>）';
              //           //                       if(this.methodData.Target_AD == true){
              //           //                         addition_text = '';
              //           //                       }
              //           //                       let two_week_budget = Math.round((daily_budget*7)+(daily_budget*7)+(daily_budget*7*(addition/100)));
              //           //                       let campaignInfo = this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['swal_text_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['swal_text_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['swal_text_total_budget_c']+"</span>"+addition_text;
              //           //                       if(this.dateData.end_date != '0000-00-00'){
              //           //                         two_week_budget = this.total_budget;
              //           //                         campaignInfo = this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['swal_text_not_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['swal_text_not_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['swal_text_not_total_budget_c']+"</span>"+addition_text;
              //           //                       }

              //           //                       // Swal.fire({
              //           //                       //   // title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['swal_title']+"「"+name+"」",
              //           //                       //   title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['swal_title'],
              //           //                       //   html: campaignInfo + "<br/><br/>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['swal_text_a']+"<span style='color:red;'>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['swal_text_b']+"</span>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['swal_text_c'],
              //           //                       //   icon: 'warning',
              //           //                       //   showCancelButton: true,
              //           //                       //   confirmButtonColor: '#3085d6',
              //           //                       //   cancelButtonColor: '#d33',
              //           //                       //   confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['yes_button'],
              //           //                       //   cancelButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['no_button'],
              //           //                       // }).then((result) => {
              //           //                       //   if (result.isConfirmed) {
              //           //                           // console.log(this.$route.params.id);

              //           //                           this.releaseType = true
              //           //                           this.style = 'z-index:100;';
              //           //                           this.releasePercent = 5;
              //           //                           let status = 1;
              //           //                           let num = 0;
              //           //                           let member_hash = this.$route.params.id;
              //           //                           var bar5 = new ldBar("#myItem5");
              //           //                           bar5.set(this.releasePercent);

              //           //                           axios
              //           //                             .post('https://www.autoturn.net/api/campaign_release.php', Qs.stringify({
              //           //                               s_code: member_hash,
              //           //                               campaign_id: this.campaign_id,
              //           //                             }))
              //           //                             .then((caResponse) => {
              //           //                               // console.log('caResponse:'+caResponse.data.return_data);
              //           //                               if(caResponse.data.status == 'success'){
              //           //                                 // console.log('#17');
              //           //                                 //進行進度條
              //           //                                 // console.log('發佈莞成，開始跑進度條');
              //           //                                 setInterval( () => {
              //           //                                   num++;
              //           //                                   if(num < 1200){
              //           //                                     // console.log('num:'+num);
              //           //                                     // console.log(this.releaseType);

              //           //                                     if(this.releaseType == true){
              //           //                                       axios
              //           //                                         .post('https://www.autoturn.net/api/campaign_states.php', Qs.stringify({
              //           //                                           s_code: member_hash,
              //           //                                           adaccount_id: this.adaccount_id,
              //           //                                           campaign_id: this.campaign_id,
              //           //                                         }))
              //           //                                         .then((csResponse) => {
              //           //                                           // console.log('csResponse:'+csResponse.data.return_data);
              //           //                                           //進行進度條
              //           //                                           if(status == 1){
              //           //                                             if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'FAILURE'){
              //           //                                               this.releaseType = false
              //           //                                               this.style = 'z-index:-1;';
              //           //                                               bar5.set(0);
              //           //                                               status = 0;
              //           //                                               // Swal.fire({
              //           //                                               //   icon: 'error',
              //           //                                               //   title: '正式發佈',
              //           //                                               //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
              //           //                                               //   showDenyButton: false,
              //           //                                               //   showCancelButton: false,
              //           //                                               //   confirmButtonText: '確定',
              //           //                                               //   timer: 5000
              //           //                                               //   // denyButtonText: `Don't save`,
              //           //                                               // }).then((result) => {
              //           //                                               //   /* Read more about isConfirmed, isDenied below */
              //           //                                               //   if (result.isConfirmed) {
              //           //                                               //     // Swal.fire('Saved!', '', 'success')
              //           //                                               //     this.allPageLoading = true
              //           //                                               //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //           //                                               //   } else if (result.isDenied) {
              //           //                                               //     // Swal.fire('Changes are not saved', '', 'info')
              //           //                                               //     this.allPageLoading = true
              //           //                                               //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //           //                                               //   }

              //           //                                               //   if (result.dismiss === Swal.DismissReason.timer) {
              //           //                                               //     this.allPageLoading = true
              //           //                                               //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //           //                                               //   }
              //           //                                               // })
              //           //                                               Swal.fire({
              //           //                                                 icon: 'error',
              //           //                                                 title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['info_state_failure']['swal_title'],
              //           //                                                 text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['info_state_failure']['swal_html']+csResponse.data.return_data.info_text,
              //           //                                                 showDenyButton: false,
              //           //                                                 showCancelButton: false,
              //           //                                                 confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['info_state_failure']['confirm_button']
              //           //                                               }).then((result) => {

              //           //                                               })
              //           //                                             } else if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'SUCCESS'){
              //           //                                               status = 0;

              //           //                                               axios
              //           //                                                 .post('https://www.autoturn.net/api/data/campaign_creative_optimize_update.php', Qs.stringify({
              //           //                                                   s_code: member_hash,
              //           //                                                   id: this.campaign_id,
              //           //                                                 }))
              //           //                                                 .then((response) => {
              //           //                                                   axios
              //           //                                                     .get('https://www.autoturn.net/udnapi/public/send_notice_email.php?s_code='+member_hash+'&s_code='+member_hash+'&form=release&sr_i='+this.campaign_id)
              //           //                                                     .then((csResponse) => {
              //           //                                                       this.releaseType = false

              //           //                                                       Swal.fire({
              //           //                                                         icon: 'success',
              //           //                                                         title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['info_state_success']['swal_title'],
              //           //                                                         text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['info_state_success']['swal_html'],
              //           //                                                         showDenyButton: false,
              //           //                                                         showCancelButton: false,
              //           //                                                         confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['info_state_success']['confirm_button'],
              //           //                                                         timer: 5000
              //           //                                                         // denyButtonText: `Don't save`,
              //           //                                                       }).then((result) => {
              //           //                                                         /* Read more about isConfirmed, isDenied below */
              //           //                                                         if (result.isConfirmed) {
              //           //                                                           // Swal.fire('Saved!', '', 'success')
              //           //                                                           this.allPageLoading = true
              //           //                                                           window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //           //                                                         } else if (result.isDenied) {
              //           //                                                           // Swal.fire('Changes are not saved', '', 'info')
              //           //                                                           this.allPageLoading = true
              //           //                                                           window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //           //                                                         }

              //           //                                                         if (result.dismiss === Swal.DismissReason.timer) {
              //           //                                                           this.allPageLoading = true
              //           //                                                           window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //           //                                                         }
              //           //                                                       })
              //           //                                                     });
              //           //                                                 });
              //           //                                             } else if(csResponse.data.return_data.state == 'FAILURE' && csResponse.data.return_data.info_state == 'FAILURE'){
              //           //                                               this.releaseType = false
              //           //                                               this.style = 'z-index:-1;';
              //           //                                               bar5.set(0);
              //           //                                               status = 0;
              //           //                                               // Swal.fire({
              //           //                                               //   icon: 'error',
              //           //                                               //   title: '正式發佈',
              //           //                                               //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
              //           //                                               //   showDenyButton: false,
              //           //                                               //   showCancelButton: false,
              //           //                                               //   confirmButtonText: '確定',
              //           //                                               //   timer: 5000
              //           //                                               //   // denyButtonText: `Don't save`,
              //           //                                               // }).then((result) => {
              //           //                                               //   /* Read more about isConfirmed, isDenied below */
              //           //                                               //   if (result.isConfirmed) {
              //           //                                               //     // Swal.fire('Saved!', '', 'success')
              //           //                                               //     this.allPageLoading = true
              //           //                                               //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //           //                                               //   } else if (result.isDenied) {
              //           //                                               //     // Swal.fire('Changes are not saved', '', 'info')
              //           //                                               //     this.allPageLoading = true
              //           //                                               //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //           //                                               //   }

              //           //                                               //   if (result.dismiss === Swal.DismissReason.timer) {
              //           //                                               //     this.allPageLoading = true
              //           //                                               //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //           //                                               //   }
              //           //                                               // })
              //           //                                               Swal.fire({
              //           //                                                 icon: 'error',
              //           //                                                 title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['state_failure']['swal_title'],
              //           //                                                 text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['state_failure']['swal_html']+csResponse.data.return_data.info_text,
              //           //                                                 showDenyButton: false,
              //           //                                                 showCancelButton: false,
              //           //                                                 confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['state_failure']['confirm_button']
              //           //                                               }).then((result) => {

              //           //                                               })
              //           //                                             } else {
              //           //                                               this.releaseText = csResponse.data.return_data.info_text
              //           //                                               this.releasePercent = csResponse.data.return_data.info_pct

              //           //                                               bar5.set(this.releasePercent);
              //           //                                               // console.log('csResponse.data.return_data.info_text:'+csResponse.data.return_data.info_text);
              //           //                                               // console.log('csResponse.data.return_data.info_pct:'+csResponse.data.return_data.info_pct);
              //           //                                               // console.log('this.releaseText:'+this.releaseText);
              //           //                                               // console.log('this.releasePercent:'+this.releasePercent);

              //           //                                               if(csResponse.data.return_data.info_pct == 100){
              //           //                                                 this.releaseType = false
              //           //                                                 this.style = 'z-index:-1;';
              //           //                                                 bar5.set(0);
              //           //                                                 status = 0;
              //           //                                               }
              //           //                                             }
              //           //                                           }
              //           //                                         });
              //           //                                     }
              //           //                                   } else {
              //           //                                     Swal.fire({
              //           //                                       icon: 'warning',
              //           //                                       title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['else']['swal_title'],
              //           //                                       text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['else']['swal_html'],
              //           //                                       showDenyButton: false,
              //           //                                       showCancelButton: false,
              //           //                                       confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['else']['confirm_button'],
              //           //                                       timer: 1000
              //           //                                       // denyButtonText: `Don't save`,
              //           //                                     }).then((result) => {
              //           //                                       /* Read more about isConfirmed, isDenied below */
              //           //                                       if (result.isConfirmed) {
              //           //                                         // Swal.fire('Saved!', '', 'success')
              //           //                                         this.allPageLoading = true
              //           //                                         window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //           //                                       } else if (result.isDenied) {
              //           //                                         // Swal.fire('Changes are not saved', '', 'info')
              //           //                                         this.allPageLoading = true
              //           //                                         window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //           //                                       }

              //           //                                       if (result.dismiss === Swal.DismissReason.timer) {
              //           //                                         this.allPageLoading = true
              //           //                                         window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //           //                                       }
              //           //                                     })
              //           //                                   }
              //           //                                 }, 3000);
              //           //                               }
              //           //                             });
              //           //                       //   }
              //           //                       // })
              //           //                     } else {
              //           //                       Swal.fire(
              //           //                         this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['not_success']['swal_title'],
              //           //                         response.data.info,
              //           //                         'error'
              //           //                       )
              //           //                     }

              //           //                     // if(type == 1){
              //           //                     //   var todayForm = new Date();
              //           //                     //   var yearForm = todayForm.getFullYear();
              //           //                     //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
              //           //                     //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
              //           //                     //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

              //           //                     //   todayForm = yearForm + monthForm + dateForm + timeForm;

              //           //                     //   this.formTitle = 'title_'+todayForm;
              //           //                     // } else {
              //           //                     //   this.formTitle = response.data.return_data.name;
              //           //                     // }

              //           //                     // this.showModal = true
              //           //                   } else {
              //           //                     let text = this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['update_not_success_default_swal_text'];
              //           //                     if(response.data.info != '' && response.data.info != null){
              //           //                       text = response.data.info
              //           //                     }
              //           //                     Swal.fire(
              //           //                       this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['update_not_success_swal_title'],
              //           //                       text,
              //           //                       'error'
              //           //                     )
              //           //                   }
              //           //                 });
              //           //             }
              //           //           } else {
              //           //         //  console.log('#33');
              //           //             Swal.fire(
              //           //                         this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['not_creative_array_swal_title'],
              //           //                         this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['not_creative_array_swal_text'],
              //           //                         "error"
              //           //                       )
              //           //           }
              //           //         } else {
              //           //       //  console.log('非開潛、訊息');
              //           //           axios
              //           //             .post('https://www.autoturn.net/api/data/campaign_update.php', Qs.stringify({
              //           //               s_code: this.$route.params.id,
              //           //               form_data: formData,
              //           //               type: 'release',
              //           //               target: 'edit_release_'+this.target,
              //           //             }))
              //           //             .then((response) => {
              //           //               // console.log(response.data);
              //           //               if(response.data.status == 'success'){
              //           //                 // console.log('#16');
              //           //                 // this.immediateList = response.data.return_data
              //           //                 // this.formData = response.data.return_data.form

              //           //                 if(response.data.release_status == 'N' && response.data.release_writing_status == 'draft'){
              //           //                   let name = this.campaign_name;
              //           //                   let currency = this.currencyData.currency;
              //           //                   let addition = this.goalsData.form_addition;
              //           //                   let daily_budget = this.methodData.daily_budget;
              //           //                   // let campaignInfo = "依您的預算設定，<br/>在未來兩週將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
              //           //                   // if(addition == '' || addition == 0){
              //           //                   //   campaignInfo = "依您的預算比率與行銷日期設定，<br/>將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
              //           //                   // }

              //           //                   let addition_text = '（'+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['addition_text']+'：<span style="color:red; font-weight:bold;">'+addition+'%</span>）';
              //           //                   if(this.methodData.Target_AD == true){
              //           //                     addition_text = '';
              //           //                   }
              //           //                   let two_week_budget = Math.round((daily_budget*7)+(daily_budget*7)+(daily_budget*7*(addition/100)));
              //           //                   let campaignInfo = this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['swal_text_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['swal_text_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['swal_text_total_budget_c']+"</span>"+addition_text;
              //           //                   if(this.dateData.end_date != '0000-00-00'){
              //           //                     two_week_budget = this.total_budget;
              //           //                     campaignInfo = this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['swal_text_not_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['swal_text_not_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['swal_text_not_total_budget_c']+"</span>"+addition_text;
              //           //                   }

              //           //                   // Swal.fire({
              //           //                   //   // title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['swal_title']+"「"+name+"」",
              //           //                   //   title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['swal_title'],
              //           //                   //   html: campaignInfo + "<br/><br/>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['swal_text_a']+"<span style='color:red;'>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['swal_text_b']+"</span>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['swal_text_c'],
              //           //                   //   icon: 'warning',
              //           //                   //   showCancelButton: true,
              //           //                   //   confirmButtonColor: '#3085d6',
              //           //                   //   cancelButtonColor: '#d33',
              //           //                   //   confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['yes_button'],
              //           //                   //   cancelButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['no_button'],
              //           //                   // }).then((result) => {
              //           //                   //   if (result.isConfirmed) {
              //           //                       // console.log(this.$route.params.id);

              //           //                       this.releaseType = true
              //           //                       this.style = 'z-index:100;';
              //           //                       this.releasePercent = 5;
              //           //                       let status = 1;
              //           //                       let num = 0;
              //           //                       let member_hash = this.$route.params.id;
              //           //                       var bar5 = new ldBar("#myItem5");
              //           //                       bar5.set(this.releasePercent);

              //           //                       axios
              //           //                         .post('https://www.autoturn.net/api/campaign_release.php', Qs.stringify({
              //           //                           s_code: member_hash,
              //           //                           campaign_id: this.campaign_id,
              //           //                         }))
              //           //                         .then((caResponse) => {
              //           //                           // console.log('caResponse:'+caResponse.data.return_data);
              //           //                           if(caResponse.data.status == 'success'){
              //           //                             // console.log('#17');
              //           //                             //進行進度條
              //           //                             // console.log('發佈莞成，開始跑進度條');
              //           //                             setInterval( () => {
              //           //                               num++;
              //           //                               if(num < 1200){
              //           //                                 // console.log('num:'+num);
              //           //                                 // console.log(this.releaseType);

              //           //                                 if(this.releaseType == true){
              //           //                                   axios
              //           //                                     .post('https://www.autoturn.net/api/campaign_states.php', Qs.stringify({
              //           //                                       s_code: member_hash,
              //           //                                       adaccount_id: this.adaccount_id,
              //           //                                       campaign_id: this.campaign_id,
              //           //                                     }))
              //           //                                     .then((csResponse) => {
              //           //                                       // console.log('csResponse:'+csResponse.data.return_data);
              //           //                                       //進行進度條
              //           //                                       if(status == 1){
              //           //                                         if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'FAILURE'){
              //           //                                           this.releaseType = false
              //           //                                           this.style = 'z-index:-1;';
              //           //                                           bar5.set(0);
              //           //                                           status = 0;
              //           //                                           // Swal.fire({
              //           //                                           //   icon: 'error',
              //           //                                           //   title: '正式發佈',
              //           //                                           //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
              //           //                                           //   showDenyButton: false,
              //           //                                           //   showCancelButton: false,
              //           //                                           //   confirmButtonText: '確定',
              //           //                                           //   timer: 5000
              //           //                                           //   // denyButtonText: `Don't save`,
              //           //                                           // }).then((result) => {
              //           //                                           //   /* Read more about isConfirmed, isDenied below */
              //           //                                           //   if (result.isConfirmed) {
              //           //                                           //     // Swal.fire('Saved!', '', 'success')
              //           //                                           //     this.allPageLoading = true
              //           //                                           //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //           //                                           //   } else if (result.isDenied) {
              //           //                                           //     // Swal.fire('Changes are not saved', '', 'info')
              //           //                                           //     this.allPageLoading = true
              //           //                                           //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //           //                                           //   }

              //           //                                           //   if (result.dismiss === Swal.DismissReason.timer) {
              //           //                                           //     this.allPageLoading = true
              //           //                                           //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //           //                                           //   }
              //           //                                           // })
              //           //                                           Swal.fire({
              //           //                                             icon: 'error',
              //           //                                             title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['info_state_failure']['swal_title'],
              //           //                                             text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['info_state_failure']['swal_html']+csResponse.data.return_data.info_text,
              //           //                                             showDenyButton: false,
              //           //                                             showCancelButton: false,
              //           //                                             confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['info_state_failure']['confirm_button']
              //           //                                           }).then((result) => {

              //           //                                           })
              //           //                                         } else if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'SUCCESS'){
              //           //                                           status = 0;

              //           //                                           axios
              //           //                                             .post('https://www.autoturn.net/api/data/campaign_creative_optimize_update.php', Qs.stringify({
              //           //                                               s_code: member_hash,
              //           //                                               id: this.campaign_id,
              //           //                                             }))
              //           //                                             .then((response) => {
              //           //                                               axios
              //           //                                                 .get('https://www.autoturn.net/udnapi/public/send_notice_email.php?s_code='+member_hash+'&form=release&sr_i='+this.campaign_id)
              //           //                                                 .then((csResponse) => {
              //           //                                                   this.releaseType = false

              //           //                                                   Swal.fire({
              //           //                                                     icon: 'success',
              //           //                                                     title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['info_state_success']['swal_title'],
              //           //                                                     text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['info_state_success']['swal_html'],
              //           //                                                     showDenyButton: false,
              //           //                                                     showCancelButton: false,
              //           //                                                     confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['info_state_success']['confirm_button'],
              //           //                                                     timer: 5000
              //           //                                                     // denyButtonText: `Don't save`,
              //           //                                                   }).then((result) => {
              //           //                                                     /* Read more about isConfirmed, isDenied below */
              //           //                                                     if (result.isConfirmed) {
              //           //                                                       // Swal.fire('Saved!', '', 'success')
              //           //                                                       this.allPageLoading = true
              //           //                                                       window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //           //                                                     } else if (result.isDenied) {
              //           //                                                       // Swal.fire('Changes are not saved', '', 'info')
              //           //                                                       this.allPageLoading = true
              //           //                                                       window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //           //                                                     }

              //           //                                                     if (result.dismiss === Swal.DismissReason.timer) {
              //           //                                                       this.allPageLoading = true
              //           //                                                       window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //           //                                                     }
              //           //                                                   })
              //           //                                                 });
              //           //                                             });
              //           //                                         } else if(csResponse.data.return_data.state == 'FAILURE' && csResponse.data.return_data.info_state == 'FAILURE'){
              //           //                                           this.releaseType = false
              //           //                                           this.style = 'z-index:-1;';
              //           //                                           bar5.set(0);
              //           //                                           status = 0;
              //           //                                           // Swal.fire({
              //           //                                           //   icon: 'error',
              //           //                                           //   title: '正式發佈',
              //           //                                           //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
              //           //                                           //   showDenyButton: false,
              //           //                                           //   showCancelButton: false,
              //           //                                           //   confirmButtonText: '確定',
              //           //                                           //   timer: 5000
              //           //                                           //   // denyButtonText: `Don't save`,
              //           //                                           // }).then((result) => {
              //           //                                           //   /* Read more about isConfirmed, isDenied below */
              //           //                                           //   if (result.isConfirmed) {
              //           //                                           //     // Swal.fire('Saved!', '', 'success')
              //           //                                           //     this.allPageLoading = true
              //           //                                           //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //           //                                           //   } else if (result.isDenied) {
              //           //                                           //     // Swal.fire('Changes are not saved', '', 'info')
              //           //                                           //     this.allPageLoading = true
              //           //                                           //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //           //                                           //   }

              //           //                                           //   if (result.dismiss === Swal.DismissReason.timer) {
              //           //                                           //     this.allPageLoading = true
              //           //                                           //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //           //                                           //   }
              //           //                                           // })
              //           //                                           Swal.fire({
              //           //                                             icon: 'error',
              //           //                                             title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['state_failure']['swal_title'],
              //           //                                             text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['state_failure']['swal_html']+csResponse.data.return_data.info_text,
              //           //                                             showDenyButton: false,
              //           //                                             showCancelButton: false,
              //           //                                             confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['state_failure']['confirm_button']
              //           //                                           }).then((result) => {

              //           //                                           })
              //           //                                         } else {
              //           //                                           this.releaseText = csResponse.data.return_data.info_text
              //           //                                           this.releasePercent = csResponse.data.return_data.info_pct

              //           //                                           bar5.set(this.releasePercent);
              //           //                                           // console.log('csResponse.data.return_data.info_text:'+csResponse.data.return_data.info_text);
              //           //                                           // console.log('csResponse.data.return_data.info_pct:'+csResponse.data.return_data.info_pct);
              //           //                                           // console.log('this.releaseText:'+this.releaseText);
              //           //                                           // console.log('this.releasePercent:'+this.releasePercent);

              //           //                                           if(csResponse.data.return_data.info_pct == 100){
              //           //                                             this.releaseType = false
              //           //                                             this.style = 'z-index:-1;';
              //           //                                             bar5.set(0);
              //           //                                             status = 0;
              //           //                                           }
              //           //                                         }
              //           //                                       }
              //           //                                     });
              //           //                                 }
              //           //                               } else {
              //           //                                 Swal.fire({
              //           //                                   icon: 'warning',
              //           //                                   title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['else']['swal_title'],
              //           //                                   text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['else']['swal_html'],
              //           //                                   showDenyButton: false,
              //           //                                   showCancelButton: false,
              //           //                                   confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['else']['confirm_button'],
              //           //                                   timer: 1000
              //           //                                   // denyButtonText: `Don't save`,
              //           //                                 }).then((result) => {
              //           //                                   /* Read more about isConfirmed, isDenied below */
              //           //                                   if (result.isConfirmed) {
              //           //                                     // Swal.fire('Saved!', '', 'success')
              //           //                                     this.allPageLoading = true
              //           //                                     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //           //                                   } else if (result.isDenied) {
              //           //                                     // Swal.fire('Changes are not saved', '', 'info')
              //           //                                     this.allPageLoading = true
              //           //                                     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //           //                                   }

              //           //                                   if (result.dismiss === Swal.DismissReason.timer) {
              //           //                                     this.allPageLoading = true
              //           //                                     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //           //                                   }
              //           //                                 })
              //           //                               }
              //           //                             }, 3000);
              //           //                           }
              //           //                         });
              //           //                   //   }
              //           //                   // })
              //           //                 } else {
              //           //                   Swal.fire(
              //           //                     this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['not_success']['swal_title'],
              //           //                     response.data.info,
              //           //                     'error'
              //           //                   )
              //           //                 }

              //           //                 // if(type == 1){
              //           //                 //   var todayForm = new Date();
              //           //                 //   var yearForm = todayForm.getFullYear();
              //           //                 //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
              //           //                 //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
              //           //                 //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

              //           //                 //   todayForm = yearForm + monthForm + dateForm + timeForm;

              //           //                 //   this.formTitle = 'title_'+todayForm;
              //           //                 // } else {
              //           //                 //   this.formTitle = response.data.return_data.name;
              //           //                 // }

              //           //                 // this.showModal = true
              //           //               } else {
              //           //                 let text = this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['update_not_success_default_swal_text'];
              //           //                 if(response.data.info != '' && response.data.info != null){
              //           //                   text = response.data.info
              //           //                 }
              //           //                 Swal.fire(
              //           //                   this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['update_not_success_swal_title'],
              //           //                   text,
              //           //                   'error'
              //           //                 )
              //           //               }
              //           //             });
              //           //         }
              //           //       });
              //           //     }

              //           //     if(status == 'success'){
              //           //       // console.log('#18');
              //           //       var daily_keyword_split_budget = this.methodData.Budget_KW;
              //           //       var daily_demo_budget = this.methodData.Budget_DM;
              //           //       var budget_addition = this.goalsData.form_addition;

              //           //       if(this.dateData.start_date != "" && this.dateData.end_date != ""){
              //           //           var d1 = new Date(this.dateData.start_date);
              //           //           var d2 = new Date(this.dateData.end_date);
              //           //           var days = parseInt((d2-d1)/86400000) + parseInt(1);
              //           //       } else {
              //           //           var days = 0;
              //           //       }

              //           //       var keyword_split_budget = 0;
              //           //       if(this.methodData.Budget_KW != ''){
              //           //           keyword_split_budget = Math.round(this.methodData.Budget_KW * days * (1+(budget_addition/100)));
              //           //       }

              //           //       var demo_budget = 0;
              //           //       if(this.methodData.Budget_DM != ''){
              //           //           demo_budget = this.methodData.Budget_DM * days;
              //           //       }

              //           //       var _tmp_audience_budget = 0;
              //           //       var audience_budget = 0;
              //           //       // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.5)');
              //           //       _tmp_audience_budget = this.methodData.Budget_LA;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.5);
              //           //       // console.log('Math.round('+_tmp_audience_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
              //           //       audience_budget = Math.round(_tmp_audience_budget * days * (1+(budget_addition/100)));

              //           //       var _tmp_marketing_again_budget = 0;
              //           //       var marketing_again_budget = 0;
              //           //       // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.25)');
              //           //       _tmp_marketing_again_budget = this.methodData.Budget_RT;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.25);
              //           //       // console.log('Math.round('+_tmp_marketing_again_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
              //           //       marketing_again_budget = Math.round(_tmp_marketing_again_budget * days * (1+(budget_addition/100)));

              //           //       // console.log(parseInt(keyword_split_budget)+' + '+parseInt(demo_budget)+' + '+parseInt(audience_budget)+' + '+parseInt(marketing_again_budget));
              //           //       var html = parseInt(keyword_split_budget) + parseInt(demo_budget) + parseInt(audience_budget) + parseInt(marketing_again_budget);

              //           //       if(isNaN(html)){
              //           //           html = '0';
              //           //       }

              //           //       this.total_budget = html;

              //           //       let _tmp_goalsData = this.goalsData;
              //           //       const _view_goalsData = JSON.parse(JSON.stringify(_tmp_goalsData));
              //           //       let _tmp_exAudiencesData = this.exAudiencesData;
              //           //       const _view_exAudiencesData = JSON.parse(JSON.stringify(_tmp_exAudiencesData));

              //           //       // console.log(_tmp_exAudiencesData);

              //           //       delete _view_goalsData['objective_list'];
              //           //       delete _view_exAudiencesData['custom_excluded_audiences'];

              //           //       let formData = {
              //           //         campaign_id: this.campaign_id,
              //           //         campaign_name: this.campaign_name,
              //           //         adaccount_id: this.adaccount_id,
              //           //         Budget_KW_result: this.Budget_KW_result,
              //           //         total_budget: this.total_budget,
              //           //         methodData: this.methodData,
              //           //         benefitsAndInvestmentData: this.benefitsAndInvestmentData,
              //           //         dateData: this.dateData,
              //           //         keywordData: this.keywordData,
              //           //         lookData: this.lookData,
              //           //         audiencesData: this.audiencesData,
              //           //         goalsData: _view_goalsData,
              //           //         regionsData: this.regionsData,
              //           //         selectCountries: this.selectCountries,
              //           //         selectLangs: this.selectLangs,
              //           //         exAudiencesData: _view_exAudiencesData,
              //           //         pdData: this.pdData,
              //           //         idData: this.idData,
              //           //         postData: this.postData,
              //           //         adMaterialData: this.adMaterialDataNew,
              //           //         stageData: _stageData
              //           //       }

              //           //   //  console.log('success formData');
              //           //   //  console.log(formData);

              //           //       let adaccount_id = this.adaccount_id

              //           //       if(this.goalsData.campaign_objective == 'LEAD_GENERATION' || this.goalsData.campaign_objective == 'MESSAGES'){
              //           //         // console.log('#1');
              //           //         let materialType = 0;
              //           //         let selectArticleLength = 0;

              //           //     //  console.log('this.postData');
              //           //     //  console.log(this.postData);
              //           //     //  console.log('this.adMaterialDataNew');
              //           //     //  console.log(this.adMaterialDataNew);

              //           //     //  console.log('b this.postData.select_article');
              //           //     //  console.log(this.postData.select_article);
              //           //     //  console.log('b this.postData.select_creatives_message');
              //           //     //  console.log(this.postData.select_creatives_message);
              //           //     //  console.log('b this.postData.select_creatives_adset_ads_message');
              //           //     //  console.log(this.postData.select_creatives_adset_ads_message);
              //           //     //  console.log('b this.adMaterialDataNew.creative_array');
              //           //     //  console.log(this.adMaterialDataNew.creative_array);

              //           //         if(this.postData.select_article != '' && this.postData.select_article != null && typeof this.postData.select_article != 'undefined'){
              //           //           selectArticleLength = this.postData.select_article.length;
              //           //         }

              //           //         let selectCreativesMessageLength = 0;
              //           //         if(this.postData.select_creatives_message != '' && this.postData.select_creatives_message != null && typeof this.postData.select_creatives_message != 'undefined'){
              //           //           selectCreativesMessageLength = this.postData.select_creatives_message.length;
              //           //         }

              //           //         let selectCreativesAdsetAdsMessageLength = 0;
              //           //         if(this.postData.select_creatives_adset_ads_message != '' && this.postData.select_creatives_adset_ads_message != null && typeof this.postData.select_creatives_adset_ads_message != 'undefined'){
              //           //           selectCreativesAdsetAdsMessageLength = this.postData.select_creatives_adset_ads_message.length;
              //           //         }

              //           //         let creativeArrayLength = 0;
              //           //         if(this.adMaterialDataNew.creative_array != '' && this.adMaterialDataNew.creative_array != null && typeof this.adMaterialDataNew.creative_array != 'undefined'){
              //           //           creativeArrayLength = this.adMaterialDataNew.creative_array.length;
              //           //         }

              //           //     //  console.log('a selectArticleLength');
              //           //     //  console.log(selectArticleLength);
              //           //     //  console.log('a selectCreativesMessageLength');
              //           //     //  console.log(selectCreativesMessageLength);
              //           //     //  console.log('a selectCreativesAdsetAdsMessageLength');
              //           //     //  console.log(selectCreativesAdsetAdsMessageLength);
              //           //     //  console.log('a creativeArrayLength');
              //           //     //  console.log(creativeArrayLength);
              //           //     //  console.log('a this.goalsData.campaign_objective');
              //           //     //  console.log(this.goalsData.campaign_objective);

              //           //         if(creativeArrayLength == 0 && (!this.postData.select_creatives || this.postData.select_creatives.length == 0) && selectArticleLength == 0 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
              //           //           materialType = 1;
              //           //         } else if(selectArticleLength == 0 && selectCreativesMessageLength == 0 && selectCreativesAdsetAdsMessageLength == 0 && creativeArrayLength == 0 && this.goalsData.campaign_objective == 'MESSAGES'){
              //           //           materialType = 2;
              //           //         }

              //           //     //  console.log('this.postData.select_article');
              //           //     //  console.log(this.postData.select_article);
              //           //     //  console.log('this.postData.select_creatives_message');
              //           //     //  console.log(this.postData.select_creatives_message);
              //           //     //  console.log('this.adMaterialDataNew.creative_array');
              //           //     //  console.log(this.adMaterialDataNew.creative_array);
              //           //     //  console.log('this.goalsData.campaign_objective');
              //           //     //  console.log(this.goalsData.campaign_objective);
              //           //     //  console.log(selectArticleLength +' == 0 && '+ selectCreativesMessageLength +' == 0 && '+ creativeArrayLength +' == 0');

              //           //     //  console.log('#4 materialType:'+materialType);

              //           //         if(materialType == 0){
              //           //           // console.log('#2');
              //           //           let message_sr_i = 0;
              //           //           let form_sr_i = 0;
              //           //           let message = 0;
              //           //           let single_object_spec = 0;
              //           //           let single_title = 0;
              //           //           let materials_item = 0;
              //           //           let materials_object_spec = 0;
              //           //           let materials_title = 0;
              //           //           let ad_name = 0;

              //           //           for(let i = 0; i < creativeArrayLength; i++){
              //           //             if(this.adMaterialDataNew.creative_array[i].title == '' || this.adMaterialDataNew.creative_array[i].title == null || typeof this.adMaterialDataNew.creative_array[i].title == 'undefined'){
              //           //               ad_name = 1;
              //           //             }

              //           //             if(this.adMaterialDataNew.creative_array[i].type == 2){
              //           //               let materials_length = this.adMaterialDataNew.creative_array[i].materials.length

              //           //               if(materials_length < 2){
              //           //                 materials_item = 1;
              //           //               } else {
              //           //                 for(let j = 0; j < materials_length; j++){
              //           //                   if(this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == '' || this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == null || typeof this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == 'undefined'){
              //           //                     materials_object_spec = 1;
              //           //                   }

              //           //                   if(this.adMaterialDataNew.creative_array[i].materials[j].title == '' || this.adMaterialDataNew.creative_array[i].materials[j].title == null || typeof this.adMaterialDataNew.creative_array[i].materials[j].title == 'undefined'){
              //           //                     materials_title = 1;
              //           //                   }
              //           //                 }
              //           //               }
              //           //             }

              //           //             if(this.adMaterialDataNew.creative_array[i].type == 1){
              //           //               if(this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == '' || this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == null || typeof this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == 'undefined'){
              //           //                 single_object_spec = 1;
              //           //               }

              //           //               if(this.adMaterialDataNew.creative_array[i].materialSingle[0].title == '' || this.adMaterialDataNew.creative_array[i].materialSingle[0].title == null || typeof this.adMaterialDataNew.creative_array[i].materialSingle[0].title == 'undefined'){
              //           //                 single_title = 1;
              //           //               }
              //           //             }

              //           //             if(this.adMaterialDataNew.creative_array[i].message == '' || this.adMaterialDataNew.creative_array[i].message == null || typeof this.adMaterialDataNew.creative_array[i].message == 'undefined'){
              //           //               message = 1;
              //           //             }

              //           //             if(this.adMaterialDataNew.creative_array[i].form_sr_i == '' || this.adMaterialDataNew.creative_array[i].form_sr_i == null || typeof this.adMaterialDataNew.creative_array[i].form_sr_i == 'undefined'){
              //           //               form_sr_i = 1;
              //           //             }

              //           //             if(this.adMaterialDataNew.creative_array[i].message_sr_i == '' || this.adMaterialDataNew.creative_array[i].message_sr_i == null || typeof this.adMaterialDataNew.creative_array[i].message_sr_i == 'undefined'){
              //           //               message_sr_i = 1;
              //           //             }
              //           //           }

              //           //           if(ad_name == 1){
              //           //             Swal.fire(
              //           //                         this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['swal_title'],
              //           //                         this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['not_ad_name_swal_text'],
              //           //                         "error"
              //           //                       )
              //           //           } else if(single_object_spec == 1){
              //           //             Swal.fire(
              //           //                         this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['swal_title'],
              //           //                         this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['not_single_object_spec_swal_text'],
              //           //                         "error"
              //           //                       )
              //           //           } else if(single_title == 1){
              //           //             Swal.fire(
              //           //                         this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['swal_title'],
              //           //                         this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['not_single_title_swal_text'],
              //           //                         "error"
              //           //                       )
              //           //           } else if(materials_item == 1){
              //           //             Swal.fire(
              //           //                         this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['swal_title'],
              //           //                         this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['not_materials_item_swal_text'],
              //           //                         "error"
              //           //                       )
              //           //           } else if(materials_object_spec == 1){
              //           //             Swal.fire(
              //           //                         this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['swal_title'],
              //           //                         this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['not_materials_object_spec_swal_text'],
              //           //                         "error"
              //           //                       )
              //           //           } else if(materials_title == 1){
              //           //             Swal.fire(
              //           //                         this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['swal_title'],
              //           //                         this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['not_materials_title_swal_text'],
              //           //                         "error"
              //           //                       )
              //           //           } else if(message == 1){
              //           //             Swal.fire(
              //           //                         this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['swal_title'],
              //           //                         this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['not_message_swal_text'],
              //           //                         "error"
              //           //                       )
              //           //           } else if(form_sr_i == 1 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
              //           //             Swal.fire(
              //           //                       this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['swal_title'],
              //           //                       this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['not_form_sr_i_swal_text'],
              //           //                       "error"
              //           //                     )
              //           //           } else if(message_sr_i == 1 && this.goalsData.campaign_objective == 'MESSAGES'){
              //           //             Swal.fire(
              //           //                       this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['swal_title'],
              //           //                       this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['not_message_sr_i_swal_text'],
              //           //                       "error"
              //           //                     )
              //           //           } else {
              //           //             // console.log('#5');
              //           //             axios
              //           //               .post('https://www.autoturn.net/api/data/campaign_update.php', Qs.stringify({
              //           //                 s_code: this.$route.params.id,
              //           //                 form_data: formData,
              //           //                 type: 'release',
              //           //                 target: 'edit_release_'+this.target,
              //           //               }))
              //           //               .then((response) => {
              //           //                 // console.log(response.data);
              //           //                 if(response.data.status == 'success'){
              //           //                   // console.log('#19');
              //           //                   // this.immediateList = response.data.return_data
              //           //                   // this.formData = response.data.return_data.form

              //           //                   if(response.data.release_status == 'N' && response.data.release_writing_status == 'draft'){
              //           //                     let name = this.campaign_name;
              //           //                     let currency = this.currencyData.currency;
              //           //                     let addition = this.goalsData.form_addition;
              //           //                     let daily_budget = this.methodData.daily_budget;
              //           //                     // let campaignInfo = "依您的預算設定，<br/>在未來兩週將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
              //           //                     // if(addition == '' || addition == 0){
              //           //                     //   campaignInfo = "依您的預算比率與行銷日期設定，<br/>將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
              //           //                     // }

              //           //                     let addition_text = '（'+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['addition_text']+'<span style="color:red; font-weight:bold;">'+addition+'%</span>）';
              //           //                     if(this.methodData.Target_AD == true){
              //           //                       addition_text = '';
              //           //                     }
              //           //                     let two_week_budget = Math.round((daily_budget*7)+(daily_budget*7)+(daily_budget*7*(addition/100)));
              //           //                     let campaignInfo = this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['swal_text_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['swal_text_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['swal_text_total_budget_c']+"</span>"+addition_text;
              //           //                     if(this.dateData.end_date != '0000-00-00'){
              //           //                       two_week_budget = this.total_budget;
              //           //                       campaignInfo = this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['swal_text_not_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['swal_text_not_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['swal_text_not_total_budget_c']+"</span>"+addition_text;
              //           //                     }

              //           //                     // Swal.fire({
              //           //                     //   // title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['swal_title']+"「"+name+"」",
              //           //                     //   title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['swal_title'],
              //           //                     //   html: campaignInfo + "<br/><br/>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['swal_text_a']+"<span style='color:red;'>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['swal_text_b']+"</span>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['swal_text_c'],
              //           //                     //   icon: 'warning',
              //           //                     //   showCancelButton: true,
              //           //                     //   confirmButtonColor: '#3085d6',
              //           //                     //   cancelButtonColor: '#d33',
              //           //                     //   confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['yes_button'],
              //           //                     //   cancelButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['no_button'],
              //           //                     // }).then((result) => {
              //           //                     //   if (result.isConfirmed) {
              //           //                         // console.log(this.$route.params.id);

              //           //                         this.releaseType = true
              //           //                         this.style = 'z-index:100;';
              //           //                         this.releasePercent = 5;
              //           //                         let status = 1;
              //           //                         let num = 0;
              //           //                         let member_hash = this.$route.params.id;
              //           //                         var bar5 = new ldBar("#myItem5");
              //           //                         bar5.set(this.releasePercent);

              //           //                         axios
              //           //                           .post('https://www.autoturn.net/api/campaign_release.php', Qs.stringify({
              //           //                             s_code: member_hash,
              //           //                             campaign_id: this.campaign_id,
              //           //                           }))
              //           //                           .then((caResponse) => {
              //           //                             // console.log('caResponse:'+caResponse.data.return_data);
              //           //                             if(caResponse.data.status == 'success'){
              //           //                               // console.log('#20');
              //           //                               //進行進度條
              //           //                               // console.log('發佈莞成，開始跑進度條');
              //           //                               setInterval( () => {
              //           //                                 num++;
              //           //                                 if(num < 1200){
              //           //                                   // console.log('num:'+num);
              //           //                                   // console.log(this.releaseType);

              //           //                                   if(this.releaseType == true){
              //           //                                     axios
              //           //                                       .post('https://www.autoturn.net/api/campaign_states.php', Qs.stringify({
              //           //                                         s_code: member_hash,
              //           //                                         adaccount_id: this.adaccount_id,
              //           //                                         campaign_id: this.campaign_id,
              //           //                                       }))
              //           //                                       .then((csResponse) => {
              //           //                                         // console.log('csResponse:'+csResponse.data.return_data);
              //           //                                         //進行進度條
              //           //                                         if(status == 1){
              //           //                                           if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'FAILURE'){
              //           //                                             this.releaseType = false
              //           //                                             this.style = 'z-index:-1;';
              //           //                                             bar5.set(0);
              //           //                                             status = 0;
              //           //                                             // Swal.fire({
              //           //                                             //   icon: 'error',
              //           //                                             //   title: '正式發佈',
              //           //                                             //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
              //           //                                             //   showDenyButton: false,
              //           //                                             //   showCancelButton: false,
              //           //                                             //   confirmButtonText: '確定',
              //           //                                             //   timer: 5000
              //           //                                             //   // denyButtonText: `Don't save`,
              //           //                                             // }).then((result) => {
              //           //                                             //   /* Read more about isConfirmed, isDenied below */
              //           //                                             //   if (result.isConfirmed) {
              //           //                                             //     // Swal.fire('Saved!', '', 'success')
              //           //                                             //     this.allPageLoading = true
              //           //                                             //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //           //                                             //   } else if (result.isDenied) {
              //           //                                             //     // Swal.fire('Changes are not saved', '', 'info')
              //           //                                             //     this.allPageLoading = true
              //           //                                             //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //           //                                             //   }

              //           //                                             //   if (result.dismiss === Swal.DismissReason.timer) {
              //           //                                             //     this.allPageLoading = true
              //           //                                             //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //           //                                             //   }
              //           //                                             // })
              //           //                                             Swal.fire({
              //           //                                               icon: 'error',
              //           //                                               title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['info_state_failure']['swal_title'],
              //           //                                               text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['info_state_failure']['swal_html']+csResponse.data.return_data.info_text,
              //           //                                               showDenyButton: false,
              //           //                                               showCancelButton: false,
              //           //                                               confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['info_state_failure']['confirm_button']
              //           //                                             }).then((result) => {
              //           //                                           //  console.log('#1');
              //           //                                               let info_text = csResponse.data.return_data.info_text;
              //           //                                               let tosStatus = info_text.includes("/leadgen/tos");
              //           //                                               if(tosStatus == true){
              //           //                                                 window.open('https://www.facebook.com/ads/leadgen/tos', '', 'height=768,width=1024');
              //           //                                               }
              //           //                                             })
              //           //                                           } else if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'SUCCESS'){
              //           //                                             status = 0;

              //           //                                             axios
              //           //                                               .post('https://www.autoturn.net/api/data/campaign_creative_optimize_update.php', Qs.stringify({
              //           //                                                 s_code: member_hash,
              //           //                                                 id: this.campaign_id,
              //           //                                               }))
              //           //                                               .then((response) => {
              //           //                                                 axios
              //           //                                                   .get('https://www.autoturn.net/udnapi/public/send_notice_email.php?s_code='+member_hash+'&form=release&sr_i='+this.campaign_id)
              //           //                                                   .then((csResponse) => {
              //           //                                                     this.releaseType = false

              //           //                                                     Swal.fire({
              //           //                                                       icon: 'success',
              //           //                                                       title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['info_state_success']['swal_title'],
              //           //                                                       text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['info_state_success']['swal_html'],
              //           //                                                       showDenyButton: false,
              //           //                                                       showCancelButton: false,
              //           //                                                       confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['info_state_success']['confirm_button'],
              //           //                                                       timer: 5000
              //           //                                                       // denyButtonText: `Don't save`,
              //           //                                                     }).then((result) => {
              //           //                                                       /* Read more about isConfirmed, isDenied below */
              //           //                                                       if (result.isConfirmed) {
              //           //                                                         // Swal.fire('Saved!', '', 'success')
              //           //                                                         this.allPageLoading = true
              //           //                                                         window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //           //                                                       } else if (result.isDenied) {
              //           //                                                         // Swal.fire('Changes are not saved', '', 'info')
              //           //                                                         this.allPageLoading = true
              //           //                                                         window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //           //                                                       }

              //           //                                                       if (result.dismiss === Swal.DismissReason.timer) {
              //           //                                                         this.allPageLoading = true
              //           //                                                         window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //           //                                                       }
              //           //                                                     })
              //           //                                                   });
              //           //                                               });
              //           //                                           } else if(csResponse.data.return_data.state == 'FAILURE' && csResponse.data.return_data.info_state == 'FAILURE'){
              //           //                                             this.releaseType = false
              //           //                                             this.style = 'z-index:-1;';
              //           //                                             bar5.set(0);
              //           //                                             status = 0;
              //           //                                             // Swal.fire({
              //           //                                             //   icon: 'error',
              //           //                                             //   title: '正式發佈',
              //           //                                             //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
              //           //                                             //   showDenyButton: false,
              //           //                                             //   showCancelButton: false,
              //           //                                             //   confirmButtonText: '確定',
              //           //                                             //   timer: 5000
              //           //                                             //   // denyButtonText: `Don't save`,
              //           //                                             // }).then((result) => {
              //           //                                             //   /* Read more about isConfirmed, isDenied below */
              //           //                                             //   if (result.isConfirmed) {
              //           //                                             //     // Swal.fire('Saved!', '', 'success')
              //           //                                             //     this.allPageLoading = true
              //           //                                             //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //           //                                             //   } else if (result.isDenied) {
              //           //                                             //     // Swal.fire('Changes are not saved', '', 'info')
              //           //                                             //     this.allPageLoading = true
              //           //                                             //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //           //                                             //   }

              //           //                                             //   if (result.dismiss === Swal.DismissReason.timer) {
              //           //                                             //     this.allPageLoading = true
              //           //                                             //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //           //                                             //   }
              //           //                                             // })
              //           //                                             Swal.fire({
              //           //                                               icon: 'error',
              //           //                                               title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['state_failure']['swal_title'],
              //           //                                               text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['state_failure']['swal_html']+csResponse.data.return_data.info_text,
              //           //                                               showDenyButton: false,
              //           //                                               showCancelButton: false,
              //           //                                               confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['state_failure']['confirm_button']
              //           //                                             }).then((result) => {
              //           //                                           //  console.log('#2');
              //           //                                               let info_text = csResponse.data.return_data.info_text;
              //           //                                               let tosStatus = info_text.includes("/leadgen/tos");
              //           //                                               if(tosStatus == true){
              //           //                                                 window.open('https://www.facebook.com/ads/leadgen/tos', '', 'height=768,width=1024');
              //           //                                               }
              //           //                                             })
              //           //                                           } else {
              //           //                                             this.releaseText = csResponse.data.return_data.info_text
              //           //                                             this.releasePercent = csResponse.data.return_data.info_pct

              //           //                                             bar5.set(this.releasePercent);
              //           //                                             // console.log('csResponse.data.return_data.info_text:'+csResponse.data.return_data.info_text);
              //           //                                             // console.log('csResponse.data.return_data.info_pct:'+csResponse.data.return_data.info_pct);
              //           //                                             // console.log('this.releaseText:'+this.releaseText);
              //           //                                             // console.log('this.releasePercent:'+this.releasePercent);

              //           //                                             if(csResponse.data.return_data.info_pct == 100){
              //           //                                               this.releaseType = false
              //           //                                               this.style = 'z-index:-1;';
              //           //                                               bar5.set(0);
              //           //                                               status = 0;
              //           //                                             }
              //           //                                           }
              //           //                                         }
              //           //                                       });
              //           //                                   }
              //           //                                 } else {
              //           //                                   Swal.fire({
              //           //                                     icon: 'warning',
              //           //                                     title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['else']['swal_title'],
              //           //                                     text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['else']['swal_html'],
              //           //                                     showDenyButton: false,
              //           //                                     showCancelButton: false,
              //           //                                     confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['else']['confirm_button'],
              //           //                                     timer: 1000
              //           //                                     // denyButtonText: `Don't save`,
              //           //                                   }).then((result) => {
              //           //                                     /* Read more about isConfirmed, isDenied below */
              //           //                                     if (result.isConfirmed) {
              //           //                                       // Swal.fire('Saved!', '', 'success')
              //           //                                       this.allPageLoading = true
              //           //                                       window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //           //                                     } else if (result.isDenied) {
              //           //                                       // Swal.fire('Changes are not saved', '', 'info')
              //           //                                       this.allPageLoading = true
              //           //                                       window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //           //                                     }

              //           //                                     if (result.dismiss === Swal.DismissReason.timer) {
              //           //                                       this.allPageLoading = true
              //           //                                       window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //           //                                     }
              //           //                                   })
              //           //                                 }
              //           //                               }, 3000);
              //           //                             }
              //           //                           });
              //           //                     //   }
              //           //                     // })
              //           //                   } else {
              //           //                     Swal.fire(
              //           //                       this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['not_success']['swal_title'],
              //           //                       response.data.info,
              //           //                       'error'
              //           //                     )
              //           //                   }

              //           //                   // if(type == 1){
              //           //                   //   var todayForm = new Date();
              //           //                   //   var yearForm = todayForm.getFullYear();
              //           //                   //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
              //           //                   //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
              //           //                   //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

              //           //                   //   todayForm = yearForm + monthForm + dateForm + timeForm;

              //           //                   //   this.formTitle = 'title_'+todayForm;
              //           //                   // } else {
              //           //                   //   this.formTitle = response.data.return_data.name;
              //           //                   // }

              //           //                   // this.showModal = true
              //           //                 } else {
              //           //                   let text = this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['update_not_success_default_swal_text'];
              //           //                   if(response.data.info != '' && response.data.info != null){
              //           //                     text = response.data.info
              //           //                   }
              //           //                   Swal.fire(
              //           //                     this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['update_not_success_swal_title'],
              //           //                     text,
              //           //                     'error'
              //           //                   )
              //           //                 }
              //           //               });
              //           //           }
              //           //         } else {
              //           //       //  console.log('#34');
              //           //           Swal.fire(
              //           //                       this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['not_creative_array_swal_title'],
              //           //                       this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['not_creative_array_swal_text'],
              //           //                       "error"
              //           //                     )
              //           //         }
              //           //       } else {
              //           //         axios
              //           //           .post('https://www.autoturn.net/api/data/campaign_update.php', Qs.stringify({
              //           //             s_code: this.$route.params.id,
              //           //             form_data: formData,
              //           //             type: 'release',
              //           //             target: 'edit_release_'+this.target,
              //           //           }))
              //           //           .then((response) => {
              //           //             // console.log(response.data);
              //           //             if(response.data.status == 'success'){
              //           //               // console.log('#19');
              //           //               // this.immediateList = response.data.return_data
              //           //               // this.formData = response.data.return_data.form

              //           //               if(response.data.release_status == 'N' && response.data.release_writing_status == 'draft'){
              //           //                 let name = this.campaign_name;
              //           //                 let currency = this.currencyData.currency;
              //           //                 let addition = this.goalsData.form_addition;
              //           //                 let daily_budget = this.methodData.daily_budget;
              //           //                 // let campaignInfo = "依您的預算設定，<br/>在未來兩週將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
              //           //                 // if(addition == '' || addition == 0){
              //           //                 //   campaignInfo = "依您的預算比率與行銷日期設定，<br/>將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
              //           //                 // }

              //           //                 let addition_text = '（'+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['addition_text']+'：<span style="color:red; font-weight:bold;">'+addition+'%</span>）';
              //           //                 if(this.methodData.Target_AD == true){
              //           //                   addition_text = '';
              //           //                 }
              //           //                 let two_week_budget = Math.round((daily_budget*7)+(daily_budget*7)+(daily_budget*7*(addition/100)));
              //           //                 let campaignInfo = this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['swal_text_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['swal_text_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['swal_text_total_budget_c']+"</span>"+addition_text;
              //           //                 if(this.dateData.end_date != '0000-00-00'){
              //           //                   two_week_budget = this.total_budget;
              //           //                   campaignInfo = this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['swal_text_not_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['swal_text_not_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['swal_text_not_total_budget_c']+"</span>"+addition_text;
              //           //                 }

              //           //                 // Swal.fire({
              //           //                 //   // title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['swal_title']+"「"+name+"」",
              //           //                 //   title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['swal_title'],
              //           //                 //   html: campaignInfo + "<br/><br/>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['swal_text_a']+"<span style='color:red;'>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['swal_text_b']+"</span>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['swal_text_c'],
              //           //                 //   icon: 'warning',
              //           //                 //   showCancelButton: true,
              //           //                 //   confirmButtonColor: '#3085d6',
              //           //                 //   cancelButtonColor: '#d33',
              //           //                 //   confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['yes_button'],
              //           //                 //   cancelButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['no_button'],
              //           //                 // }).then((result) => {
              //           //                 //   if (result.isConfirmed) {
              //           //                     // console.log(this.$route.params.id);

              //           //                     this.releaseType = true
              //           //                     this.style = 'z-index:100;';
              //           //                     this.releasePercent = 5;
              //           //                     let status = 1;
              //           //                     let num = 0;
              //           //                     let member_hash = this.$route.params.id;
              //           //                     var bar5 = new ldBar("#myItem5");
              //           //                     bar5.set(this.releasePercent);

              //           //                     axios
              //           //                       .post('https://www.autoturn.net/api/campaign_release.php', Qs.stringify({
              //           //                         s_code: member_hash,
              //           //                         campaign_id: this.campaign_id,
              //           //                       }))
              //           //                       .then((caResponse) => {
              //           //                         // console.log('caResponse:'+caResponse.data.return_data);
              //           //                         if(caResponse.data.status == 'success'){
              //           //                           // console.log('#20');
              //           //                           //進行進度條
              //           //                           // console.log('發佈莞成，開始跑進度條');
              //           //                           setInterval( () => {
              //           //                             num++;
              //           //                             if(num < 1200){
              //           //                               // console.log('num:'+num);
              //           //                               // console.log(this.releaseType);

              //           //                               if(this.releaseType == true){
              //           //                                 axios
              //           //                                   .post('https://www.autoturn.net/api/campaign_states.php', Qs.stringify({
              //           //                                     s_code: member_hash,
              //           //                                     adaccount_id: this.adaccount_id,
              //           //                                     campaign_id: this.campaign_id,
              //           //                                   }))
              //           //                                   .then((csResponse) => {
              //           //                                     // console.log('csResponse:'+csResponse.data.return_data);
              //           //                                     //進行進度條
              //           //                                     if(status == 1){
              //           //                                       if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'FAILURE'){
              //           //                                         this.releaseType = false
              //           //                                         this.style = 'z-index:-1;';
              //           //                                         bar5.set(0);
              //           //                                         status = 0;
              //           //                                         // Swal.fire({
              //           //                                         //   icon: 'error',
              //           //                                         //   title: '正式發佈',
              //           //                                         //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
              //           //                                         //   showDenyButton: false,
              //           //                                         //   showCancelButton: false,
              //           //                                         //   confirmButtonText: '確定',
              //           //                                         //   timer: 5000
              //           //                                         //   // denyButtonText: `Don't save`,
              //           //                                         // }).then((result) => {
              //           //                                         //   /* Read more about isConfirmed, isDenied below */
              //           //                                         //   if (result.isConfirmed) {
              //           //                                         //     // Swal.fire('Saved!', '', 'success')
              //           //                                         //     this.allPageLoading = true
              //           //                                         //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //           //                                         //   } else if (result.isDenied) {
              //           //                                         //     // Swal.fire('Changes are not saved', '', 'info')
              //           //                                         //     this.allPageLoading = true
              //           //                                         //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //           //                                         //   }

              //           //                                         //   if (result.dismiss === Swal.DismissReason.timer) {
              //           //                                         //     this.allPageLoading = true
              //           //                                         //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //           //                                         //   }
              //           //                                         // })
              //           //                                         Swal.fire({
              //           //                                           icon: 'error',
              //           //                                           title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['info_state_failure']['swal_title'],
              //           //                                           text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['info_state_failure']['swal_html']+csResponse.data.return_data.info_text,
              //           //                                           showDenyButton: false,
              //           //                                           showCancelButton: false,
              //           //                                           confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['info_state_failure']['confirm_button']
              //           //                                         }).then((result) => {
              //           //                                       //  console.log('#3');
              //           //                                           let info_text = csResponse.data.return_data.info_text;
              //           //                                           let tosStatus = info_text.includes("/leadgen/tos");
              //           //                                           if(tosStatus == true){
              //           //                                             window.open('https://www.facebook.com/ads/leadgen/tos', '', 'height=768,width=1024');
              //           //                                           }
              //           //                                         })
              //           //                                       } else if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'SUCCESS'){
              //           //                                         status = 0;

              //           //                                         axios
              //           //                                           .post('https://www.autoturn.net/api/data/campaign_creative_optimize_update.php', Qs.stringify({
              //           //                                             s_code: member_hash,
              //           //                                             id: this.campaign_id,
              //           //                                           }))
              //           //                                           .then((response) => {
              //           //                                             axios
              //           //                                               .get('https://www.autoturn.net/udnapi/public/send_notice_email.php?s_code='+member_hash+'&form=release&sr_i='+this.campaign_id)
              //           //                                               .then((csResponse) => {
              //           //                                                 this.releaseType = false

              //           //                                                 Swal.fire({
              //           //                                                   icon: 'success',
              //           //                                                   title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['info_state_success']['swal_title'],
              //           //                                                   text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['info_state_success']['swal_html'],
              //           //                                                   showDenyButton: false,
              //           //                                                   showCancelButton: false,
              //           //                                                   confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['info_state_success']['confirm_button'],
              //           //                                                   timer: 5000
              //           //                                                   // denyButtonText: `Don't save`,
              //           //                                                 }).then((result) => {
              //           //                                                   /* Read more about isConfirmed, isDenied below */
              //           //                                                   if (result.isConfirmed) {
              //           //                                                     // Swal.fire('Saved!', '', 'success')
              //           //                                                     this.allPageLoading = true
              //           //                                                     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //           //                                                   } else if (result.isDenied) {
              //           //                                                     // Swal.fire('Changes are not saved', '', 'info')
              //           //                                                     this.allPageLoading = true
              //           //                                                     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //           //                                                   }

              //           //                                                   if (result.dismiss === Swal.DismissReason.timer) {
              //           //                                                     this.allPageLoading = true
              //           //                                                     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //           //                                                   }
              //           //                                                 })
              //           //                                               });
              //           //                                           });
              //           //                                       } else if(csResponse.data.return_data.state == 'FAILURE' && csResponse.data.return_data.info_state == 'FAILURE'){
              //           //                                         this.releaseType = false
              //           //                                         this.style = 'z-index:-1;';
              //           //                                         bar5.set(0);
              //           //                                         status = 0;
              //           //                                         // Swal.fire({
              //           //                                         //   icon: 'error',
              //           //                                         //   title: '正式發佈',
              //           //                                         //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
              //           //                                         //   showDenyButton: false,
              //           //                                         //   showCancelButton: false,
              //           //                                         //   confirmButtonText: '確定',
              //           //                                         //   timer: 5000
              //           //                                         //   // denyButtonText: `Don't save`,
              //           //                                         // }).then((result) => {
              //           //                                         //   /* Read more about isConfirmed, isDenied below */
              //           //                                         //   if (result.isConfirmed) {
              //           //                                         //     // Swal.fire('Saved!', '', 'success')
              //           //                                         //     this.allPageLoading = true
              //           //                                         //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //           //                                         //   } else if (result.isDenied) {
              //           //                                         //     // Swal.fire('Changes are not saved', '', 'info')
              //           //                                         //     this.allPageLoading = true
              //           //                                         //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //           //                                         //   }

              //           //                                         //   if (result.dismiss === Swal.DismissReason.timer) {
              //           //                                         //     this.allPageLoading = true
              //           //                                         //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //           //                                         //   }
              //           //                                         // })
              //           //                                         Swal.fire({
              //           //                                           icon: 'error',
              //           //                                           title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['state_failure']['swal_title'],
              //           //                                           text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['state_failure']['swal_html']+csResponse.data.return_data.info_text,
              //           //                                           showDenyButton: false,
              //           //                                           showCancelButton: false,
              //           //                                           confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['state_failure']['confirm_button']
              //           //                                         }).then((result) => {
              //           //                                       //  console.log('#4');
              //           //                                           let info_text = csResponse.data.return_data.info_text;
              //           //                                           let tosStatus = info_text.includes("/leadgen/tos");
              //           //                                           if(tosStatus == true){
              //           //                                             window.open('https://www.facebook.com/ads/leadgen/tos', '', 'height=768,width=1024');
              //           //                                           }
              //           //                                         })
              //           //                                       } else {
              //           //                                         this.releaseText = csResponse.data.return_data.info_text
              //           //                                         this.releasePercent = csResponse.data.return_data.info_pct

              //           //                                         bar5.set(this.releasePercent);
              //           //                                         // console.log('csResponse.data.return_data.info_text:'+csResponse.data.return_data.info_text);
              //           //                                         // console.log('csResponse.data.return_data.info_pct:'+csResponse.data.return_data.info_pct);
              //           //                                         // console.log('this.releaseText:'+this.releaseText);
              //           //                                         // console.log('this.releasePercent:'+this.releasePercent);

              //           //                                         if(csResponse.data.return_data.info_pct == 100){
              //           //                                           this.releaseType = false
              //           //                                           this.style = 'z-index:-1;';
              //           //                                           bar5.set(0);
              //           //                                           status = 0;
              //           //                                         }
              //           //                                       }
              //           //                                     }
              //           //                                   });
              //           //                               }
              //           //                             } else {
              //           //                               Swal.fire({
              //           //                                 icon: 'warning',
              //           //                                 title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['else']['swal_title'],
              //           //                                 text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['else']['swal_html'],
              //           //                                 showDenyButton: false,
              //           //                                 showCancelButton: false,
              //           //                                 confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['else']['confirm_button'],
              //           //                                 timer: 1000
              //           //                                 // denyButtonText: `Don't save`,
              //           //                               }).then((result) => {
              //           //                                 /* Read more about isConfirmed, isDenied below */
              //           //                                 if (result.isConfirmed) {
              //           //                                   // Swal.fire('Saved!', '', 'success')
              //           //                                   this.allPageLoading = true
              //           //                                   window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //           //                                 } else if (result.isDenied) {
              //           //                                   // Swal.fire('Changes are not saved', '', 'info')
              //           //                                   this.allPageLoading = true
              //           //                                   window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //           //                                 }

              //           //                                 if (result.dismiss === Swal.DismissReason.timer) {
              //           //                                   this.allPageLoading = true
              //           //                                   window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //           //                                 }
              //           //                               })
              //           //                             }
              //           //                           }, 3000);
              //           //                         }
              //           //                       });
              //           //                 //   }
              //           //                 // })
              //           //               } else {
              //           //                 Swal.fire(
              //           //                   this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['not_success']['swal_title'],
              //           //                   response.data.info,
              //           //                   'error'
              //           //                 )
              //           //               }

              //           //               // if(type == 1){
              //           //               //   var todayForm = new Date();
              //           //               //   var yearForm = todayForm.getFullYear();
              //           //               //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
              //           //               //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
              //           //               //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

              //           //               //   todayForm = yearForm + monthForm + dateForm + timeForm;

              //           //               //   this.formTitle = 'title_'+todayForm;
              //           //               // } else {
              //           //               //   this.formTitle = response.data.return_data.name;
              //           //               // }

              //           //               // this.showModal = true
              //           //             } else {
              //           //               let text = this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['update_not_success_default_swal_text'];
              //           //               if(response.data.info != '' && response.data.info != null){
              //           //                 text = response.data.info
              //           //               }
              //           //               Swal.fire(
              //           //                 this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['update_not_success_swal_title'],
              //           //                 text,
              //           //                 'error'
              //           //               )
              //           //             }
              //           //           });
              //           //       }
              //           //     }

              //           // //  console.log('customize end');
              //           // //  console.log(this.customRulesData);
              //           //   }
              //           // })
              //         } else {
              //           Swal.fire({
              //                       icon: 'error',
              //                       title: '自定義規則-發布',
              //                       html: '資料更新失敗，請稍候再嘗試。',
              //                       showDenyButton: false,
              //                       showCancelButton: false,
              //                       confirmButtonText: 'OK',
              //                     });

              //       //  console.log('customize error end');
              //       //  console.log(this.customRulesData);
              //         }
              //       }
              //     }
              //   });
            } else {
              Swal.fire(
                _swalTitle,
                _swalText,
                "error"
              );

              this.nextLoading = false;
              this.showCampaignData = true;

              break;
            }
          }

          // if(this.benefitsAndInvestmentData.toTaiwan === true){
          //   if(this.benefitsAndInvestmentData.person_or_business.value == 2){
          //     if(this.benefitsAndInvestmentData.benefits == '' || this.benefitsAndInvestmentData.benefits == null || typeof this.benefitsAndInvestmentData.benefits == 'undefined'){
          //       Swal.fire(
          //                 this.showLang[this.selectLang]['components']['Event']['BenefitsAndInvestment']['title'],
          //                 '受益者不能為空。',
          //                 "error"
          //               )
          //       isTrue = 0;
          //     }

          //     if(this.benefitsAndInvestmentData.investment == '' || this.benefitsAndInvestmentData.investment == null || typeof this.benefitsAndInvestmentData.investment == 'undefined'){
          //       Swal.fire(
          //                 this.showLang[this.selectLang]['components']['Event']['BenefitsAndInvestment']['title'],
          //                 '出資者不能為空。',
          //                 "error"
          //               )
          //       isTrue = 0;
          //     }
          //   } else {
          //     if(this.benefitsAndInvestmentData.beneficiary_id == '' || this.benefitsAndInvestmentData.beneficiary_id == null || typeof this.benefitsAndInvestmentData.beneficiary_id == 'undefined'){
          //       Swal.fire(
          //                 this.showLang[this.selectLang]['components']['Event']['BenefitsAndInvestment']['title'],
          //                 '請填寫受益者 ID',
          //                 "error"
          //               )
          //       isTrue = 0;
          //     }

          //     if(this.benefitsAndInvestmentData.beneficiary_name == '' || this.benefitsAndInvestmentData.beneficiary_name == null || typeof this.benefitsAndInvestmentData.beneficiary_name == 'undefined'){
          //       Swal.fire(
          //                 this.showLang[this.selectLang]['components']['Event']['BenefitsAndInvestment']['title'],
          //                 '請填寫受益者 名稱',
          //                 "error"
          //               )
          //       isTrue = 0;
          //     }

          //     if(this.benefitsAndInvestmentData.payer_id == '' || this.benefitsAndInvestmentData.payer_id == null || typeof this.benefitsAndInvestmentData.payer_id == 'undefined'){
          //       Swal.fire(
          //                 this.showLang[this.selectLang]['components']['Event']['BenefitsAndInvestment']['title'],
          //                 '請填寫出資者 ID',
          //                 "error"
          //               )
          //       isTrue = 0;
          //     }

          //     if(this.benefitsAndInvestmentData.payer_name == '' || this.benefitsAndInvestmentData.payer_name == null || typeof this.benefitsAndInvestmentData.payer_name == 'undefined'){
          //       Swal.fire(
          //                 this.showLang[this.selectLang]['components']['Event']['BenefitsAndInvestment']['title'],
          //                 '請填寫出資者 名稱',
          //                 "error"
          //               )
          //       isTrue = 0;
          //     }
          //   }
          // }

          if (this.benefitsAndInvestmentData.toTaiwan === true) {
            const isBusinesss = this.benefitsAndInvestmentData.person_or_business.value === 2;

            if (isBusiness === true) {
              if (!this.hasValue(this.benefitsAndInvestmentData.benefits, true) && 
                !this.hasValue(this.benefitsAndInvestmentData.investment, true)) {
                Swal.fire(
                      this.showLang[this.selectLang]['components']['Event']['BenefitsAndInvestment']['title'],
                      '請設定出資者、受益者。',
                      "error"
                    )
                isTrue = 0;
              }
            } else {
              if (!this.validateBeneficiary()) {
                Swal.fire(
                      this.showLang[this.selectLang]['components']['Event']['BenefitsAndInvestment']['title'],
                      '您的受益者資料並未設定完成（選擇已驗證，或手動輸入名稱、ID）。',
                      "error"
                    )
                isTrue = 0;
              }
              if (!this.validatePayer()) {
                Swal.fire(
                      this.showLang[this.selectLang]['components']['Event']['BenefitsAndInvestment']['title'],
                      '您的出資者資料並未設定完成（選擇已驗證，或手動輸入名稱、ID）。',
                      "error"
                    )
                isTrue = 0;
              }
            }
          }

          if(isTrue == 1){
            await Promise.all(promises);

        //  console.log('All axios requests finished');
        //  console.log(_stageData);
        //  console.log(_stageData.length +'=='+ _tmpSubCampaignsContentLength);

            // 在所有 axios 完成后，再执行以下逻辑
            if(_stageData.length == _tmpSubCampaignsContentLength){
              var daily_keyword_split_budget = this.methodData.Budget_KW;
              var daily_demo_budget = this.methodData.Budget_DM;
              var budget_addition = this.goalsData.form_addition;

              this.total_budget = 0;

              let _tmp_goalsData = this.goalsData;
              const _view_goalsData = JSON.parse(JSON.stringify(_tmp_goalsData));
              let _tmp_exAudiencesData = this.exAudiencesData;
              const _view_exAudiencesData = JSON.parse(JSON.stringify(_tmp_exAudiencesData));

              // console.log(_tmp_exAudiencesData);

              delete _view_goalsData['objective_list'];
              delete _view_exAudiencesData['custom_excluded_audiences'];

              let formData = {
                campaign_id: this.db_campaign_id,
                campaign_name: this.campaign_name,
                      budget_type: this.budget_type,
                      special_ad_category: this.special_ad_category,
                adaccount_id: this.adaccount_id,
                Budget_KW_result: this.Budget_KW_result,
                total_budget: this.total_budget,
                useDefaultLayout: this.useDefaultLayout,
                dynBudgetData: this.dynBudgetData,
                doForwardData: this.doForwardData,
                methodData: this.methodData,
                benefitsAndInvestmentData: this.benefitsAndInvestmentData,
                dateData: this.dateData,
                keywordData: this.keywordData,
                lookData: this.lookData,
                audiencesData: this.audiencesData,
                goalsData: _view_goalsData,
                regionsData: this.regionsData,
                selectCountries: this.selectCountries,
                selectLangs: this.selectLangs,
                exAudiencesData: _view_exAudiencesData,
                pdData: this.pdData,
                idData: this.idData,
                postData: this.postData,
                adMaterialData: this.adMaterialDataNew,
                autoAdjustData: this.autoAdjustData,
                stageData: _stageData
              }

          //  console.log('warning formData');
          //  console.log(formData);

              let adaccount_id = this.adaccount_id
              let subHaveTest = false;

              axios
                .post('https://www.autoturn.net/api/data/campaign_update.php', Qs.stringify({
                  s_code: this.$route.params.id,
                  form_data: formData,
                  type: 'release',
                  target: 'add_release_'+this.target,
                }))
                .then((response) => {
                  if(response.data.status == 'success'){
                    if(response.data.release_status == 'N' && response.data.release_writing_status == 'draft'){
                      let _tableContent = '<div class="sub_table">\
                                      <div class="sub_row">\
                                        <div class="sub_cell header">階段</div>\
                                        <div class="sub_cell header">目標</div>\
                                        <div class="sub_cell header">預算</div>\
                                      </div>';

                      let _currency = this.currencyData.currency
                      for(let j = 0; j < _tmpSubCampaignsContentLength; j++){
                        let _methodName = this.methodName(this.customRulesData.subCampaignsContent[j].method);
                        let _objectiveName = this.objectiveName(this.customRulesData.subCampaignsContent[j].goalsData.campaign_objective);
                        let _budgetSuffix = this.budget_type === 'lifetime' ? _currency : _currency+'/day';
                        let _budget = '<b>'+this.customRulesData.subCampaignsContent[j].budgetData.daily_budget+'</b><span style="font-size:14px; margin-left:4px; margin-top:4px;">'+_budgetSuffix+'</span>';

                        _tableContent += '<div class="sub_row">\
                                            <div class="sub_cell">'+_methodName+'</div>\
                                            <div class="sub_cell">'+_objectiveName+'</div>\
                                            <div class="sub_cell">'+_budget+'</div>\
                                          </div>';
                      }

                      _tableContent += '</div>';
                      _tableContent += "<b style='color:red;'>請勿在Facebook廣告後台修改行銷活動設定、受眾資料(AutoTurn開頭)，<br/>若修改到系統便會暫停自動化</b><br/>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['swal_text_c'];

                      Swal.fire({
                        title: '自定義規則 - 發布',
                        html: _tableContent,
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        width: 'auto', // 可選：根據內容自動調整寬度
                        padding: '1em',
                        confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['yes_button'],
                        cancelButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['no_button'],
                      }).then((result) => {
                        if (result.isConfirmed) {
                          this.releaseType = true
                          this.style = 'z-index:100;';
                          this.releasePercent = 5;
                          let status = 1;
                          let num = 0;
                          let member_hash = this.$route.params.id;
                          var bar5 = new ldBar("#myItem5");
                          bar5.set(this.releasePercent);

                          axios
                            .post('https://www.autoturn.net/api/campaign_release.php', Qs.stringify({
                              s_code: member_hash,
                              campaign_id: this.db_campaign_id,
                            }))
                            .then((caResponse) => {
                              // console.log('caResponse:'+caResponse.data.return_data);
                              if(caResponse.data.status == 'success'){
                                // console.log('#20');
                                //進行進度條
                                // console.log('發佈莞成，開始跑進度條');
                                setInterval( () => {
                                  num++;
                                  if(num < 1200){
                                    // console.log('num:'+num);
                                    // console.log(this.releaseType);

                                    if(this.releaseType == true){
                                      axios
                                        .post('https://www.autoturn.net/api/campaign_states.php', Qs.stringify({
                                          s_code: member_hash,
                                          adaccount_id: this.adaccount_id,
                                          campaign_id: this.db_campaign_id,
                                        }))
                                        .then((csResponse) => {
                                          // console.log('csResponse:'+csResponse.data.return_data);
                                          //進行進度條
                                          if(status == 1){
                                            if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'FAILURE'){
                                              this.releaseType = false
                                              this.style = 'z-index:-1;';
                                              bar5.set(0);
                                              status = 0;
                                              // Swal.fire({
                                              //   icon: 'error',
                                              //   title: '正式發佈',
                                              //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
                                              //   showDenyButton: false,
                                              //   showCancelButton: false,
                                              //   confirmButtonText: '確定',
                                              //   timer: 5000
                                              //   // denyButtonText: `Don't save`,
                                              // }).then((result) => {
                                              //   /* Read more about isConfirmed, isDenied below */
                                              //   if (result.isConfirmed) {
                                              //     // Swal.fire('Saved!', '', 'success')
                                              //     this.allPageLoading = true
                                              //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                              //   } else if (result.isDenied) {
                                              //     // Swal.fire('Changes are not saved', '', 'info')
                                              //     this.allPageLoading = true
                                              //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                              //   }

                                              //   if (result.dismiss === Swal.DismissReason.timer) {
                                              //     this.allPageLoading = true
                                              //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                              //   }
                                              // })

                                              let _tableContent = '<br/><div class="return_table">\
                                                              <div class="return_row">\
                                                                <div class="cell_stage return_header">階段名稱</div>\
                                                                <div class="cell_content return_header">發布結果</div>\
                                                              </div>';

                                              for(let j = 0; j < _tmpSubCampaignsContentLength; j++){
                                                let _methodName = this.methodName(this.customRulesData.subCampaignsContent[j].method);
                                                let _releaseContent = csResponse.data.sub_campaigns[this.customRulesData.subCampaignsContent[j].release.sr_i].current;
                                                let stageIndex = j;
                                                let stageTitle = _methodName;
                                                if(this.customRulesData.subCampaignsContent[0].method != 'META_TEST'){
                                                  stageIndex = j + parseInt(1);
                                                  stageTitle = '階段 '+stageIndex+'：'+_methodName;
                                                } else {
                                                  if(j != 0){
                                                    stageTitle = '階段 '+stageIndex+'：'+_methodName;
                                                  }
                                                }

                                                _tableContent += '<div class="return_row">\
                                                                    <div class="cell_stage">'+stageTitle+'</div>\
                                                                    <div class="cell_content">'+_releaseContent+'</div>\
                                                                  </div>';
                                              }

                                              _tableContent += '</div>';

                                              Swal.fire({
                                                icon: 'error',
                                                title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['info_state_failure']['swal_title'],
                                                html: '發布失敗，請參考下列各階段的發布結果，來進行調整：<br/>'+_tableContent,
                                                showDenyButton: false,
                                                showCancelButton: false,
                                                width: 'auto',
                                                padding: '1em',
                                                confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['info_state_failure']['confirm_button']
                                              }).then((result) => {
                                            //  console.log('#1');
                                                let info_text = csResponse.data.return_data.info_text;
                                                let tosStatus = info_text.includes("/leadgen/tos");
                                                if(tosStatus == true){
                                                  window.open('https://www.facebook.com/ads/leadgen/tos', '', 'height=768,width=1024');
                                                }
                                              })
                                            } else if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'SUCCESS'){
                                              status = 0;

                                              let postData = {adaccount_id: this.$route.params.adaccount_id};
                                              let codeHash = ['de', 'di']

                                              const data = new URLSearchParams();
                                              data.append('s_code', this.$route.params.id);
                                              data.append('post_data', JSON.stringify(postData));
                                              data.append('code_hash', JSON.stringify(codeHash));
                                              data.append('update_type', true);

                                              // 發送請求
                                              navigator.sendBeacon(
                                                'https://www.autoturn.net/api/update_cache.php',
                                                data
                                              );

                                              axios
                                                .post('https://www.autoturn.net/api/data/campaign_creative_optimize_update.php', Qs.stringify({
                                                  s_code: member_hash,
                                                  id: this.db_campaign_id,
                                                }))
                                                .then((response) => {
                                                  axios
                                                    .get('https://www.autoturn.net/udnapi/public/send_notice_email.php?s_code='+member_hash+'&form=release&sr_i='+this.db_campaign_id)
                                                    .then((csResponse) => {
                                                      this.releaseType = false

                                                      Swal.fire({
                                                        icon: 'success',
                                                        title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['info_state_success']['swal_title'],
                                                        text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['info_state_success']['swal_html'],
                                                        showDenyButton: false,
                                                        showCancelButton: false,
                                                        confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['info_state_success']['confirm_button'],
                                                        timer: 5000
                                                        // denyButtonText: `Don't save`,
                                                      }).then((result) => {
                                                        /* Read more about isConfirmed, isDenied below */
                                                        if (result.isConfirmed) {
                                                          // Swal.fire('Saved!', '', 'success')
                                                          this.allPageLoading = true
                                                          window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                                        } else if (result.isDenied) {
                                                          // Swal.fire('Changes are not saved', '', 'info')
                                                          this.allPageLoading = true
                                                          window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                                        }

                                                        if (result.dismiss === Swal.DismissReason.timer) {
                                                          this.allPageLoading = true
                                                          window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                                        }
                                                      })
                                                    });
                                                });
                                            } else if(csResponse.data.return_data.state == 'FAILURE' && csResponse.data.return_data.info_state == 'FAILURE'){
                                              this.releaseType = false
                                              this.style = 'z-index:-1;';
                                              bar5.set(0);
                                              status = 0;
                                              // Swal.fire({
                                              //   icon: 'error',
                                              //   title: '正式發佈',
                                              //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
                                              //   showDenyButton: false,
                                              //   showCancelButton: false,
                                              //   confirmButtonText: '確定',
                                              //   timer: 5000
                                              //   // denyButtonText: `Don't save`,
                                              // }).then((result) => {
                                              //   /* Read more about isConfirmed, isDenied below */
                                              //   if (result.isConfirmed) {
                                              //     // Swal.fire('Saved!', '', 'success')
                                              //     this.allPageLoading = true
                                              //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                              //   } else if (result.isDenied) {
                                              //     // Swal.fire('Changes are not saved', '', 'info')
                                              //     this.allPageLoading = true
                                              //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                              //   }

                                              //   if (result.dismiss === Swal.DismissReason.timer) {
                                              //     this.allPageLoading = true
                                              //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                              //   }
                                              // })

                                              let _tableContent = '<br/><div class="return_table">\
                                                              <div class="return_row">\
                                                                <div class="cell_stage return_header">階段名稱</div>\
                                                                <div class="cell_content return_header">發布結果</div>\
                                                              </div>';

                                              for(let j = 0; j < _tmpSubCampaignsContentLength; j++){
                                                let _methodName = this.methodName(this.customRulesData.subCampaignsContent[j].method);
                                                let _releaseContent = csResponse.data.sub_campaigns[this.customRulesData.subCampaignsContent[j].release.sr_i].current;
                                                let stageIndex = j;
                                                let stageTitle = _methodName;
                                                if(this.customRulesData.subCampaignsContent[0].method != 'META_TEST'){
                                                  stageIndex = j + parseInt(1);
                                                  stageTitle = '階段 '+stageIndex+'：'+_methodName;
                                                } else {
                                                  if(j != 0){
                                                    stageTitle = '階段 '+stageIndex+'：'+_methodName;
                                                  }
                                                }

                                                _tableContent += '<div class="return_row">\
                                                                    <div class="cell_stage">'+stageTitle+'</div>\
                                                                    <div class="cell_content">'+_releaseContent+'</div>\
                                                                  </div>';
                                              }

                                              _tableContent += '</div>';

                                              Swal.fire({
                                                icon: 'error',
                                                title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['state_failure']['swal_title'],
                                                html: '發布失敗，請參考下列各階段的發布結果，來進行調整：<br/>'+_tableContent,
                                                showDenyButton: false,
                                                showCancelButton: false,
                                                width: 'auto',
                                                padding: '1em',
                                                confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['state_failure']['confirm_button']
                                              }).then((result) => {
                                            //  console.log('#2');
                                                let info_text = csResponse.data.return_data.info_text;
                                                let tosStatus = info_text.includes("/leadgen/tos");
                                                if(tosStatus == true){
                                                  window.open('https://www.facebook.com/ads/leadgen/tos', '', 'height=768,width=1024');
                                                }
                                              })
                                            } else {
                                              this.releaseText = csResponse.data.return_data.info_text
                                              this.releasePercent = csResponse.data.return_data.info_pct

                                              bar5.set(this.releasePercent);
                                              // console.log('csResponse.data.return_data.info_text:'+csResponse.data.return_data.info_text);
                                              // console.log('csResponse.data.return_data.info_pct:'+csResponse.data.return_data.info_pct);
                                              // console.log('this.releaseText:'+this.releaseText);
                                              // console.log('this.releasePercent:'+this.releasePercent);

                                              if(csResponse.data.return_data.info_pct == 100){
                                                this.releaseType = false
                                                this.style = 'z-index:-1;';
                                                bar5.set(0);
                                                status = 0;
                                              }
                                            }
                                          }
                                        });
                                    }
                                  } else {
                                    Swal.fire({
                                      icon: 'warning',
                                      title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['else']['swal_title'],
                                      text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['else']['swal_html'],
                                      showDenyButton: false,
                                      showCancelButton: false,
                                      confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['else']['confirm_button'],
                                      timer: 1000
                                      // denyButtonText: `Don't save`,
                                    }).then((result) => {
                                      /* Read more about isConfirmed, isDenied below */
                                      if (result.isConfirmed) {
                                        // Swal.fire('Saved!', '', 'success')
                                        this.allPageLoading = true
                                        window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                      } else if (result.isDenied) {
                                        // Swal.fire('Changes are not saved', '', 'info')
                                        this.allPageLoading = true
                                        window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                      }

                                      if (result.dismiss === Swal.DismissReason.timer) {
                                        this.allPageLoading = true
                                        window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                      }
                                    })
                                  }
                                }, 3000);
                              }
                            });
                        }
                      });
                    } else {
                      Swal.fire(
                        this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['not_success']['swal_title'],
                        response.data.info,
                        'error'
                      )
                    }

                  } else {
                    let text = this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['update_not_success_default_swal_text'];
                    if(response.data.info != '' && response.data.info != null){
                      text = response.data.info
                    }
                    Swal.fire(
                      this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['update_not_success_swal_title'],
                      text,
                      'error'
                    )
                  }

                  this.nextLoading = false;
                  this.showCampaignData = true;
                });











              // let _tableContent = '<div class="table">\
              //                         <div class="row">\
              //                           <div class="cell header">階段</div>\
              //                           <div class="cell header">目標</div>\
              //                           <div class="cell header">預算</div>\
              //                         </div>';

              // let _currency = this.currencyData.currency
              // for(let j = 0; j < _tmpSubCampaignsContentLength; j++){
              //   let _methodName = this.methodName(this.customRulesData.subCampaignsContent[j].method);
              //   let _objectiveName = this.objectiveName(this.customRulesData.subCampaignsContent[j].goalsData.campaign_objective);
              //   let _budget = '<b>'+this.customRulesData.subCampaignsContent[j].budgetData.daily_budget+'</b><span style="font-size:14px; margin-left:4px; margin-top:4px;">'+_currency+'/day</span>';

              //   _tableContent += '<div class="row">\
              //                       <div class="cell">'+_methodName+'</div>\
              //                       <div class="cell">'+_objectiveName+'</div>\
              //                       <div class="cell">'+_budget+'</div>\
              //                     </div>';
              // }

              // _tableContent += '</div>';
              // _tableContent += "<b style='color:red;'>請勿在Facebook廣告後台修改行銷活動設定、受眾資料(AutoTurn開頭)，<br/>若修改到系統便會暫停自動化</b><br/>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['swal_text_c'];

              // Swal.fire({
              //   title: '自定義規則 - 發布',
              //   html: _tableContent,
              //   icon: 'warning',
              //   showCancelButton: true,
              //   confirmButtonColor: '#3085d6',
              //   cancelButtonColor: '#d33',
              //   width: 'auto', // 可選：根據內容自動調整寬度
              //   padding: '1em',
              //   confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['yes_button'],
              //   cancelButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['no_button'],
              // }).then((result) => {
              //   if (result.isConfirmed) {
              // //  console.log(result.isConfirmed);

              //     if(status == 'warning'){
              //       // console.log('#15');
              //       Swal.fire({
              //         icon: 'warning',
              //         title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['swal_title'],
              //         text: caResponse.data.info,
              //         showDenyButton: false,
              //         showCancelButton: false,
              //         confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['confirm_button']
              //         // denyButtonText: `Don't save`,
              //       }).then((result) => {
              //         var daily_keyword_split_budget = this.methodData.Budget_KW;
              //         var daily_demo_budget = this.methodData.Budget_DM;
              //         var budget_addition = this.goalsData.form_addition;

              //         if(this.dateData.start_date != "" && this.dateData.end_date != ""){
              //             var d1 = new Date(this.dateData.start_date);
              //             var d2 = new Date(this.dateData.end_date);
              //             var days = parseInt((d2-d1)/86400000) + parseInt(1);
              //         } else {
              //             var days = 0;
              //         }

              //         var keyword_split_budget = 0;
              //         if(this.methodData.Budget_KW != ''){
              //             keyword_split_budget = Math.round(this.methodData.Budget_KW * days * (1+(budget_addition/100)));
              //         }

              //         var demo_budget = 0;
              //         if(this.methodData.Budget_DM != ''){
              //             demo_budget = this.methodData.Budget_DM * days;
              //         }

              //         var _tmp_audience_budget = 0;
              //         var audience_budget = 0;
              //         // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.5)');
              //         _tmp_audience_budget = this.methodData.Budget_LA;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.5);
              //         // console.log('Math.round('+_tmp_audience_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
              //         audience_budget = Math.round(_tmp_audience_budget * days * (1+(budget_addition/100)));

              //         var _tmp_marketing_again_budget = 0;
              //         var marketing_again_budget = 0;
              //         // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.25)');
              //         _tmp_marketing_again_budget = this.methodData.Budget_RT;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.25);
              //         // console.log('Math.round('+_tmp_marketing_again_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
              //         marketing_again_budget = Math.round(_tmp_marketing_again_budget * days * (1+(budget_addition/100)));

              //         // console.log(parseInt(keyword_split_budget)+' + '+parseInt(demo_budget)+' + '+parseInt(audience_budget)+' + '+parseInt(marketing_again_budget));
              //         var html = parseInt(keyword_split_budget) + parseInt(demo_budget) + parseInt(audience_budget) + parseInt(marketing_again_budget);

              //         if(isNaN(html)){
              //             html = '0';
              //         }

              //         this.total_budget = html;

              //         let _tmp_goalsData = this.goalsData;
              //         const _view_goalsData = JSON.parse(JSON.stringify(_tmp_goalsData));
              //         let _tmp_exAudiencesData = this.exAudiencesData;
              //         const _view_exAudiencesData = JSON.parse(JSON.stringify(_tmp_exAudiencesData));

              //         // console.log(_tmp_exAudiencesData);

              //         delete _view_goalsData['objective_list'];
              //         delete _view_exAudiencesData['custom_excluded_audiences'];

              //         let formData = {
              //           campaign_id: this.campaign_id,
              //           campaign_name: this.campaign_name,
              //           adaccount_id: this.adaccount_id,
              //           Budget_KW_result: this.Budget_KW_result,
              //           total_budget: this.total_budget,
              //           methodData: this.methodData,
              //           benefitsAndInvestmentData: this.benefitsAndInvestmentData,
              //           dateData: this.dateData,
              //           keywordData: this.keywordData,
              //           lookData: this.lookData,
              //           audiencesData: this.audiencesData,
              //           goalsData: _view_goalsData,
              //           regionsData: this.regionsData,
              //           selectCountries: this.selectCountries,
              //           selectLangs: this.selectLangs,
              //           exAudiencesData: _view_exAudiencesData,
              //           pdData: this.pdData,
              //           idData: this.idData,
              //           postData: this.postData,
              //           adMaterialData: this.adMaterialDataNew,
              //           stageData: _stageData
              //         }

              //     //  console.log('warning formData');
              //     //  console.log(formData);

              //         let adaccount_id = this.adaccount_id

              //         if(this.goalsData.campaign_objective == 'LEAD_GENERATION' || this.goalsData.campaign_objective == 'MESSAGES'){
              //           // console.log('開潛、訊息');
              //           let materialType = 0;
              //           let selectArticleLength = 0;
              //           if(this.postData.select_article != '' && this.postData.select_article != null && typeof this.postData.select_article != 'undefined'){
              //             selectArticleLength = this.postData.select_article.length;
              //           }

              //           let selectCreativesMessageLength = 0;
              //           if(this.postData.select_creatives_message != '' && this.postData.select_creatives_message != null && typeof this.postData.select_creatives_message != 'undefined'){
              //             selectCreativesMessageLength = this.postData.select_creatives_message.length;
              //           }

              //           let selectCreativesAdsetAdsMessageLength = 0;
              //           if(this.postData.select_creatives_adset_ads_message != '' && this.postData.select_creatives_adset_ads_message != null && typeof this.postData.select_creatives_adset_ads_message != 'undefined'){
              //             selectCreativesAdsetAdsMessageLength = this.postData.select_creatives_adset_ads_message.length;
              //           }

              //           let creativeArrayLength = 0;
              //           if(this.adMaterialDataNew.creative_array != '' && this.adMaterialDataNew.creative_array != null && typeof this.adMaterialDataNew.creative_array != 'undefined'){
              //             creativeArrayLength = this.adMaterialDataNew.creative_array.length;
              //           }

              //           if(creativeArrayLength == 0 && (!this.postData.select_creatives || this.postData.select_creatives.length == 0) && selectArticleLength == 0 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
              //             materialType = 1;
              //           } else if(selectArticleLength == 0 && selectCreativesMessageLength == 0 && selectCreativesAdsetAdsMessageLength == 0 && creativeArrayLength == 0 && this.goalsData.campaign_objective == 'MESSAGES'){
              //             materialType = 2;
              //           }

              //       //  console.log('#3 materialType:'+materialType);

              //           if(materialType == 0){
              //             // console.log('#2');
              //             let message_sr_i = 0;
              //             let form_sr_i = 0;
              //             let message = 0;
              //             let single_object_spec = 0;
              //             let single_title = 0;
              //             let materials_item = 0;
              //             let materials_object_spec = 0;
              //             let materials_title = 0;
              //             let ad_name = 0;

              //             for(let i = 0; i < creativeArrayLength; i++){
              //               if(this.adMaterialDataNew.creative_array[i].title == '' || this.adMaterialDataNew.creative_array[i].title == null || typeof this.adMaterialDataNew.creative_array[i].title == 'undefined'){
              //                 ad_name = 1;
              //               }

              //               if(this.adMaterialDataNew.creative_array[i].type == 2){
              //                 let materials_length = this.adMaterialDataNew.creative_array[i].materials.length

              //                 if(materials_length < 2){
              //                   materials_item = 1;
              //                 } else {
              //                   for(let j = 0; j < materials_length; j++){
              //                     if(this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == '' || this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == null || typeof this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == 'undefined'){
              //                       materials_object_spec = 1;
              //                     }

              //                     if(this.adMaterialDataNew.creative_array[i].materials[j].title == '' || this.adMaterialDataNew.creative_array[i].materials[j].title == null || typeof this.adMaterialDataNew.creative_array[i].materials[j].title == 'undefined'){
              //                       materials_title = 1;
              //                     }
              //                   }
              //                 }
              //               }

              //               if(this.adMaterialDataNew.creative_array[i].type == 1){
              //                 if(this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == '' || this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == null || typeof this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == 'undefined'){
              //                   single_object_spec = 1;
              //                 }

              //                 if(this.adMaterialDataNew.creative_array[i].materialSingle[0].title == '' || this.adMaterialDataNew.creative_array[i].materialSingle[0].title == null || typeof this.adMaterialDataNew.creative_array[i].materialSingle[0].title == 'undefined'){
              //                   single_title = 1;
              //                 }
              //               }

              //               if(this.adMaterialDataNew.creative_array[i].message == '' || this.adMaterialDataNew.creative_array[i].message == null || typeof this.adMaterialDataNew.creative_array[i].message == 'undefined'){
              //                 message = 1;
              //               }

              //               if(this.adMaterialDataNew.creative_array[i].form_sr_i == '' || this.adMaterialDataNew.creative_array[i].form_sr_i == null || typeof this.adMaterialDataNew.creative_array[i].form_sr_i == 'undefined'){
              //                 form_sr_i = 1;
              //               }

              //               if(this.adMaterialDataNew.creative_array[i].message_sr_i == '' || this.adMaterialDataNew.creative_array[i].message_sr_i == null || typeof this.adMaterialDataNew.creative_array[i].message_sr_i == 'undefined'){
              //                 message_sr_i = 1;
              //               }
              //             }

              //             if(ad_name == 1){
              //               Swal.fire(
              //                           this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['swal_title'],
              //                           this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['not_ad_name_swal_text'],
              //                           "error"
              //                         )
              //             } else if(single_object_spec == 1){
              //               Swal.fire(
              //                           this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['swal_title'],
              //                           this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['not_single_object_spec_swal_text'],
              //                           "error"
              //                         )
              //             } else if(single_title == 1){
              //               Swal.fire(
              //                           this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['swal_title'],
              //                           this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['not_single_title_swal_text'],
              //                           "error"
              //                         )
              //             } else if(materials_item == 1){
              //               Swal.fire(
              //                           this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['swal_title'],
              //                           this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['not_materials_item_swal_text'],
              //                           "error"
              //                         )
              //             } else if(materials_object_spec == 1){
              //               Swal.fire(
              //                           this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['swal_title'],
              //                           this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['not_materials_object_spec_swal_text'],
              //                           "error"
              //                         )
              //             } else if(materials_title == 1){
              //               Swal.fire(
              //                           this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['swal_title'],
              //                           this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['not_materials_title_swal_text'],
              //                           "error"
              //                         )
              //             } else if(message == 1){
              //               Swal.fire(
              //                           this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['swal_title'],
              //                           this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['not_message_swal_text'],
              //                           "error"
              //                         )
              //             } else if(form_sr_i == 1 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
              //               Swal.fire(
              //                         this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['swal_title'],
              //                         this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['not_form_sr_i_swal_text'],
              //                         "error"
              //                       )
              //             } else if(message_sr_i == 1 && this.goalsData.campaign_objective == 'MESSAGES'){
              //               Swal.fire(
              //                         this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['swal_title'],
              //                         this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['not_message_sr_i_swal_text'],
              //                         "error"
              //                       )
              //             } else {
              //               // console.log('#5');
              //               axios
              //                 .post('https://www.autoturn.net/api/data/campaign_update.php', Qs.stringify({
              //                   s_code: this.$route.params.id,
              //                   form_data: formData,
              //                   type: 'release',
              //                   target: 'add_release_'+this.target,
              //                 }))
              //                 .then((response) => {
              //                   // console.log(response.data);
              //                   if(response.data.status == 'success'){
              //                     // console.log('#16');
              //                     // this.immediateList = response.data.return_data
              //                     // this.formData = response.data.return_data.form

              //                     if(response.data.release_status == 'N' && response.data.release_writing_status == 'draft'){
              //                       let name = this.campaign_name;
              //                       let currency = this.currencyData.currency;
              //                       let addition = this.goalsData.form_addition;
              //                       let daily_budget = this.methodData.daily_budget;
              //                       // let campaignInfo = "依您的預算設定，<br/>在未來兩週將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
              //                       // if(addition == '' || addition == 0){
              //                       //   campaignInfo = "依您的預算比率與行銷日期設定，<br/>將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
              //                       // }

              //                       let addition_text = '（'+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['addition_text']+'：<span style="color:red; font-weight:bold;">'+addition+'%</span>）';
              //                       if(this.methodData.Target_AD == true){
              //                         addition_text = '';
              //                       }
              //                       let two_week_budget = Math.round((daily_budget*7)+(daily_budget*7)+(daily_budget*7*(addition/100)));
              //                       let campaignInfo = this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['swal_text_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['swal_text_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['swal_text_total_budget_c']+"</span>"+addition_text;
              //                       if(this.dateData.end_date != '0000-00-00'){
              //                         two_week_budget = this.total_budget;
              //                         campaignInfo = this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['swal_text_not_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['swal_text_not_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['swal_text_not_total_budget_c']+"</span>"+addition_text;
              //                       }

              //                       // Swal.fire({
              //                       //   // title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['swal_title']+"「"+name+"」",
              //                       //   title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['swal_title'],
              //                       //   html: campaignInfo + "<br/><br/>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['swal_text_a']+"<span style='color:red;'>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['swal_text_b']+"</span>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['swal_text_c'],
              //                       //   icon: 'warning',
              //                       //   showCancelButton: true,
              //                       //   confirmButtonColor: '#3085d6',
              //                       //   cancelButtonColor: '#d33',
              //                       //   confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['yes_button'],
              //                       //   cancelButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['no_button'],
              //                       // }).then((result) => {
              //                       //   if (result.isConfirmed) {
              //                           // console.log(this.$route.params.id);

              //                           this.releaseType = true
              //                           this.style = 'z-index:100;';
              //                           this.releasePercent = 5;
              //                           let status = 1;
              //                           let num = 0;
              //                           let member_hash = this.$route.params.id;
              //                           var bar5 = new ldBar("#myItem5");
              //                           bar5.set(this.releasePercent);

              //                           axios
              //                             .post('https://www.autoturn.net/api/campaign_release.php', Qs.stringify({
              //                               s_code: member_hash,
              //                               campaign_id: this.campaign_id,
              //                             }))
              //                             .then((caResponse) => {
              //                               // console.log('caResponse:'+caResponse.data.return_data);
              //                               if(caResponse.data.status == 'success'){
              //                                 // console.log('#17');
              //                                 //進行進度條
              //                                 // console.log('發佈莞成，開始跑進度條');
              //                                 setInterval( () => {
              //                                   num++;
              //                                   if(num < 1200){
              //                                     // console.log('num:'+num);
              //                                     // console.log(this.releaseType);

              //                                     if(this.releaseType == true){
              //                                       axios
              //                                         .post('https://www.autoturn.net/api/campaign_states.php', Qs.stringify({
              //                                           s_code: member_hash,
              //                                           adaccount_id: this.adaccount_id,
              //                                           campaign_id: this.campaign_id,
              //                                         }))
              //                                         .then((csResponse) => {
              //                                           // console.log('csResponse:'+csResponse.data.return_data);
              //                                           //進行進度條
              //                                           if(status == 1){
              //                                             if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'FAILURE'){
              //                                               this.releaseType = false
              //                                               this.style = 'z-index:-1;';
              //                                               bar5.set(0);
              //                                               status = 0;
              //                                               // Swal.fire({
              //                                               //   icon: 'error',
              //                                               //   title: '正式發佈',
              //                                               //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
              //                                               //   showDenyButton: false,
              //                                               //   showCancelButton: false,
              //                                               //   confirmButtonText: '確定',
              //                                               //   timer: 5000
              //                                               //   // denyButtonText: `Don't save`,
              //                                               // }).then((result) => {
              //                                               //   /* Read more about isConfirmed, isDenied below */
              //                                               //   if (result.isConfirmed) {
              //                                               //     // Swal.fire('Saved!', '', 'success')
              //                                               //     this.allPageLoading = true
              //                                               //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                               //   } else if (result.isDenied) {
              //                                               //     // Swal.fire('Changes are not saved', '', 'info')
              //                                               //     this.allPageLoading = true
              //                                               //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                               //   }

              //                                               //   if (result.dismiss === Swal.DismissReason.timer) {
              //                                               //     this.allPageLoading = true
              //                                               //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                               //   }
              //                                               // })
              //                                               Swal.fire({
              //                                                 icon: 'error',
              //                                                 title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['info_state_failure']['swal_title'],
              //                                                 text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['info_state_failure']['swal_html']+csResponse.data.return_data.info_text,
              //                                                 showDenyButton: false,
              //                                                 showCancelButton: false,
              //                                                 confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['info_state_failure']['confirm_button']
              //                                               }).then((result) => {

              //                                               })
              //                                             } else if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'SUCCESS'){
              //                                               status = 0;

              //                                               axios
              //                                                 .post('https://www.autoturn.net/api/data/campaign_creative_optimize_update.php', Qs.stringify({
              //                                                   s_code: member_hash,
              //                                                   id: this.campaign_id,
              //                                                 }))
              //                                                 .then((response) => {
              //                                                   axios
              //                                                     .get('https://www.autoturn.net/udnapi/public/send_notice_email.php?s_code='+member_hash+'&s_code='+member_hash+'&form=release&sr_i='+this.campaign_id)
              //                                                     .then((csResponse) => {
              //                                                       this.releaseType = false

              //                                                       Swal.fire({
              //                                                         icon: 'success',
              //                                                         title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['info_state_success']['swal_title'],
              //                                                         text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['info_state_success']['swal_html'],
              //                                                         showDenyButton: false,
              //                                                         showCancelButton: false,
              //                                                         confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['info_state_success']['confirm_button'],
              //                                                         timer: 5000
              //                                                         // denyButtonText: `Don't save`,
              //                                                       }).then((result) => {
              //                                                         /* Read more about isConfirmed, isDenied below */
              //                                                         if (result.isConfirmed) {
              //                                                           // Swal.fire('Saved!', '', 'success')
              //                                                           this.allPageLoading = true
              //                                                           window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                                         } else if (result.isDenied) {
              //                                                           // Swal.fire('Changes are not saved', '', 'info')
              //                                                           this.allPageLoading = true
              //                                                           window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                                         }

              //                                                         if (result.dismiss === Swal.DismissReason.timer) {
              //                                                           this.allPageLoading = true
              //                                                           window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                                         }
              //                                                       })
              //                                                     });
              //                                                 });
              //                                             } else if(csResponse.data.return_data.state == 'FAILURE' && csResponse.data.return_data.info_state == 'FAILURE'){
              //                                               this.releaseType = false
              //                                               this.style = 'z-index:-1;';
              //                                               bar5.set(0);
              //                                               status = 0;
              //                                               // Swal.fire({
              //                                               //   icon: 'error',
              //                                               //   title: '正式發佈',
              //                                               //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
              //                                               //   showDenyButton: false,
              //                                               //   showCancelButton: false,
              //                                               //   confirmButtonText: '確定',
              //                                               //   timer: 5000
              //                                               //   // denyButtonText: `Don't save`,
              //                                               // }).then((result) => {
              //                                               //   /* Read more about isConfirmed, isDenied below */
              //                                               //   if (result.isConfirmed) {
              //                                               //     // Swal.fire('Saved!', '', 'success')
              //                                               //     this.allPageLoading = true
              //                                               //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                               //   } else if (result.isDenied) {
              //                                               //     // Swal.fire('Changes are not saved', '', 'info')
              //                                               //     this.allPageLoading = true
              //                                               //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                               //   }

              //                                               //   if (result.dismiss === Swal.DismissReason.timer) {
              //                                               //     this.allPageLoading = true
              //                                               //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                               //   }
              //                                               // })
              //                                               Swal.fire({
              //                                                 icon: 'error',
              //                                                 title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['state_failure']['swal_title'],
              //                                                 text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['state_failure']['swal_html']+csResponse.data.return_data.info_text,
              //                                                 showDenyButton: false,
              //                                                 showCancelButton: false,
              //                                                 confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['state_failure']['confirm_button']
              //                                               }).then((result) => {

              //                                               })
              //                                             } else {
              //                                               this.releaseText = csResponse.data.return_data.info_text
              //                                               this.releasePercent = csResponse.data.return_data.info_pct

              //                                               bar5.set(this.releasePercent);
              //                                               // console.log('csResponse.data.return_data.info_text:'+csResponse.data.return_data.info_text);
              //                                               // console.log('csResponse.data.return_data.info_pct:'+csResponse.data.return_data.info_pct);
              //                                               // console.log('this.releaseText:'+this.releaseText);
              //                                               // console.log('this.releasePercent:'+this.releasePercent);

              //                                               if(csResponse.data.return_data.info_pct == 100){
              //                                                 this.releaseType = false
              //                                                 this.style = 'z-index:-1;';
              //                                                 bar5.set(0);
              //                                                 status = 0;
              //                                               }
              //                                             }
              //                                           }
              //                                         });
              //                                     }
              //                                   } else {
              //                                     Swal.fire({
              //                                       icon: 'warning',
              //                                       title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['else']['swal_title'],
              //                                       text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['else']['swal_html'],
              //                                       showDenyButton: false,
              //                                       showCancelButton: false,
              //                                       confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['else']['confirm_button'],
              //                                       timer: 1000
              //                                       // denyButtonText: `Don't save`,
              //                                     }).then((result) => {
              //                                       /* Read more about isConfirmed, isDenied below */
              //                                       if (result.isConfirmed) {
              //                                         // Swal.fire('Saved!', '', 'success')
              //                                         this.allPageLoading = true
              //                                         window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                       } else if (result.isDenied) {
              //                                         // Swal.fire('Changes are not saved', '', 'info')
              //                                         this.allPageLoading = true
              //                                         window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                       }

              //                                       if (result.dismiss === Swal.DismissReason.timer) {
              //                                         this.allPageLoading = true
              //                                         window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                       }
              //                                     })
              //                                   }
              //                                 }, 3000);
              //                               }
              //                             });
              //                       //   }
              //                       // })
              //                     } else {
              //                       Swal.fire(
              //                         this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['not_success']['swal_title'],
              //                         response.data.info,
              //                         'error'
              //                       )
              //                     }

              //                     // if(type == 1){
              //                     //   var todayForm = new Date();
              //                     //   var yearForm = todayForm.getFullYear();
              //                     //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
              //                     //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
              //                     //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

              //                     //   todayForm = yearForm + monthForm + dateForm + timeForm;

              //                     //   this.formTitle = 'title_'+todayForm;
              //                     // } else {
              //                     //   this.formTitle = response.data.return_data.name;
              //                     // }

              //                     // this.showModal = true
              //                   } else {
              //                     let text = this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['update_not_success_default_swal_text'];
              //                     if(response.data.info != '' && response.data.info != null){
              //                       text = response.data.info
              //                     }
              //                     Swal.fire(
              //                       this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['update_not_success_swal_title'],
              //                       text,
              //                       'error'
              //                     )
              //                   }
              //                 });
              //             }
              //           } else {
              //         //  console.log('#33');
              //             Swal.fire(
              //                         this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['not_creative_array_swal_title'],
              //                         this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['not_creative_array_swal_text'],
              //                         "error"
              //                       )
              //           }
              //         } else {
              //       //  console.log('非開潛、訊息');
              //           axios
              //             .post('https://www.autoturn.net/api/data/campaign_update.php', Qs.stringify({
              //               s_code: this.$route.params.id,
              //               form_data: formData,
              //               type: 'release',
              //               target: 'add_release_'+this.target,
              //             }))
              //             .then((response) => {
              //               // console.log(response.data);
              //               if(response.data.status == 'success'){
              //                 // console.log('#16');
              //                 // this.immediateList = response.data.return_data
              //                 // this.formData = response.data.return_data.form

              //                 if(response.data.release_status == 'N' && response.data.release_writing_status == 'draft'){
              //                   let name = this.campaign_name;
              //                   let currency = this.currencyData.currency;
              //                   let addition = this.goalsData.form_addition;
              //                   let daily_budget = this.methodData.daily_budget;
              //                   // let campaignInfo = "依您的預算設定，<br/>在未來兩週將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
              //                   // if(addition == '' || addition == 0){
              //                   //   campaignInfo = "依您的預算比率與行銷日期設定，<br/>將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
              //                   // }

              //                   let addition_text = '（'+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['addition_text']+'：<span style="color:red; font-weight:bold;">'+addition+'%</span>）';
              //                   if(this.methodData.Target_AD == true){
              //                     addition_text = '';
              //                   }
              //                   let two_week_budget = Math.round((daily_budget*7)+(daily_budget*7)+(daily_budget*7*(addition/100)));
              //                   let campaignInfo = this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['swal_text_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['swal_text_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['swal_text_total_budget_c']+"</span>"+addition_text;
              //                   if(this.dateData.end_date != '0000-00-00'){
              //                     two_week_budget = this.total_budget;
              //                     campaignInfo = this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['swal_text_not_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['swal_text_not_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['swal_text_not_total_budget_c']+"</span>"+addition_text;
              //                   }

              //                   // Swal.fire({
              //                   //   // title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['swal_title']+"「"+name+"」",
              //                   //   title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['swal_title'],
              //                   //   html: campaignInfo + "<br/><br/>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['swal_text_a']+"<span style='color:red;'>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['swal_text_b']+"</span>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['swal_text_c'],
              //                   //   icon: 'warning',
              //                   //   showCancelButton: true,
              //                   //   confirmButtonColor: '#3085d6',
              //                   //   cancelButtonColor: '#d33',
              //                   //   confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['yes_button'],
              //                   //   cancelButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['no_button'],
              //                   // }).then((result) => {
              //                   //   if (result.isConfirmed) {
              //                       // console.log(this.$route.params.id);

              //                       this.releaseType = true
              //                       this.style = 'z-index:100;';
              //                       this.releasePercent = 5;
              //                       let status = 1;
              //                       let num = 0;
              //                       let member_hash = this.$route.params.id;
              //                       var bar5 = new ldBar("#myItem5");
              //                       bar5.set(this.releasePercent);

              //                       axios
              //                         .post('https://www.autoturn.net/api/campaign_release.php', Qs.stringify({
              //                           s_code: member_hash,
              //                           campaign_id: this.campaign_id,
              //                         }))
              //                         .then((caResponse) => {
              //                           // console.log('caResponse:'+caResponse.data.return_data);
              //                           if(caResponse.data.status == 'success'){
              //                             // console.log('#17');
              //                             //進行進度條
              //                             // console.log('發佈莞成，開始跑進度條');
              //                             setInterval( () => {
              //                               num++;
              //                               if(num < 1200){
              //                                 // console.log('num:'+num);
              //                                 // console.log(this.releaseType);

              //                                 if(this.releaseType == true){
              //                                   axios
              //                                     .post('https://www.autoturn.net/api/campaign_states.php', Qs.stringify({
              //                                       s_code: member_hash,
              //                                       adaccount_id: this.adaccount_id,
              //                                       campaign_id: this.campaign_id,
              //                                     }))
              //                                     .then((csResponse) => {
              //                                       // console.log('csResponse:'+csResponse.data.return_data);
              //                                       //進行進度條
              //                                       if(status == 1){
              //                                         if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'FAILURE'){
              //                                           this.releaseType = false
              //                                           this.style = 'z-index:-1;';
              //                                           bar5.set(0);
              //                                           status = 0;
              //                                           // Swal.fire({
              //                                           //   icon: 'error',
              //                                           //   title: '正式發佈',
              //                                           //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
              //                                           //   showDenyButton: false,
              //                                           //   showCancelButton: false,
              //                                           //   confirmButtonText: '確定',
              //                                           //   timer: 5000
              //                                           //   // denyButtonText: `Don't save`,
              //                                           // }).then((result) => {
              //                                           //   /* Read more about isConfirmed, isDenied below */
              //                                           //   if (result.isConfirmed) {
              //                                           //     // Swal.fire('Saved!', '', 'success')
              //                                           //     this.allPageLoading = true
              //                                           //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                           //   } else if (result.isDenied) {
              //                                           //     // Swal.fire('Changes are not saved', '', 'info')
              //                                           //     this.allPageLoading = true
              //                                           //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                           //   }

              //                                           //   if (result.dismiss === Swal.DismissReason.timer) {
              //                                           //     this.allPageLoading = true
              //                                           //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                           //   }
              //                                           // })
              //                                           Swal.fire({
              //                                             icon: 'error',
              //                                             title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['info_state_failure']['swal_title'],
              //                                             text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['info_state_failure']['swal_html']+csResponse.data.return_data.info_text,
              //                                             showDenyButton: false,
              //                                             showCancelButton: false,
              //                                             confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['info_state_failure']['confirm_button']
              //                                           }).then((result) => {

              //                                           })
              //                                         } else if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'SUCCESS'){
              //                                           status = 0;

              //                                           axios
              //                                             .post('https://www.autoturn.net/api/data/campaign_creative_optimize_update.php', Qs.stringify({
              //                                               s_code: member_hash,
              //                                               id: this.campaign_id,
              //                                             }))
              //                                             .then((response) => {
              //                                               axios
              //                                                 .get('https://www.autoturn.net/udnapi/public/send_notice_email.php?s_code='+member_hash+'&form=release&sr_i='+this.campaign_id)
              //                                                 .then((csResponse) => {
              //                                                   this.releaseType = false

              //                                                   Swal.fire({
              //                                                     icon: 'success',
              //                                                     title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['info_state_success']['swal_title'],
              //                                                     text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['info_state_success']['swal_html'],
              //                                                     showDenyButton: false,
              //                                                     showCancelButton: false,
              //                                                     confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['info_state_success']['confirm_button'],
              //                                                     timer: 5000
              //                                                     // denyButtonText: `Don't save`,
              //                                                   }).then((result) => {
              //                                                     /* Read more about isConfirmed, isDenied below */
              //                                                     if (result.isConfirmed) {
              //                                                       // Swal.fire('Saved!', '', 'success')
              //                                                       this.allPageLoading = true
              //                                                       window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                                     } else if (result.isDenied) {
              //                                                       // Swal.fire('Changes are not saved', '', 'info')
              //                                                       this.allPageLoading = true
              //                                                       window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                                     }

              //                                                     if (result.dismiss === Swal.DismissReason.timer) {
              //                                                       this.allPageLoading = true
              //                                                       window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                                     }
              //                                                   })
              //                                                 });
              //                                             });
              //                                         } else if(csResponse.data.return_data.state == 'FAILURE' && csResponse.data.return_data.info_state == 'FAILURE'){
              //                                           this.releaseType = false
              //                                           this.style = 'z-index:-1;';
              //                                           bar5.set(0);
              //                                           status = 0;
              //                                           // Swal.fire({
              //                                           //   icon: 'error',
              //                                           //   title: '正式發佈',
              //                                           //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
              //                                           //   showDenyButton: false,
              //                                           //   showCancelButton: false,
              //                                           //   confirmButtonText: '確定',
              //                                           //   timer: 5000
              //                                           //   // denyButtonText: `Don't save`,
              //                                           // }).then((result) => {
              //                                           //   /* Read more about isConfirmed, isDenied below */
              //                                           //   if (result.isConfirmed) {
              //                                           //     // Swal.fire('Saved!', '', 'success')
              //                                           //     this.allPageLoading = true
              //                                           //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                           //   } else if (result.isDenied) {
              //                                           //     // Swal.fire('Changes are not saved', '', 'info')
              //                                           //     this.allPageLoading = true
              //                                           //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                           //   }

              //                                           //   if (result.dismiss === Swal.DismissReason.timer) {
              //                                           //     this.allPageLoading = true
              //                                           //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                           //   }
              //                                           // })
              //                                           Swal.fire({
              //                                             icon: 'error',
              //                                             title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['state_failure']['swal_title'],
              //                                             text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['state_failure']['swal_html']+csResponse.data.return_data.info_text,
              //                                             showDenyButton: false,
              //                                             showCancelButton: false,
              //                                             confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['state_failure']['confirm_button']
              //                                           }).then((result) => {

              //                                           })
              //                                         } else {
              //                                           this.releaseText = csResponse.data.return_data.info_text
              //                                           this.releasePercent = csResponse.data.return_data.info_pct

              //                                           bar5.set(this.releasePercent);
              //                                           // console.log('csResponse.data.return_data.info_text:'+csResponse.data.return_data.info_text);
              //                                           // console.log('csResponse.data.return_data.info_pct:'+csResponse.data.return_data.info_pct);
              //                                           // console.log('this.releaseText:'+this.releaseText);
              //                                           // console.log('this.releasePercent:'+this.releasePercent);

              //                                           if(csResponse.data.return_data.info_pct == 100){
              //                                             this.releaseType = false
              //                                             this.style = 'z-index:-1;';
              //                                             bar5.set(0);
              //                                             status = 0;
              //                                           }
              //                                         }
              //                                       }
              //                                     });
              //                                 }
              //                               } else {
              //                                 Swal.fire({
              //                                   icon: 'warning',
              //                                   title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['else']['swal_title'],
              //                                   text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['else']['swal_html'],
              //                                   showDenyButton: false,
              //                                   showCancelButton: false,
              //                                   confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['else']['confirm_button'],
              //                                   timer: 1000
              //                                   // denyButtonText: `Don't save`,
              //                                 }).then((result) => {
              //                                   /* Read more about isConfirmed, isDenied below */
              //                                   if (result.isConfirmed) {
              //                                     // Swal.fire('Saved!', '', 'success')
              //                                     this.allPageLoading = true
              //                                     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                   } else if (result.isDenied) {
              //                                     // Swal.fire('Changes are not saved', '', 'info')
              //                                     this.allPageLoading = true
              //                                     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                   }

              //                                   if (result.dismiss === Swal.DismissReason.timer) {
              //                                     this.allPageLoading = true
              //                                     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                   }
              //                                 })
              //                               }
              //                             }, 3000);
              //                           }
              //                         });
              //                   //   }
              //                   // })
              //                 } else {
              //                   Swal.fire(
              //                     this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['not_success']['swal_title'],
              //                     response.data.info,
              //                     'error'
              //                   )
              //                 }

              //                 // if(type == 1){
              //                 //   var todayForm = new Date();
              //                 //   var yearForm = todayForm.getFullYear();
              //                 //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
              //                 //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
              //                 //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

              //                 //   todayForm = yearForm + monthForm + dateForm + timeForm;

              //                 //   this.formTitle = 'title_'+todayForm;
              //                 // } else {
              //                 //   this.formTitle = response.data.return_data.name;
              //                 // }

              //                 // this.showModal = true
              //               } else {
              //                 let text = this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['update_not_success_default_swal_text'];
              //                 if(response.data.info != '' && response.data.info != null){
              //                   text = response.data.info
              //                 }
              //                 Swal.fire(
              //                   this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['update_not_success_swal_title'],
              //                   text,
              //                   'error'
              //                 )
              //               }
              //             });
              //         }
              //       });
              //     }

              //     if(status == 'success'){
              //       // console.log('#18');
              //       var daily_keyword_split_budget = this.methodData.Budget_KW;
              //       var daily_demo_budget = this.methodData.Budget_DM;
              //       var budget_addition = this.goalsData.form_addition;

              //       if(this.dateData.start_date != "" && this.dateData.end_date != ""){
              //           var d1 = new Date(this.dateData.start_date);
              //           var d2 = new Date(this.dateData.end_date);
              //           var days = parseInt((d2-d1)/86400000) + parseInt(1);
              //       } else {
              //           var days = 0;
              //       }

              //       var keyword_split_budget = 0;
              //       if(this.methodData.Budget_KW != ''){
              //           keyword_split_budget = Math.round(this.methodData.Budget_KW * days * (1+(budget_addition/100)));
              //       }

              //       var demo_budget = 0;
              //       if(this.methodData.Budget_DM != ''){
              //           demo_budget = this.methodData.Budget_DM * days;
              //       }

              //       var _tmp_audience_budget = 0;
              //       var audience_budget = 0;
              //       // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.5)');
              //       _tmp_audience_budget = this.methodData.Budget_LA;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.5);
              //       // console.log('Math.round('+_tmp_audience_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
              //       audience_budget = Math.round(_tmp_audience_budget * days * (1+(budget_addition/100)));

              //       var _tmp_marketing_again_budget = 0;
              //       var marketing_again_budget = 0;
              //       // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.25)');
              //       _tmp_marketing_again_budget = this.methodData.Budget_RT;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.25);
              //       // console.log('Math.round('+_tmp_marketing_again_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
              //       marketing_again_budget = Math.round(_tmp_marketing_again_budget * days * (1+(budget_addition/100)));

              //       // console.log(parseInt(keyword_split_budget)+' + '+parseInt(demo_budget)+' + '+parseInt(audience_budget)+' + '+parseInt(marketing_again_budget));
              //       var html = parseInt(keyword_split_budget) + parseInt(demo_budget) + parseInt(audience_budget) + parseInt(marketing_again_budget);

              //       if(isNaN(html)){
              //           html = '0';
              //       }

              //       this.total_budget = html;

              //       let _tmp_goalsData = this.goalsData;
              //       const _view_goalsData = JSON.parse(JSON.stringify(_tmp_goalsData));
              //       let _tmp_exAudiencesData = this.exAudiencesData;
              //       const _view_exAudiencesData = JSON.parse(JSON.stringify(_tmp_exAudiencesData));

              //       // console.log(_tmp_exAudiencesData);

              //       delete _view_goalsData['objective_list'];
              //       delete _view_exAudiencesData['custom_excluded_audiences'];

              //       let formData = {
              //         campaign_id: this.campaign_id,
              //         campaign_name: this.campaign_name,
              //         adaccount_id: this.adaccount_id,
              //         Budget_KW_result: this.Budget_KW_result,
              //         total_budget: this.total_budget,
              //         methodData: this.methodData,
              //         benefitsAndInvestmentData: this.benefitsAndInvestmentData,
              //         dateData: this.dateData,
              //         keywordData: this.keywordData,
              //         lookData: this.lookData,
              //         audiencesData: this.audiencesData,
              //         goalsData: _view_goalsData,
              //         regionsData: this.regionsData,
              //         selectCountries: this.selectCountries,
              //         selectLangs: this.selectLangs,
              //         exAudiencesData: _view_exAudiencesData,
              //         pdData: this.pdData,
              //         idData: this.idData,
              //         postData: this.postData,
              //         adMaterialData: this.adMaterialDataNew,
              //         stageData: _stageData
              //       }

              //   //  console.log('success formData');
              //   //  console.log(formData);

              //       let adaccount_id = this.adaccount_id

              //       if(this.goalsData.campaign_objective == 'LEAD_GENERATION' || this.goalsData.campaign_objective == 'MESSAGES'){
              //         // console.log('#1');
              //         let materialType = 0;
              //         let selectArticleLength = 0;

              //     //  console.log('this.postData');
              //     //  console.log(this.postData);
              //     //  console.log('this.adMaterialDataNew');
              //     //  console.log(this.adMaterialDataNew);

              //     //  console.log('b this.postData.select_article');
              //     //  console.log(this.postData.select_article);
              //     //  console.log('b this.postData.select_creatives_message');
              //     //  console.log(this.postData.select_creatives_message);
              //     //  console.log('b this.postData.select_creatives_adset_ads_message');
              //     //  console.log(this.postData.select_creatives_adset_ads_message);
              //     //  console.log('b this.adMaterialDataNew.creative_array');
              //     //  console.log(this.adMaterialDataNew.creative_array);

              //         if(this.postData.select_article != '' && this.postData.select_article != null && typeof this.postData.select_article != 'undefined'){
              //           selectArticleLength = this.postData.select_article.length;
              //         }

              //         let selectCreativesMessageLength = 0;
              //         if(this.postData.select_creatives_message != '' && this.postData.select_creatives_message != null && typeof this.postData.select_creatives_message != 'undefined'){
              //           selectCreativesMessageLength = this.postData.select_creatives_message.length;
              //         }

              //         let selectCreativesAdsetAdsMessageLength = 0;
              //         if(this.postData.select_creatives_adset_ads_message != '' && this.postData.select_creatives_adset_ads_message != null && typeof this.postData.select_creatives_adset_ads_message != 'undefined'){
              //           selectCreativesAdsetAdsMessageLength = this.postData.select_creatives_adset_ads_message.length;
              //         }

              //         let creativeArrayLength = 0;
              //         if(this.adMaterialDataNew.creative_array != '' && this.adMaterialDataNew.creative_array != null && typeof this.adMaterialDataNew.creative_array != 'undefined'){
              //           creativeArrayLength = this.adMaterialDataNew.creative_array.length;
              //         }

              //     //  console.log('a selectArticleLength');
              //     //  console.log(selectArticleLength);
              //     //  console.log('a selectCreativesMessageLength');
              //     //  console.log(selectCreativesMessageLength);
              //     //  console.log('a selectCreativesAdsetAdsMessageLength');
              //     //  console.log(selectCreativesAdsetAdsMessageLength);
              //     //  console.log('a creativeArrayLength');
              //     //  console.log(creativeArrayLength);
              //     //  console.log('a this.goalsData.campaign_objective');
              //     //  console.log(this.goalsData.campaign_objective);

              //         if(creativeArrayLength == 0 && (!this.postData.select_creatives || this.postData.select_creatives.length == 0) && selectArticleLength == 0 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
              //           materialType = 1;
              //         } else if(selectArticleLength == 0 && selectCreativesMessageLength == 0 && selectCreativesAdsetAdsMessageLength == 0 && creativeArrayLength == 0 && this.goalsData.campaign_objective == 'MESSAGES'){
              //           materialType = 2;
              //         }

              //     //  console.log('this.postData.select_article');
              //     //  console.log(this.postData.select_article);
              //     //  console.log('this.postData.select_creatives_message');
              //     //  console.log(this.postData.select_creatives_message);
              //     //  console.log('this.adMaterialDataNew.creative_array');
              //     //  console.log(this.adMaterialDataNew.creative_array);
              //     //  console.log('this.goalsData.campaign_objective');
              //     //  console.log(this.goalsData.campaign_objective);
              //     //  console.log(selectArticleLength +' == 0 && '+ selectCreativesMessageLength +' == 0 && '+ creativeArrayLength +' == 0');

              //     //  console.log('#4 materialType:'+materialType);

              //         if(materialType == 0){
              //           // console.log('#2');
              //           let message_sr_i = 0;
              //           let form_sr_i = 0;
              //           let message = 0;
              //           let single_object_spec = 0;
              //           let single_title = 0;
              //           let materials_item = 0;
              //           let materials_object_spec = 0;
              //           let materials_title = 0;
              //           let ad_name = 0;

              //           for(let i = 0; i < creativeArrayLength; i++){
              //             if(this.adMaterialDataNew.creative_array[i].title == '' || this.adMaterialDataNew.creative_array[i].title == null || typeof this.adMaterialDataNew.creative_array[i].title == 'undefined'){
              //               ad_name = 1;
              //             }

              //             if(this.adMaterialDataNew.creative_array[i].type == 2){
              //               let materials_length = this.adMaterialDataNew.creative_array[i].materials.length

              //               if(materials_length < 2){
              //                 materials_item = 1;
              //               } else {
              //                 for(let j = 0; j < materials_length; j++){
              //                   if(this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == '' || this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == null || typeof this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == 'undefined'){
              //                     materials_object_spec = 1;
              //                   }

              //                   if(this.adMaterialDataNew.creative_array[i].materials[j].title == '' || this.adMaterialDataNew.creative_array[i].materials[j].title == null || typeof this.adMaterialDataNew.creative_array[i].materials[j].title == 'undefined'){
              //                     materials_title = 1;
              //                   }
              //                 }
              //               }
              //             }

              //             if(this.adMaterialDataNew.creative_array[i].type == 1){
              //               if(this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == '' || this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == null || typeof this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == 'undefined'){
              //                 single_object_spec = 1;
              //               }

              //               if(this.adMaterialDataNew.creative_array[i].materialSingle[0].title == '' || this.adMaterialDataNew.creative_array[i].materialSingle[0].title == null || typeof this.adMaterialDataNew.creative_array[i].materialSingle[0].title == 'undefined'){
              //                 single_title = 1;
              //               }
              //             }

              //             if(this.adMaterialDataNew.creative_array[i].message == '' || this.adMaterialDataNew.creative_array[i].message == null || typeof this.adMaterialDataNew.creative_array[i].message == 'undefined'){
              //               message = 1;
              //             }

              //             if(this.adMaterialDataNew.creative_array[i].form_sr_i == '' || this.adMaterialDataNew.creative_array[i].form_sr_i == null || typeof this.adMaterialDataNew.creative_array[i].form_sr_i == 'undefined'){
              //               form_sr_i = 1;
              //             }

              //             if(this.adMaterialDataNew.creative_array[i].message_sr_i == '' || this.adMaterialDataNew.creative_array[i].message_sr_i == null || typeof this.adMaterialDataNew.creative_array[i].message_sr_i == 'undefined'){
              //               message_sr_i = 1;
              //             }
              //           }

              //           if(ad_name == 1){
              //             Swal.fire(
              //                         this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['swal_title'],
              //                         this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['not_ad_name_swal_text'],
              //                         "error"
              //                       )
              //           } else if(single_object_spec == 1){
              //             Swal.fire(
              //                         this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['swal_title'],
              //                         this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['not_single_object_spec_swal_text'],
              //                         "error"
              //                       )
              //           } else if(single_title == 1){
              //             Swal.fire(
              //                         this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['swal_title'],
              //                         this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['not_single_title_swal_text'],
              //                         "error"
              //                       )
              //           } else if(materials_item == 1){
              //             Swal.fire(
              //                         this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['swal_title'],
              //                         this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['not_materials_item_swal_text'],
              //                         "error"
              //                       )
              //           } else if(materials_object_spec == 1){
              //             Swal.fire(
              //                         this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['swal_title'],
              //                         this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['not_materials_object_spec_swal_text'],
              //                         "error"
              //                       )
              //           } else if(materials_title == 1){
              //             Swal.fire(
              //                         this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['swal_title'],
              //                         this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['not_materials_title_swal_text'],
              //                         "error"
              //                       )
              //           } else if(message == 1){
              //             Swal.fire(
              //                         this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['swal_title'],
              //                         this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['not_message_swal_text'],
              //                         "error"
              //                       )
              //           } else if(form_sr_i == 1 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
              //             Swal.fire(
              //                       this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['swal_title'],
              //                       this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['not_form_sr_i_swal_text'],
              //                       "error"
              //                     )
              //           } else if(message_sr_i == 1 && this.goalsData.campaign_objective == 'MESSAGES'){
              //             Swal.fire(
              //                       this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['swal_title'],
              //                       this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['not_message_sr_i_swal_text'],
              //                       "error"
              //                     )
              //           } else {
              //             // console.log('#5');
              //             axios
              //               .post('https://www.autoturn.net/api/data/campaign_update.php', Qs.stringify({
              //                 s_code: this.$route.params.id,
              //                 form_data: formData,
              //                 type: 'release',
              //                 target: 'add_release_'+this.target,
              //               }))
              //               .then((response) => {
              //                 // console.log(response.data);
              //                 if(response.data.status == 'success'){
              //                   // console.log('#19');
              //                   // this.immediateList = response.data.return_data
              //                   // this.formData = response.data.return_data.form

              //                   if(response.data.release_status == 'N' && response.data.release_writing_status == 'draft'){
              //                     let name = this.campaign_name;
              //                     let currency = this.currencyData.currency;
              //                     let addition = this.goalsData.form_addition;
              //                     let daily_budget = this.methodData.daily_budget;
              //                     // let campaignInfo = "依您的預算設定，<br/>在未來兩週將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
              //                     // if(addition == '' || addition == 0){
              //                     //   campaignInfo = "依您的預算比率與行銷日期設定，<br/>將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
              //                     // }

              //                     let addition_text = '（'+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['addition_text']+'<span style="color:red; font-weight:bold;">'+addition+'%</span>）';
              //                     if(this.methodData.Target_AD == true){
              //                       addition_text = '';
              //                     }
              //                     let two_week_budget = Math.round((daily_budget*7)+(daily_budget*7)+(daily_budget*7*(addition/100)));
              //                     let campaignInfo = this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['swal_text_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['swal_text_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['swal_text_total_budget_c']+"</span>"+addition_text;
              //                     if(this.dateData.end_date != '0000-00-00'){
              //                       two_week_budget = this.total_budget;
              //                       campaignInfo = this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['swal_text_not_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['swal_text_not_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['swal_text_not_total_budget_c']+"</span>"+addition_text;
              //                     }

              //                     // Swal.fire({
              //                     //   // title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['swal_title']+"「"+name+"」",
              //                     //   title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['swal_title'],
              //                     //   html: campaignInfo + "<br/><br/>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['swal_text_a']+"<span style='color:red;'>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['swal_text_b']+"</span>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['swal_text_c'],
              //                     //   icon: 'warning',
              //                     //   showCancelButton: true,
              //                     //   confirmButtonColor: '#3085d6',
              //                     //   cancelButtonColor: '#d33',
              //                     //   confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['yes_button'],
              //                     //   cancelButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['no_button'],
              //                     // }).then((result) => {
              //                     //   if (result.isConfirmed) {
              //                         // console.log(this.$route.params.id);

              //                         this.releaseType = true
              //                         this.style = 'z-index:100;';
              //                         this.releasePercent = 5;
              //                         let status = 1;
              //                         let num = 0;
              //                         let member_hash = this.$route.params.id;
              //                         var bar5 = new ldBar("#myItem5");
              //                         bar5.set(this.releasePercent);

              //                         axios
              //                           .post('https://www.autoturn.net/api/campaign_release.php', Qs.stringify({
              //                             s_code: member_hash,
              //                             campaign_id: this.campaign_id,
              //                           }))
              //                           .then((caResponse) => {
              //                             // console.log('caResponse:'+caResponse.data.return_data);
              //                             if(caResponse.data.status == 'success'){
              //                               // console.log('#20');
              //                               //進行進度條
              //                               // console.log('發佈莞成，開始跑進度條');
              //                               setInterval( () => {
              //                                 num++;
              //                                 if(num < 1200){
              //                                   // console.log('num:'+num);
              //                                   // console.log(this.releaseType);

              //                                   if(this.releaseType == true){
              //                                     axios
              //                                       .post('https://www.autoturn.net/api/campaign_states.php', Qs.stringify({
              //                                         s_code: member_hash,
              //                                         adaccount_id: this.adaccount_id,
              //                                         campaign_id: this.campaign_id,
              //                                       }))
              //                                       .then((csResponse) => {
              //                                         // console.log('csResponse:'+csResponse.data.return_data);
              //                                         //進行進度條
              //                                         if(status == 1){
              //                                           if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'FAILURE'){
              //                                             this.releaseType = false
              //                                             this.style = 'z-index:-1;';
              //                                             bar5.set(0);
              //                                             status = 0;
              //                                             // Swal.fire({
              //                                             //   icon: 'error',
              //                                             //   title: '正式發佈',
              //                                             //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
              //                                             //   showDenyButton: false,
              //                                             //   showCancelButton: false,
              //                                             //   confirmButtonText: '確定',
              //                                             //   timer: 5000
              //                                             //   // denyButtonText: `Don't save`,
              //                                             // }).then((result) => {
              //                                             //   /* Read more about isConfirmed, isDenied below */
              //                                             //   if (result.isConfirmed) {
              //                                             //     // Swal.fire('Saved!', '', 'success')
              //                                             //     this.allPageLoading = true
              //                                             //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                             //   } else if (result.isDenied) {
              //                                             //     // Swal.fire('Changes are not saved', '', 'info')
              //                                             //     this.allPageLoading = true
              //                                             //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                             //   }

              //                                             //   if (result.dismiss === Swal.DismissReason.timer) {
              //                                             //     this.allPageLoading = true
              //                                             //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                             //   }
              //                                             // })
              //                                             Swal.fire({
              //                                               icon: 'error',
              //                                               title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['info_state_failure']['swal_title'],
              //                                               text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['info_state_failure']['swal_html']+csResponse.data.return_data.info_text,
              //                                               showDenyButton: false,
              //                                               showCancelButton: false,
              //                                               confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['info_state_failure']['confirm_button']
              //                                             }).then((result) => {
              //                                           //  console.log('#1');
              //                                               let info_text = csResponse.data.return_data.info_text;
              //                                               let tosStatus = info_text.includes("/leadgen/tos");
              //                                               if(tosStatus == true){
              //                                                 window.open('https://www.facebook.com/ads/leadgen/tos', '', 'height=768,width=1024');
              //                                               }
              //                                             })
              //                                           } else if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'SUCCESS'){
              //                                             status = 0;

              //                                             axios
              //                                               .post('https://www.autoturn.net/api/data/campaign_creative_optimize_update.php', Qs.stringify({
              //                                                 s_code: member_hash,
              //                                                 id: this.campaign_id,
              //                                               }))
              //                                               .then((response) => {
              //                                                 axios
              //                                                   .get('https://www.autoturn.net/udnapi/public/send_notice_email.php?s_code='+member_hash+'&form=release&sr_i='+this.campaign_id)
              //                                                   .then((csResponse) => {
              //                                                     this.releaseType = false

              //                                                     Swal.fire({
              //                                                       icon: 'success',
              //                                                       title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['info_state_success']['swal_title'],
              //                                                       text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['info_state_success']['swal_html'],
              //                                                       showDenyButton: false,
              //                                                       showCancelButton: false,
              //                                                       confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['info_state_success']['confirm_button'],
              //                                                       timer: 5000
              //                                                       // denyButtonText: `Don't save`,
              //                                                     }).then((result) => {
              //                                                       /* Read more about isConfirmed, isDenied below */
              //                                                       if (result.isConfirmed) {
              //                                                         // Swal.fire('Saved!', '', 'success')
              //                                                         this.allPageLoading = true
              //                                                         window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                                       } else if (result.isDenied) {
              //                                                         // Swal.fire('Changes are not saved', '', 'info')
              //                                                         this.allPageLoading = true
              //                                                         window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                                       }

              //                                                       if (result.dismiss === Swal.DismissReason.timer) {
              //                                                         this.allPageLoading = true
              //                                                         window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                                       }
              //                                                     })
              //                                                   });
              //                                               });
              //                                           } else if(csResponse.data.return_data.state == 'FAILURE' && csResponse.data.return_data.info_state == 'FAILURE'){
              //                                             this.releaseType = false
              //                                             this.style = 'z-index:-1;';
              //                                             bar5.set(0);
              //                                             status = 0;
              //                                             // Swal.fire({
              //                                             //   icon: 'error',
              //                                             //   title: '正式發佈',
              //                                             //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
              //                                             //   showDenyButton: false,
              //                                             //   showCancelButton: false,
              //                                             //   confirmButtonText: '確定',
              //                                             //   timer: 5000
              //                                             //   // denyButtonText: `Don't save`,
              //                                             // }).then((result) => {
              //                                             //   /* Read more about isConfirmed, isDenied below */
              //                                             //   if (result.isConfirmed) {
              //                                             //     // Swal.fire('Saved!', '', 'success')
              //                                             //     this.allPageLoading = true
              //                                             //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                             //   } else if (result.isDenied) {
              //                                             //     // Swal.fire('Changes are not saved', '', 'info')
              //                                             //     this.allPageLoading = true
              //                                             //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                             //   }

              //                                             //   if (result.dismiss === Swal.DismissReason.timer) {
              //                                             //     this.allPageLoading = true
              //                                             //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                             //   }
              //                                             // })
              //                                             Swal.fire({
              //                                               icon: 'error',
              //                                               title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['state_failure']['swal_title'],
              //                                               text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['state_failure']['swal_html']+csResponse.data.return_data.info_text,
              //                                               showDenyButton: false,
              //                                               showCancelButton: false,
              //                                               confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['state_failure']['confirm_button']
              //                                             }).then((result) => {
              //                                           //  console.log('#2');
              //                                               let info_text = csResponse.data.return_data.info_text;
              //                                               let tosStatus = info_text.includes("/leadgen/tos");
              //                                               if(tosStatus == true){
              //                                                 window.open('https://www.facebook.com/ads/leadgen/tos', '', 'height=768,width=1024');
              //                                               }
              //                                             })
              //                                           } else {
              //                                             this.releaseText = csResponse.data.return_data.info_text
              //                                             this.releasePercent = csResponse.data.return_data.info_pct

              //                                             bar5.set(this.releasePercent);
              //                                             // console.log('csResponse.data.return_data.info_text:'+csResponse.data.return_data.info_text);
              //                                             // console.log('csResponse.data.return_data.info_pct:'+csResponse.data.return_data.info_pct);
              //                                             // console.log('this.releaseText:'+this.releaseText);
              //                                             // console.log('this.releasePercent:'+this.releasePercent);

              //                                             if(csResponse.data.return_data.info_pct == 100){
              //                                               this.releaseType = false
              //                                               this.style = 'z-index:-1;';
              //                                               bar5.set(0);
              //                                               status = 0;
              //                                             }
              //                                           }
              //                                         }
              //                                       });
              //                                   }
              //                                 } else {
              //                                   Swal.fire({
              //                                     icon: 'warning',
              //                                     title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['else']['swal_title'],
              //                                     text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['else']['swal_html'],
              //                                     showDenyButton: false,
              //                                     showCancelButton: false,
              //                                     confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['else']['confirm_button'],
              //                                     timer: 1000
              //                                     // denyButtonText: `Don't save`,
              //                                   }).then((result) => {
              //                                     /* Read more about isConfirmed, isDenied below */
              //                                     if (result.isConfirmed) {
              //                                       // Swal.fire('Saved!', '', 'success')
              //                                       this.allPageLoading = true
              //                                       window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                     } else if (result.isDenied) {
              //                                       // Swal.fire('Changes are not saved', '', 'info')
              //                                       this.allPageLoading = true
              //                                       window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                     }

              //                                     if (result.dismiss === Swal.DismissReason.timer) {
              //                                       this.allPageLoading = true
              //                                       window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                     }
              //                                   })
              //                                 }
              //                               }, 3000);
              //                             }
              //                           });
              //                     //   }
              //                     // })
              //                   } else {
              //                     Swal.fire(
              //                       this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['not_success']['swal_title'],
              //                       response.data.info,
              //                       'error'
              //                     )
              //                   }

              //                   // if(type == 1){
              //                   //   var todayForm = new Date();
              //                   //   var yearForm = todayForm.getFullYear();
              //                   //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
              //                   //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
              //                   //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

              //                   //   todayForm = yearForm + monthForm + dateForm + timeForm;

              //                   //   this.formTitle = 'title_'+todayForm;
              //                   // } else {
              //                   //   this.formTitle = response.data.return_data.name;
              //                   // }

              //                   // this.showModal = true
              //                 } else {
              //                   let text = this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['update_not_success_default_swal_text'];
              //                   if(response.data.info != '' && response.data.info != null){
              //                     text = response.data.info
              //                   }
              //                   Swal.fire(
              //                     this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['update_not_success_swal_title'],
              //                     text,
              //                     'error'
              //                   )
              //                 }
              //               });
              //           }
              //         } else {
              //       //  console.log('#34');
              //           Swal.fire(
              //                       this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['not_creative_array_swal_title'],
              //                       this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['not_creative_array_swal_text'],
              //                       "error"
              //                     )
              //         }
              //       } else {
              //         axios
              //           .post('https://www.autoturn.net/api/data/campaign_update.php', Qs.stringify({
              //             s_code: this.$route.params.id,
              //             form_data: formData,
              //             type: 'release',
              //             target: 'add_release_'+this.target,
              //           }))
              //           .then((response) => {
              //             // console.log(response.data);
              //             if(response.data.status == 'success'){
              //               // console.log('#19');
              //               // this.immediateList = response.data.return_data
              //               // this.formData = response.data.return_data.form

              //               if(response.data.release_status == 'N' && response.data.release_writing_status == 'draft'){
              //                 let name = this.campaign_name;
              //                 let currency = this.currencyData.currency;
              //                 let addition = this.goalsData.form_addition;
              //                 let daily_budget = this.methodData.daily_budget;
              //                 // let campaignInfo = "依您的預算設定，<br/>在未來兩週將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
              //                 // if(addition == '' || addition == 0){
              //                 //   campaignInfo = "依您的預算比率與行銷日期設定，<br/>將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
              //                 // }

              //                 let addition_text = '（'+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['addition_text']+'：<span style="color:red; font-weight:bold;">'+addition+'%</span>）';
              //                 if(this.methodData.Target_AD == true){
              //                   addition_text = '';
              //                 }
              //                 let two_week_budget = Math.round((daily_budget*7)+(daily_budget*7)+(daily_budget*7*(addition/100)));
              //                 let campaignInfo = this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['swal_text_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['swal_text_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['swal_text_total_budget_c']+"</span>"+addition_text;
              //                 if(this.dateData.end_date != '0000-00-00'){
              //                   two_week_budget = this.total_budget;
              //                   campaignInfo = this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['swal_text_not_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['swal_text_not_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['swal_text_not_total_budget_c']+"</span>"+addition_text;
              //                 }

              //                 // Swal.fire({
              //                 //   // title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['swal_title']+"「"+name+"」",
              //                 //   title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['swal_title'],
              //                 //   html: campaignInfo + "<br/><br/>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['swal_text_a']+"<span style='color:red;'>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['swal_text_b']+"</span>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['swal_text_c'],
              //                 //   icon: 'warning',
              //                 //   showCancelButton: true,
              //                 //   confirmButtonColor: '#3085d6',
              //                 //   cancelButtonColor: '#d33',
              //                 //   confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['yes_button'],
              //                 //   cancelButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['no_button'],
              //                 // }).then((result) => {
              //                 //   if (result.isConfirmed) {
              //                     // console.log(this.$route.params.id);

              //                     this.releaseType = true
              //                     this.style = 'z-index:100;';
              //                     this.releasePercent = 5;
              //                     let status = 1;
              //                     let num = 0;
              //                     let member_hash = this.$route.params.id;
              //                     var bar5 = new ldBar("#myItem5");
              //                     bar5.set(this.releasePercent);

              //                     axios
              //                       .post('https://www.autoturn.net/api/campaign_release.php', Qs.stringify({
              //                         s_code: member_hash,
              //                         campaign_id: this.campaign_id,
              //                       }))
              //                       .then((caResponse) => {
              //                         // console.log('caResponse:'+caResponse.data.return_data);
              //                         if(caResponse.data.status == 'success'){
              //                           // console.log('#20');
              //                           //進行進度條
              //                           // console.log('發佈莞成，開始跑進度條');
              //                           setInterval( () => {
              //                             num++;
              //                             if(num < 1200){
              //                               // console.log('num:'+num);
              //                               // console.log(this.releaseType);

              //                               if(this.releaseType == true){
              //                                 axios
              //                                   .post('https://www.autoturn.net/api/campaign_states.php', Qs.stringify({
              //                                     s_code: member_hash,
              //                                     adaccount_id: this.adaccount_id,
              //                                     campaign_id: this.campaign_id,
              //                                   }))
              //                                   .then((csResponse) => {
              //                                     // console.log('csResponse:'+csResponse.data.return_data);
              //                                     //進行進度條
              //                                     if(status == 1){
              //                                       if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'FAILURE'){
              //                                         this.releaseType = false
              //                                         this.style = 'z-index:-1;';
              //                                         bar5.set(0);
              //                                         status = 0;
              //                                         // Swal.fire({
              //                                         //   icon: 'error',
              //                                         //   title: '正式發佈',
              //                                         //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
              //                                         //   showDenyButton: false,
              //                                         //   showCancelButton: false,
              //                                         //   confirmButtonText: '確定',
              //                                         //   timer: 5000
              //                                         //   // denyButtonText: `Don't save`,
              //                                         // }).then((result) => {
              //                                         //   /* Read more about isConfirmed, isDenied below */
              //                                         //   if (result.isConfirmed) {
              //                                         //     // Swal.fire('Saved!', '', 'success')
              //                                         //     this.allPageLoading = true
              //                                         //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                         //   } else if (result.isDenied) {
              //                                         //     // Swal.fire('Changes are not saved', '', 'info')
              //                                         //     this.allPageLoading = true
              //                                         //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                         //   }

              //                                         //   if (result.dismiss === Swal.DismissReason.timer) {
              //                                         //     this.allPageLoading = true
              //                                         //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                         //   }
              //                                         // })
              //                                         Swal.fire({
              //                                           icon: 'error',
              //                                           title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['info_state_failure']['swal_title'],
              //                                           text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['info_state_failure']['swal_html']+csResponse.data.return_data.info_text,
              //                                           showDenyButton: false,
              //                                           showCancelButton: false,
              //                                           confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['info_state_failure']['confirm_button']
              //                                         }).then((result) => {
              //                                       //  console.log('#3');
              //                                           let info_text = csResponse.data.return_data.info_text;
              //                                           let tosStatus = info_text.includes("/leadgen/tos");
              //                                           if(tosStatus == true){
              //                                             window.open('https://www.facebook.com/ads/leadgen/tos', '', 'height=768,width=1024');
              //                                           }
              //                                         })
              //                                       } else if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'SUCCESS'){
              //                                         status = 0;

              //                                         axios
              //                                           .post('https://www.autoturn.net/api/data/campaign_creative_optimize_update.php', Qs.stringify({
              //                                             s_code: member_hash,
              //                                             id: this.campaign_id,
              //                                           }))
              //                                           .then((response) => {
              //                                             axios
              //                                               .get('https://www.autoturn.net/udnapi/public/send_notice_email.php?s_code='+member_hash+'&form=release&sr_i='+this.campaign_id)
              //                                               .then((csResponse) => {
              //                                                 this.releaseType = false

              //                                                 Swal.fire({
              //                                                   icon: 'success',
              //                                                   title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['info_state_success']['swal_title'],
              //                                                   text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['info_state_success']['swal_html'],
              //                                                   showDenyButton: false,
              //                                                   showCancelButton: false,
              //                                                   confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['info_state_success']['confirm_button'],
              //                                                   timer: 5000
              //                                                   // denyButtonText: `Don't save`,
              //                                                 }).then((result) => {
              //                                                   /* Read more about isConfirmed, isDenied below */
              //                                                   if (result.isConfirmed) {
              //                                                     // Swal.fire('Saved!', '', 'success')
              //                                                     this.allPageLoading = true
              //                                                     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                                   } else if (result.isDenied) {
              //                                                     // Swal.fire('Changes are not saved', '', 'info')
              //                                                     this.allPageLoading = true
              //                                                     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                                   }

              //                                                   if (result.dismiss === Swal.DismissReason.timer) {
              //                                                     this.allPageLoading = true
              //                                                     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                                   }
              //                                                 })
              //                                               });
              //                                           });
              //                                       } else if(csResponse.data.return_data.state == 'FAILURE' && csResponse.data.return_data.info_state == 'FAILURE'){
              //                                         this.releaseType = false
              //                                         this.style = 'z-index:-1;';
              //                                         bar5.set(0);
              //                                         status = 0;
              //                                         // Swal.fire({
              //                                         //   icon: 'error',
              //                                         //   title: '正式發佈',
              //                                         //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
              //                                         //   showDenyButton: false,
              //                                         //   showCancelButton: false,
              //                                         //   confirmButtonText: '確定',
              //                                         //   timer: 5000
              //                                         //   // denyButtonText: `Don't save`,
              //                                         // }).then((result) => {
              //                                         //   /* Read more about isConfirmed, isDenied below */
              //                                         //   if (result.isConfirmed) {
              //                                         //     // Swal.fire('Saved!', '', 'success')
              //                                         //     this.allPageLoading = true
              //                                         //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                         //   } else if (result.isDenied) {
              //                                         //     // Swal.fire('Changes are not saved', '', 'info')
              //                                         //     this.allPageLoading = true
              //                                         //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                         //   }

              //                                         //   if (result.dismiss === Swal.DismissReason.timer) {
              //                                         //     this.allPageLoading = true
              //                                         //     window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                         //   }
              //                                         // })
              //                                         Swal.fire({
              //                                           icon: 'error',
              //                                           title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['state_failure']['swal_title'],
              //                                           text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['state_failure']['swal_html']+csResponse.data.return_data.info_text,
              //                                           showDenyButton: false,
              //                                           showCancelButton: false,
              //                                           confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['state_failure']['confirm_button']
              //                                         }).then((result) => {
              //                                       //  console.log('#4');
              //                                           let info_text = csResponse.data.return_data.info_text;
              //                                           let tosStatus = info_text.includes("/leadgen/tos");
              //                                           if(tosStatus == true){
              //                                             window.open('https://www.facebook.com/ads/leadgen/tos', '', 'height=768,width=1024');
              //                                           }
              //                                         })
              //                                       } else {
              //                                         this.releaseText = csResponse.data.return_data.info_text
              //                                         this.releasePercent = csResponse.data.return_data.info_pct

              //                                         bar5.set(this.releasePercent);
              //                                         // console.log('csResponse.data.return_data.info_text:'+csResponse.data.return_data.info_text);
              //                                         // console.log('csResponse.data.return_data.info_pct:'+csResponse.data.return_data.info_pct);
              //                                         // console.log('this.releaseText:'+this.releaseText);
              //                                         // console.log('this.releasePercent:'+this.releasePercent);

              //                                         if(csResponse.data.return_data.info_pct == 100){
              //                                           this.releaseType = false
              //                                           this.style = 'z-index:-1;';
              //                                           bar5.set(0);
              //                                           status = 0;
              //                                         }
              //                                       }
              //                                     }
              //                                   });
              //                               }
              //                             } else {
              //                               Swal.fire({
              //                                 icon: 'warning',
              //                                 title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['else']['swal_title'],
              //                                 text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['else']['swal_html'],
              //                                 showDenyButton: false,
              //                                 showCancelButton: false,
              //                                 confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['else']['confirm_button'],
              //                                 timer: 1000
              //                                 // denyButtonText: `Don't save`,
              //                               }).then((result) => {
              //                                 /* Read more about isConfirmed, isDenied below */
              //                                 if (result.isConfirmed) {
              //                                   // Swal.fire('Saved!', '', 'success')
              //                                   this.allPageLoading = true
              //                                   window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                 } else if (result.isDenied) {
              //                                   // Swal.fire('Changes are not saved', '', 'info')
              //                                   this.allPageLoading = true
              //                                   window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                 }

              //                                 if (result.dismiss === Swal.DismissReason.timer) {
              //                                   this.allPageLoading = true
              //                                   window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
              //                                 }
              //                               })
              //                             }
              //                           }, 3000);
              //                         }
              //                       });
              //                 //   }
              //                 // })
              //               } else {
              //                 Swal.fire(
              //                   this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['not_success']['swal_title'],
              //                   response.data.info,
              //                   'error'
              //                 )
              //               }

              //               // if(type == 1){
              //               //   var todayForm = new Date();
              //               //   var yearForm = todayForm.getFullYear();
              //               //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
              //               //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
              //               //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

              //               //   todayForm = yearForm + monthForm + dateForm + timeForm;

              //               //   this.formTitle = 'title_'+todayForm;
              //               // } else {
              //               //   this.formTitle = response.data.return_data.name;
              //               // }

              //               // this.showModal = true
              //             } else {
              //               let text = this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['update_not_success_default_swal_text'];
              //               if(response.data.info != '' && response.data.info != null){
              //                 text = response.data.info
              //               }
              //               Swal.fire(
              //                 this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['update_not_success_swal_title'],
              //                 text,
              //                 'error'
              //               )
              //             }
              //           });
              //       }
              //     }

              // //  console.log('customize end');
              // //  console.log(this.customRulesData);
              //   }
              // })
            } else {
              Swal.fire({
                          icon: 'error',
                          title: '自定義規則-發布',
                          html: '資料更新失敗，請稍候再嘗試。',
                          showDenyButton: false,
                          showCancelButton: false,
                          confirmButtonText: 'OK',
                        });

          //  console.log('customize error end');
          //  console.log(this.customRulesData);
              this.nextLoading = false;
              this.showCampaignData = true;
            }
          }
        }
      },
      customize(){
    //  console.log('customize');
        let member_hash = this.$route.params.id
        axios
          .post('https://www.autoturn.net/api/campaign_member_status.php', Qs.stringify({
            s_code: member_hash,
            route_type: this.$route.params.type,
            active: 'release',
          }))
          .then((caResponse) => {
            let _swal = [];

            if(caResponse.data.status == 'error'){
              // console.log('#14');
              if(caResponse.data.type == 2){
                Swal.fire({
                  icon: caResponse.data.status,
                  title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['error']['swal_title'],
                  text: caResponse.data.info,
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['error']['confirm_button']
                  // denyButtonText: `Don't save`,
                }).then((result) => {
                  if (result.isConfirmed) {
                    // Swal.fire('Saved!', '', 'success')
                    this.allPageLoading = true
                    window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                  } else if (result.isDenied) {
                    // Swal.fire('Changes are not saved', '', 'info')
                    this.allPageLoading = true
                    window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                  }
                })
              } else if(caResponse.data.type == 3){
                Swal.fire({
                  icon: caResponse.data.status,
                  title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['error']['swal_title'],
                  text: caResponse.data.info,
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['error']['confirm_button']
                  // denyButtonText: `Don't save`,
                }).then((result) => {
                  if (result.isConfirmed) {
                    // Swal.fire('Saved!', '', 'success')
                    this.allPageLoading = true
                    window.location.href = "https://private.autoturn.net/f/"+member_hash;
                  } else if (result.isDenied) {
                    // Swal.fire('Changes are not saved', '', 'info')
                    this.allPageLoading = true
                    window.location.href = "https://private.autoturn.net/f/"+member_hash;
                  }
                })
              } else {
                Swal.fire(
                          this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['error']['swal_title'],
                          caResponse.data.info,
                          caResponse.data.status
                        )
              }
            }

            if(caResponse.data.status == 'warning' || caResponse.data.status == 'success'){
              this.customizeSave(caResponse.data.status);
            }

            if(caResponse.data.status == 'login'){
              Swal.fire({
                icon: 'error',
                title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['login']['swal_title'],
                text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['login']['swal_text'],
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['login']['confirm_button']
                // denyButtonText: `Don't save`,
              }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                  // Swal.fire('Saved!', '', 'success')
                  // this.allPageLoading = true
                  window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
                } else if (result.isDenied) {
                  // Swal.fire('Changes are not saved', '', 'info')
                  // this.allPageLoading = true
                  window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
                }
              })
            }
          });
      },
    }
  }
</script>

<style lang="scss" scope>
  .progressbar {
    background: linear-gradient(270.01deg, #1D619F 0%, #7FDCFA 51.04%, #7AD5C0 76.56%);
    border-radius: 6px;
  }

  .sub_table {
    display: flex;
    flex-wrap: wrap;
    width: 600px; /* 表格的寬度 */
    border: 1px solid #ccc; /* 表格邊框 */
  }
  .sub_row {
    display: flex;
    width: 100%;
  }
  .sub_cell {
    width: 33.33%;
    height: auto; /* 單元格的高度 */
    border: 1px solid #ccc; /* 單元格邊框 */
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    padding: 18px 4px;
  }
  .sub_header {
    background-color: #CBD5E1;
  }

  .return_table {
    display: flex;
    flex-wrap: wrap;
    width: 800px; /* 表格的寬度 */
  }
  .return_row {
    display: flex;
    width: 100%;
  }
  .cell_stage {
    width: 33.33%;
    height: auto; /* 單元格的高度 */
    border: 1px solid #ccc; /* 單元格邊框 */
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    padding: 18px 4px;
  }
  .cell_content {
    width: 66.67%;
    height: auto; /* 單元格的高度 */
    border: 1px solid #ccc; /* 單元格邊框 */
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    padding: 18px 4px;
  }
  .return_header {
    background-color: #CBD5E1;
  }
</style>
